(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("react-router-dom"));
	else if(typeof define === 'function' && define.amd)
		define("p1s-common-react", ["react", "prop-types", "react-router-dom"], factory);
	else if(typeof exports === 'object')
		exports["p1s-common-react"] = factory(require("react"), require("prop-types"), require("react-router-dom"));
	else
		root["p1s-common-react"] = factory(root["react"], root["prop-types"], root["react-router-dom"]);
})(typeof self !== 'undefined' ? self : this, (__WEBPACK_EXTERNAL_MODULE__9155__, __WEBPACK_EXTERNAL_MODULE__1949__, __WEBPACK_EXTERNAL_MODULE__4442__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 5320:
/***/ ((module) => {

module.exports = function (t) {
  function n(e) {
    if (r[e]) return r[e].exports;
    var o = r[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return t[e].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }
  var r = {};
  return n.m = t, n.c = r, n.d = function (t, r, e) {
    n.o(t, r) || Object.defineProperty(t, r, {
      configurable: !1,
      enumerable: !0,
      get: e
    });
  }, n.n = function (t) {
    var r = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return n.d(r, "a", r), r;
  }, n.o = function (t, n) {
    return Object.prototype.hasOwnProperty.call(t, n);
  }, n.p = "", n(n.s = 13);
}([function (t, n) {
  var r = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
  "number" == typeof __g && (__g = r);
}, function (t, n) {
  t.exports = function (t) {
    return "object" == typeof t ? null !== t : "function" == typeof t;
  };
}, function (t, n) {
  var r = t.exports = {
    version: "2.5.0"
  };
  "number" == typeof __e && (__e = r);
}, function (t, n, r) {
  t.exports = !r(4)(function () {
    return 7 != Object.defineProperty({}, "a", {
      get: function () {
        return 7;
      }
    }).a;
  });
}, function (t, n) {
  t.exports = function (t) {
    try {
      return !!t();
    } catch (t) {
      return !0;
    }
  };
}, function (t, n) {
  var r = {}.toString;
  t.exports = function (t) {
    return r.call(t).slice(8, -1);
  };
}, function (t, n, r) {
  var e = r(32)("wks"),
    o = r(9),
    i = r(0).Symbol,
    u = "function" == typeof i;
  (t.exports = function (t) {
    return e[t] || (e[t] = u && i[t] || (u ? i : o)("Symbol." + t));
  }).store = e;
}, function (t, n, r) {
  var e = r(0),
    o = r(2),
    i = r(8),
    u = r(22),
    c = r(10),
    f = function (t, n, r) {
      var a,
        s,
        p,
        l,
        v = t & f.F,
        y = t & f.G,
        h = t & f.S,
        d = t & f.P,
        x = t & f.B,
        g = y ? e : h ? e[n] || (e[n] = {}) : (e[n] || {}).prototype,
        m = y ? o : o[n] || (o[n] = {}),
        b = m.prototype || (m.prototype = {});
      y && (r = n);
      for (a in r) s = !v && g && void 0 !== g[a], p = (s ? g : r)[a], l = x && s ? c(p, e) : d && "function" == typeof p ? c(Function.call, p) : p, g && u(g, a, p, t & f.U), m[a] != p && i(m, a, l), d && b[a] != p && (b[a] = p);
    };
  e.core = o, f.F = 1, f.G = 2, f.S = 4, f.P = 8, f.B = 16, f.W = 32, f.U = 64, f.R = 128, t.exports = f;
}, function (t, n, r) {
  var e = r(16),
    o = r(21);
  t.exports = r(3) ? function (t, n, r) {
    return e.f(t, n, o(1, r));
  } : function (t, n, r) {
    return t[n] = r, t;
  };
}, function (t, n) {
  var r = 0,
    e = Math.random();
  t.exports = function (t) {
    return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++r + e).toString(36));
  };
}, function (t, n, r) {
  var e = r(24);
  t.exports = function (t, n, r) {
    if (e(t), void 0 === n) return t;
    switch (r) {
      case 1:
        return function (r) {
          return t.call(n, r);
        };
      case 2:
        return function (r, e) {
          return t.call(n, r, e);
        };
      case 3:
        return function (r, e, o) {
          return t.call(n, r, e, o);
        };
    }
    return function () {
      return t.apply(n, arguments);
    };
  };
}, function (t, n) {
  t.exports = function (t) {
    if (void 0 == t) throw TypeError("Can't call method on  " + t);
    return t;
  };
}, function (t, n, r) {
  var e = r(28),
    o = Math.min;
  t.exports = function (t) {
    return t > 0 ? o(e(t), 9007199254740991) : 0;
  };
}, function (t, n, r) {
  "use strict";

  n.__esModule = !0, n.default = function (t, n) {
    if (t && n) {
      var r = Array.isArray(n) ? n : n.split(","),
        e = t.name || "",
        o = t.type || "",
        i = o.replace(/\/.*$/, "");
      return r.some(function (t) {
        var n = t.trim();
        return "." === n.charAt(0) ? e.toLowerCase().endsWith(n.toLowerCase()) : n.endsWith("/*") ? i === n.replace(/\/.*$/, "") : o === n;
      });
    }
    return !0;
  }, r(14), r(34);
}, function (t, n, r) {
  r(15), t.exports = r(2).Array.some;
}, function (t, n, r) {
  "use strict";

  var e = r(7),
    o = r(25)(3);
  e(e.P + e.F * !r(33)([].some, !0), "Array", {
    some: function (t) {
      return o(this, t, arguments[1]);
    }
  });
}, function (t, n, r) {
  var e = r(17),
    o = r(18),
    i = r(20),
    u = Object.defineProperty;
  n.f = r(3) ? Object.defineProperty : function (t, n, r) {
    if (e(t), n = i(n, !0), e(r), o) try {
      return u(t, n, r);
    } catch (t) {}
    if ("get" in r || "set" in r) throw TypeError("Accessors not supported!");
    return "value" in r && (t[n] = r.value), t;
  };
}, function (t, n, r) {
  var e = r(1);
  t.exports = function (t) {
    if (!e(t)) throw TypeError(t + " is not an object!");
    return t;
  };
}, function (t, n, r) {
  t.exports = !r(3) && !r(4)(function () {
    return 7 != Object.defineProperty(r(19)("div"), "a", {
      get: function () {
        return 7;
      }
    }).a;
  });
}, function (t, n, r) {
  var e = r(1),
    o = r(0).document,
    i = e(o) && e(o.createElement);
  t.exports = function (t) {
    return i ? o.createElement(t) : {};
  };
}, function (t, n, r) {
  var e = r(1);
  t.exports = function (t, n) {
    if (!e(t)) return t;
    var r, o;
    if (n && "function" == typeof (r = t.toString) && !e(o = r.call(t))) return o;
    if ("function" == typeof (r = t.valueOf) && !e(o = r.call(t))) return o;
    if (!n && "function" == typeof (r = t.toString) && !e(o = r.call(t))) return o;
    throw TypeError("Can't convert object to primitive value");
  };
}, function (t, n) {
  t.exports = function (t, n) {
    return {
      enumerable: !(1 & t),
      configurable: !(2 & t),
      writable: !(4 & t),
      value: n
    };
  };
}, function (t, n, r) {
  var e = r(0),
    o = r(8),
    i = r(23),
    u = r(9)("src"),
    c = Function.toString,
    f = ("" + c).split("toString");
  r(2).inspectSource = function (t) {
    return c.call(t);
  }, (t.exports = function (t, n, r, c) {
    var a = "function" == typeof r;
    a && (i(r, "name") || o(r, "name", n)), t[n] !== r && (a && (i(r, u) || o(r, u, t[n] ? "" + t[n] : f.join(String(n)))), t === e ? t[n] = r : c ? t[n] ? t[n] = r : o(t, n, r) : (delete t[n], o(t, n, r)));
  })(Function.prototype, "toString", function () {
    return "function" == typeof this && this[u] || c.call(this);
  });
}, function (t, n) {
  var r = {}.hasOwnProperty;
  t.exports = function (t, n) {
    return r.call(t, n);
  };
}, function (t, n) {
  t.exports = function (t) {
    if ("function" != typeof t) throw TypeError(t + " is not a function!");
    return t;
  };
}, function (t, n, r) {
  var e = r(10),
    o = r(26),
    i = r(27),
    u = r(12),
    c = r(29);
  t.exports = function (t, n) {
    var r = 1 == t,
      f = 2 == t,
      a = 3 == t,
      s = 4 == t,
      p = 6 == t,
      l = 5 == t || p,
      v = n || c;
    return function (n, c, y) {
      for (var h, d, x = i(n), g = o(x), m = e(c, y, 3), b = u(g.length), _ = 0, w = r ? v(n, b) : f ? v(n, 0) : void 0; b > _; _++) if ((l || _ in g) && (h = g[_], d = m(h, _, x), t)) if (r) w[_] = d;else if (d) switch (t) {
        case 3:
          return !0;
        case 5:
          return h;
        case 6:
          return _;
        case 2:
          w.push(h);
      } else if (s) return !1;
      return p ? -1 : a || s ? s : w;
    };
  };
}, function (t, n, r) {
  var e = r(5);
  t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
    return "String" == e(t) ? t.split("") : Object(t);
  };
}, function (t, n, r) {
  var e = r(11);
  t.exports = function (t) {
    return Object(e(t));
  };
}, function (t, n) {
  var r = Math.ceil,
    e = Math.floor;
  t.exports = function (t) {
    return isNaN(t = +t) ? 0 : (t > 0 ? e : r)(t);
  };
}, function (t, n, r) {
  var e = r(30);
  t.exports = function (t, n) {
    return new (e(t))(n);
  };
}, function (t, n, r) {
  var e = r(1),
    o = r(31),
    i = r(6)("species");
  t.exports = function (t) {
    var n;
    return o(t) && (n = t.constructor, "function" != typeof n || n !== Array && !o(n.prototype) || (n = void 0), e(n) && null === (n = n[i]) && (n = void 0)), void 0 === n ? Array : n;
  };
}, function (t, n, r) {
  var e = r(5);
  t.exports = Array.isArray || function (t) {
    return "Array" == e(t);
  };
}, function (t, n, r) {
  var e = r(0),
    o = e["__core-js_shared__"] || (e["__core-js_shared__"] = {});
  t.exports = function (t) {
    return o[t] || (o[t] = {});
  };
}, function (t, n, r) {
  "use strict";

  var e = r(4);
  t.exports = function (t, n) {
    return !!t && e(function () {
      n ? t.call(null, function () {}, 1) : t.call(null);
    });
  };
}, function (t, n, r) {
  r(35), t.exports = r(2).String.endsWith;
}, function (t, n, r) {
  "use strict";

  var e = r(7),
    o = r(12),
    i = r(36),
    u = "".endsWith;
  e(e.P + e.F * r(38)("endsWith"), "String", {
    endsWith: function (t) {
      var n = i(this, t, "endsWith"),
        r = arguments.length > 1 ? arguments[1] : void 0,
        e = o(n.length),
        c = void 0 === r ? e : Math.min(o(r), e),
        f = String(t);
      return u ? u.call(n, f, c) : n.slice(c - f.length, c) === f;
    }
  });
}, function (t, n, r) {
  var e = r(37),
    o = r(11);
  t.exports = function (t, n, r) {
    if (e(n)) throw TypeError("String#" + r + " doesn't accept regex!");
    return String(o(t));
  };
}, function (t, n, r) {
  var e = r(1),
    o = r(5),
    i = r(6)("match");
  t.exports = function (t) {
    var n;
    return e(t) && (void 0 !== (n = t[i]) ? !!n : "RegExp" == o(t));
  };
}, function (t, n, r) {
  var e = r(6)("match");
  t.exports = function (t) {
    var n = /./;
    try {
      "/./"[t](n);
    } catch (r) {
      try {
        return n[e] = !1, !"/./"[t](n);
      } catch (t) {}
    }
    return !0;
  };
}]);

/***/ }),

/***/ 2857:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(8299);
var callBind = __webpack_require__(8953);
var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
  var intrinsic = GetIntrinsic(name, !!allowMissing);
  if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
    return callBind(intrinsic);
  }
  return intrinsic;
};

/***/ }),

/***/ 8953:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(5465);
var GetIntrinsic = __webpack_require__(8299);
var setFunctionLength = __webpack_require__(5887);
var $TypeError = __webpack_require__(1953);
var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
var $defineProperty = __webpack_require__(5049);
var $max = GetIntrinsic('%Math.max%');
module.exports = function callBind(originalFunction) {
  if (typeof originalFunction !== 'function') {
    throw new $TypeError('a function is required');
  }
  var func = $reflectApply(bind, $call, arguments);
  return setFunctionLength(func, 1 + $max(0, originalFunction.length - (arguments.length - 1)), true);
};
var applyBind = function applyBind() {
  return $reflectApply(bind, $apply, arguments);
};
if ($defineProperty) {
  $defineProperty(module.exports, 'apply', {
    value: applyBind
  });
} else {
  module.exports.apply = applyBind;
}

/***/ }),

/***/ 6543:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
  if (true) module.exports = factory(__webpack_require__(9155));else {}
})(this, function (__WEBPACK_EXTERNAL_MODULE_1__) {
  return /******/function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/
    var installedModules = {};

    /******/ // The require function
    /******/
    function __nested_webpack_require_624__(moduleId) {
      /******/ // Check if module is in cache
      /******/if (installedModules[moduleId]) /******/return installedModules[moduleId].exports;

      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = installedModules[moduleId] = {
        /******/exports: {},
        /******/id: moduleId,
        /******/loaded: false
        /******/
      };

      /******/ // Execute the module function
      /******/
      modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_624__);

      /******/ // Flag the module as loaded
      /******/
      module.loaded = true;

      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }

    /******/ // expose the modules object (__webpack_modules__)
    /******/
    __nested_webpack_require_624__.m = modules;

    /******/ // expose the module cache
    /******/
    __nested_webpack_require_624__.c = installedModules;

    /******/ // __webpack_public_path__
    /******/
    __nested_webpack_require_624__.p = "";

    /******/ // Load entry module and return exports
    /******/
    return __nested_webpack_require_624__(0);
    /******/
  }
  /************************************************************************/
  /******/([(/* 0 */
  /***/function (module, exports, __nested_webpack_require_1965__) {
    'use strict';

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    function _objectWithoutProperties(obj, keys) {
      var target = {};
      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }
      return target;
    }
    var React = __nested_webpack_require_1965__(1); // eslint-disable-line no-unused-vars
    var CreateReactClass = __nested_webpack_require_1965__(2);
    var NumeralFormatter = __nested_webpack_require_1965__(10);
    var DateFormatter = __nested_webpack_require_1965__(11);
    var TimeFormatter = __nested_webpack_require_1965__(12);
    var PhoneFormatter = __nested_webpack_require_1965__(13);
    var CreditCardDetector = __nested_webpack_require_1965__(14);
    var Util = __nested_webpack_require_1965__(15);
    var DefaultProperties = __nested_webpack_require_1965__(16);
    var cleaveReactClass = CreateReactClass({
      componentDidMount: function componentDidMount() {
        this.init();
      },
      componentDidUpdate: function componentDidUpdate(prevProps) {
        var owner = this,
          phoneRegionCode = (owner.props.options || {}).phoneRegionCode,
          newValue = owner.props.value,
          pps = owner.properties;
        owner.updateRegisteredEvents(owner.props);
        if (prevProps.value !== newValue && newValue !== undefined && newValue !== null) {
          newValue = newValue.toString();
          if (newValue !== owner.properties.result) {
            owner.properties.initValue = newValue;
            owner.onInput(newValue, true);
          }
        }

        // update phone region code
        var prevPhoneRegionCode = (prevProps.options || {}).phoneRegionCode;
        if (prevPhoneRegionCode !== phoneRegionCode && phoneRegionCode && phoneRegionCode !== owner.properties.phoneRegionCode) {
          owner.properties.phoneRegionCode = phoneRegionCode;
          owner.initPhoneFormatter();
          owner.onInput(owner.properties.result);
        }
        Util.setSelection(owner.element, owner.state.cursorPosition, pps.document);
      },
      updateRegisteredEvents: function updateRegisteredEvents(props) {
        var owner = this,
          _owner$registeredEven = owner.registeredEvents,
          onKeyDown = _owner$registeredEven.onKeyDown,
          onChange = _owner$registeredEven.onChange,
          onFocus = _owner$registeredEven.onFocus,
          onBlur = _owner$registeredEven.onBlur,
          onInit = _owner$registeredEven.onInit;
        if (props.onInit && props.onInit !== onInit) owner.registeredEvents.onInit = props.onInit;
        if (props.onChange && props.onChange !== onChange) owner.registeredEvents.onChange = props.onChange;
        if (props.onFocus && props.onFocus !== onFocus) owner.registeredEvents.onFocus = props.onFocus;
        if (props.onBlur && props.onBlur !== onBlur) owner.registeredEvents.onBlur = props.onBlur;
        if (props.onKeyDown && props.onKeyDown !== onKeyDown) owner.registeredEvents.onKeyDown = props.onKeyDown;
      },
      getInitialState: function getInitialState() {
        var owner = this,
          _owner$props = owner.props,
          value = _owner$props.value,
          options = _owner$props.options,
          onKeyDown = _owner$props.onKeyDown,
          onChange = _owner$props.onChange,
          onFocus = _owner$props.onFocus,
          onBlur = _owner$props.onBlur,
          onInit = _owner$props.onInit;
        owner.registeredEvents = {
          onInit: onInit || Util.noop,
          onChange: onChange || Util.noop,
          onFocus: onFocus || Util.noop,
          onBlur: onBlur || Util.noop,
          onKeyDown: onKeyDown || Util.noop
        };
        if (!options) {
          options = {};
        }
        options.initValue = value;
        owner.properties = DefaultProperties.assign({}, options);
        return {
          value: owner.properties.result,
          cursorPosition: 0
        };
      },
      init: function init() {
        var owner = this,
          pps = owner.properties;

        // so no need for this lib at all
        if (!pps.numeral && !pps.phone && !pps.creditCard && !pps.time && !pps.date && pps.blocksLength === 0 && !pps.prefix) {
          owner.onInput(pps.initValue);
          owner.registeredEvents.onInit(owner);
          return;
        }
        pps.maxLength = Util.getMaxLength(pps.blocks);
        owner.isAndroid = Util.isAndroid();
        owner.initPhoneFormatter();
        owner.initDateFormatter();
        owner.initTimeFormatter();
        owner.initNumeralFormatter();

        // avoid touch input field if value is null
        // otherwise Firefox will add red box-shadow for <input required />
        if (pps.initValue || pps.prefix && !pps.noImmediatePrefix) {
          owner.onInput(pps.initValue);
        }
        owner.registeredEvents.onInit(owner);
      },
      initNumeralFormatter: function initNumeralFormatter() {
        var owner = this,
          pps = owner.properties;
        if (!pps.numeral) {
          return;
        }
        pps.numeralFormatter = new NumeralFormatter(pps.numeralDecimalMark, pps.numeralIntegerScale, pps.numeralDecimalScale, pps.numeralThousandsGroupStyle, pps.numeralPositiveOnly, pps.stripLeadingZeroes, pps.prefix, pps.signBeforePrefix, pps.tailPrefix, pps.delimiter);
      },
      initTimeFormatter: function initTimeFormatter() {
        var owner = this,
          pps = owner.properties;
        if (!pps.time) {
          return;
        }
        pps.timeFormatter = new TimeFormatter(pps.timePattern, pps.timeFormat);
        pps.blocks = pps.timeFormatter.getBlocks();
        pps.blocksLength = pps.blocks.length;
        pps.maxLength = Util.getMaxLength(pps.blocks);
      },
      initDateFormatter: function initDateFormatter() {
        var owner = this,
          pps = owner.properties;
        if (!pps.date) {
          return;
        }
        pps.dateFormatter = new DateFormatter(pps.datePattern, pps.dateMin, pps.dateMax);
        pps.blocks = pps.dateFormatter.getBlocks();
        pps.blocksLength = pps.blocks.length;
        pps.maxLength = Util.getMaxLength(pps.blocks);
      },
      initPhoneFormatter: function initPhoneFormatter() {
        var owner = this,
          pps = owner.properties;
        if (!pps.phone) {
          return;
        }

        // Cleave.AsYouTypeFormatter should be provided by
        // external google closure lib
        try {
          pps.phoneFormatter = new PhoneFormatter(new pps.root.Cleave.AsYouTypeFormatter(pps.phoneRegionCode), pps.delimiter);
        } catch (ex) {
          throw new Error('Please include phone-type-formatter.{country}.js lib');
        }
      },
      setRawValue: function setRawValue(value) {
        var owner = this,
          pps = owner.properties;
        value = value !== undefined && value !== null ? value.toString() : '';
        if (pps.numeral) {
          value = value.replace('.', pps.numeralDecimalMark);
        }
        pps.postDelimiterBackspace = false;
        owner.onChange({
          target: {
            value: value
          },
          // Methods to better resemble a SyntheticEvent
          stopPropagation: Util.noop,
          preventDefault: Util.noop,
          persist: Util.noop
        });
      },
      getRawValue: function getRawValue() {
        var owner = this,
          pps = owner.properties,
          rawValue = pps.result;
        if (pps.rawValueTrimPrefix) {
          rawValue = Util.getPrefixStrippedValue(rawValue, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);
        }
        if (pps.numeral) {
          rawValue = pps.numeralFormatter ? pps.numeralFormatter.getRawValue(rawValue) : '';
        } else {
          rawValue = Util.stripDelimiters(rawValue, pps.delimiter, pps.delimiters);
        }
        return rawValue;
      },
      getISOFormatDate: function getISOFormatDate() {
        var owner = this,
          pps = owner.properties;
        return pps.date ? pps.dateFormatter.getISOFormatDate() : '';
      },
      getISOFormatTime: function getISOFormatTime() {
        var owner = this,
          pps = owner.properties;
        return pps.time ? pps.timeFormatter.getISOFormatTime() : '';
      },
      onInit: function onInit(owner) {
        return owner;
      },
      onKeyDown: function onKeyDown(event) {
        var owner = this,
          pps = owner.properties,
          charCode = event.which || event.keyCode;
        owner.lastInputValue = pps.result;
        owner.isBackward = charCode === 8;
        owner.registeredEvents.onKeyDown(event);
      },
      onFocus: function onFocus(event) {
        var owner = this,
          pps = owner.properties;
        if (pps.prefix && pps.noImmediatePrefix && !event.target.value) {
          owner.onInput(pps.prefix);
        }
        event.target.rawValue = owner.getRawValue();
        event.target.value = pps.result;
        owner.registeredEvents.onFocus(event);
        Util.fixPrefixCursor(owner.element, pps.prefix, pps.delimiter, pps.delimiters);
      },
      onBlur: function onBlur(event) {
        var owner = this,
          pps = owner.properties;
        event.target.rawValue = owner.getRawValue();
        event.target.value = pps.result;
        owner.registeredEvents.onBlur(event);
      },
      onChange: function onChange(event) {
        var owner = this,
          pps = owner.properties;
        owner.isBackward = owner.isBackward || event.inputType === 'deleteContentBackward';
        // hit backspace when last character is delimiter
        var postDelimiter = Util.getPostDelimiter(owner.lastInputValue, pps.delimiter, pps.delimiters);
        if (owner.isBackward && postDelimiter) {
          pps.postDelimiterBackspace = postDelimiter;
        } else {
          pps.postDelimiterBackspace = false;
        }
        owner.onInput(event.target.value);
        event.target.rawValue = owner.getRawValue();
        event.target.value = pps.result;
        owner.registeredEvents.onChange(event);
      },
      onInput: function onInput(value, fromProps) {
        var owner = this,
          pps = owner.properties;

        // case 1: delete one more character "4"
        // 1234*| -> hit backspace -> 123|
        // case 2: last character is not delimiter which is:
        // 12|34* -> hit backspace -> 1|34*
        var postDelimiterAfter = Util.getPostDelimiter(value, pps.delimiter, pps.delimiters);
        if (!fromProps && !pps.numeral && pps.postDelimiterBackspace && !postDelimiterAfter) {
          value = Util.headStr(value, value.length - pps.postDelimiterBackspace.length);
        }

        // phone formatter
        if (pps.phone) {
          if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
            pps.result = pps.prefix + pps.phoneFormatter.format(value).slice(pps.prefix.length);
          } else {
            pps.result = pps.phoneFormatter.format(value);
          }
          owner.updateValueState();
          return;
        }

        // numeral formatter
        if (pps.numeral) {
          // Do not show prefix when noImmediatePrefix is specified
          // This mostly because we need to show user the native input placeholder
          if (pps.prefix && pps.noImmediatePrefix && value.length === 0) {
            pps.result = '';
          } else {
            pps.result = pps.numeralFormatter.format(value);
          }
          owner.updateValueState();
          return;
        }

        // date
        if (pps.date) {
          value = pps.dateFormatter.getValidatedDate(value);
        }

        // time
        if (pps.time) {
          value = pps.timeFormatter.getValidatedTime(value);
        }

        // strip delimiters
        value = Util.stripDelimiters(value, pps.delimiter, pps.delimiters);

        // strip prefix
        value = Util.getPrefixStrippedValue(value, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);

        // strip non-numeric characters
        value = pps.numericOnly ? Util.strip(value, /[^\d]/g) : value;

        // convert case
        value = pps.uppercase ? value.toUpperCase() : value;
        value = pps.lowercase ? value.toLowerCase() : value;

        // prevent from showing prefix when no immediate option enabled with empty input value
        if (pps.prefix) {
          if (pps.tailPrefix) {
            value = value + pps.prefix;
          } else {
            value = pps.prefix + value;
          }

          // no blocks specified, no need to do formatting
          if (pps.blocksLength === 0) {
            pps.result = value;
            owner.updateValueState();
            return;
          }
        }

        // update credit card props
        if (pps.creditCard) {
          owner.updateCreditCardPropsByValue(value);
        }

        // strip over length characters
        value = pps.maxLength > 0 ? Util.headStr(value, pps.maxLength) : value;

        // apply blocks
        pps.result = Util.getFormattedValue(value, pps.blocks, pps.blocksLength, pps.delimiter, pps.delimiters, pps.delimiterLazyShow);
        owner.updateValueState();
      },
      updateCreditCardPropsByValue: function updateCreditCardPropsByValue(value) {
        var owner = this,
          pps = owner.properties,
          creditCardInfo;

        // At least one of the first 4 characters has changed
        if (Util.headStr(pps.result, 4) === Util.headStr(value, 4)) {
          return;
        }
        creditCardInfo = CreditCardDetector.getInfo(value, pps.creditCardStrictMode);
        pps.blocks = creditCardInfo.blocks;
        pps.blocksLength = pps.blocks.length;
        pps.maxLength = Util.getMaxLength(pps.blocks);

        // credit card type changed
        if (pps.creditCardType !== creditCardInfo.type) {
          pps.creditCardType = creditCardInfo.type;
          pps.onCreditCardTypeChanged.call(owner, pps.creditCardType);
        }
      },
      updateValueState: function updateValueState() {
        var owner = this,
          pps = owner.properties;
        if (!owner.element) {
          owner.setState({
            value: pps.result
          });
          return;
        }
        var endPos = owner.element.selectionEnd;
        var oldValue = owner.element.value;
        var newValue = pps.result;
        owner.lastInputValue = newValue;
        endPos = Util.getNextCursorPosition(endPos, oldValue, newValue, pps.delimiter, pps.delimiters);
        if (owner.isAndroid) {
          window.setTimeout(function () {
            owner.setState({
              value: newValue,
              cursorPosition: endPos
            });
          }, 1);
          return;
        }
        owner.setState({
          value: newValue,
          cursorPosition: endPos
        });
      },
      render: function render() {
        var owner = this;
        // eslint-disable-next-line

        var _owner$props2 = owner.props,
          value = _owner$props2.value,
          options = _owner$props2.options,
          onKeyDown = _owner$props2.onKeyDown,
          onFocus = _owner$props2.onFocus,
          onBlur = _owner$props2.onBlur,
          onChange = _owner$props2.onChange,
          onInit = _owner$props2.onInit,
          htmlRef = _owner$props2.htmlRef,
          propsToTransfer = _objectWithoutProperties(_owner$props2, ['value', 'options', 'onKeyDown', 'onFocus', 'onBlur', 'onChange', 'onInit', 'htmlRef']);
        return React.createElement('input', _extends({
          type: 'text',
          ref: function ref(_ref) {
            owner.element = _ref;
            if (!htmlRef) {
              return;
            }
            htmlRef.apply(this, arguments);
          },
          value: owner.state.value,
          onKeyDown: owner.onKeyDown,
          onChange: owner.onChange,
          onFocus: owner.onFocus,
          onBlur: owner.onBlur
        }, propsToTransfer));
      }
    });
    module.exports = cleaveReactClass;

    /***/
  }), (/* 1 */
  /***/function (module, exports) {
    module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

    /***/
  }), (/* 2 */
  /***/function (module, exports, __nested_webpack_require_18542__) {
    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     *
     */

    'use strict';

    var React = __nested_webpack_require_18542__(1);
    var factory = __nested_webpack_require_18542__(3);
    if (typeof React === 'undefined') {
      throw Error('create-react-class could not find the React object. If you are using script tags, ' + 'make sure that React is being loaded before create-react-class.');
    }

    // Hack to grab NoopUpdateQueue from isomorphic React
    var ReactNoopUpdateQueue = new React.Component().updater;
    module.exports = factory(React.Component, React.isValidElement, ReactNoopUpdateQueue);

    /***/
  }), (/* 3 */
  /***/function (module, exports, __nested_webpack_require_19372__) {
    /* WEBPACK VAR INJECTION */(function (process) {
      /**
      * Copyright (c) 2013-present, Facebook, Inc.
      *
      * This source code is licensed under the MIT license found in the
      * LICENSE file in the root directory of this source tree.
      *
      */

      'use strict';

      var _assign = __nested_webpack_require_19372__(5);
      var emptyObject = __nested_webpack_require_19372__(6);
      var _invariant = __nested_webpack_require_19372__(7);
      if (process.env.NODE_ENV !== 'production') {
        var warning = __nested_webpack_require_19372__(8);
      }
      var MIXINS_KEY = 'mixins';

      // Helper function to allow the creation of anonymous functions which do not
      // have .name set to the name of the variable being assigned to.
      function identity(fn) {
        return fn;
      }
      var ReactPropTypeLocationNames;
      if (process.env.NODE_ENV !== 'production') {
        ReactPropTypeLocationNames = {
          prop: 'prop',
          context: 'context',
          childContext: 'child context'
        };
      } else {
        ReactPropTypeLocationNames = {};
      }
      function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
        /**
         * Policies that describe methods in `ReactClassInterface`.
         */

        var injectedMixins = [];

        /**
         * Composite components are higher-level components that compose other composite
         * or host components.
         *
         * To create a new type of `ReactClass`, pass a specification of
         * your new class to `React.createClass`. The only requirement of your class
         * specification is that you implement a `render` method.
         *
         *   var MyComponent = React.createClass({
         *     render: function() {
         *       return <div>Hello World</div>;
         *     }
         *   });
         *
         * The class specification supports a specific protocol of methods that have
         * special meaning (e.g. `render`). See `ReactClassInterface` for
         * more the comprehensive protocol. Any other properties and methods in the
         * class specification will be available on the prototype.
         *
         * @interface ReactClassInterface
         * @internal
         */
        var ReactClassInterface = {
          /**
           * An array of Mixin objects to include when defining your component.
           *
           * @type {array}
           * @optional
           */
          mixins: 'DEFINE_MANY',
          /**
           * An object containing properties and methods that should be defined on
           * the component's constructor instead of its prototype (static methods).
           *
           * @type {object}
           * @optional
           */
          statics: 'DEFINE_MANY',
          /**
           * Definition of prop types for this component.
           *
           * @type {object}
           * @optional
           */
          propTypes: 'DEFINE_MANY',
          /**
           * Definition of context types for this component.
           *
           * @type {object}
           * @optional
           */
          contextTypes: 'DEFINE_MANY',
          /**
           * Definition of context types this component sets for its children.
           *
           * @type {object}
           * @optional
           */
          childContextTypes: 'DEFINE_MANY',
          // ==== Definition methods ====

          /**
           * Invoked when the component is mounted. Values in the mapping will be set on
           * `this.props` if that prop is not specified (i.e. using an `in` check).
           *
           * This method is invoked before `getInitialState` and therefore cannot rely
           * on `this.state` or use `this.setState`.
           *
           * @return {object}
           * @optional
           */
          getDefaultProps: 'DEFINE_MANY_MERGED',
          /**
           * Invoked once before the component is mounted. The return value will be used
           * as the initial value of `this.state`.
           *
           *   getInitialState: function() {
           *     return {
           *       isOn: false,
           *       fooBaz: new BazFoo()
           *     }
           *   }
           *
           * @return {object}
           * @optional
           */
          getInitialState: 'DEFINE_MANY_MERGED',
          /**
           * @return {object}
           * @optional
           */
          getChildContext: 'DEFINE_MANY_MERGED',
          /**
           * Uses props from `this.props` and state from `this.state` to render the
           * structure of the component.
           *
           * No guarantees are made about when or how often this method is invoked, so
           * it must not have side effects.
           *
           *   render: function() {
           *     var name = this.props.name;
           *     return <div>Hello, {name}!</div>;
           *   }
           *
           * @return {ReactComponent}
           * @required
           */
          render: 'DEFINE_ONCE',
          // ==== Delegate methods ====

          /**
           * Invoked when the component is initially created and about to be mounted.
           * This may have side effects, but any external subscriptions or data created
           * by this method must be cleaned up in `componentWillUnmount`.
           *
           * @optional
           */
          componentWillMount: 'DEFINE_MANY',
          /**
           * Invoked when the component has been mounted and has a DOM representation.
           * However, there is no guarantee that the DOM node is in the document.
           *
           * Use this as an opportunity to operate on the DOM when the component has
           * been mounted (initialized and rendered) for the first time.
           *
           * @param {DOMElement} rootNode DOM element representing the component.
           * @optional
           */
          componentDidMount: 'DEFINE_MANY',
          /**
           * Invoked before the component receives new props.
           *
           * Use this as an opportunity to react to a prop transition by updating the
           * state using `this.setState`. Current props are accessed via `this.props`.
           *
           *   componentWillReceiveProps: function(nextProps, nextContext) {
           *     this.setState({
           *       likesIncreasing: nextProps.likeCount > this.props.likeCount
           *     });
           *   }
           *
           * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
           * transition may cause a state change, but the opposite is not true. If you
           * need it, you are probably looking for `componentWillUpdate`.
           *
           * @param {object} nextProps
           * @optional
           */
          componentWillReceiveProps: 'DEFINE_MANY',
          /**
           * Invoked while deciding if the component should be updated as a result of
           * receiving new props, state and/or context.
           *
           * Use this as an opportunity to `return false` when you're certain that the
           * transition to the new props/state/context will not require a component
           * update.
           *
           *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
           *     return !equal(nextProps, this.props) ||
           *       !equal(nextState, this.state) ||
           *       !equal(nextContext, this.context);
           *   }
           *
           * @param {object} nextProps
           * @param {?object} nextState
           * @param {?object} nextContext
           * @return {boolean} True if the component should update.
           * @optional
           */
          shouldComponentUpdate: 'DEFINE_ONCE',
          /**
           * Invoked when the component is about to update due to a transition from
           * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
           * and `nextContext`.
           *
           * Use this as an opportunity to perform preparation before an update occurs.
           *
           * NOTE: You **cannot** use `this.setState()` in this method.
           *
           * @param {object} nextProps
           * @param {?object} nextState
           * @param {?object} nextContext
           * @param {ReactReconcileTransaction} transaction
           * @optional
           */
          componentWillUpdate: 'DEFINE_MANY',
          /**
           * Invoked when the component's DOM representation has been updated.
           *
           * Use this as an opportunity to operate on the DOM when the component has
           * been updated.
           *
           * @param {object} prevProps
           * @param {?object} prevState
           * @param {?object} prevContext
           * @param {DOMElement} rootNode DOM element representing the component.
           * @optional
           */
          componentDidUpdate: 'DEFINE_MANY',
          /**
           * Invoked when the component is about to be removed from its parent and have
           * its DOM representation destroyed.
           *
           * Use this as an opportunity to deallocate any external resources.
           *
           * NOTE: There is no `componentDidUnmount` since your component will have been
           * destroyed by that point.
           *
           * @optional
           */
          componentWillUnmount: 'DEFINE_MANY',
          /**
           * Replacement for (deprecated) `componentWillMount`.
           *
           * @optional
           */
          UNSAFE_componentWillMount: 'DEFINE_MANY',
          /**
           * Replacement for (deprecated) `componentWillReceiveProps`.
           *
           * @optional
           */
          UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
          /**
           * Replacement for (deprecated) `componentWillUpdate`.
           *
           * @optional
           */
          UNSAFE_componentWillUpdate: 'DEFINE_MANY',
          // ==== Advanced methods ====

          /**
           * Updates the component's currently mounted DOM representation.
           *
           * By default, this implements React's rendering and reconciliation algorithm.
           * Sophisticated clients may wish to override this.
           *
           * @param {ReactReconcileTransaction} transaction
           * @internal
           * @overridable
           */
          updateComponent: 'OVERRIDE_BASE'
        };

        /**
         * Similar to ReactClassInterface but for static methods.
         */
        var ReactClassStaticInterface = {
          /**
           * This method is invoked after a component is instantiated and when it
           * receives new props. Return an object to update state in response to
           * prop changes. Return null to indicate no change to state.
           *
           * If an object is returned, its keys will be merged into the existing state.
           *
           * @return {object || null}
           * @optional
           */
          getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
        };

        /**
         * Mapping from class specification keys to special processing functions.
         *
         * Although these are declared like instance properties in the specification
         * when defining classes using `React.createClass`, they are actually static
         * and are accessible on the constructor instead of the prototype. Despite
         * being static, they must be defined outside of the "statics" key under
         * which all other static methods are defined.
         */
        var RESERVED_SPEC_KEYS = {
          displayName: function (Constructor, displayName) {
            Constructor.displayName = displayName;
          },
          mixins: function (Constructor, mixins) {
            if (mixins) {
              for (var i = 0; i < mixins.length; i++) {
                mixSpecIntoComponent(Constructor, mixins[i]);
              }
            }
          },
          childContextTypes: function (Constructor, childContextTypes) {
            if (process.env.NODE_ENV !== 'production') {
              validateTypeDef(Constructor, childContextTypes, 'childContext');
            }
            Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
          },
          contextTypes: function (Constructor, contextTypes) {
            if (process.env.NODE_ENV !== 'production') {
              validateTypeDef(Constructor, contextTypes, 'context');
            }
            Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
          },
          /**
           * Special case getDefaultProps which should move into statics but requires
           * automatic merging.
           */
          getDefaultProps: function (Constructor, getDefaultProps) {
            if (Constructor.getDefaultProps) {
              Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
            } else {
              Constructor.getDefaultProps = getDefaultProps;
            }
          },
          propTypes: function (Constructor, propTypes) {
            if (process.env.NODE_ENV !== 'production') {
              validateTypeDef(Constructor, propTypes, 'prop');
            }
            Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
          },
          statics: function (Constructor, statics) {
            mixStaticSpecIntoComponent(Constructor, statics);
          },
          autobind: function () {}
        };
        function validateTypeDef(Constructor, typeDef, location) {
          for (var propName in typeDef) {
            if (typeDef.hasOwnProperty(propName)) {
              // use a warning instead of an _invariant so components
              // don't show up in prod but only in __DEV__
              if (process.env.NODE_ENV !== 'production') {
                warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName);
              }
            }
          }
        }
        function validateMethodOverride(isAlreadyDefined, name) {
          var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

          // Disallow overriding of base class methods unless explicitly allowed.
          if (ReactClassMixin.hasOwnProperty(name)) {
            _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
          }

          // Disallow defining methods more than once unless explicitly allowed.
          if (isAlreadyDefined) {
            _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
          }
        }

        /**
         * Mixin helper which handles policy validation and reserved
         * specification keys when building React classes.
         */
        function mixSpecIntoComponent(Constructor, spec) {
          if (!spec) {
            if (process.env.NODE_ENV !== 'production') {
              var typeofSpec = typeof spec;
              var isMixinValid = typeofSpec === 'object' && spec !== null;
              if (process.env.NODE_ENV !== 'production') {
                warning(isMixinValid, "%s: You're attempting to include a mixin that is either null " + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec);
              }
            }
            return;
          }
          _invariant(typeof spec !== 'function', "ReactClass: You're attempting to " + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
          _invariant(!isValidElement(spec), "ReactClass: You're attempting to " + 'use a component as a mixin. Instead, just use a regular object.');
          var proto = Constructor.prototype;
          var autoBindPairs = proto.__reactAutoBindPairs;

          // By handling mixins before any other properties, we ensure the same
          // chaining order is applied to methods with DEFINE_MANY policy, whether
          // mixins are listed before or after these methods in the spec.
          if (spec.hasOwnProperty(MIXINS_KEY)) {
            RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
          }
          for (var name in spec) {
            if (!spec.hasOwnProperty(name)) {
              continue;
            }
            if (name === MIXINS_KEY) {
              // We have already handled mixins in a special case above.
              continue;
            }
            var property = spec[name];
            var isAlreadyDefined = proto.hasOwnProperty(name);
            validateMethodOverride(isAlreadyDefined, name);
            if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
              RESERVED_SPEC_KEYS[name](Constructor, property);
            } else {
              // Setup methods on prototype:
              // The following member methods should not be automatically bound:
              // 1. Expected ReactClass methods (in the "interface").
              // 2. Overridden methods (that were mixed in).
              var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
              var isFunction = typeof property === 'function';
              var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
              if (shouldAutoBind) {
                autoBindPairs.push(name, property);
                proto[name] = property;
              } else {
                if (isAlreadyDefined) {
                  var specPolicy = ReactClassInterface[name];

                  // These cases should already be caught by validateMethodOverride.
                  _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);

                  // For methods which are defined more than once, call the existing
                  // methods before calling the new property, merging if appropriate.
                  if (specPolicy === 'DEFINE_MANY_MERGED') {
                    proto[name] = createMergedResultFunction(proto[name], property);
                  } else if (specPolicy === 'DEFINE_MANY') {
                    proto[name] = createChainedFunction(proto[name], property);
                  }
                } else {
                  proto[name] = property;
                  if (process.env.NODE_ENV !== 'production') {
                    // Add verbose displayName to the function, which helps when looking
                    // at profiling tools.
                    if (typeof property === 'function' && spec.displayName) {
                      proto[name].displayName = spec.displayName + '_' + name;
                    }
                  }
                }
              }
            }
          }
        }
        function mixStaticSpecIntoComponent(Constructor, statics) {
          if (!statics) {
            return;
          }
          for (var name in statics) {
            var property = statics[name];
            if (!statics.hasOwnProperty(name)) {
              continue;
            }
            var isReserved = name in RESERVED_SPEC_KEYS;
            _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);
            var isAlreadyDefined = name in Constructor;
            if (isAlreadyDefined) {
              var specPolicy = ReactClassStaticInterface.hasOwnProperty(name) ? ReactClassStaticInterface[name] : null;
              _invariant(specPolicy === 'DEFINE_MANY_MERGED', 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
              Constructor[name] = createMergedResultFunction(Constructor[name], property);
              return;
            }
            Constructor[name] = property;
          }
        }

        /**
         * Merge two objects, but throw if both contain the same key.
         *
         * @param {object} one The first object, which is mutated.
         * @param {object} two The second object
         * @return {object} one after it has been mutated to contain everything in two.
         */
        function mergeIntoWithNoDuplicateKeys(one, two) {
          _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');
          for (var key in two) {
            if (two.hasOwnProperty(key)) {
              _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
              one[key] = two[key];
            }
          }
          return one;
        }

        /**
         * Creates a function that invokes two functions and merges their return values.
         *
         * @param {function} one Function to invoke first.
         * @param {function} two Function to invoke second.
         * @return {function} Function that invokes the two argument functions.
         * @private
         */
        function createMergedResultFunction(one, two) {
          return function mergedResult() {
            var a = one.apply(this, arguments);
            var b = two.apply(this, arguments);
            if (a == null) {
              return b;
            } else if (b == null) {
              return a;
            }
            var c = {};
            mergeIntoWithNoDuplicateKeys(c, a);
            mergeIntoWithNoDuplicateKeys(c, b);
            return c;
          };
        }

        /**
         * Creates a function that invokes two functions and ignores their return vales.
         *
         * @param {function} one Function to invoke first.
         * @param {function} two Function to invoke second.
         * @return {function} Function that invokes the two argument functions.
         * @private
         */
        function createChainedFunction(one, two) {
          return function chainedFunction() {
            one.apply(this, arguments);
            two.apply(this, arguments);
          };
        }

        /**
         * Binds a method to the component.
         *
         * @param {object} component Component whose method is going to be bound.
         * @param {function} method Method to be bound.
         * @return {function} The bound method.
         */
        function bindAutoBindMethod(component, method) {
          var boundMethod = method.bind(component);
          if (process.env.NODE_ENV !== 'production') {
            boundMethod.__reactBoundContext = component;
            boundMethod.__reactBoundMethod = method;
            boundMethod.__reactBoundArguments = null;
            var componentName = component.constructor.displayName;
            var _bind = boundMethod.bind;
            boundMethod.bind = function (newThis) {
              for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
              }

              // User is trying to bind() an autobound method; we effectively will
              // ignore the value of "this" that the user is trying to use, so
              // let's warn.
              if (newThis !== component && newThis !== null) {
                if (process.env.NODE_ENV !== 'production') {
                  warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName);
                }
              } else if (!args.length) {
                if (process.env.NODE_ENV !== 'production') {
                  warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName);
                }
                return boundMethod;
              }
              var reboundMethod = _bind.apply(boundMethod, arguments);
              reboundMethod.__reactBoundContext = component;
              reboundMethod.__reactBoundMethod = method;
              reboundMethod.__reactBoundArguments = args;
              return reboundMethod;
            };
          }
          return boundMethod;
        }

        /**
         * Binds all auto-bound methods in a component.
         *
         * @param {object} component Component whose method is going to be bound.
         */
        function bindAutoBindMethods(component) {
          var pairs = component.__reactAutoBindPairs;
          for (var i = 0; i < pairs.length; i += 2) {
            var autoBindKey = pairs[i];
            var method = pairs[i + 1];
            component[autoBindKey] = bindAutoBindMethod(component, method);
          }
        }
        var IsMountedPreMixin = {
          componentDidMount: function () {
            this.__isMounted = true;
          }
        };
        var IsMountedPostMixin = {
          componentWillUnmount: function () {
            this.__isMounted = false;
          }
        };

        /**
         * Add more to the ReactClass base class. These are all legacy features and
         * therefore not already part of the modern ReactComponent.
         */
        var ReactClassMixin = {
          /**
           * TODO: This will be deprecated because state should always keep a consistent
           * type signature and the only use case for this, is to avoid that.
           */
          replaceState: function (newState, callback) {
            this.updater.enqueueReplaceState(this, newState, callback);
          },
          /**
           * Checks whether or not this composite component is mounted.
           * @return {boolean} True if mounted, false otherwise.
           * @protected
           * @final
           */
          isMounted: function () {
            if (process.env.NODE_ENV !== 'production') {
              warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component');
              this.__didWarnIsMounted = true;
            }
            return !!this.__isMounted;
          }
        };
        var ReactClassComponent = function () {};
        _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

        /**
         * Creates a composite component class given a class specification.
         * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
         *
         * @param {object} spec Class specification (which must define `render`).
         * @return {function} Component constructor function.
         * @public
         */
        function createClass(spec) {
          // To keep our warnings more understandable, we'll use a little hack here to
          // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
          // unnecessarily identify a class without displayName as 'Constructor'.
          var Constructor = identity(function (props, context, updater) {
            // This constructor gets overridden by mocks. The argument is used
            // by mocks to assert on what gets mounted.

            if (process.env.NODE_ENV !== 'production') {
              warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory');
            }

            // Wire up auto-binding
            if (this.__reactAutoBindPairs.length) {
              bindAutoBindMethods(this);
            }
            this.props = props;
            this.context = context;
            this.refs = emptyObject;
            this.updater = updater || ReactNoopUpdateQueue;
            this.state = null;

            // ReactClasses doesn't have constructors. Instead, they use the
            // getInitialState and componentWillMount methods for initialization.

            var initialState = this.getInitialState ? this.getInitialState() : null;
            if (process.env.NODE_ENV !== 'production') {
              // We allow auto-mocks to proceed as if they're returning null.
              if (initialState === undefined && this.getInitialState._isMockFunction) {
                // This is probably bad practice. Consider warning here and
                // deprecating this convenience.
                initialState = null;
              }
            }
            _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');
            this.state = initialState;
          });
          Constructor.prototype = new ReactClassComponent();
          Constructor.prototype.constructor = Constructor;
          Constructor.prototype.__reactAutoBindPairs = [];
          injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
          mixSpecIntoComponent(Constructor, IsMountedPreMixin);
          mixSpecIntoComponent(Constructor, spec);
          mixSpecIntoComponent(Constructor, IsMountedPostMixin);

          // Initialize the defaultProps property after all mixins have been merged.
          if (Constructor.getDefaultProps) {
            Constructor.defaultProps = Constructor.getDefaultProps();
          }
          if (process.env.NODE_ENV !== 'production') {
            // This is a tag to indicate that the use of these method names is ok,
            // since it's used with createClass. If it's not, then it's likely a
            // mistake so we'll warn you to use the static property, property
            // initializer or constructor respectively.
            if (Constructor.getDefaultProps) {
              Constructor.getDefaultProps.isReactClassApproved = {};
            }
            if (Constructor.prototype.getInitialState) {
              Constructor.prototype.getInitialState.isReactClassApproved = {};
            }
          }
          _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');
          if (process.env.NODE_ENV !== 'production') {
            warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component');
            warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component');
            warning(!Constructor.prototype.UNSAFE_componentWillRecieveProps, '%s has a method called UNSAFE_componentWillRecieveProps(). ' + 'Did you mean UNSAFE_componentWillReceiveProps()?', spec.displayName || 'A component');
          }

          // Reduce time spent doing lookups by setting these on the prototype.
          for (var methodName in ReactClassInterface) {
            if (!Constructor.prototype[methodName]) {
              Constructor.prototype[methodName] = null;
            }
          }
          return Constructor;
        }
        return createClass;
      }
      module.exports = factory;

      /* WEBPACK VAR INJECTION */
    }).call(exports, __nested_webpack_require_19372__(4));

    /***/
  }), (/* 4 */
  /***/function (module, exports) {
    // shim for using process in browser
    var process = module.exports = {};

    // cached from whatever global is present so that test runners that stub it
    // don't break things.  But we need to wrap it in a try catch in case it is
    // wrapped in strict mode code which doesn't define any globals.  It's inside a
    // function because try/catches deoptimize in certain engines.

    var cachedSetTimeout;
    var cachedClearTimeout;
    function defaultSetTimout() {
      throw new Error('setTimeout has not been defined');
    }
    function defaultClearTimeout() {
      throw new Error('clearTimeout has not been defined');
    }
    (function () {
      try {
        if (typeof setTimeout === 'function') {
          cachedSetTimeout = setTimeout;
        } else {
          cachedSetTimeout = defaultSetTimout;
        }
      } catch (e) {
        cachedSetTimeout = defaultSetTimout;
      }
      try {
        if (typeof clearTimeout === 'function') {
          cachedClearTimeout = clearTimeout;
        } else {
          cachedClearTimeout = defaultClearTimeout;
        }
      } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
      }
    })();
    function runTimeout(fun) {
      if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
      }
      // if setTimeout wasn't available but was latter defined
      if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
      }
      try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
      } catch (e) {
        try {
          // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
          return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
          // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
          return cachedSetTimeout.call(this, fun, 0);
        }
      }
    }
    function runClearTimeout(marker) {
      if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
      }
      // if clearTimeout wasn't available but was latter defined
      if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
      }
      try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
      } catch (e) {
        try {
          // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
          return cachedClearTimeout.call(null, marker);
        } catch (e) {
          // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
          // Some versions of I.E. have different rules for clearTimeout vs setTimeout
          return cachedClearTimeout.call(this, marker);
        }
      }
    }
    var queue = [];
    var draining = false;
    var currentQueue;
    var queueIndex = -1;
    function cleanUpNextTick() {
      if (!draining || !currentQueue) {
        return;
      }
      draining = false;
      if (currentQueue.length) {
        queue = currentQueue.concat(queue);
      } else {
        queueIndex = -1;
      }
      if (queue.length) {
        drainQueue();
      }
    }
    function drainQueue() {
      if (draining) {
        return;
      }
      var timeout = runTimeout(cleanUpNextTick);
      draining = true;
      var len = queue.length;
      while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
          if (currentQueue) {
            currentQueue[queueIndex].run();
          }
        }
        queueIndex = -1;
        len = queue.length;
      }
      currentQueue = null;
      draining = false;
      runClearTimeout(timeout);
    }
    process.nextTick = function (fun) {
      var args = new Array(arguments.length - 1);
      if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
          args[i - 1] = arguments[i];
        }
      }
      queue.push(new Item(fun, args));
      if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
      }
    };

    // v8 likes predictible objects
    function Item(fun, array) {
      this.fun = fun;
      this.array = array;
    }
    Item.prototype.run = function () {
      this.fun.apply(null, this.array);
    };
    process.title = 'browser';
    process.browser = true;
    process.env = {};
    process.argv = [];
    process.version = ''; // empty string to avoid regexp issues
    process.versions = {};
    function noop() {}
    process.on = noop;
    process.addListener = noop;
    process.once = noop;
    process.off = noop;
    process.removeListener = noop;
    process.removeAllListeners = noop;
    process.emit = noop;
    process.prependListener = noop;
    process.prependOnceListener = noop;
    process.listeners = function (name) {
      return [];
    };
    process.binding = function (name) {
      throw new Error('process.binding is not supported');
    };
    process.cwd = function () {
      return '/';
    };
    process.chdir = function (dir) {
      throw new Error('process.chdir is not supported');
    };
    process.umask = function () {
      return 0;
    };

    /***/
  }), (/* 5 */
  /***/function (module, exports) {
    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */

    'use strict';

    /* eslint-disable no-unused-vars */
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === undefined) {
        throw new TypeError('Object.assign cannot be called with null or undefined');
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }

        // Detect buggy property enumeration order in older V8 versions.

        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') {
          return false;
        }

        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for (var i = 0; i < 10; i++) {
          test2['_' + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
          return test2[n];
        });
        if (order2.join('') !== '0123456789') {
          return false;
        }

        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
          return false;
        }
        return true;
      } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function (target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
          if (hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i = 0; i < symbols.length; i++) {
            if (propIsEnumerable.call(from, symbols[i])) {
              to[symbols[i]] = from[symbols[i]];
            }
          }
        }
      }
      return to;
    };

    /***/
  }), (/* 6 */
  /***/function (module, exports, __nested_webpack_require_60403__) {
    /* WEBPACK VAR INJECTION */(function (process) {
      /**
      * Copyright (c) 2013-present, Facebook, Inc.
      *
      * This source code is licensed under the MIT license found in the
      * LICENSE file in the root directory of this source tree.
      *
      */

      'use strict';

      var emptyObject = {};
      if (process.env.NODE_ENV !== 'production') {
        Object.freeze(emptyObject);
      }
      module.exports = emptyObject;
      /* WEBPACK VAR INJECTION */
    }).call(exports, __nested_webpack_require_60403__(4));

    /***/
  }), (/* 7 */
  /***/function (module, exports, __nested_webpack_require_61022__) {
    /* WEBPACK VAR INJECTION */(function (process) {
      /**
      * Copyright (c) 2013-present, Facebook, Inc.
      *
      * This source code is licensed under the MIT license found in the
      * LICENSE file in the root directory of this source tree.
      *
      */

      'use strict';

      /**
       * Use invariant() to assert state which your program assumes to be true.
       *
       * Provide sprintf-style format (only %s is supported) and arguments
       * to provide information about what broke and what you were
       * expecting.
       *
       * The invariant message will be stripped in production, but the invariant
       * will remain to ensure logic does not differ in production.
       */
      var validateFormat = function validateFormat(format) {};
      if (process.env.NODE_ENV !== 'production') {
        validateFormat = function validateFormat(format) {
          if (format === undefined) {
            throw new Error('invariant requires an error message argument');
          }
        };
      }
      function invariant(condition, format, a, b, c, d, e, f) {
        validateFormat(format);
        if (!condition) {
          var error;
          if (format === undefined) {
            error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
          } else {
            var args = [a, b, c, d, e, f];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function () {
              return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
          }
          error.framesToPop = 1; // we don't care about invariant's own frame
          throw error;
        }
      }
      module.exports = invariant;
      /* WEBPACK VAR INJECTION */
    }).call(exports, __nested_webpack_require_61022__(4));

    /***/
  }), (/* 8 */
  /***/function (module, exports, __nested_webpack_require_63003__) {
    /* WEBPACK VAR INJECTION */(function (process) {
      /**
      * Copyright (c) 2014-present, Facebook, Inc.
      *
      * This source code is licensed under the MIT license found in the
      * LICENSE file in the root directory of this source tree.
      *
      */

      'use strict';

      var emptyFunction = __nested_webpack_require_63003__(9);

      /**
       * Similar to invariant but only logs a warning if the condition is not met.
       * This can be used to log issues in development environments in critical
       * paths. Removing the logging code for production environments will keep the
       * same logic and follow the same code paths.
       */

      var warning = emptyFunction;
      if (process.env.NODE_ENV !== 'production') {
        var printWarning = function printWarning(format) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          var argIndex = 0;
          var message = 'Warning: ' + format.replace(/%s/g, function () {
            return args[argIndex++];
          });
          if (typeof console !== 'undefined') {
            console.error(message);
          }
          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
          } catch (x) {}
        };
        warning = function warning(condition, format) {
          if (format === undefined) {
            throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
          }
          if (format.indexOf('Failed Composite propType: ') === 0) {
            return; // Ignore CompositeComponent proptype check.
          }
          if (!condition) {
            for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
              args[_key2 - 2] = arguments[_key2];
            }
            printWarning.apply(undefined, [format].concat(args));
          }
        };
      }
      module.exports = warning;
      /* WEBPACK VAR INJECTION */
    }).call(exports, __nested_webpack_require_63003__(4));

    /***/
  }), (/* 9 */
  /***/function (module, exports) {
    "use strict";

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     *
     * 
     */
    function makeEmptyFunction(arg) {
      return function () {
        return arg;
      };
    }

    /**
     * This function accepts and discards inputs; it has no side effects. This is
     * primarily useful idiomatically for overridable function endpoints which
     * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
     */
    var emptyFunction = function emptyFunction() {};
    emptyFunction.thatReturns = makeEmptyFunction;
    emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
    emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
    emptyFunction.thatReturnsNull = makeEmptyFunction(null);
    emptyFunction.thatReturnsThis = function () {
      return this;
    };
    emptyFunction.thatReturnsArgument = function (arg) {
      return arg;
    };
    module.exports = emptyFunction;

    /***/
  }), (/* 10 */
  /***/function (module, exports) {
    'use strict';

    var NumeralFormatter = function NumeralFormatter(numeralDecimalMark, numeralIntegerScale, numeralDecimalScale, numeralThousandsGroupStyle, numeralPositiveOnly, stripLeadingZeroes, prefix, signBeforePrefix, tailPrefix, delimiter) {
      var owner = this;
      owner.numeralDecimalMark = numeralDecimalMark || '.';
      owner.numeralIntegerScale = numeralIntegerScale > 0 ? numeralIntegerScale : 0;
      owner.numeralDecimalScale = numeralDecimalScale >= 0 ? numeralDecimalScale : 2;
      owner.numeralThousandsGroupStyle = numeralThousandsGroupStyle || NumeralFormatter.groupStyle.thousand;
      owner.numeralPositiveOnly = !!numeralPositiveOnly;
      owner.stripLeadingZeroes = stripLeadingZeroes !== false;
      owner.prefix = prefix || prefix === '' ? prefix : '';
      owner.signBeforePrefix = !!signBeforePrefix;
      owner.tailPrefix = !!tailPrefix;
      owner.delimiter = delimiter || delimiter === '' ? delimiter : ',';
      owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';
    };
    NumeralFormatter.groupStyle = {
      thousand: 'thousand',
      lakh: 'lakh',
      wan: 'wan',
      none: 'none'
    };
    NumeralFormatter.prototype = {
      getRawValue: function getRawValue(value) {
        return value.replace(this.delimiterRE, '').replace(this.numeralDecimalMark, '.');
      },
      format: function format(value) {
        var owner = this,
          parts,
          partSign,
          partSignAndPrefix,
          partInteger,
          partDecimal = '';

        // strip alphabet letters
        value = value.replace(/[A-Za-z]/g, '')
        // replace the first decimal mark with reserved placeholder
        .replace(owner.numeralDecimalMark, 'M')

        // strip non numeric letters except minus and "M"
        // this is to ensure prefix has been stripped
        .replace(/[^\dM-]/g, '')

        // replace the leading minus with reserved placeholder
        .replace(/^\-/, 'N')

        // strip the other minus sign (if present)
        .replace(/\-/g, '')

        // replace the minus sign (if present)
        .replace('N', owner.numeralPositiveOnly ? '' : '-')

        // replace decimal mark
        .replace('M', owner.numeralDecimalMark);

        // strip any leading zeros
        if (owner.stripLeadingZeroes) {
          value = value.replace(/^(-)?0+(?=\d)/, '$1');
        }
        partSign = value.slice(0, 1) === '-' ? '-' : '';
        if (typeof owner.prefix != 'undefined') {
          if (owner.signBeforePrefix) {
            partSignAndPrefix = partSign + owner.prefix;
          } else {
            partSignAndPrefix = owner.prefix + partSign;
          }
        } else {
          partSignAndPrefix = partSign;
        }
        partInteger = value;
        if (value.indexOf(owner.numeralDecimalMark) >= 0) {
          parts = value.split(owner.numeralDecimalMark);
          partInteger = parts[0];
          partDecimal = owner.numeralDecimalMark + parts[1].slice(0, owner.numeralDecimalScale);
        }
        if (partSign === '-') {
          partInteger = partInteger.slice(1);
        }
        if (owner.numeralIntegerScale > 0) {
          partInteger = partInteger.slice(0, owner.numeralIntegerScale);
        }
        switch (owner.numeralThousandsGroupStyle) {
          case NumeralFormatter.groupStyle.lakh:
            partInteger = partInteger.replace(/(\d)(?=(\d\d)+\d$)/g, '$1' + owner.delimiter);
            break;
          case NumeralFormatter.groupStyle.wan:
            partInteger = partInteger.replace(/(\d)(?=(\d{4})+$)/g, '$1' + owner.delimiter);
            break;
          case NumeralFormatter.groupStyle.thousand:
            partInteger = partInteger.replace(/(\d)(?=(\d{3})+$)/g, '$1' + owner.delimiter);
            break;
        }
        if (owner.tailPrefix) {
          return partSign + partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : '') + owner.prefix;
        }
        return partSignAndPrefix + partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : '');
      }
    };
    module.exports = NumeralFormatter;

    /***/
  }), (/* 11 */
  /***/function (module, exports) {
    'use strict';

    var DateFormatter = function DateFormatter(datePattern, dateMin, dateMax) {
      var owner = this;
      owner.date = [];
      owner.blocks = [];
      owner.datePattern = datePattern;
      owner.dateMin = dateMin.split('-').reverse().map(function (x) {
        return parseInt(x, 10);
      });
      if (owner.dateMin.length === 2) owner.dateMin.unshift(0);
      owner.dateMax = dateMax.split('-').reverse().map(function (x) {
        return parseInt(x, 10);
      });
      if (owner.dateMax.length === 2) owner.dateMax.unshift(0);
      owner.initBlocks();
    };
    DateFormatter.prototype = {
      initBlocks: function initBlocks() {
        var owner = this;
        owner.datePattern.forEach(function (value) {
          if (value === 'Y') {
            owner.blocks.push(4);
          } else {
            owner.blocks.push(2);
          }
        });
      },
      getISOFormatDate: function getISOFormatDate() {
        var owner = this,
          date = owner.date;
        return date[2] ? date[2] + '-' + owner.addLeadingZero(date[1]) + '-' + owner.addLeadingZero(date[0]) : '';
      },
      getBlocks: function getBlocks() {
        return this.blocks;
      },
      getValidatedDate: function getValidatedDate(value) {
        var owner = this,
          result = '';
        value = value.replace(/[^\d]/g, '');
        owner.blocks.forEach(function (length, index) {
          if (value.length > 0) {
            var sub = value.slice(0, length),
              sub0 = sub.slice(0, 1),
              rest = value.slice(length);
            switch (owner.datePattern[index]) {
              case 'd':
                if (sub === '00') {
                  sub = '01';
                } else if (parseInt(sub0, 10) > 3) {
                  sub = '0' + sub0;
                } else if (parseInt(sub, 10) > 31) {
                  sub = '31';
                }
                break;
              case 'm':
                if (sub === '00') {
                  sub = '01';
                } else if (parseInt(sub0, 10) > 1) {
                  sub = '0' + sub0;
                } else if (parseInt(sub, 10) > 12) {
                  sub = '12';
                }
                break;
            }
            result += sub;

            // update remaining string
            value = rest;
          }
        });
        return this.getFixedDateString(result);
      },
      getFixedDateString: function getFixedDateString(value) {
        var owner = this,
          datePattern = owner.datePattern,
          date = [],
          dayIndex = 0,
          monthIndex = 0,
          yearIndex = 0,
          dayStartIndex = 0,
          monthStartIndex = 0,
          yearStartIndex = 0,
          day,
          month,
          year,
          fullYearDone = false;

        // mm-dd || dd-mm
        if (value.length === 4 && datePattern[0].toLowerCase() !== 'y' && datePattern[1].toLowerCase() !== 'y') {
          dayStartIndex = datePattern[0] === 'd' ? 0 : 2;
          monthStartIndex = 2 - dayStartIndex;
          day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
          month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
          date = this.getFixedDate(day, month, 0);
        }

        // yyyy-mm-dd || yyyy-dd-mm || mm-dd-yyyy || dd-mm-yyyy || dd-yyyy-mm || mm-yyyy-dd
        if (value.length === 8) {
          datePattern.forEach(function (type, index) {
            switch (type) {
              case 'd':
                dayIndex = index;
                break;
              case 'm':
                monthIndex = index;
                break;
              default:
                yearIndex = index;
                break;
            }
          });
          yearStartIndex = yearIndex * 2;
          dayStartIndex = dayIndex <= yearIndex ? dayIndex * 2 : dayIndex * 2 + 2;
          monthStartIndex = monthIndex <= yearIndex ? monthIndex * 2 : monthIndex * 2 + 2;
          day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
          month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
          year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);
          fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;
          date = this.getFixedDate(day, month, year);
        }

        // mm-yy || yy-mm
        if (value.length === 4 && (datePattern[0] === 'y' || datePattern[1] === 'y')) {
          monthStartIndex = datePattern[0] === 'm' ? 0 : 2;
          yearStartIndex = 2 - monthStartIndex;
          month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
          year = parseInt(value.slice(yearStartIndex, yearStartIndex + 2), 10);
          fullYearDone = value.slice(yearStartIndex, yearStartIndex + 2).length === 2;
          date = [0, month, year];
        }

        // mm-yyyy || yyyy-mm
        if (value.length === 6 && (datePattern[0] === 'Y' || datePattern[1] === 'Y')) {
          monthStartIndex = datePattern[0] === 'm' ? 0 : 4;
          yearStartIndex = 2 - 0.5 * monthStartIndex;
          month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
          year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);
          fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;
          date = [0, month, year];
        }
        date = owner.getRangeFixedDate(date);
        owner.date = date;
        var result = date.length === 0 ? value : datePattern.reduce(function (previous, current) {
          switch (current) {
            case 'd':
              return previous + (date[0] === 0 ? '' : owner.addLeadingZero(date[0]));
            case 'm':
              return previous + (date[1] === 0 ? '' : owner.addLeadingZero(date[1]));
            case 'y':
              return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], false) : '');
            case 'Y':
              return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], true) : '');
          }
        }, '');
        return result;
      },
      getRangeFixedDate: function getRangeFixedDate(date) {
        var owner = this,
          datePattern = owner.datePattern,
          dateMin = owner.dateMin || [],
          dateMax = owner.dateMax || [];
        if (!date.length || dateMin.length < 3 && dateMax.length < 3) return date;
        if (datePattern.find(function (x) {
          return x.toLowerCase() === 'y';
        }) && date[2] === 0) return date;
        if (dateMax.length && (dateMax[2] < date[2] || dateMax[2] === date[2] && (dateMax[1] < date[1] || dateMax[1] === date[1] && dateMax[0] < date[0]))) return dateMax;
        if (dateMin.length && (dateMin[2] > date[2] || dateMin[2] === date[2] && (dateMin[1] > date[1] || dateMin[1] === date[1] && dateMin[0] > date[0]))) return dateMin;
        return date;
      },
      getFixedDate: function getFixedDate(day, month, year) {
        day = Math.min(day, 31);
        month = Math.min(month, 12);
        year = parseInt(year || 0, 10);
        if (month < 7 && month % 2 === 0 || month > 8 && month % 2 === 1) {
          day = Math.min(day, month === 2 ? this.isLeapYear(year) ? 29 : 28 : 30);
        }
        return [day, month, year];
      },
      isLeapYear: function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
      },
      addLeadingZero: function addLeadingZero(number) {
        return (number < 10 ? '0' : '') + number;
      },
      addLeadingZeroForYear: function addLeadingZeroForYear(number, fullYearMode) {
        if (fullYearMode) {
          return (number < 10 ? '000' : number < 100 ? '00' : number < 1000 ? '0' : '') + number;
        }
        return (number < 10 ? '0' : '') + number;
      }
    };
    module.exports = DateFormatter;

    /***/
  }), (/* 12 */
  /***/function (module, exports) {
    'use strict';

    var TimeFormatter = function TimeFormatter(timePattern, timeFormat) {
      var owner = this;
      owner.time = [];
      owner.blocks = [];
      owner.timePattern = timePattern;
      owner.timeFormat = timeFormat;
      owner.initBlocks();
    };
    TimeFormatter.prototype = {
      initBlocks: function initBlocks() {
        var owner = this;
        owner.timePattern.forEach(function () {
          owner.blocks.push(2);
        });
      },
      getISOFormatTime: function getISOFormatTime() {
        var owner = this,
          time = owner.time;
        return time[2] ? owner.addLeadingZero(time[0]) + ':' + owner.addLeadingZero(time[1]) + ':' + owner.addLeadingZero(time[2]) : '';
      },
      getBlocks: function getBlocks() {
        return this.blocks;
      },
      getTimeFormatOptions: function getTimeFormatOptions() {
        var owner = this;
        if (String(owner.timeFormat) === '12') {
          return {
            maxHourFirstDigit: 1,
            maxHours: 12,
            maxMinutesFirstDigit: 5,
            maxMinutes: 60
          };
        }
        return {
          maxHourFirstDigit: 2,
          maxHours: 23,
          maxMinutesFirstDigit: 5,
          maxMinutes: 60
        };
      },
      getValidatedTime: function getValidatedTime(value) {
        var owner = this,
          result = '';
        value = value.replace(/[^\d]/g, '');
        var timeFormatOptions = owner.getTimeFormatOptions();
        owner.blocks.forEach(function (length, index) {
          if (value.length > 0) {
            var sub = value.slice(0, length),
              sub0 = sub.slice(0, 1),
              rest = value.slice(length);
            switch (owner.timePattern[index]) {
              case 'h':
                if (parseInt(sub0, 10) > timeFormatOptions.maxHourFirstDigit) {
                  sub = '0' + sub0;
                } else if (parseInt(sub, 10) > timeFormatOptions.maxHours) {
                  sub = timeFormatOptions.maxHours + '';
                }
                break;
              case 'm':
              case 's':
                if (parseInt(sub0, 10) > timeFormatOptions.maxMinutesFirstDigit) {
                  sub = '0' + sub0;
                } else if (parseInt(sub, 10) > timeFormatOptions.maxMinutes) {
                  sub = timeFormatOptions.maxMinutes + '';
                }
                break;
            }
            result += sub;

            // update remaining string
            value = rest;
          }
        });
        return this.getFixedTimeString(result);
      },
      getFixedTimeString: function getFixedTimeString(value) {
        var owner = this,
          timePattern = owner.timePattern,
          time = [],
          secondIndex = 0,
          minuteIndex = 0,
          hourIndex = 0,
          secondStartIndex = 0,
          minuteStartIndex = 0,
          hourStartIndex = 0,
          second,
          minute,
          hour;
        if (value.length === 6) {
          timePattern.forEach(function (type, index) {
            switch (type) {
              case 's':
                secondIndex = index * 2;
                break;
              case 'm':
                minuteIndex = index * 2;
                break;
              case 'h':
                hourIndex = index * 2;
                break;
            }
          });
          hourStartIndex = hourIndex;
          minuteStartIndex = minuteIndex;
          secondStartIndex = secondIndex;
          second = parseInt(value.slice(secondStartIndex, secondStartIndex + 2), 10);
          minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
          hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);
          time = this.getFixedTime(hour, minute, second);
        }
        if (value.length === 4 && owner.timePattern.indexOf('s') < 0) {
          timePattern.forEach(function (type, index) {
            switch (type) {
              case 'm':
                minuteIndex = index * 2;
                break;
              case 'h':
                hourIndex = index * 2;
                break;
            }
          });
          hourStartIndex = hourIndex;
          minuteStartIndex = minuteIndex;
          second = 0;
          minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
          hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);
          time = this.getFixedTime(hour, minute, second);
        }
        owner.time = time;
        return time.length === 0 ? value : timePattern.reduce(function (previous, current) {
          switch (current) {
            case 's':
              return previous + owner.addLeadingZero(time[2]);
            case 'm':
              return previous + owner.addLeadingZero(time[1]);
            case 'h':
              return previous + owner.addLeadingZero(time[0]);
          }
        }, '');
      },
      getFixedTime: function getFixedTime(hour, minute, second) {
        second = Math.min(parseInt(second || 0, 10), 60);
        minute = Math.min(minute, 60);
        hour = Math.min(hour, 60);
        return [hour, minute, second];
      },
      addLeadingZero: function addLeadingZero(number) {
        return (number < 10 ? '0' : '') + number;
      }
    };
    module.exports = TimeFormatter;

    /***/
  }), (/* 13 */
  /***/function (module, exports) {
    'use strict';

    var PhoneFormatter = function PhoneFormatter(formatter, delimiter) {
      var owner = this;
      owner.delimiter = delimiter || delimiter === '' ? delimiter : ' ';
      owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';
      owner.formatter = formatter;
    };
    PhoneFormatter.prototype = {
      setFormatter: function setFormatter(formatter) {
        this.formatter = formatter;
      },
      format: function format(phoneNumber) {
        var owner = this;
        owner.formatter.clear();

        // only keep number and +
        phoneNumber = phoneNumber.replace(/[^\d+]/g, '');

        // strip non-leading +
        phoneNumber = phoneNumber.replace(/^\+/, 'B').replace(/\+/g, '').replace('B', '+');

        // strip delimiter
        phoneNumber = phoneNumber.replace(owner.delimiterRE, '');
        var result = '',
          current,
          validated = false;
        for (var i = 0, iMax = phoneNumber.length; i < iMax; i++) {
          current = owner.formatter.inputDigit(phoneNumber.charAt(i));

          // has ()- or space inside
          if (/[\s()-]/g.test(current)) {
            result = current;
            validated = true;
          } else {
            if (!validated) {
              result = current;
            }
            // else: over length input
            // it turns to invalid number again
          }
        }

        // strip ()
        // e.g. US: 7161234567 returns (716) 123-4567
        result = result.replace(/[()]/g, '');
        // replace library delimiter with user customized delimiter
        result = result.replace(/[\s-]/g, owner.delimiter);
        return result;
      }
    };
    module.exports = PhoneFormatter;

    /***/
  }), (/* 14 */
  /***/function (module, exports) {
    'use strict';

    var CreditCardDetector = {
      blocks: {
        uatp: [4, 5, 6],
        amex: [4, 6, 5],
        diners: [4, 6, 4],
        discover: [4, 4, 4, 4],
        mastercard: [4, 4, 4, 4],
        dankort: [4, 4, 4, 4],
        instapayment: [4, 4, 4, 4],
        jcb15: [4, 6, 5],
        jcb: [4, 4, 4, 4],
        maestro: [4, 4, 4, 4],
        visa: [4, 4, 4, 4],
        mir: [4, 4, 4, 4],
        unionPay: [4, 4, 4, 4],
        general: [4, 4, 4, 4]
      },
      re: {
        // starts with 1; 15 digits, not starts with 1800 (jcb card)
        uatp: /^(?!1800)1\d{0,14}/,
        // starts with 34/37; 15 digits
        amex: /^3[47]\d{0,13}/,
        // starts with 6011/65/644-649; 16 digits
        discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/,
        // starts with 300-305/309 or 36/38/39; 14 digits
        diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,
        // starts with 51-55/2221–2720; 16 digits
        mastercard: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,
        // starts with 5019/4175/4571; 16 digits
        dankort: /^(5019|4175|4571)\d{0,12}/,
        // starts with 637-639; 16 digits
        instapayment: /^63[7-9]\d{0,13}/,
        // starts with 2131/1800; 15 digits
        jcb15: /^(?:2131|1800)\d{0,11}/,
        // starts with 2131/1800/35; 16 digits
        jcb: /^(?:35\d{0,2})\d{0,12}/,
        // starts with 50/56-58/6304/67; 16 digits
        maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,
        // starts with 22; 16 digits
        mir: /^220[0-4]\d{0,12}/,
        // starts with 4; 16 digits
        visa: /^4\d{0,15}/,
        // starts with 62/81; 16 digits
        unionPay: /^(62|81)\d{0,14}/
      },
      getStrictBlocks: function getStrictBlocks(block) {
        var total = block.reduce(function (prev, current) {
          return prev + current;
        }, 0);
        return block.concat(19 - total);
      },
      getInfo: function getInfo(value, strictMode) {
        var blocks = CreditCardDetector.blocks,
          re = CreditCardDetector.re;

        // Some credit card can have up to 19 digits number.
        // Set strictMode to true will remove the 16 max-length restrain,
        // however, I never found any website validate card number like
        // this, hence probably you don't want to enable this option.
        strictMode = !!strictMode;
        for (var key in re) {
          if (re[key].test(value)) {
            var matchedBlocks = blocks[key];
            return {
              type: key,
              blocks: strictMode ? this.getStrictBlocks(matchedBlocks) : matchedBlocks
            };
          }
        }
        return {
          type: 'unknown',
          blocks: strictMode ? this.getStrictBlocks(blocks.general) : blocks.general
        };
      }
    };
    module.exports = CreditCardDetector;

    /***/
  }), (/* 15 */
  /***/function (module, exports) {
    'use strict';

    var Util = {
      noop: function noop() {},
      strip: function strip(value, re) {
        return value.replace(re, '');
      },
      getPostDelimiter: function getPostDelimiter(value, delimiter, delimiters) {
        // single delimiter
        if (delimiters.length === 0) {
          return value.slice(-delimiter.length) === delimiter ? delimiter : '';
        }

        // multiple delimiters
        var matchedDelimiter = '';
        delimiters.forEach(function (current) {
          if (value.slice(-current.length) === current) {
            matchedDelimiter = current;
          }
        });
        return matchedDelimiter;
      },
      getDelimiterREByDelimiter: function getDelimiterREByDelimiter(delimiter) {
        return new RegExp(delimiter.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'), 'g');
      },
      getNextCursorPosition: function getNextCursorPosition(prevPos, oldValue, newValue, delimiter, delimiters) {
        // If cursor was at the end of value, just place it back.
        // Because new value could contain additional chars.
        if (oldValue.length === prevPos) {
          return newValue.length;
        }
        return prevPos + this.getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters);
      },
      getPositionOffset: function getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters) {
        var oldRawValue, newRawValue, lengthOffset;
        oldRawValue = this.stripDelimiters(oldValue.slice(0, prevPos), delimiter, delimiters);
        newRawValue = this.stripDelimiters(newValue.slice(0, prevPos), delimiter, delimiters);
        lengthOffset = oldRawValue.length - newRawValue.length;
        return lengthOffset !== 0 ? lengthOffset / Math.abs(lengthOffset) : 0;
      },
      stripDelimiters: function stripDelimiters(value, delimiter, delimiters) {
        var owner = this;

        // single delimiter
        if (delimiters.length === 0) {
          var delimiterRE = delimiter ? owner.getDelimiterREByDelimiter(delimiter) : '';
          return value.replace(delimiterRE, '');
        }

        // multiple delimiters
        delimiters.forEach(function (current) {
          current.split('').forEach(function (letter) {
            value = value.replace(owner.getDelimiterREByDelimiter(letter), '');
          });
        });
        return value;
      },
      headStr: function headStr(str, length) {
        return str.slice(0, length);
      },
      getMaxLength: function getMaxLength(blocks) {
        return blocks.reduce(function (previous, current) {
          return previous + current;
        }, 0);
      },
      // strip prefix
      // Before type  |   After type    |     Return value
      // PEFIX-...    |   PEFIX-...     |     ''
      // PREFIX-123   |   PEFIX-123     |     123
      // PREFIX-123   |   PREFIX-23     |     23
      // PREFIX-123   |   PREFIX-1234   |     1234
      getPrefixStrippedValue: function getPrefixStrippedValue(value, prefix, prefixLength, prevResult, delimiter, delimiters, noImmediatePrefix, tailPrefix, signBeforePrefix) {
        // No prefix
        if (prefixLength === 0) {
          return value;
        }

        // Value is prefix
        if (value === prefix && value !== '') {
          return '';
        }
        if (signBeforePrefix && value.slice(0, 1) == '-') {
          var prev = prevResult.slice(0, 1) == '-' ? prevResult.slice(1) : prevResult;
          return '-' + this.getPrefixStrippedValue(value.slice(1), prefix, prefixLength, prev, delimiter, delimiters, noImmediatePrefix, tailPrefix, signBeforePrefix);
        }

        // Pre result prefix string does not match pre-defined prefix
        if (prevResult.slice(0, prefixLength) !== prefix && !tailPrefix) {
          // Check if the first time user entered something
          if (noImmediatePrefix && !prevResult && value) return value;
          return '';
        } else if (prevResult.slice(-prefixLength) !== prefix && tailPrefix) {
          // Check if the first time user entered something
          if (noImmediatePrefix && !prevResult && value) return value;
          return '';
        }
        var prevValue = this.stripDelimiters(prevResult, delimiter, delimiters);

        // New value has issue, someone typed in between prefix letters
        // Revert to pre value
        if (value.slice(0, prefixLength) !== prefix && !tailPrefix) {
          return prevValue.slice(prefixLength);
        } else if (value.slice(-prefixLength) !== prefix && tailPrefix) {
          return prevValue.slice(0, -prefixLength - 1);
        }

        // No issue, strip prefix for new value
        return tailPrefix ? value.slice(0, -prefixLength) : value.slice(prefixLength);
      },
      getFirstDiffIndex: function getFirstDiffIndex(prev, current) {
        var index = 0;
        while (prev.charAt(index) === current.charAt(index)) {
          if (prev.charAt(index++) === '') {
            return -1;
          }
        }
        return index;
      },
      getFormattedValue: function getFormattedValue(value, blocks, blocksLength, delimiter, delimiters, delimiterLazyShow) {
        var result = '',
          multipleDelimiters = delimiters.length > 0,
          currentDelimiter = '';

        // no options, normal input
        if (blocksLength === 0) {
          return value;
        }
        blocks.forEach(function (length, index) {
          if (value.length > 0) {
            var sub = value.slice(0, length),
              rest = value.slice(length);
            if (multipleDelimiters) {
              currentDelimiter = delimiters[delimiterLazyShow ? index - 1 : index] || currentDelimiter;
            } else {
              currentDelimiter = delimiter;
            }
            if (delimiterLazyShow) {
              if (index > 0) {
                result += currentDelimiter;
              }
              result += sub;
            } else {
              result += sub;
              if (sub.length === length && index < blocksLength - 1) {
                result += currentDelimiter;
              }
            }

            // update remaining string
            value = rest;
          }
        });
        return result;
      },
      // move cursor to the end
      // the first time user focuses on an input with prefix
      fixPrefixCursor: function fixPrefixCursor(el, prefix, delimiter, delimiters) {
        if (!el) {
          return;
        }
        var val = el.value,
          appendix = delimiter || delimiters[0] || ' ';
        if (!el.setSelectionRange || !prefix || prefix.length + appendix.length <= val.length) {
          return;
        }
        var len = val.length * 2;

        // set timeout to avoid blink
        setTimeout(function () {
          el.setSelectionRange(len, len);
        }, 1);
      },
      // Check if input field is fully selected
      checkFullSelection: function checkFullSelection(value) {
        try {
          var selection = window.getSelection() || document.getSelection() || {};
          return selection.toString().length === value.length;
        } catch (ex) {
          // Ignore
        }
        return false;
      },
      setSelection: function setSelection(element, position, doc) {
        if (element !== this.getActiveElement(doc)) {
          return;
        }

        // cursor is already in the end
        if (element && element.value.length <= position) {
          return;
        }
        if (element.createTextRange) {
          var range = element.createTextRange();
          range.move('character', position);
          range.select();
        } else {
          try {
            element.setSelectionRange(position, position);
          } catch (e) {
            // eslint-disable-next-line
            console.warn('The input element type does not support selection');
          }
        }
      },
      getActiveElement: function getActiveElement(parent) {
        var activeElement = parent.activeElement;
        if (activeElement && activeElement.shadowRoot) {
          return this.getActiveElement(activeElement.shadowRoot);
        }
        return activeElement;
      },
      isAndroid: function isAndroid() {
        return navigator && /android/i.test(navigator.userAgent);
      },
      // On Android chrome, the keyup and keydown events
      // always return key code 229 as a composition that
      // buffers the user’s keystrokes
      // see https://github.com/nosir/cleave.js/issues/147
      isAndroidBackspaceKeydown: function isAndroidBackspaceKeydown(lastInputValue, currentInputValue) {
        if (!this.isAndroid() || !lastInputValue || !currentInputValue) {
          return false;
        }
        return currentInputValue === lastInputValue.slice(0, -1);
      }
    };
    module.exports = Util;

    /***/
  }), (/* 16 */
  /***/function (module, exports) {
    /* WEBPACK VAR INJECTION */(function (global) {
      'use strict';

      /**
       * Props Assignment
       *
       * Separate this, so react module can share the usage
       */
      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
      var DefaultProperties = {
        // Maybe change to object-assign
        // for now just keep it as simple
        assign: function assign(target, opts) {
          target = target || {};
          opts = opts || {};

          // credit card
          target.creditCard = !!opts.creditCard;
          target.creditCardStrictMode = !!opts.creditCardStrictMode;
          target.creditCardType = '';
          target.onCreditCardTypeChanged = opts.onCreditCardTypeChanged || function () {};

          // phone
          target.phone = !!opts.phone;
          target.phoneRegionCode = opts.phoneRegionCode || 'AU';
          target.phoneFormatter = {};

          // time
          target.time = !!opts.time;
          target.timePattern = opts.timePattern || ['h', 'm', 's'];
          target.timeFormat = opts.timeFormat || '24';
          target.timeFormatter = {};

          // date
          target.date = !!opts.date;
          target.datePattern = opts.datePattern || ['d', 'm', 'Y'];
          target.dateMin = opts.dateMin || '';
          target.dateMax = opts.dateMax || '';
          target.dateFormatter = {};

          // numeral
          target.numeral = !!opts.numeral;
          target.numeralIntegerScale = opts.numeralIntegerScale > 0 ? opts.numeralIntegerScale : 0;
          target.numeralDecimalScale = opts.numeralDecimalScale >= 0 ? opts.numeralDecimalScale : 2;
          target.numeralDecimalMark = opts.numeralDecimalMark || '.';
          target.numeralThousandsGroupStyle = opts.numeralThousandsGroupStyle || 'thousand';
          target.numeralPositiveOnly = !!opts.numeralPositiveOnly;
          target.stripLeadingZeroes = opts.stripLeadingZeroes !== false;
          target.signBeforePrefix = !!opts.signBeforePrefix;
          target.tailPrefix = !!opts.tailPrefix;

          // others
          target.swapHiddenInput = !!opts.swapHiddenInput;
          target.numericOnly = target.creditCard || target.date || !!opts.numericOnly;
          target.uppercase = !!opts.uppercase;
          target.lowercase = !!opts.lowercase;
          target.prefix = target.creditCard || target.date ? '' : opts.prefix || '';
          target.noImmediatePrefix = !!opts.noImmediatePrefix;
          target.prefixLength = target.prefix.length;
          target.rawValueTrimPrefix = !!opts.rawValueTrimPrefix;
          target.copyDelimiter = !!opts.copyDelimiter;
          target.initValue = opts.initValue !== undefined && opts.initValue !== null ? opts.initValue.toString() : '';
          target.delimiter = opts.delimiter || opts.delimiter === '' ? opts.delimiter : opts.date ? '/' : opts.time ? ':' : opts.numeral ? ',' : opts.phone ? ' ' : ' ';
          target.delimiterLength = target.delimiter.length;
          target.delimiterLazyShow = !!opts.delimiterLazyShow;
          target.delimiters = opts.delimiters || [];
          target.blocks = opts.blocks || [];
          target.blocksLength = target.blocks.length;
          target.root = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global ? global : window;
          target.document = opts.document || target.root.document;
          target.maxLength = 0;
          target.backspace = false;
          target.result = '';
          target.onValueChanged = opts.onValueChanged || function () {};
          return target;
        }
      };
      module.exports = DefaultProperties;
      /* WEBPACK VAR INJECTION */
    }).call(exports, function () {
      return this;
    }());

    /***/
  }
  /******/)]);
});
;

/***/ }),

/***/ 8532:
/***/ ((module) => {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);
      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }
      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names

  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }
      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }
      list.push(item);
    }
  };
  return list;
};
function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];
  if (!cssMapping) {
    return content;
  }
  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }
  return [content].join('\n');
} // Adapted from convert-source-map (MIT)

function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ 3423:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var $defineProperty = __webpack_require__(5049);
var $SyntaxError = __webpack_require__(1226);
var $TypeError = __webpack_require__(1953);
var gopd = __webpack_require__(3581);

/** @type {import('.')} */
module.exports = function defineDataProperty(obj, property, value) {
  if (!obj || typeof obj !== 'object' && typeof obj !== 'function') {
    throw new $TypeError('`obj` must be an object or a function`');
  }
  if (typeof property !== 'string' && typeof property !== 'symbol') {
    throw new $TypeError('`property` must be a string or a symbol`');
  }
  if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
    throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
  }
  if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
    throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
  }
  if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
    throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
  }
  if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
    throw new $TypeError('`loose`, if provided, must be a boolean');
  }
  var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
  var nonWritable = arguments.length > 4 ? arguments[4] : null;
  var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
  var loose = arguments.length > 6 ? arguments[6] : false;

  /* @type {false | TypedPropertyDescriptor<unknown>} */
  var desc = !!gopd && gopd(obj, property);
  if ($defineProperty) {
    $defineProperty(obj, property, {
      configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
      enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
      value: value,
      writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
  } else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) {
    // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
  } else {
    throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
  }
};

/***/ }),

/***/ 8774:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(8772);
exports.__esModule = true;
exports["default"] = void 0;
var _inDOM = _interopRequireDefault(__webpack_require__(8647));
var on = function on() {};
if (_inDOM.default) {
  on = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}
var _default = on;
exports["default"] = _default;
module.exports = exports["default"];

/***/ }),

/***/ 3152:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(8772);
__webpack_unused_export__ = true;
__webpack_unused_export__ = exports.My = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
var _inDOM = _interopRequireDefault(__webpack_require__(8647));
var transform = 'transform';
__webpack_unused_export__ = transform;
var prefix, transitionEnd, animationEnd;
exports.My = animationEnd;
__webpack_unused_export__ = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
__webpack_unused_export__ = transitionDelay;
__webpack_unused_export__ = transitionTiming;
__webpack_unused_export__ = transitionDuration;
__webpack_unused_export__ = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
__webpack_unused_export__ = animationDelay;
__webpack_unused_export__ = animationTiming;
__webpack_unused_export__ = animationDuration;
__webpack_unused_export__ = animationName;
if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();
  prefix = _getTransitionPropert.prefix;
  __webpack_unused_export__ = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.My = animationEnd = _getTransitionPropert.animationEnd;
  __webpack_unused_export__ = transform = prefix + "-" + transform;
  __webpack_unused_export__ = transitionProperty = prefix + "-transition-property";
  __webpack_unused_export__ = transitionDuration = prefix + "-transition-duration";
  __webpack_unused_export__ = transitionDelay = prefix + "-transition-delay";
  __webpack_unused_export__ = transitionTiming = prefix + "-transition-timing-function";
  __webpack_unused_export__ = animationName = prefix + "-animation-name";
  __webpack_unused_export__ = animationDuration = prefix + "-animation-duration";
  __webpack_unused_export__ = animationTiming = prefix + "-animation-delay";
  __webpack_unused_export__ = animationDelay = prefix + "-animation-timing-function";
}
var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
__webpack_unused_export__ = _default;
function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';
  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];
    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }
  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),

/***/ 8647:
/***/ ((module, exports) => {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;
var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports["default"] = _default;
module.exports = exports["default"];

/***/ }),

/***/ 5049:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(8299);

/** @type {import('.')} */
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
if ($defineProperty) {
  try {
    $defineProperty({}, 'a', {
      value: 1
    });
  } catch (e) {
    // IE 8 has a broken defineProperty
    $defineProperty = false;
  }
}
module.exports = $defineProperty;

/***/ }),

/***/ 15:
/***/ ((module) => {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;

/***/ }),

/***/ 157:
/***/ ((module) => {

"use strict";


/** @type {import('.')} */
module.exports = Error;

/***/ }),

/***/ 2104:
/***/ ((module) => {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;

/***/ }),

/***/ 6076:
/***/ ((module) => {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;

/***/ }),

/***/ 1226:
/***/ ((module) => {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;

/***/ }),

/***/ 1953:
/***/ ((module) => {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;

/***/ }),

/***/ 7047:
/***/ ((module) => {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;

/***/ }),

/***/ 2703:
/***/ ((module) => {

"use strict";


/* eslint no-invalid-this: 1 */
var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';
var concatty = function concatty(a, b) {
  var arr = [];
  for (var i = 0; i < a.length; i += 1) {
    arr[i] = a[i];
  }
  for (var j = 0; j < b.length; j += 1) {
    arr[j + a.length] = b[j];
  }
  return arr;
};
var slicy = function slicy(arrLike, offset) {
  var arr = [];
  for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
    arr[j] = arrLike[i];
  }
  return arr;
};
var joiny = function (arr, joiner) {
  var str = '';
  for (var i = 0; i < arr.length; i += 1) {
    str += arr[i];
    if (i + 1 < arr.length) {
      str += joiner;
    }
  }
  return str;
};
module.exports = function bind(that) {
  var target = this;
  if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }
  var args = slicy(arguments, 1);
  var bound;
  var binder = function () {
    if (this instanceof bound) {
      var result = target.apply(this, concatty(args, arguments));
      if (Object(result) === result) {
        return result;
      }
      return this;
    }
    return target.apply(that, concatty(args, arguments));
  };
  var boundLength = max(0, target.length - args.length);
  var boundArgs = [];
  for (var i = 0; i < boundLength; i++) {
    boundArgs[i] = '$' + i;
  }
  bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
  if (target.prototype) {
    var Empty = function Empty() {};
    Empty.prototype = target.prototype;
    bound.prototype = new Empty();
    Empty.prototype = null;
  }
  return bound;
};

/***/ }),

/***/ 5465:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var implementation = __webpack_require__(2703);
module.exports = Function.prototype.bind || implementation;

/***/ }),

/***/ 8299:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var undefined;
var $Error = __webpack_require__(157);
var $EvalError = __webpack_require__(15);
var $RangeError = __webpack_require__(2104);
var $ReferenceError = __webpack_require__(6076);
var $SyntaxError = __webpack_require__(1226);
var $TypeError = __webpack_require__(1953);
var $URIError = __webpack_require__(7047);
var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
  } catch (e) {}
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
  try {
    $gOPD({}, '');
  } catch (e) {
    $gOPD = null; // this is IE 8, which has a broken gOPD
  }
}
var throwTypeError = function () {
  throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function () {
  try {
    // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
    arguments.callee; // IE 8 does not throw here
    return throwTypeError;
  } catch (calleeThrows) {
    try {
      // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
      return $gOPD(arguments, 'callee').get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;
var hasSymbols = __webpack_require__(377)();
var hasProto = __webpack_require__(9486)();
var getProto = Object.getPrototypeOf || (hasProto ? function (x) {
  return x.__proto__;
} // eslint-disable-line no-proto
: null);
var needsEval = {};
var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
var INTRINSICS = {
  __proto__: null,
  '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
  '%Array%': Array,
  '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
  '%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
  '%AsyncFromSyncIteratorPrototype%': undefined,
  '%AsyncFunction%': needsEval,
  '%AsyncGenerator%': needsEval,
  '%AsyncGeneratorFunction%': needsEval,
  '%AsyncIteratorPrototype%': needsEval,
  '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
  '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
  '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
  '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
  '%Boolean%': Boolean,
  '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
  '%Date%': Date,
  '%decodeURI%': decodeURI,
  '%decodeURIComponent%': decodeURIComponent,
  '%encodeURI%': encodeURI,
  '%encodeURIComponent%': encodeURIComponent,
  '%Error%': $Error,
  '%eval%': eval,
  // eslint-disable-line no-eval
  '%EvalError%': $EvalError,
  '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
  '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
  '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
  '%Function%': $Function,
  '%GeneratorFunction%': needsEval,
  '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
  '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
  '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
  '%isFinite%': isFinite,
  '%isNaN%': isNaN,
  '%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
  '%JSON%': typeof JSON === 'object' ? JSON : undefined,
  '%Map%': typeof Map === 'undefined' ? undefined : Map,
  '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
  '%Math%': Math,
  '%Number%': Number,
  '%Object%': Object,
  '%parseFloat%': parseFloat,
  '%parseInt%': parseInt,
  '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
  '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
  '%RangeError%': $RangeError,
  '%ReferenceError%': $ReferenceError,
  '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
  '%RegExp%': RegExp,
  '%Set%': typeof Set === 'undefined' ? undefined : Set,
  '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
  '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
  '%String%': String,
  '%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
  '%Symbol%': hasSymbols ? Symbol : undefined,
  '%SyntaxError%': $SyntaxError,
  '%ThrowTypeError%': ThrowTypeError,
  '%TypedArray%': TypedArray,
  '%TypeError%': $TypeError,
  '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
  '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
  '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
  '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
  '%URIError%': $URIError,
  '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
  '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
  '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
if (getProto) {
  try {
    null.error; // eslint-disable-line no-unused-expressions
  } catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var errorProto = getProto(getProto(e));
    INTRINSICS['%Error.prototype%'] = errorProto;
  }
}
var doEval = function doEval(name) {
  var value;
  if (name === '%AsyncFunction%') {
    value = getEvalledConstructor('async function () {}');
  } else if (name === '%GeneratorFunction%') {
    value = getEvalledConstructor('function* () {}');
  } else if (name === '%AsyncGeneratorFunction%') {
    value = getEvalledConstructor('async function* () {}');
  } else if (name === '%AsyncGenerator%') {
    var fn = doEval('%AsyncGeneratorFunction%');
    if (fn) {
      value = fn.prototype;
    }
  } else if (name === '%AsyncIteratorPrototype%') {
    var gen = doEval('%AsyncGenerator%');
    if (gen && getProto) {
      value = getProto(gen.prototype);
    }
  }
  INTRINSICS[name] = value;
  return value;
};
var LEGACY_ALIASES = {
  __proto__: null,
  '%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
  '%ArrayPrototype%': ['Array', 'prototype'],
  '%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
  '%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
  '%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
  '%ArrayProto_values%': ['Array', 'prototype', 'values'],
  '%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
  '%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
  '%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
  '%BooleanPrototype%': ['Boolean', 'prototype'],
  '%DataViewPrototype%': ['DataView', 'prototype'],
  '%DatePrototype%': ['Date', 'prototype'],
  '%ErrorPrototype%': ['Error', 'prototype'],
  '%EvalErrorPrototype%': ['EvalError', 'prototype'],
  '%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
  '%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
  '%FunctionPrototype%': ['Function', 'prototype'],
  '%Generator%': ['GeneratorFunction', 'prototype'],
  '%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
  '%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
  '%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
  '%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
  '%JSONParse%': ['JSON', 'parse'],
  '%JSONStringify%': ['JSON', 'stringify'],
  '%MapPrototype%': ['Map', 'prototype'],
  '%NumberPrototype%': ['Number', 'prototype'],
  '%ObjectPrototype%': ['Object', 'prototype'],
  '%ObjProto_toString%': ['Object', 'prototype', 'toString'],
  '%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
  '%PromisePrototype%': ['Promise', 'prototype'],
  '%PromiseProto_then%': ['Promise', 'prototype', 'then'],
  '%Promise_all%': ['Promise', 'all'],
  '%Promise_reject%': ['Promise', 'reject'],
  '%Promise_resolve%': ['Promise', 'resolve'],
  '%RangeErrorPrototype%': ['RangeError', 'prototype'],
  '%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
  '%RegExpPrototype%': ['RegExp', 'prototype'],
  '%SetPrototype%': ['Set', 'prototype'],
  '%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
  '%StringPrototype%': ['String', 'prototype'],
  '%SymbolPrototype%': ['Symbol', 'prototype'],
  '%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
  '%TypedArrayPrototype%': ['TypedArray', 'prototype'],
  '%TypeErrorPrototype%': ['TypeError', 'prototype'],
  '%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
  '%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
  '%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
  '%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
  '%URIErrorPrototype%': ['URIError', 'prototype'],
  '%WeakMapPrototype%': ['WeakMap', 'prototype'],
  '%WeakSetPrototype%': ['WeakSet', 'prototype']
};
var bind = __webpack_require__(5465);
var hasOwn = __webpack_require__(863);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
  var first = $strSlice(string, 0, 1);
  var last = $strSlice(string, -1);
  if (first === '%' && last !== '%') {
    throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
  } else if (last === '%' && first !== '%') {
    throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
  }
  var result = [];
  $replace(string, rePropName, function (match, number, quote, subString) {
    result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
  });
  return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
  var intrinsicName = name;
  var alias;
  if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
    alias = LEGACY_ALIASES[intrinsicName];
    intrinsicName = '%' + alias[0] + '%';
  }
  if (hasOwn(INTRINSICS, intrinsicName)) {
    var value = INTRINSICS[intrinsicName];
    if (value === needsEval) {
      value = doEval(intrinsicName);
    }
    if (typeof value === 'undefined' && !allowMissing) {
      throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
    }
    return {
      alias: alias,
      name: intrinsicName,
      value: value
    };
  }
  throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
  if (typeof name !== 'string' || name.length === 0) {
    throw new $TypeError('intrinsic name must be a non-empty string');
  }
  if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
    throw new $TypeError('"allowMissing" argument must be a boolean');
  }
  if ($exec(/^%?[^%]*%?$/, name) === null) {
    throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
  }
  var parts = stringToPath(name);
  var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
  var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value = intrinsic.value;
  var skipFurtherCaching = false;
  var alias = intrinsic.alias;
  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply(parts, $concat([0, 1], alias));
  }
  for (var i = 1, isOwn = true; i < parts.length; i += 1) {
    var part = parts[i];
    var first = $strSlice(part, 0, 1);
    var last = $strSlice(part, -1);
    if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) {
      throw new $SyntaxError('property names with quotes must have matching quotes');
    }
    if (part === 'constructor' || !isOwn) {
      skipFurtherCaching = true;
    }
    intrinsicBaseName += '.' + part;
    intrinsicRealName = '%' + intrinsicBaseName + '%';
    if (hasOwn(INTRINSICS, intrinsicRealName)) {
      value = INTRINSICS[intrinsicRealName];
    } else if (value != null) {
      if (!(part in value)) {
        if (!allowMissing) {
          throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
        }
        return void undefined;
      }
      if ($gOPD && i + 1 >= parts.length) {
        var desc = $gOPD(value, part);
        isOwn = !!desc;

        // By convention, when a data property is converted to an accessor
        // property to emulate a data property that does not suffer from
        // the override mistake, that accessor's getter is marked with
        // an `originalValue` property. Here, when we detect this, we
        // uphold the illusion by pretending to see that original data
        // property, i.e., returning the value rather than the getter
        // itself.
        if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
          value = desc.get;
        } else {
          value = value[part];
        }
      } else {
        isOwn = hasOwn(value, part);
        value = value[part];
      }
      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value;
      }
    }
  }
  return value;
};

/***/ }),

/***/ 3581:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(8299);
var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
if ($gOPD) {
  try {
    $gOPD([], 'length');
  } catch (e) {
    // IE 8 has a broken gOPD
    $gOPD = null;
  }
}
module.exports = $gOPD;

/***/ }),

/***/ 6698:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var $defineProperty = __webpack_require__(5049);
var hasPropertyDescriptors = function hasPropertyDescriptors() {
  return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
  // node v0.6 has a bug where array lengths can be Set but not Defined
  if (!$defineProperty) {
    return null;
  }
  try {
    return $defineProperty([], 'length', {
      value: 1
    }).length !== 1;
  } catch (e) {
    // In Firefox 4-22, defining length on an array throws an exception.
    return true;
  }
};
module.exports = hasPropertyDescriptors;

/***/ }),

/***/ 9486:
/***/ ((module) => {

"use strict";


var test = {
  __proto__: null,
  foo: {}
};
var $Object = Object;

/** @type {import('.')} */
module.exports = function hasProto() {
  // @ts-expect-error: TS errors on an inherited property for some reason
  return {
    __proto__: test
  }.foo === test.foo && !(test instanceof $Object);
};

/***/ }),

/***/ 377:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(4379);
module.exports = function hasNativeSymbols() {
  if (typeof origSymbol !== 'function') {
    return false;
  }
  if (typeof Symbol !== 'function') {
    return false;
  }
  if (typeof origSymbol('foo') !== 'symbol') {
    return false;
  }
  if (typeof Symbol('bar') !== 'symbol') {
    return false;
  }
  return hasSymbolSham();
};

/***/ }),

/***/ 4379:
/***/ ((module) => {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
  if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
    return false;
  }
  if (typeof Symbol.iterator === 'symbol') {
    return true;
  }
  var obj = {};
  var sym = Symbol('test');
  var symObj = Object(sym);
  if (typeof sym === 'string') {
    return false;
  }
  if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
    return false;
  }
  if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
    return false;
  }

  // temp disabled per https://github.com/ljharb/object.assign/issues/17
  // if (sym instanceof Symbol) { return false; }
  // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
  // if (!(symObj instanceof Symbol)) { return false; }

  // if (typeof Symbol.prototype.toString !== 'function') { return false; }
  // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

  var symVal = 42;
  obj[sym] = symVal;
  for (sym in obj) {
    return false;
  } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
  if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
    return false;
  }
  if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }
  var syms = Object.getOwnPropertySymbols(obj);
  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }
  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }
  if (typeof Object.getOwnPropertyDescriptor === 'function') {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }
  return true;
};

/***/ }),

/***/ 863:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(5465);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);

/***/ }),

/***/ 8657:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
? function (O) {
  return O.__proto__; // eslint-disable-line no-proto
} : null);
function addNumericSeparator(num, str) {
  if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $test.call(/e/, str)) {
    return str;
  }
  var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof num === 'number') {
    var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
    if (int !== num) {
      var intStr = String(int);
      var dec = $slice.call(str, intStr.length + 1);
      return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
    }
  }
  return $replace.call(str, sepRegex, '$&_');
}
var utilInspect = __webpack_require__(2634);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
  var opts = options || {};
  if (has(opts, 'quoteStyle') && opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double') {
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  }
  if (has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  }
  var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
  if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
    throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
  }
  if (has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  }
  if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  }
  var numericSeparator = opts.numericSeparator;
  if (typeof obj === 'undefined') {
    return 'undefined';
  }
  if (obj === null) {
    return 'null';
  }
  if (typeof obj === 'boolean') {
    return obj ? 'true' : 'false';
  }
  if (typeof obj === 'string') {
    return inspectString(obj, opts);
  }
  if (typeof obj === 'number') {
    if (obj === 0) {
      return Infinity / obj > 0 ? '0' : '-0';
    }
    var str = String(obj);
    return numericSeparator ? addNumericSeparator(obj, str) : str;
  }
  if (typeof obj === 'bigint') {
    var bigIntStr = String(obj) + 'n';
    return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
  }
  var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
  if (typeof depth === 'undefined') {
    depth = 0;
  }
  if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
    return isArray(obj) ? '[Array]' : '[Object]';
  }
  var indent = getIndent(opts, depth);
  if (typeof seen === 'undefined') {
    seen = [];
  } else if (indexOf(seen, obj) >= 0) {
    return '[Circular]';
  }
  function inspect(value, from, noIndent) {
    if (from) {
      seen = $arrSlice.call(seen);
      seen.push(from);
    }
    if (noIndent) {
      var newOpts = {
        depth: opts.depth
      };
      if (has(opts, 'quoteStyle')) {
        newOpts.quoteStyle = opts.quoteStyle;
      }
      return inspect_(value, newOpts, depth + 1, seen);
    }
    return inspect_(value, opts, depth + 1, seen);
  }
  if (typeof obj === 'function' && !isRegExp(obj)) {
    // in older engines, regexes are callable
    var name = nameOf(obj);
    var keys = arrObjKeys(obj, inspect);
    return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
  }
  if (isSymbol(obj)) {
    var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
    return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
  }
  if (isElement(obj)) {
    var s = '<' + $toLowerCase.call(String(obj.nodeName));
    var attrs = obj.attributes || [];
    for (var i = 0; i < attrs.length; i++) {
      s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
    }
    s += '>';
    if (obj.childNodes && obj.childNodes.length) {
      s += '...';
    }
    s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
    return s;
  }
  if (isArray(obj)) {
    if (obj.length === 0) {
      return '[]';
    }
    var xs = arrObjKeys(obj, inspect);
    if (indent && !singleLineValues(xs)) {
      return '[' + indentedJoin(xs, indent) + ']';
    }
    return '[ ' + $join.call(xs, ', ') + ' ]';
  }
  if (isError(obj)) {
    var parts = arrObjKeys(obj, inspect);
    if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
      return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
    }
    if (parts.length === 0) {
      return '[' + String(obj) + ']';
    }
    return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
  }
  if (typeof obj === 'object' && customInspect) {
    if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
      return utilInspect(obj, {
        depth: maxDepth - depth
      });
    } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
      return obj.inspect();
    }
  }
  if (isMap(obj)) {
    var mapParts = [];
    if (mapForEach) {
      mapForEach.call(obj, function (value, key) {
        mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
      });
    }
    return collectionOf('Map', mapSize.call(obj), mapParts, indent);
  }
  if (isSet(obj)) {
    var setParts = [];
    if (setForEach) {
      setForEach.call(obj, function (value) {
        setParts.push(inspect(value, obj));
      });
    }
    return collectionOf('Set', setSize.call(obj), setParts, indent);
  }
  if (isWeakMap(obj)) {
    return weakCollectionOf('WeakMap');
  }
  if (isWeakSet(obj)) {
    return weakCollectionOf('WeakSet');
  }
  if (isWeakRef(obj)) {
    return weakCollectionOf('WeakRef');
  }
  if (isNumber(obj)) {
    return markBoxed(inspect(Number(obj)));
  }
  if (isBigInt(obj)) {
    return markBoxed(inspect(bigIntValueOf.call(obj)));
  }
  if (isBoolean(obj)) {
    return markBoxed(booleanValueOf.call(obj));
  }
  if (isString(obj)) {
    return markBoxed(inspect(String(obj)));
  }
  // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
  /* eslint-env browser */
  if (typeof window !== 'undefined' && obj === window) {
    return '{ [object Window] }';
  }
  if (typeof globalThis !== 'undefined' && obj === globalThis || typeof __webpack_require__.g !== 'undefined' && obj === __webpack_require__.g) {
    return '{ [object globalThis] }';
  }
  if (!isDate(obj) && !isRegExp(obj)) {
    var ys = arrObjKeys(obj, inspect);
    var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
    var protoTag = obj instanceof Object ? '' : 'null prototype';
    var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
    var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
    var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
    if (ys.length === 0) {
      return tag + '{}';
    }
    if (indent) {
      return tag + '{' + indentedJoin(ys, indent) + '}';
    }
    return tag + '{ ' + $join.call(ys, ', ') + ' }';
  }
  return String(obj);
};
function wrapQuotes(s, defaultStyle, opts) {
  var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
  return quoteChar + s + quoteChar;
}
function quote(s) {
  return $replace.call(String(s), /"/g, '&quot;');
}
function isArray(obj) {
  return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isDate(obj) {
  return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isRegExp(obj) {
  return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isError(obj) {
  return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isString(obj) {
  return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isNumber(obj) {
  return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isBoolean(obj) {
  return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
  if (hasShammedSymbols) {
    return obj && typeof obj === 'object' && obj instanceof Symbol;
  }
  if (typeof obj === 'symbol') {
    return true;
  }
  if (!obj || typeof obj !== 'object' || !symToString) {
    return false;
  }
  try {
    symToString.call(obj);
    return true;
  } catch (e) {}
  return false;
}
function isBigInt(obj) {
  if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
    return false;
  }
  try {
    bigIntValueOf.call(obj);
    return true;
  } catch (e) {}
  return false;
}
var hasOwn = Object.prototype.hasOwnProperty || function (key) {
  return key in this;
};
function has(obj, key) {
  return hasOwn.call(obj, key);
}
function toStr(obj) {
  return objectToString.call(obj);
}
function nameOf(f) {
  if (f.name) {
    return f.name;
  }
  var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
  if (m) {
    return m[1];
  }
  return null;
}
function indexOf(xs, x) {
  if (xs.indexOf) {
    return xs.indexOf(x);
  }
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) {
      return i;
    }
  }
  return -1;
}
function isMap(x) {
  if (!mapSize || !x || typeof x !== 'object') {
    return false;
  }
  try {
    mapSize.call(x);
    try {
      setSize.call(x);
    } catch (s) {
      return true;
    }
    return x instanceof Map; // core-js workaround, pre-v2.5.0
  } catch (e) {}
  return false;
}
function isWeakMap(x) {
  if (!weakMapHas || !x || typeof x !== 'object') {
    return false;
  }
  try {
    weakMapHas.call(x, weakMapHas);
    try {
      weakSetHas.call(x, weakSetHas);
    } catch (s) {
      return true;
    }
    return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
  } catch (e) {}
  return false;
}
function isWeakRef(x) {
  if (!weakRefDeref || !x || typeof x !== 'object') {
    return false;
  }
  try {
    weakRefDeref.call(x);
    return true;
  } catch (e) {}
  return false;
}
function isSet(x) {
  if (!setSize || !x || typeof x !== 'object') {
    return false;
  }
  try {
    setSize.call(x);
    try {
      mapSize.call(x);
    } catch (m) {
      return true;
    }
    return x instanceof Set; // core-js workaround, pre-v2.5.0
  } catch (e) {}
  return false;
}
function isWeakSet(x) {
  if (!weakSetHas || !x || typeof x !== 'object') {
    return false;
  }
  try {
    weakSetHas.call(x, weakSetHas);
    try {
      weakMapHas.call(x, weakMapHas);
    } catch (s) {
      return true;
    }
    return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
  } catch (e) {}
  return false;
}
function isElement(x) {
  if (!x || typeof x !== 'object') {
    return false;
  }
  if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
    return true;
  }
  return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function inspectString(str, opts) {
  if (str.length > opts.maxStringLength) {
    var remaining = str.length - opts.maxStringLength;
    var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
    return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
  }
  // eslint-disable-next-line no-control-regex
  var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
  return wrapQuotes(s, 'single', opts);
}
function lowbyte(c) {
  var n = c.charCodeAt(0);
  var x = {
    8: 'b',
    9: 't',
    10: 'n',
    12: 'f',
    13: 'r'
  }[n];
  if (x) {
    return '\\' + x;
  }
  return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}
function markBoxed(str) {
  return 'Object(' + str + ')';
}
function weakCollectionOf(type) {
  return type + ' { ? }';
}
function collectionOf(type, size, entries, indent) {
  var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
  return type + ' (' + size + ') {' + joinedEntries + '}';
}
function singleLineValues(xs) {
  for (var i = 0; i < xs.length; i++) {
    if (indexOf(xs[i], '\n') >= 0) {
      return false;
    }
  }
  return true;
}
function getIndent(opts, depth) {
  var baseIndent;
  if (opts.indent === '\t') {
    baseIndent = '\t';
  } else if (typeof opts.indent === 'number' && opts.indent > 0) {
    baseIndent = $join.call(Array(opts.indent + 1), ' ');
  } else {
    return null;
  }
  return {
    base: baseIndent,
    prev: $join.call(Array(depth + 1), baseIndent)
  };
}
function indentedJoin(xs, indent) {
  if (xs.length === 0) {
    return '';
  }
  var lineJoiner = '\n' + indent.prev + indent.base;
  return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function arrObjKeys(obj, inspect) {
  var isArr = isArray(obj);
  var xs = [];
  if (isArr) {
    xs.length = obj.length;
    for (var i = 0; i < obj.length; i++) {
      xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
    }
  }
  var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
  var symMap;
  if (hasShammedSymbols) {
    symMap = {};
    for (var k = 0; k < syms.length; k++) {
      symMap['$' + syms[k]] = syms[k];
    }
  }
  for (var key in obj) {
    // eslint-disable-line no-restricted-syntax
    if (!has(obj, key)) {
      continue;
    } // eslint-disable-line no-restricted-syntax, no-continue
    if (isArr && String(Number(key)) === key && key < obj.length) {
      continue;
    } // eslint-disable-line no-restricted-syntax, no-continue
    if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
      // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
      continue; // eslint-disable-line no-restricted-syntax, no-continue
    } else if ($test.call(/[^\w$]/, key)) {
      xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
    } else {
      xs.push(key + ': ' + inspect(obj[key], obj));
    }
  }
  if (typeof gOPS === 'function') {
    for (var j = 0; j < syms.length; j++) {
      if (isEnumerable.call(obj, syms[j])) {
        xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
      }
    }
  }
  return xs;
}

/***/ }),

/***/ 5887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(8299);
var define = __webpack_require__(3423);
var hasDescriptors = __webpack_require__(6698)();
var gOPD = __webpack_require__(3581);
var $TypeError = __webpack_require__(1953);
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
  if (typeof fn !== 'function') {
    throw new $TypeError('`fn` is not a function');
  }
  if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
    throw new $TypeError('`length` must be a positive 32-bit integer');
  }
  var loose = arguments.length > 2 && !!arguments[2];
  var functionLengthIsConfigurable = true;
  var functionLengthIsWritable = true;
  if ('length' in fn && gOPD) {
    var desc = gOPD(fn, 'length');
    if (desc && !desc.configurable) {
      functionLengthIsConfigurable = false;
    }
    if (desc && !desc.writable) {
      functionLengthIsWritable = false;
    }
  }
  if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
    if (hasDescriptors) {
      define(/** @type {Parameters<define>[0]} */fn, 'length', length, true, true);
    } else {
      define(/** @type {Parameters<define>[0]} */fn, 'length', length);
    }
  }
  return fn;
};

/***/ }),

/***/ 6402:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(8299);
var callBound = __webpack_require__(2857);
var inspect = __webpack_require__(8657);
var $TypeError = __webpack_require__(1953);
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);
var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('.').listGetNode} */
var listGetNode = function (list, key) {
  // eslint-disable-line consistent-return
  /** @type {typeof list | NonNullable<(typeof list)['next']>} */
  var prev = list;
  /** @type {(typeof list)['next']} */
  var curr;
  for (; (curr = prev.next) !== null; prev = curr) {
    if (curr.key === key) {
      prev.next = curr.next;
      // eslint-disable-next-line no-extra-parens
      curr.next = /** @type {NonNullable<typeof list.next>} */list.next;
      list.next = curr; // eslint-disable-line no-param-reassign
      return curr;
    }
  }
};

/** @type {import('.').listGet} */
var listGet = function (objects, key) {
  var node = listGetNode(objects, key);
  return node && node.value;
};
/** @type {import('.').listSet} */
var listSet = function (objects, key, value) {
  var node = listGetNode(objects, key);
  if (node) {
    node.value = value;
  } else {
    // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */{
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: key,
      next: objects.next,
      value: value
    };
  }
};
/** @type {import('.').listHas} */
var listHas = function (objects, key) {
  return !!listGetNode(objects, key);
};

/** @type {import('.')} */
module.exports = function getSideChannel() {
  /** @type {WeakMap<object, unknown>} */var $wm;
  /** @type {Map<object, unknown>} */
  var $m;
  /** @type {import('.').RootNode<unknown>} */
  var $o;

  /** @type {import('.').Channel} */
  var channel = {
    assert: function (key) {
      if (!channel.has(key)) {
        throw new $TypeError('Side channel does not contain ' + inspect(key));
      }
    },
    get: function (key) {
      // eslint-disable-line consistent-return
      if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
        if ($wm) {
          return $weakMapGet($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapGet($m, key);
        }
      } else {
        if ($o) {
          // eslint-disable-line no-lonely-if
          return listGet($o, key);
        }
      }
    },
    has: function (key) {
      if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
        if ($wm) {
          return $weakMapHas($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapHas($m, key);
        }
      } else {
        if ($o) {
          // eslint-disable-line no-lonely-if
          return listHas($o, key);
        }
      }
      return false;
    },
    set: function (key, value) {
      if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
        if (!$wm) {
          $wm = new $WeakMap();
        }
        $weakMapSet($wm, key, value);
      } else if ($Map) {
        if (!$m) {
          $m = new $Map();
        }
        $mapSet($m, key, value);
      } else {
        if (!$o) {
          // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
          $o = {
            key: {},
            next: null
          };
        }
        listSet($o, key, value);
      }
    }
  };
  return channel;
};

/***/ }),

/***/ 5592:
/***/ ((module) => {

/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;
  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

  // blank or null?
  if (!css || typeof css !== "string") {
    return css;
  }
  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

  // convert each url(...)
  /*
  This regular expression is just a way to recursively match brackets within
  a string.
  	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
     (  = Start a capturing group
       (?:  = Start a non-capturing group
           [^)(]  = Match anything that isn't a parentheses
           |  = OR
           \(  = Match a start parentheses
               (?:  = Start another non-capturing groups
                   [^)(]+  = Match anything that isn't a parentheses
                   |  = OR
                   \(  = Match a start parentheses
                       [^)(]*  = Match anything that isn't a parentheses
                   \)  = Match a end parentheses
               )  = End Group
               *\) = Match anything and then a close parens
           )  = Close non-capturing group
           *  = Match anything
        )  = Close capturing group
   \)  = Match a close parens
  	 /gi  = Get all matches, not the first.  Be case insensitive.
   */
  var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
    // strip quotes (if they exist)
    var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
      return $1;
    }).replace(/^'(.*)'$/, function (o, $1) {
      return $1;
    });

    // already a full url? no change
    if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
      return fullMatch;
    }

    // convert the url to a full url
    var newUrl;
    if (unquotedOrigUrl.indexOf("//") === 0) {
      //TODO: should we add protocol?
      newUrl = unquotedOrigUrl;
    } else if (unquotedOrigUrl.indexOf("/") === 0) {
      // path should be relative to the base url
      newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
    } else {
      // path should be relative to current directory
      newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
    }

    // send back the fixed url(...)
    return "url(" + JSON.stringify(newUrl) + ")";
  });

  // send back the fixed css
  return fixedCss;
};

/***/ }),

/***/ 1820:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;
(function (root) {
  /** Detect free variables */
  var freeExports =  true && exports && !exports.nodeType && exports;
  var freeModule =  true && module && !module.nodeType && module;
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g;
  if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
    root = freeGlobal;
  }

  /**
   * The `punycode` object.
   * @name punycode
   * @type Object
   */
  var punycode,
    /** Highest positive signed 32-bit float value */
    maxInt = 2147483647,
    // aka. 0x7FFFFFFF or 2^31-1

    /** Bootstring parameters */
    base = 36,
    tMin = 1,
    tMax = 26,
    skew = 38,
    damp = 700,
    initialBias = 72,
    initialN = 128,
    // 0x80
    delimiter = '-',
    // '\x2D'

    /** Regular expressions */
    regexPunycode = /^xn--/,
    regexNonASCII = /[^\x20-\x7E]/,
    // unprintable ASCII chars + non-ASCII chars
    regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g,
    // RFC 3490 separators

    /** Error messages */
    errors = {
      'overflow': 'Overflow: input needs wider integers to process',
      'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
      'invalid-input': 'Invalid input'
    },
    /** Convenience shortcuts */
    baseMinusTMin = base - tMin,
    floor = Math.floor,
    stringFromCharCode = String.fromCharCode,
    /** Temporary variable */
    key;

  /*--------------------------------------------------------------------------*/

  /**
   * A generic error utility function.
   * @private
   * @param {String} type The error type.
   * @returns {Error} Throws a `RangeError` with the applicable error message.
   */
  function error(type) {
    throw new RangeError(errors[type]);
  }

  /**
   * A generic `Array#map` utility function.
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function that gets called for every array
   * item.
   * @returns {Array} A new array of values returned by the callback function.
   */
  function map(array, fn) {
    var length = array.length;
    var result = [];
    while (length--) {
      result[length] = fn(array[length]);
    }
    return result;
  }

  /**
   * A simple `Array#map`-like wrapper to work with domain name strings or email
   * addresses.
   * @private
   * @param {String} domain The domain name or email address.
   * @param {Function} callback The function that gets called for every
   * character.
   * @returns {Array} A new string of characters returned by the callback
   * function.
   */
  function mapDomain(string, fn) {
    var parts = string.split('@');
    var result = '';
    if (parts.length > 1) {
      // In email addresses, only the domain name should be punycoded. Leave
      // the local part (i.e. everything up to `@`) intact.
      result = parts[0] + '@';
      string = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    string = string.replace(regexSeparators, '\x2E');
    var labels = string.split('.');
    var encoded = map(labels, fn).join('.');
    return result + encoded;
  }

  /**
   * Creates an array containing the numeric code points of each Unicode
   * character in the string. While JavaScript uses UCS-2 internally,
   * this function will convert a pair of surrogate halves (each of which
   * UCS-2 exposes as separate characters) into a single code point,
   * matching UTF-16.
   * @see `punycode.ucs2.encode`
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode.ucs2
   * @name decode
   * @param {String} string The Unicode input string (UCS-2).
   * @returns {Array} The new array of code points.
   */
  function ucs2decode(string) {
    var output = [],
      counter = 0,
      length = string.length,
      value,
      extra;
    while (counter < length) {
      value = string.charCodeAt(counter++);
      if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
        // high surrogate, and there is a next character
        extra = string.charCodeAt(counter++);
        if ((extra & 0xFC00) == 0xDC00) {
          // low surrogate
          output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
        } else {
          // unmatched surrogate; only append this code unit, in case the next
          // code unit is the high surrogate of a surrogate pair
          output.push(value);
          counter--;
        }
      } else {
        output.push(value);
      }
    }
    return output;
  }

  /**
   * Creates a string based on an array of numeric code points.
   * @see `punycode.ucs2.decode`
   * @memberOf punycode.ucs2
   * @name encode
   * @param {Array} codePoints The array of numeric code points.
   * @returns {String} The new Unicode string (UCS-2).
   */
  function ucs2encode(array) {
    return map(array, function (value) {
      var output = '';
      if (value > 0xFFFF) {
        value -= 0x10000;
        output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
        value = 0xDC00 | value & 0x3FF;
      }
      output += stringFromCharCode(value);
      return output;
    }).join('');
  }

  /**
   * Converts a basic code point into a digit/integer.
   * @see `digitToBasic()`
   * @private
   * @param {Number} codePoint The basic numeric code point value.
   * @returns {Number} The numeric value of a basic code point (for use in
   * representing integers) in the range `0` to `base - 1`, or `base` if
   * the code point does not represent a value.
   */
  function basicToDigit(codePoint) {
    if (codePoint - 48 < 10) {
      return codePoint - 22;
    }
    if (codePoint - 65 < 26) {
      return codePoint - 65;
    }
    if (codePoint - 97 < 26) {
      return codePoint - 97;
    }
    return base;
  }

  /**
   * Converts a digit/integer into a basic code point.
   * @see `basicToDigit()`
   * @private
   * @param {Number} digit The numeric value of a basic code point.
   * @returns {Number} The basic code point whose value (when used for
   * representing integers) is `digit`, which needs to be in the range
   * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
   * used; else, the lowercase form is used. The behavior is undefined
   * if `flag` is non-zero and `digit` has no uppercase form.
   */
  function digitToBasic(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
  }

  /**
   * Bias adaptation function as per section 3.4 of RFC 3492.
   * https://tools.ietf.org/html/rfc3492#section-3.4
   * @private
   */
  function adapt(delta, numPoints, firstTime) {
    var k = 0;
    delta = firstTime ? floor(delta / damp) : delta >> 1;
    delta += floor(delta / numPoints);
    for /* no initialization */
    (; delta > baseMinusTMin * tMax >> 1; k += base) {
      delta = floor(delta / baseMinusTMin);
    }
    return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
  }

  /**
   * Converts a Punycode string of ASCII-only symbols to a string of Unicode
   * symbols.
   * @memberOf punycode
   * @param {String} input The Punycode string of ASCII-only symbols.
   * @returns {String} The resulting string of Unicode symbols.
   */
  function decode(input) {
    // Don't use UCS-2
    var output = [],
      inputLength = input.length,
      out,
      i = 0,
      n = initialN,
      bias = initialBias,
      basic,
      j,
      index,
      oldi,
      w,
      k,
      digit,
      t,
      /** Cached calculation results */
      baseMinusT;

    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.

    basic = input.lastIndexOf(delimiter);
    if (basic < 0) {
      basic = 0;
    }
    for (j = 0; j < basic; ++j) {
      // if it's not a basic code point
      if (input.charCodeAt(j) >= 0x80) {
        error('not-basic');
      }
      output.push(input.charCodeAt(j));
    }

    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.

    for /* no final expression */
    (index = basic > 0 ? basic + 1 : 0; index < inputLength;) {
      // `index` is the index of the next character to be consumed.
      // Decode a generalized variable-length integer into `delta`,
      // which gets added to `i`. The overflow checking is easier
      // if we increase `i` as we go, then subtract off its starting
      // value at the end to obtain `delta`.
      for /* no condition */
      (oldi = i, w = 1, k = base;; k += base) {
        if (index >= inputLength) {
          error('invalid-input');
        }
        digit = basicToDigit(input.charCodeAt(index++));
        if (digit >= base || digit > floor((maxInt - i) / w)) {
          error('overflow');
        }
        i += digit * w;
        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
        if (digit < t) {
          break;
        }
        baseMinusT = base - t;
        if (w > floor(maxInt / baseMinusT)) {
          error('overflow');
        }
        w *= baseMinusT;
      }
      out = output.length + 1;
      bias = adapt(i - oldi, out, oldi == 0);

      // `i` was supposed to wrap around from `out` to `0`,
      // incrementing `n` each time, so we'll fix that now:
      if (floor(i / out) > maxInt - n) {
        error('overflow');
      }
      n += floor(i / out);
      i %= out;

      // Insert `n` at position `i` of the output
      output.splice(i++, 0, n);
    }
    return ucs2encode(output);
  }

  /**
   * Converts a string of Unicode symbols (e.g. a domain name label) to a
   * Punycode string of ASCII-only symbols.
   * @memberOf punycode
   * @param {String} input The string of Unicode symbols.
   * @returns {String} The resulting Punycode string of ASCII-only symbols.
   */
  function encode(input) {
    var n,
      delta,
      handledCPCount,
      basicLength,
      bias,
      j,
      m,
      q,
      k,
      t,
      currentValue,
      output = [],
      /** `inputLength` will hold the number of code points in `input`. */
      inputLength,
      /** Cached calculation results */
      handledCPCountPlusOne,
      baseMinusT,
      qMinusT;

    // Convert the input in UCS-2 to Unicode
    input = ucs2decode(input);

    // Cache the length
    inputLength = input.length;

    // Initialize the state
    n = initialN;
    delta = 0;
    bias = initialBias;

    // Handle the basic code points
    for (j = 0; j < inputLength; ++j) {
      currentValue = input[j];
      if (currentValue < 0x80) {
        output.push(stringFromCharCode(currentValue));
      }
    }
    handledCPCount = basicLength = output.length;

    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.

    // Finish the basic string - if it is not empty - with a delimiter
    if (basicLength) {
      output.push(delimiter);
    }

    // Main encoding loop:
    while (handledCPCount < inputLength) {
      // All non-basic code points < n have been handled already. Find the next
      // larger one:
      for (m = maxInt, j = 0; j < inputLength; ++j) {
        currentValue = input[j];
        if (currentValue >= n && currentValue < m) {
          m = currentValue;
        }
      }

      // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
      // but guard against overflow
      handledCPCountPlusOne = handledCPCount + 1;
      if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
        error('overflow');
      }
      delta += (m - n) * handledCPCountPlusOne;
      n = m;
      for (j = 0; j < inputLength; ++j) {
        currentValue = input[j];
        if (currentValue < n && ++delta > maxInt) {
          error('overflow');
        }
        if (currentValue == n) {
          // Represent delta as a generalized variable-length integer
          for /* no condition */
          (q = delta, k = base;; k += base) {
            t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
            if (q < t) {
              break;
            }
            qMinusT = q - t;
            baseMinusT = base - t;
            output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
            q = floor(qMinusT / baseMinusT);
          }
          output.push(stringFromCharCode(digitToBasic(q, 0)));
          bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
          delta = 0;
          ++handledCPCount;
        }
      }
      ++delta;
      ++n;
    }
    return output.join('');
  }

  /**
   * Converts a Punycode string representing a domain name or an email address
   * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
   * it doesn't matter if you call it on a string that has already been
   * converted to Unicode.
   * @memberOf punycode
   * @param {String} input The Punycoded domain name or email address to
   * convert to Unicode.
   * @returns {String} The Unicode representation of the given Punycode
   * string.
   */
  function toUnicode(input) {
    return mapDomain(input, function (string) {
      return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
    });
  }

  /**
   * Converts a Unicode string representing a domain name or an email address to
   * Punycode. Only the non-ASCII parts of the domain name will be converted,
   * i.e. it doesn't matter if you call it with a domain that's already in
   * ASCII.
   * @memberOf punycode
   * @param {String} input The domain name or email address to convert, as a
   * Unicode string.
   * @returns {String} The Punycode representation of the given domain name or
   * email address.
   */
  function toASCII(input) {
    return mapDomain(input, function (string) {
      return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
    });
  }

  /*--------------------------------------------------------------------------*/

  /** Define the public API */
  punycode = {
    /**
     * A string representing the current Punycode.js version number.
     * @memberOf punycode
     * @type String
     */
    'version': '1.4.1',
    /**
     * An object of methods to convert from JavaScript's internal character
     * representation (UCS-2) to Unicode code points, and back.
     * @see <https://mathiasbynens.be/notes/javascript-encoding>
     * @memberOf punycode
     * @type Object
     */
    'ucs2': {
      'decode': ucs2decode,
      'encode': ucs2encode
    },
    'decode': decode,
    'encode': encode,
    'toASCII': toASCII,
    'toUnicode': toUnicode
  };

  /** Expose `punycode` */
  // Some AMD build optimizers, like r.js, check for specific condition patterns
  // like the following:
  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return punycode;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(this);

/***/ }),

/***/ 9292:
/***/ ((module) => {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
  RFC1738: 'RFC1738',
  RFC3986: 'RFC3986'
};
module.exports = {
  'default': Format.RFC3986,
  formatters: {
    RFC1738: function (value) {
      return replace.call(value, percentTwenties, '+');
    },
    RFC3986: function (value) {
      return String(value);
    }
  },
  RFC1738: Format.RFC1738,
  RFC3986: Format.RFC3986
};

/***/ }),

/***/ 3988:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var stringify = __webpack_require__(6889);
var parse = __webpack_require__(9367);
var formats = __webpack_require__(9292);
module.exports = {
  formats: formats,
  parse: parse,
  stringify: stringify
};

/***/ }),

/***/ 9367:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(4509);
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var defaults = {
  allowDots: false,
  allowEmptyArrays: false,
  allowPrototypes: false,
  allowSparse: false,
  arrayLimit: 20,
  charset: 'utf-8',
  charsetSentinel: false,
  comma: false,
  decodeDotInKeys: false,
  decoder: utils.decode,
  delimiter: '&',
  depth: 5,
  duplicates: 'combine',
  ignoreQueryPrefix: false,
  interpretNumericEntities: false,
  parameterLimit: 1000,
  parseArrays: true,
  plainObjects: false,
  strictDepth: false,
  strictNullHandling: false
};
var interpretNumericEntities = function (str) {
  return str.replace(/&#(\d+);/g, function ($0, numberStr) {
    return String.fromCharCode(parseInt(numberStr, 10));
  });
};
var parseArrayValue = function (val, options) {
  if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
    return val.split(',');
  }
  return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
  var obj = {
    __proto__: null
  };
  var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
  cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
  var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
  var parts = cleanStr.split(options.delimiter, limit);
  var skipIndex = -1; // Keep track of where the utf8 sentinel was found
  var i;
  var charset = options.charset;
  if (options.charsetSentinel) {
    for (i = 0; i < parts.length; ++i) {
      if (parts[i].indexOf('utf8=') === 0) {
        if (parts[i] === charsetSentinel) {
          charset = 'utf-8';
        } else if (parts[i] === isoSentinel) {
          charset = 'iso-8859-1';
        }
        skipIndex = i;
        i = parts.length; // The eslint settings do not allow break;
      }
    }
  }
  for (i = 0; i < parts.length; ++i) {
    if (i === skipIndex) {
      continue;
    }
    var part = parts[i];
    var bracketEqualsPos = part.indexOf(']=');
    var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
    var key, val;
    if (pos === -1) {
      key = options.decoder(part, defaults.decoder, charset, 'key');
      val = options.strictNullHandling ? null : '';
    } else {
      key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
      val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options), function (encodedVal) {
        return options.decoder(encodedVal, defaults.decoder, charset, 'value');
      });
    }
    if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
      val = interpretNumericEntities(val);
    }
    if (part.indexOf('[]=') > -1) {
      val = isArray(val) ? [val] : val;
    }
    var existing = has.call(obj, key);
    if (existing && options.duplicates === 'combine') {
      obj[key] = utils.combine(obj[key], val);
    } else if (!existing || options.duplicates === 'last') {
      obj[key] = val;
    }
  }
  return obj;
};
var parseObject = function (chain, val, options, valuesParsed) {
  var leaf = valuesParsed ? val : parseArrayValue(val, options);
  for (var i = chain.length - 1; i >= 0; --i) {
    var obj;
    var root = chain[i];
    if (root === '[]' && options.parseArrays) {
      obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : [].concat(leaf);
    } else {
      obj = options.plainObjects ? Object.create(null) : {};
      var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
      var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
      var index = parseInt(decodedRoot, 10);
      if (!options.parseArrays && decodedRoot === '') {
        obj = {
          0: leaf
        };
      } else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
        obj = [];
        obj[index] = leaf;
      } else if (decodedRoot !== '__proto__') {
        obj[decodedRoot] = leaf;
      }
    }
    leaf = obj;
  }
  return leaf;
};
var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
  if (!givenKey) {
    return;
  }

  // Transform dot notation to bracket notation
  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

  // The regex chunks

  var brackets = /(\[[^[\]]*])/;
  var child = /(\[[^[\]]*])/g;

  // Get the parent

  var segment = options.depth > 0 && brackets.exec(key);
  var parent = segment ? key.slice(0, segment.index) : key;

  // Stash the parent if it exists

  var keys = [];
  if (parent) {
    // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
    if (!options.plainObjects && has.call(Object.prototype, parent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys.push(parent);
  }

  // Loop through children appending to the array until we hit depth

  var i = 0;
  while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
    i += 1;
    if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys.push(segment[1]);
  }

  // If there's a remainder, check strictDepth option for throw, else just add whatever is left

  if (segment) {
    if (options.strictDepth === true) {
      throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
    }
    keys.push('[' + key.slice(segment.index) + ']');
  }
  return parseObject(keys, val, options, valuesParsed);
};
var normalizeParseOptions = function normalizeParseOptions(opts) {
  if (!opts) {
    return defaults;
  }
  if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
    throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
  }
  if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
    throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
  }
  if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
    throw new TypeError('Decoder has to be a function.');
  }
  if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
    throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
  }
  var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
  var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;
  if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
    throw new TypeError('The duplicates option must be either combine, first, or last');
  }
  var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
  return {
    allowDots: allowDots,
    allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
    allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
    allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
    arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
    charset: charset,
    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
    comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
    decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
    decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
    delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : defaults.depth,
    duplicates: duplicates,
    ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
    interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
    parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
    parseArrays: opts.parseArrays !== false,
    plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
    strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
  };
};
module.exports = function (str, opts) {
  var options = normalizeParseOptions(opts);
  if (str === '' || str === null || typeof str === 'undefined') {
    return options.plainObjects ? Object.create(null) : {};
  }
  var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
  var obj = options.plainObjects ? Object.create(null) : {};

  // Iterate over the keys and setup the new object

  var keys = Object.keys(tempObj);
  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];
    var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
    obj = utils.merge(obj, newObj, options);
  }
  if (options.allowSparse === true) {
    return obj;
  }
  return utils.compact(obj);
};

/***/ }),

/***/ 6889:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var getSideChannel = __webpack_require__(6402);
var utils = __webpack_require__(4509);
var formats = __webpack_require__(9292);
var has = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
  brackets: function brackets(prefix) {
    return prefix + '[]';
  },
  comma: 'comma',
  indices: function indices(prefix, key) {
    return prefix + '[' + key + ']';
  },
  repeat: function repeat(prefix) {
    return prefix;
  }
};
var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
  push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};
var toISO = Date.prototype.toISOString;
var defaultFormat = formats['default'];
var defaults = {
  addQueryPrefix: false,
  allowDots: false,
  allowEmptyArrays: false,
  arrayFormat: 'indices',
  charset: 'utf-8',
  charsetSentinel: false,
  delimiter: '&',
  encode: true,
  encodeDotInKeys: false,
  encoder: utils.encode,
  encodeValuesOnly: false,
  format: defaultFormat,
  formatter: formats.formatters[defaultFormat],
  // deprecated
  indices: false,
  serializeDate: function serializeDate(date) {
    return toISO.call(date);
  },
  skipNulls: false,
  strictNullHandling: false
};
var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
  return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var sentinel = {};
var stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
  var obj = object;
  var tmpSc = sideChannel;
  var step = 0;
  var findFlag = false;
  while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
    // Where object last appeared in the ref tree
    var pos = tmpSc.get(object);
    step += 1;
    if (typeof pos !== 'undefined') {
      if (pos === step) {
        throw new RangeError('Cyclic object value');
      } else {
        findFlag = true; // Break while
      }
    }
    if (typeof tmpSc.get(sentinel) === 'undefined') {
      step = 0;
    }
  }
  if (typeof filter === 'function') {
    obj = filter(prefix, obj);
  } else if (obj instanceof Date) {
    obj = serializeDate(obj);
  } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
    obj = utils.maybeMap(obj, function (value) {
      if (value instanceof Date) {
        return serializeDate(value);
      }
      return value;
    });
  }
  if (obj === null) {
    if (strictNullHandling) {
      return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
    }
    obj = '';
  }
  if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
    if (encoder) {
      var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
      return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
    }
    return [formatter(prefix) + '=' + formatter(String(obj))];
  }
  var values = [];
  if (typeof obj === 'undefined') {
    return values;
  }
  var objKeys;
  if (generateArrayPrefix === 'comma' && isArray(obj)) {
    // we need to join elements in
    if (encodeValuesOnly && encoder) {
      obj = utils.maybeMap(obj, encoder);
    }
    objKeys = [{
      value: obj.length > 0 ? obj.join(',') || null : void undefined
    }];
  } else if (isArray(filter)) {
    objKeys = filter;
  } else {
    var keys = Object.keys(obj);
    objKeys = sort ? keys.sort(sort) : keys;
  }
  var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, '%2E') : prefix;
  var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
  if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
    return adjustedPrefix + '[]';
  }
  for (var j = 0; j < objKeys.length; ++j) {
    var key = objKeys[j];
    var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];
    if (skipNulls && value === null) {
      continue;
    }
    var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, '%2E') : key;
    var keyPrefix = isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
    sideChannel.set(object, step);
    var valueSideChannel = getSideChannel();
    valueSideChannel.set(sentinel, sideChannel);
    pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
  }
  return values;
};
var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
  if (!opts) {
    return defaults;
  }
  if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
    throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
  }
  if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
    throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
  }
  if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
    throw new TypeError('Encoder has to be a function.');
  }
  var charset = opts.charset || defaults.charset;
  if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
    throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
  }
  var format = formats['default'];
  if (typeof opts.format !== 'undefined') {
    if (!has.call(formats.formatters, opts.format)) {
      throw new TypeError('Unknown format option provided.');
    }
    format = opts.format;
  }
  var formatter = formats.formatters[format];
  var filter = defaults.filter;
  if (typeof opts.filter === 'function' || isArray(opts.filter)) {
    filter = opts.filter;
  }
  var arrayFormat;
  if (opts.arrayFormat in arrayPrefixGenerators) {
    arrayFormat = opts.arrayFormat;
  } else if ('indices' in opts) {
    arrayFormat = opts.indices ? 'indices' : 'repeat';
  } else {
    arrayFormat = defaults.arrayFormat;
  }
  if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
    throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
  }
  var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
  return {
    addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
    allowDots: allowDots,
    allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
    arrayFormat: arrayFormat,
    charset: charset,
    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
    commaRoundTrip: opts.commaRoundTrip,
    delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
    encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
    encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
    encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
    encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
    filter: filter,
    format: format,
    formatter: formatter,
    serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
    skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
    sort: typeof opts.sort === 'function' ? opts.sort : null,
    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
  };
};
module.exports = function (object, opts) {
  var obj = object;
  var options = normalizeStringifyOptions(opts);
  var objKeys;
  var filter;
  if (typeof options.filter === 'function') {
    filter = options.filter;
    obj = filter('', obj);
  } else if (isArray(options.filter)) {
    filter = options.filter;
    objKeys = filter;
  }
  var keys = [];
  if (typeof obj !== 'object' || obj === null) {
    return '';
  }
  var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
  var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
  if (!objKeys) {
    objKeys = Object.keys(obj);
  }
  if (options.sort) {
    objKeys.sort(options.sort);
  }
  var sideChannel = getSideChannel();
  for (var i = 0; i < objKeys.length; ++i) {
    var key = objKeys[i];
    if (options.skipNulls && obj[key] === null) {
      continue;
    }
    pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
  }
  var joined = keys.join(options.delimiter);
  var prefix = options.addQueryPrefix === true ? '?' : '';
  if (options.charsetSentinel) {
    if (options.charset === 'iso-8859-1') {
      // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
      prefix += 'utf8=%26%2310003%3B&';
    } else {
      // encodeURIComponent('✓')
      prefix += 'utf8=%E2%9C%93&';
    }
  }
  return joined.length > 0 ? prefix + joined : '';
};

/***/ }),

/***/ 4509:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var formats = __webpack_require__(9292);
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var hexTable = function () {
  var array = [];
  for (var i = 0; i < 256; ++i) {
    array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
  }
  return array;
}();
var compactQueue = function compactQueue(queue) {
  while (queue.length > 1) {
    var item = queue.pop();
    var obj = item.obj[item.prop];
    if (isArray(obj)) {
      var compacted = [];
      for (var j = 0; j < obj.length; ++j) {
        if (typeof obj[j] !== 'undefined') {
          compacted.push(obj[j]);
        }
      }
      item.obj[item.prop] = compacted;
    }
  }
};
var arrayToObject = function arrayToObject(source, options) {
  var obj = options && options.plainObjects ? Object.create(null) : {};
  for (var i = 0; i < source.length; ++i) {
    if (typeof source[i] !== 'undefined') {
      obj[i] = source[i];
    }
  }
  return obj;
};
var merge = function merge(target, source, options) {
  /* eslint no-param-reassign: 0 */
  if (!source) {
    return target;
  }
  if (typeof source !== 'object') {
    if (isArray(target)) {
      target.push(source);
    } else if (target && typeof target === 'object') {
      if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) {
        target[source] = true;
      }
    } else {
      return [target, source];
    }
    return target;
  }
  if (!target || typeof target !== 'object') {
    return [target].concat(source);
  }
  var mergeTarget = target;
  if (isArray(target) && !isArray(source)) {
    mergeTarget = arrayToObject(target, options);
  }
  if (isArray(target) && isArray(source)) {
    source.forEach(function (item, i) {
      if (has.call(target, i)) {
        var targetItem = target[i];
        if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
          target[i] = merge(targetItem, item, options);
        } else {
          target.push(item);
        }
      } else {
        target[i] = item;
      }
    });
    return target;
  }
  return Object.keys(source).reduce(function (acc, key) {
    var value = source[key];
    if (has.call(acc, key)) {
      acc[key] = merge(acc[key], value, options);
    } else {
      acc[key] = value;
    }
    return acc;
  }, mergeTarget);
};
var assign = function assignSingleSource(target, source) {
  return Object.keys(source).reduce(function (acc, key) {
    acc[key] = source[key];
    return acc;
  }, target);
};
var decode = function (str, decoder, charset) {
  var strWithoutPlus = str.replace(/\+/g, ' ');
  if (charset === 'iso-8859-1') {
    // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
  }
  // utf-8
  try {
    return decodeURIComponent(strWithoutPlus);
  } catch (e) {
    return strWithoutPlus;
  }
};
var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
  // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
  // It has been adapted here for stricter adherence to RFC 3986
  if (str.length === 0) {
    return str;
  }
  var string = str;
  if (typeof str === 'symbol') {
    string = Symbol.prototype.toString.call(str);
  } else if (typeof str !== 'string') {
    string = String(str);
  }
  if (charset === 'iso-8859-1') {
    return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
      return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
  }
  var out = '';
  for (var j = 0; j < string.length; j += limit) {
    var segment = string.length >= limit ? string.slice(j, j + limit) : string;
    var arr = [];
    for (var i = 0; i < segment.length; ++i) {
      var c = segment.charCodeAt(i);
      if (c === 0x2D // -
      || c === 0x2E // .
      || c === 0x5F // _
      || c === 0x7E // ~
      || c >= 0x30 && c <= 0x39 // 0-9
      || c >= 0x41 && c <= 0x5A // a-z
      || c >= 0x61 && c <= 0x7A // A-Z
      || format === formats.RFC1738 && (c === 0x28 || c === 0x29) // ( )
      ) {
        arr[arr.length] = segment.charAt(i);
        continue;
      }
      if (c < 0x80) {
        arr[arr.length] = hexTable[c];
        continue;
      }
      if (c < 0x800) {
        arr[arr.length] = hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F];
        continue;
      }
      if (c < 0xD800 || c >= 0xE000) {
        arr[arr.length] = hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
        continue;
      }
      i += 1;
      c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
      arr[arr.length] = hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
    }
    out += arr.join('');
  }
  return out;
};
var compact = function compact(value) {
  var queue = [{
    obj: {
      o: value
    },
    prop: 'o'
  }];
  var refs = [];
  for (var i = 0; i < queue.length; ++i) {
    var item = queue[i];
    var obj = item.obj[item.prop];
    var keys = Object.keys(obj);
    for (var j = 0; j < keys.length; ++j) {
      var key = keys[j];
      var val = obj[key];
      if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
        queue.push({
          obj: obj,
          prop: key
        });
        refs.push(val);
      }
    }
  }
  compactQueue(queue);
  return value;
};
var isRegExp = function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var isBuffer = function isBuffer(obj) {
  if (!obj || typeof obj !== 'object') {
    return false;
  }
  return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var combine = function combine(a, b) {
  return [].concat(a, b);
};
var maybeMap = function maybeMap(val, fn) {
  if (isArray(val)) {
    var mapped = [];
    for (var i = 0; i < val.length; i += 1) {
      mapped.push(fn(val[i]));
    }
    return mapped;
  }
  return fn(val);
};
module.exports = {
  arrayToObject: arrayToObject,
  assign: assign,
  combine: combine,
  compact: compact,
  decode: decode,
  encode: encode,
  isBuffer: isBuffer,
  isRegExp: isRegExp,
  maybeMap: maybeMap,
  merge: merge
};

/***/ }),

/***/ 1837:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */



var punycode = __webpack_require__(1820);
function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */
var protocolPattern = /^([a-z0-9.+-]+:)/i,
  portPattern = /:[0-9]*$/,
  // Special case for a simple path URL
  simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/,
  /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */
  delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
  // RFC 2396: characters not allowed for various reasons.
  unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
  // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
  autoEscape = ['\''].concat(unwise),
  /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */
  nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
  hostEndingChars = ['/', '?', '#'],
  hostnameMaxLen = 255,
  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
  // protocols that can allow "unsafe" and "unwise" chars.
  unsafeProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that never have a hostname.
  hostlessProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that always contain a // bit.
  slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
  },
  querystring = __webpack_require__(3988);
function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && typeof url === 'object' && url instanceof Url) {
    return url;
  }
  var u = new Url();
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}
Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
  if (typeof url !== 'string') {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */
  var queryIndex = url.indexOf('?'),
    splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
    uSplit = url.split(splitter),
    slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);
  var rest = url;

  /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */
  rest = rest.trim();
  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }
  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }
  if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
    /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */

    /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
        hostEnd = hec;
      }
    }

    /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
        hostEnd = hec;
      }
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) {
      hostEnd = rest.length;
    }
    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */
    this.hostname = this.hostname || '';

    /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) {
          continue;
        }
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }
    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }
    if (!ipv6Hostname) {
      /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */
      this.hostname = punycode.toASCII(this.hostname);
    }
    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */
  if (!unsafeProtocol[lowerProto]) {
    /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1) {
        continue;
      }
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) {
    this.pathname = rest;
  }
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  // to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */
  if (typeof obj === 'string') {
    obj = urlParse(obj);
  }
  if (!(obj instanceof Url)) {
    return Url.prototype.format.call(obj);
  }
  return obj.format();
}
Url.prototype.format = function () {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }
  var protocol = this.protocol || '',
    pathname = this.pathname || '',
    hash = this.hash || '',
    host = false,
    query = '';
  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }
  if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }
  var search = this.search || query && '?' + query || '';
  if (protocol && protocol.substr(-1) !== ':') {
    protocol += ':';
  }

  /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */
  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') {
      pathname = '/' + pathname;
    }
  } else if (!host) {
    host = '';
  }
  if (hash && hash.charAt(0) !== '#') {
    hash = '#' + hash;
  }
  if (search && search.charAt(0) !== '?') {
    search = '?' + search;
  }
  pathname = pathname.replace(/[?#]/g, function (match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');
  return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function (relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
  if (!source) {
    return relative;
  }
  return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function (relative) {
  if (typeof relative === 'string') {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }
  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol') {
        result[rkey] = relative[rkey];
      }
    }

    // urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
      result.pathname = '/';
      result.path = result.pathname;
    }
    result.href = result.format();
    return result;
  }
  if (relative.protocol && relative.protocol !== result.protocol) {
    /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }
    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift())) {}
      if (!relative.host) {
        relative.host = '';
      }
      if (!relative.hostname) {
        relative.hostname = '';
      }
      if (relPath[0] !== '') {
        relPath.unshift('');
      }
      if (relPath.length < 2) {
        relPath.unshift('');
      }
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }
  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
    isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
    mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname,
    removeAllDots = mustEndAbs,
    srcPath = result.pathname && result.pathname.split('/') || [],
    relPath = relative.pathname && relative.pathname.split('/') || [],
    psychotic = result.protocol && !slashedProtocol[result.protocol];

  /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') {
        srcPath[0] = result.host;
      } else {
        srcPath.unshift(result.host);
      }
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') {
          relPath[0] = relative.host;
        } else {
          relPath.unshift(relative.host);
        }
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }
  if (isRelAbs) {
    // it's absolute.
    result.host = relative.host || relative.host === '' ? relative.host : result.host;
    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */
    if (!srcPath) {
      srcPath = [];
    }
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (relative.search != null) {
    /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */
    if (psychotic) {
      result.host = srcPath.shift();
      result.hostname = result.host;
      /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */
      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.hostname = authInHost.shift();
        result.host = result.hostname;
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    // to support http.request
    if (result.pathname !== null || result.search !== null) {
      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }
  if (!srcPath.length) {
    /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */
    result.pathname = null;
    // to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';

  /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }
  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }
  if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') {
    srcPath.push('');
  }
  var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';

  // put the host back
  if (psychotic) {
    result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
    result.host = result.hostname;
    /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */
    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.hostname = authInHost.shift();
      result.host = result.hostname;
    }
  }
  mustEndAbs = mustEndAbs || result.host && srcPath.length;
  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }
  if (srcPath.length > 0) {
    result.pathname = srcPath.join('/');
  } else {
    result.pathname = null;
    result.path = null;
  }

  // to support request.http
  if (result.pathname !== null || result.search !== null) {
    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};
Url.prototype.parseHost = function () {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) {
    this.hostname = host;
  }
};
__webpack_unused_export__ = urlParse;
__webpack_unused_export__ = urlResolve;
__webpack_unused_export__ = urlResolveObject;
__webpack_unused_export__ = urlFormat;
__webpack_unused_export__ = Url;

/***/ }),

/***/ 2696:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ components_Accordion)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3368);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Accordion/_styles.scss
var _styles = __webpack_require__(9267);
// EXTERNAL MODULE: ./src/utilities/EventUtilities.js
var EventUtilities = __webpack_require__(5609);
;// CONCATENATED MODULE: ./src/components/Accordion/Accordion.jsx





var Accordion = function Accordion(props) {
  var onHeaderClick = function onHeaderClick() {
    var _props$onChange;
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props);
  };
  var onHeaderKeyDown = function onHeaderKeyDown(e) {
    if ((0,EventUtilities/* isEnterPressed */.DV)(e)) {
      e.preventDefault();
      onHeaderClick();
    }
  };
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: classnames_default()("accordion", {
      "expanded": props.expanded
    })
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "accordion-header-container",
    id: props.id,
    onClick: onHeaderClick,
    onKeyDown: onHeaderKeyDown,
    "aria-controls": props.ariaControls,
    "aria-expanded": props.expanded,
    "aria-disabled": "false",
    role: "button",
    tabIndex: props.tabIndex
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "accordion-header"
  }, props.header), /*#__PURE__*/external_react_default().createElement("div", {
    className: "accordion-header-icon-container"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "ion-ios-arrow-down"
  }))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "accordion-content-container",
    "aria-disabled": "false",
    "aria-hidden": "true"
  }, props.children));
};
 false ? 0 : void 0;
/* harmony default export */ const Accordion_Accordion = (Accordion);
;// CONCATENATED MODULE: ./src/components/Accordion/index.js

/* harmony default export */ const components_Accordion = (Accordion_Accordion);

/***/ }),

/***/ 1504:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export ActionButtonsPanel */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9305);
/* harmony import */ var _components_PendingButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7113);
/* harmony import */ var _utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5609);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }





var ActionButtonsPanel = /*#__PURE__*/function (_React$PureComponent) {
  function ActionButtonsPanel(props) {
    var _this;
    _classCallCheck(this, ActionButtonsPanel);
    _this = _callSuper(this, ActionButtonsPanel, [props]);
    _this.setFocus = _this.setFocus.bind(_this);
    _this.onCancelKeyDown = _this.onCancelKeyDown.bind(_this);
    _this.onSaveKeyDown = _this.onSaveKeyDown.bind(_this);
    _this.onAdditionalButtonKeyDown = _this.onAdditionalButtonKeyDown.bind(_this);
    return _this;
  }
  _inherits(ActionButtonsPanel, _React$PureComponent);
  return _createClass(ActionButtonsPanel, [{
    key: "setFocus",
    value: function setFocus() {
      this.cancelButton.setFocus();
    }
  }, {
    key: "setFocusToSave",
    value: function setFocusToSave() {
      this.saveButton.setFocus();
    }
  }, {
    key: "onCancelKeyDown",
    value: function onCancelKeyDown(event) {
      if (!(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isTabPressed */ .Wz)(event) || (0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isShiftPressed */ .Hk)(event)) return;
      event.preventDefault();
      if (this.props.hasExternalFocus) {
        this.props.moveFocusBack && this.props.moveFocusBack();
      } else {
        this.saveButton.setFocus();
      }
    }
  }, {
    key: "onSaveKeyDown",
    value: function onSaveKeyDown(event) {
      if (!(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isTabPressed */ .Wz)(event) || !(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isShiftPressed */ .Hk)(event)) return;
      if (this.props.hasExternalFocus) {
        this.props.onSaveFocusBack && this.props.onSaveFocusBack();
      } else {
        event.preventDefault();
        this.cancelButton.setFocus();
      }
    }
  }, {
    key: "onAdditionalButtonKeyDown",
    value: function onAdditionalButtonKeyDown(event) {
      if (!(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isTabPressed */ .Wz)(event) || !(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isShiftPressed */ .Hk)(event)) return;
      if (this.props.hasExternalFocus) {
        this.props.onSaveFocusBack && this.props.onSaveFocusBack();
      } else {
        event.preventDefault();
        this.cancelButton.setFocus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var shouldShowSave = !this.props.hideSave;
      var shouldShowAdditional = !this.props.hideAdditionalButton;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: this.props.className,
        name: "actionButtonsPanel"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
        name: "cancelButton",
        className: "btn btn-default btn-mobile-cancel",
        tabIndex: 3,
        onClick: this.props.onCancel,
        onKeyDown: this.onCancelKeyDown,
        disabled: this.props.isSaving,
        ref: function ref(input) {
          return _this2.cancelButton = input;
        }
      }, "Cancel"), shouldShowAdditional && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_components_PendingButton__WEBPACK_IMPORTED_MODULE_4__["default"], {
        type: "button",
        name: "additionalButton",
        className: this.props.additionalButtonClassName,
        tabIndex: 1,
        title: this.props.additionalButtonTitle,
        onClick: this.props.onAdditionalButtonClick,
        onKeyDown: this.onAdditionalButtonKeyDown,
        ref: function ref(input) {
          return _this2.additionalButton = input;
        },
        disabled: this.props.isDisabled,
        iconName: this.props.additionalButtonIconName,
        iconClassName: this.props.additionalButtonIconClassName,
        isPending: this.props.isAdditionalButtonPending
      }), shouldShowSave && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_components_PendingButton__WEBPACK_IMPORTED_MODULE_4__["default"], {
        name: "saveButton",
        className: "btn btn-success",
        tabIndex: 2,
        title: this.props.saveTitle,
        isPending: this.props.isSaving,
        pendingTitle: this.props.savingTitle,
        onClick: this.props.onSave,
        onKeyDown: this.onSaveKeyDown,
        ref: function ref(input) {
          return _this2.saveButton = input;
        },
        disabled: this.props.isDisabled
      }));
    }
  }]);
}((react__WEBPACK_IMPORTED_MODULE_0___default().PureComponent));
ActionButtonsPanel.defaultProps = {
  onSave: function onSave() {},
  onCancel: function onCancel() {},
  onAdditionalButtonClick: function onAdditionalButtonClick() {},
  onSaveFocusBack: function onSaveFocusBack() {},
  saveTitle: "Done",
  savingTitle: "Saving",
  isSaving: false,
  isDisabled: false,
  className: "btn-control",
  moveFocusBack: function moveFocusBack() {},
  hideSave: false,
  hideAdditionalButton: true,
  additionalButtonClassName: "btn btn-warning",
  isAdditionalButtonPending: false
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ActionButtonsPanel);

/***/ }),

/***/ 8312:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export BadgeLabel */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var BadgeLabel = function BadgeLabel(_ref) {
  var title = _ref.title,
    className = _ref.className;
  if (!title) return null;
  var resultClassName = className ? className : "";
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: resultClassName,
    name: "badge-label"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, title));
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BadgeLabel);

/***/ }),

/***/ 9305:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export Button */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }


var Button = /*#__PURE__*/function (_React$PureComponent) {
  function Button(props) {
    var _this;
    _classCallCheck(this, Button);
    _this = _callSuper(this, Button, [props]);
    _this.setFocus = _this.setFocus.bind(_this);
    return _this;
  }
  _inherits(Button, _React$PureComponent);
  return _createClass(Button, [{
    key: "setFocus",
    value: function setFocus() {
      this.button.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var buttonProps = {};
      buttonProps["disabled"] = this.props.disabled;
      buttonProps["onKeyDown"] = this.props.onKeyDown;
      buttonProps["autoFocus"] = this.props.autoFocus;
      buttonProps["name"] = this.props.name;
      var children = this.props.title && this.props.title.length > 0 ? this.props.title : this.props.children;
      if (this.props.id) {
        buttonProps["id"] = this.props.id;
      }
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", _extends({
        ref: function ref(input) {
          _this2.button = input;
        },
        tabIndex: this.props.tabIndex,
        className: this.props.className,
        "aria-describedby": this.props.ariaDescribedBy
      }, buttonProps, {
        onClick: this.props.onClick
      }), children);
    }
  }]);
}((react__WEBPACK_IMPORTED_MODULE_0___default().PureComponent));
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Button);

/***/ }),

/***/ 8124:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Caret: () => (/* binding */ Caret),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var Caret = function Caret(_ref) {
  var sort = _ref.sort;
  if (sort === "asc") return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "mdi-arrow-down"
  });else if (sort === "desc") return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "mdi-arrow-up"
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "unsorted"
  });
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Caret);

/***/ }),

/***/ 9692:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export CheckBox */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5609);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3368);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3554);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_3__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }





var CheckBox = /*#__PURE__*/function (_Component) {
  function CheckBox(props) {
    var _this;
    _classCallCheck(this, CheckBox);
    _this = _callSuper(this, CheckBox, [props]);
    _this.setFocus = _this.setFocus.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onKeyPress = _this.onKeyPress.bind(_this);
    return _this;
  }
  _inherits(CheckBox, _Component);
  return _createClass(CheckBox, [{
    key: "setFocus",
    value: function setFocus() {
      this.checkbox.focus();
    }
  }, {
    key: "onClick",
    value: function onClick() {
      if (!this.props.disabled) this.props.onChange(this.props.value);
    }
  }, {
    key: "onKeyPress",
    value: function onKeyPress(e) {
      if (!this.props.disabled && (0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_4__/* .isSpacePressed */ .l_)(e)) {
        this.props.onChange(this.props.value);
        e.preventDefault();
      }
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      var _this$props = this.props,
        icon = _this$props.icon,
        iconContainerClass = _this$props.iconContainerClass;
      if (!icon) return null;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "checkbox-icon " + iconContainerClass
      }, this.props.icon));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var checkBoxProps = {};
      checkBoxProps["disabled"] = this.props.disabled;
      checkBoxProps["checked"] = this.props.checked;
      var tabProps = {};
      if (this.props.tabIndex && !this.props.disabled) tabProps["tabIndex"] = this.props.tabIndex;
      var resultedCheckBoxClass = this.props.className;
      resultedCheckBoxClass = resultedCheckBoxClass + " sl-checkbox";
      var iconClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()({
        "ion-ios-checkbox": this.props.checked,
        "ion-md-square-outline": !this.props.checked,
        "inactive": this.props.disabled
      });
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: resultedCheckBoxClass,
        onClick: this.onClick,
        name: "checkboxContainer"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
        className: "blueCheckBox",
        name: "checkbox"
      }, tabProps, {
        onKeyDown: this.props.onKeyDown,
        onKeyPress: this.onKeyPress,
        ref: function ref(checkbox) {
          _this2.checkbox = checkbox;
        },
        "data-checked": this.props.checked
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", _extends({
        type: "checkbox",
        name: this.props.name
      }, checkBoxProps, {
        onChange: this.onClick
      })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("i", {
        className: iconClass
      })), this.getIcon(), this.props.label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: this.props.labelContainerClassName
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", {
        className: this.props.labelClassName,
        name: "checkboxLabel"
      }, this.props.label)));
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
CheckBox.defaultProps = {
  iconContainerClass: "",
  className: "",
  disabled: false,
  onKeyDown: function onKeyDown() {}
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CheckBox);

/***/ }),

/***/ 7276:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export ClickableMenu */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }


var ClickableMenu = /*#__PURE__*/function (_React$PureComponent) {
  function ClickableMenu(props, context) {
    var _this;
    _classCallCheck(this, ClickableMenu);
    _this = _callSuper(this, ClickableMenu, [props, context]);
    _this.state = {
      dropdownIsVisible: false
    };
    _this.dropdownIsActive = false;
    _this.hideDropdown = _this.hideDropdown.bind(_this);
    _this.toggleDropdown = _this.toggleDropdown.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.onMouseEnter = _this.onMouseEnter.bind(_this);
    _this.onMouseLeave = _this.onMouseLeave.bind(_this);
    return _this;
  }
  _inherits(ClickableMenu, _React$PureComponent);
  return _createClass(ClickableMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("click", this.hideDropdown, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("click", this.hideDropdown, false);
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown() {
      var dropdownIsVisible = this.state.dropdownIsVisible;
      this.dropdownIsActive = !dropdownIsVisible;
      this.setState({
        dropdownIsVisible: !dropdownIsVisible
      });
      if (this.props.onClick) this.props.onClick();
      if (this.props.setIsVisible) this.props.setIsVisible(this.dropdownIsActive);
    }
  }, {
    key: "hideDropdown",
    value: function hideDropdown() {
      if (!this.dropdownIsActive) {
        this.setState({
          dropdownIsVisible: false
        });
        if (this.props.setIsVisible) this.props.setIsVisible(false);
      }
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      this.dropdownIsActive = false;
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter() {
      this.dropdownIsActive = true;
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.dropdownIsActive = true;
    }
  }, {
    key: "title",
    value: function title() {
      if (this.props.titleClass) return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
        className: this.props.titleClass,
        title: this.props.title
      });
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var dropdownId = this.props.id;
      var dropdownIsVisible = this.state.dropdownIsVisible;
      var title = this.props.title;
      var linkClass = dropdownIsVisible ? this.props.titleClass + " active" : this.props.titleClass;
      var divClass = dropdownIsVisible ? "custom-dropdown active" : "custom-dropdown";
      var menuClass = dropdownIsVisible ? "smooth-menu menu-visible" : "smooth-menu menu-invisible";
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        id: dropdownId,
        className: divClass,
        tabIndex: dropdownId,
        onFocus: this.handleFocus,
        onClick: this.toggleDropdown,
        onMouseLeave: this.onMouseLeave,
        onMouseEnter: this.onMouseEnter
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
        className: linkClass,
        type: "button"
      }, this.props.label, this.props.icon, title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: menuClass
      }, this.props.children));
    }
  }]);
}((react__WEBPACK_IMPORTED_MODULE_0___default().PureComponent));
ClickableMenu.defaultProps = {
  titleClass: ""
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ClickableMenu);

/***/ }),

/***/ 1789:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var cleave_js_dist_cleave_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6543);
/* harmony import */ var cleave_js_dist_cleave_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(cleave_js_dist_cleave_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var DateInput = /*#__PURE__*/function (_Component) {
  function DateInput() {
    var _this;
    _classCallCheck(this, DateInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DateInput, [].concat(args));
    _defineProperty(_this, "setFocus", function () {
      _this.dateInput.element.focus();
    });
    return _this;
  }
  _inherits(DateInput, _Component);
  return _createClass(DateInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var wrapperClass = "form-group";
      if (this.props.error && this.props.error.length > 0) {
        wrapperClass += " " + "has-error";
      }
      if (this.props.className) wrapperClass += " " + this.props.className;
      var labelId = this.props.name + "Label";
      var inputId = this.props.name + "Input";
      var componentName = this.props.name + "Field";
      var inputFinalClassName = this.props.inputClassName ? "form-control " + this.props.inputClassName : "form-control";
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: wrapperClass,
        name: componentName
      }, this.props.label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", {
        id: labelId,
        htmlFor: this.props.name
      }, this.props.label), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((cleave_js_dist_cleave_react__WEBPACK_IMPORTED_MODULE_1___default()), {
        id: inputId,
        name: this.props.name,
        ref: function ref(_ref) {
          return _this2.dateInput = _ref;
        },
        value: this.props.value,
        placeholder: this.props.placeholder,
        className: inputFinalClassName,
        tabIndex: this.props.tabIndex,
        autoFocus: this.props.autoFocus,
        options: this.props.options,
        onChange: this.props.onChange,
        onKeyDown: this.props.onKeyDown,
        disabled: this.props.disabled
      }), this.props.error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        name: "dateError",
        className: "validate-error-message"
      }, this.props.error));
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
DateInput.defaultProps = {
  error: "",
  placeholder: "mm/dd/yyyy",
  options: {
    date: true,
    datePattern: ["m", "d", "Y"]
  }
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (DateInput);

/***/ }),

/***/ 6938:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _TextInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7642);
/* harmony import */ var _utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5609);




var DecimalInput = function DecimalInput(_ref) {
  var value = _ref.value,
    error = _ref.error,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    tabIndex = _ref.tabIndex,
    autoFocus = _ref.autoFocus,
    name = _ref.name,
    className = _ref.className,
    decimalPlacesCount = _ref.decimalPlacesCount;
  var isAcceptableKey = function isAcceptableKey(event) {
    if (!(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isNumberKeyFromEvent */ .Db)(event) && !(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isDecimalPointFromEvent */ .IE)(event)) {
      event.preventDefault();
    }
    var hasDecimalPoint = value.indexOf(".") >= 0;
    if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isDecimalPointFromEvent */ .IE)(event) && (value.length == 0 || hasDecimalPoint)) {
      event.preventDefault();
    }
    var decimalPlaces = hasDecimalPoint ? value.substring(value.indexOf("."), value.length).length : 0;
    if (decimalPlacesCount && decimalPlaces > decimalPlacesCount) {
      event.preventDefault();
    }
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_TextInput__WEBPACK_IMPORTED_MODULE_3__["default"], {
    name: name,
    tabIndex: tabIndex,
    value: value,
    autoFocus: autoFocus,
    onChange: onChange,
    error: error,
    className: className,
    disabled: disabled,
    onKeyPress: isAcceptableKey,
    placeholder: ""
  });
};
DecimalInput.defaultProps = {
  disabled: false
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (DecimalInput);

/***/ }),

/***/ 4834:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export DocumentTitle */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }


var DocumentTitle = /*#__PURE__*/function (_PureComponent) {
  function DocumentTitle() {
    _classCallCheck(this, DocumentTitle);
    return _callSuper(this, DocumentTitle, arguments);
  }
  _inherits(DocumentTitle, _PureComponent);
  return _createClass(DocumentTitle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.title = this.props.title;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.title !== this.props.title) {
        document.title = this.props.title;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (DocumentTitle);

/***/ }),

/***/ 3615:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ components_DropDown)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./src/utilities/EventUtilities.js
var EventUtilities = __webpack_require__(5609);
;// CONCATENATED MODULE: ./src/components/DropDown/ItemRow.jsx


var ItemRow = function ItemRow(_ref) {
  var item = _ref.item,
    index = _ref.index,
    getRowContent = _ref.getRowContent,
    dataFieldName = _ref.dataFieldName,
    titleFieldName = _ref.titleFieldName,
    selectedItemIndex = _ref.selectedItemIndex,
    onItemSelected = _ref.onItemSelected,
    contentClassName = _ref.contentClassName,
    liRef = _ref.liRef;
  var showDefaultRow = !getRowContent;
  var displayedValue = dataFieldName && dataFieldName.length > 0 ? item[dataFieldName] : item;
  var title = titleFieldName && titleFieldName.length > 0 ? item[titleFieldName] : displayedValue;
  var isItemSelected = index === selectedItemIndex;
  var className = isItemSelected ? "selected" : "";
  var onMouseDown = function onMouseDown() {
    onItemSelected(item);
  };
  return /*#__PURE__*/external_react_default().createElement("li", {
    className: className,
    ref: isItemSelected ? liRef : null,
    onMouseDown: onMouseDown
  }, getContent(showDefaultRow, contentClassName, title, displayedValue, item, getRowContent));
};
var getContent = function getContent(showDefaultRow, contentClassName, title, displayedValue, item, getRowContent) {
  if (showDefaultRow) {
    return /*#__PURE__*/external_react_default().createElement("a", {
      href: "",
      className: contentClassName
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "truncate",
      title: title
    }, /*#__PURE__*/external_react_default().createElement("span", null, displayedValue)));
  }
  return getRowContent(item);
};
 false ? 0 : void 0;
/* harmony default export */ const DropDown_ItemRow = (ItemRow);
;// CONCATENATED MODULE: ./src/components/DropDown/DropDown.jsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }




var DropDown = /*#__PURE__*/function (_React$Component) {
  function DropDown(props, context) {
    var _this;
    _classCallCheck(this, DropDown);
    _this = _callSuper(this, DropDown, [props, context]);
    _this.state = {
      selectedItemIndex: -1,
      dropdownIsActive: false
    };
    _this.onBlur = _this.onBlur.bind(_this);
    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.onItemSelected = _this.onItemSelected.bind(_this);
    _this.getItemRow = _this.getItemRow.bind(_this);
    _this.setFocus = _this.setFocus.bind(_this);
    _this.toggleDropdown = _this.toggleDropdown.bind(_this);
    return _this;
  }
  _inherits(DropDown, _React$Component);
  return _createClass(DropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.selectedItem) {
        var selectedItemIndex = this.getPropsSelectedItemIndex();
        if (selectedItemIndex >= 0) this.setState({
          selectedItemIndex: selectedItemIndex
        });
      }
      if (this.props.autoFocus) {
        this.setFocus();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.selectedItem && this.props.selectedItem !== prevProps.selectedItem) {
        var selectedItemIndex = this.getPropsSelectedItemIndex();
        if (selectedItemIndex >= 0) this.setState({
          selectedItemIndex: selectedItemIndex
        });
      }
      if (prevState.selectedItem !== this.state.selectedItemIndex && this.ul && this.li) {
        this.updateScrollingPosition();
      }
    }
  }, {
    key: "getPropsSelectedItemIndex",
    value: function getPropsSelectedItemIndex() {
      var _this2 = this;
      var selectedItemIndex = this.state.selectedItemIndex;
      if (!this.props.valueFieldName || this.props.valueFieldName == "") {
        selectedItemIndex = this.props.items.indexOf(this.props.selectedItem);
      } else {
        selectedItemIndex = this.props.items.findIndex(function (item) {
          return item[_this2.props.valueFieldName] === _this2.props.selectedItem[_this2.props.valueFieldName];
        });
      }
      return selectedItemIndex;
    }
  }, {
    key: "updateScrollingPosition",
    value: function updateScrollingPosition() {
      var ul = this.ul;
      var elementBottomPosition = this.li.offsetTop + this.li.scrollHeight;
      var elementTopPosition = this.li.offsetTop;
      var ulBottomPosition = ul.offsetHeight + ul.scrollTop;
      if (elementBottomPosition > ulBottomPosition) {
        ul.scrollTop = elementBottomPosition - ul.offsetHeight;
      } else if (elementTopPosition < ul.scrollTop) {
        ul.scrollTop = elementTopPosition;
      }
    }
  }, {
    key: "onItemSelected",
    value: function onItemSelected(item) {
      this.props.onSelect(item);
      this.toggleDropdown();
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      if (this.state.dropdownIsActive) {
        this.setState({
          dropdownIsActive: false
        });
        var selectedItemIndex = this.getPropsSelectedItemIndex();
        if (selectedItemIndex !== this.state.selectedItemIndex) {
          this.selectItem();
        }
      }
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown() {
      var dropdownIsActive = this.state.dropdownIsActive;
      var newDropdownState = !dropdownIsActive;
      if (this.state.selectedItemIndex == -1 && newDropdownState) this.setState({
        selectedItemIndex: 0
      });
      this.setState({
        dropdownIsActive: newDropdownState
      });
    }
  }, {
    key: "setFocus",
    value: function setFocus() {
      if (this.dropdown) {
        this.dropdown.focus();
      }
    }
  }, {
    key: "getItemRow",
    value: function getItemRow(item, index) {
      var _this3 = this;
      return /*#__PURE__*/external_react_default().createElement(DropDown_ItemRow, {
        getRowContent: this.props.getRowContent,
        liRef: function liRef(el) {
          return _this3.li = el;
        },
        item: item,
        index: index,
        key: index,
        selectedItemIndex: this.state.selectedItemIndex,
        titleFieldName: this.props.titleFieldName,
        onItemSelected: this.onItemSelected,
        contentClassName: this.props.contentClassName,
        dataFieldName: this.props.dataFieldName
      });
    }
  }, {
    key: "getDropDown",
    value: function getDropDown() {
      var _this4 = this;
      var items = this.props.items;
      return /*#__PURE__*/external_react_default().createElement("ul", {
        ref: function ref(_ref) {
          return _this4.ul = _ref;
        },
        className: "tabbed-dropdown-menu"
      }, items.map(function (item, index) {
        return _this4.getItemRow(item, index);
      }));
    }
  }, {
    key: "onSpaceHandler",
    value: function onSpaceHandler() {
      if (this.props.items && this.props.items.length > 0 && this.state.dropdownIsActive) {
        this.selectItem();
        return;
      }
      this.toggleDropdown();
    }
  }, {
    key: "onDownArrowHandler",
    value: function onDownArrowHandler() {
      var currentIndex = this.state.selectedItemIndex;
      var newIndex = currentIndex < this.props.items.length - 1 ? currentIndex + 1 : 0;
      this.setState({
        selectedItemIndex: newIndex
      });
      if (!this.state.dropdownIsActive) {
        var item = this.props.items[newIndex];
        this.props.onSelect(item);
      }
    }
  }, {
    key: "onUpArrowHandler",
    value: function onUpArrowHandler() {
      var currentIndex = this.state.selectedItemIndex;
      var newIndex = currentIndex <= 0 ? this.props.items.length - 1 : currentIndex - 1;
      this.setState({
        selectedItemIndex: newIndex
      });
      if (!this.state.dropdownIsActive) {
        var item = this.props.items[newIndex];
        this.props.onSelect(item);
      }
    }
  }, {
    key: "onShiftTabHandler",
    value: function onShiftTabHandler(e) {
      this.props.moveFocusBack();
      e.preventDefault();
    }
  }, {
    key: "onEnterHandler",
    value: function onEnterHandler() {
      this.selectItem();
    }
  }, {
    key: "onTabHandler",
    value: function onTabHandler(e) {
      this.selectItem();
      e.preventDefault();
    }
  }, {
    key: "selectItem",
    value: function selectItem() {
      var item = this.props.items[this.state.selectedItemIndex];
      this.onItemSelected(item);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      if (this.props.isDisabled) return;
      if ((0,EventUtilities/* isSpacePressed */.l_)(e)) {
        this.onSpaceHandler();
        e.preventDefault();
        return;
      }
      if ((0,EventUtilities/* downArrowPressed */.Ur)(e)) {
        this.onDownArrowHandler();
        e.preventDefault();
        return;
      }
      if ((0,EventUtilities/* upArrowPressed */.P7)(e)) {
        this.onUpArrowHandler();
        e.preventDefault();
        return;
      }
      if (((0,EventUtilities/* isTabPressed */.Wz)(e) || (0,EventUtilities/* isEnterPressed */.DV)(e)) && this.state.dropdownIsActive) {
        this.selectItem();
      }
      if ((0,EventUtilities/* isTabPressed */.Wz)(e) && (0,EventUtilities/* isShiftPressed */.Hk)(e) && this.props.moveFocusBack) {
        this.props.moveFocusBack();
        e.preventDefault();
      }
      if ((0,EventUtilities/* isEscPressed */.e0)(e) && this.state.dropdownIsActive) {
        var selectedItemIndex = this.props.items.indexOf(this.props.selectedItem);
        this.setState({
          selectedItemIndex: selectedItemIndex
        });
        this.toggleDropdown();
      }
    }
  }, {
    key: "getDropDownButton",
    value: function getDropDownButton() {
      var _this5 = this;
      var selectedItem = this.props.selectedItem;
      var dataFieldName = this.props.dataFieldName;
      var selectedItemClassName = "selected-value " + this.props.selectedItemClassName;
      var displaySelectedItem = selectedItem && selectedItem[dataFieldName] != undefined ? selectedItem[dataFieldName] : selectedItem;
      if (this.props.isDisabled) {
        return /*#__PURE__*/external_react_default().createElement("div", {
          className: "tabbed-button-dropdown disabled",
          tabIndex: this.props.tabIndex,
          name: "buttonDropdown"
        }, /*#__PURE__*/external_react_default().createElement("span", {
          className: selectedItemClassName,
          name: "selectedItemName"
        }, displaySelectedItem), /*#__PURE__*/external_react_default().createElement("span", {
          className: "ion-md-arrow-dropdown",
          name: "dropDownArrow"
        }));
      }
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "tabbed-button-dropdown",
        tabIndex: this.props.tabIndex,
        name: "buttonDropdown",
        ref: function ref(dropdown) {
          _this5.dropdown = dropdown;
        },
        onKeyDown: this.onKeyDown,
        onClick: this.toggleDropdown,
        onBlur: this.onBlur
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: selectedItemClassName,
        name: "selectedItemName",
        onClick: function onClick(e) {
          _this5.props.onDisplayItemClick(selectedItem, e);
        }
      }, displaySelectedItem), /*#__PURE__*/external_react_default().createElement("span", {
        className: "ion-md-arrow-dropdown",
        name: "dropDownArrow"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var dropdownIsVisible = this.state.dropdownIsActive;
      var className = "tabbed-dropdown " + this.props.className;
      var showLabel = this.props.label && this.props.label.length > 0;
      return /*#__PURE__*/external_react_default().createElement("div", {
        id: this.props.id,
        className: className,
        name: this.props.name
      }, showLabel && /*#__PURE__*/external_react_default().createElement("label", null, this.props.label), this.getDropDownButton(), dropdownIsVisible && this.getDropDown(), this.props.error && /*#__PURE__*/external_react_default().createElement("div", {
        className: "validate-error-message"
      }, this.props.error));
    }
  }]);
}((external_react_default()).Component);
DropDown.defaultProps = {
  onDisplayItemClick: function onDisplayItemClick() {},
  items: [],
  dataFieldName: "",
  titleFieldName: "",
  valueFieldName: "",
  className: "",
  selectedItemClassName: "",
  contentClassName: "blue",
  autoFocus: false,
  isDisabled: false
};
 false ? 0 : void 0;
/* harmony default export */ const DropDown_DropDown = (DropDown);
;// CONCATENATED MODULE: ./src/components/DropDown/index.js


/* harmony default export */ const components_DropDown = (DropDown_DropDown);

/***/ }),

/***/ 6426:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ FormContainer)
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _NavigationBar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(144);
/* harmony import */ var _ActionButtonsPanel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1504);
/* harmony import */ var _Popup_OptionsPopup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(296);
/* harmony import */ var _utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5609);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }






var FormContainer = /*#__PURE__*/function (_Component) {
  function FormContainer(props) {
    var _this;
    _classCallCheck(this, FormContainer);
    _this = _callSuper(this, FormContainer, [props]);
    _this.moveFocusToCancelButton = _this.moveFocusToCancelButton.bind(_this);
    _this.moveFocusToSaveButton = _this.moveFocusToSaveButton.bind(_this);
    _this.moveFocusToBackButton = _this.moveFocusToBackButton.bind(_this);
    _this.handleBackButtonKeyDown = _this.handleBackButtonKeyDown.bind(_this);
    return _this;
  }
  _inherits(FormContainer, _Component);
  return _createClass(FormContainer, [{
    key: "moveFocusToCancelButton",
    value: function moveFocusToCancelButton() {
      this.actionsPanel.setFocus();
    }
  }, {
    key: "moveFocusToSaveButton",
    value: function moveFocusToSaveButton() {
      this.actionsPanel.setFocusToSave();
    }
  }, {
    key: "moveFocusToBackButton",
    value: function moveFocusToBackButton() {
      this.navigationBar.setFocus();
    }
  }, {
    key: "handleBackButtonKeyDown",
    value: function handleBackButtonKeyDown(e) {
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isEnterPressed */ .DV)(e) || (0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isSpacePressed */ .l_)(e)) {
        e.preventDefault();
        var onBack = this.props.onBack || this.props.onCancel;
        onBack && onBack(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
        className: this.props.className,
        id: this.props.id
      }, this.props.showNavigationBar && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_NavigationBar__WEBPACK_IMPORTED_MODULE_3__["default"], {
        titleText: this.props.navBarTitle,
        onClick: this.props.onBack || this.props.onCancel,
        disabled: this.props.isSaving,
        backLinkName: "backLinkContainer",
        extraComponent: this.props.navBarExtraComponent,
        ref: function ref(_ref) {
          return _this2.navigationBar = _ref;
        },
        onKeyDown: this.handleBackButtonKeyDown
      }), this.props.popupItems && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
        className: "details-header"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_Popup_OptionsPopup__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A, {
        hidden: this.props.isPopupHidden,
        items: this.props.popupItems,
        showAlways: false,
        popupClass: "right-side-popup"
      })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
        className: "base-content"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
        className: "form form-vertical"
      }, this.props.legend && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("legend", {
        className: this.props.legendClassName
      }, this.props.legend), this.props.fieldsetWrapper && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("fieldset", null, this.props.children), !this.props.fieldsetWrapper && this.props.children, this.props.showActionsPanel && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_ActionButtonsPanel__WEBPACK_IMPORTED_MODULE_5__["default"], {
        ref: function ref(_ref2) {
          return _this2.actionsPanel = _ref2;
        },
        className: this.props.buttonsClassName,
        onBack: this.props.onBack,
        onCancel: this.props.onCancel,
        onSave: this.props.onSave,
        onAdditionalButtonClick: this.props.onAdditionalButtonClick,
        isSaving: this.props.isSaving,
        onSaveFocusBack: this.props.onSaveFocusBack,
        isDisabled: this.props.isSaveButtonDisabled,
        moveFocusBack: this.props.moveFocusBack,
        saveTitle: this.props.saveButtonTitle,
        hasExternalFocus: this.props.hasFocusedChild,
        additionalButtonTitle: this.props.additionalButtonTitle,
        hideAdditionalButton: this.props.hideAdditionalButton,
        isAdditionalButtonPending: this.props.isAdditionalButtonPending
      }))));
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);

FormContainer.defaultProps = {
  className: "form-container",
  showActionsPanel: true,
  fieldsetWrapper: true,
  hasFocusedChild: true,
  isPopupHidden: false,
  buttonsClassName: "btn-control",
  legendClassName: "full-row-truncate",
  showNavigationBar: true,
  isAdditionalButtonPending: false
};
 false ? 0 : void 0;

/***/ }),

/***/ 4937:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export Glyph */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var Glyph = function Glyph(_ref) {
  var iconClass = _ref.iconClass,
    iconName = _ref.iconName,
    divClass = _ref.divClass;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: divClass
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: iconClass,
    "aria-hidden": "true",
    name: "glyph"
  }, iconName));
};
Glyph.defaultProps = {
  iconClass: "ion-ios-arrow-forward",
  divClass: "col-xs-1 col-md-1 rightLink"
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Glyph);

/***/ }),

/***/ 1233:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _IconView_IconView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7434);
/* harmony import */ var _utilities_SortingUtilities__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7609);
/* harmony import */ var _utilities_ProductUtilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2500);






var AppSelector = function AppSelector(_ref) {
  var _ref$apps = _ref.apps,
    apps = _ref$apps === void 0 ? [] : _ref$apps,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "left-menu-select-product" : _ref$className;
  var getProductLink = function getProductLink(app) {
    var linkClass = app.isLocked ? "locked" : "";
    var href = app.isLocked ? null : app.url;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
      className: "sidebar-item",
      key: app.id
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
      href: href,
      className: linkClass
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "product-icon"
    }, " ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_IconView_IconView__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A, {
      icon: app.icon
    })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "product-title"
    }, " ", app.title)));
  };
  var showProducts = function showProducts(products, title) {
    if (!products || !products.length) return null;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
      className: "app-list"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
      className: "sidebar-item",
      key: 0
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "product-portfolio"
    }, title)), products.map(function (product) {
      return getProductLink(product);
    }));
  };
  var appWithConfiguration = apps.map(function (app) {
    var config = (0,_utilities_ProductUtilities__WEBPACK_IMPORTED_MODULE_3__/* .getProductConfigurationById */ .OI)(app.id);
    var title;
    if (config) {
      title = config.leftMenuLabel ? config.leftMenuLabel : config.label;
    } else {
      title = app.name;
    }
    return {
      id: app.id,
      url: app.url,
      isLocked: app.isLocked,
      title: title,
      icon: config ? config.icon : null
    };
  });
  var surveillance = appWithConfiguration.filter(function (product) {
    return (0,_utilities_ProductUtilities__WEBPACK_IMPORTED_MODULE_3__/* .isSurveillanceProduct */ .ZV)(product.id);
  }).sort(sortByName);
  var safety = appWithConfiguration.filter(function (product) {
    return (0,_utilities_ProductUtilities__WEBPACK_IMPORTED_MODULE_3__/* .isSafetyProduct */ .ih)(product.id);
  }).sort(sortByName);
  var tools = appWithConfiguration.filter(function (product) {
    return (0,_utilities_ProductUtilities__WEBPACK_IMPORTED_MODULE_3__/* .isTools */ .gL)(product.id);
  }).sort(sortByName);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("nav", {
    "aria-label": "product selector",
    className: className
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "sidebar-item app-button"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "ion-md-apps"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "sidebar-item solesource-title"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "SoleSource Apps")), showProducts(surveillance, "Sentri7® Surveillance"), showProducts(safety, "Simplifi+® Compliance"), showProducts(tools, "Tools"));
};
var sortByName = function sortByName(a, b) {
  return (0,_utilities_SortingUtilities__WEBPACK_IMPORTED_MODULE_4__/* .sortByField */ .q_)(a, b, "asc", "title");
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AppSelector);

/***/ }),

/***/ 3472:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ClickableMenu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7276);
/* harmony import */ var _AppSelector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1233);
/* harmony import */ var _ApplicationTitle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4247);






var ApplicationMenu = function ApplicationMenu(_ref) {
  var availableAppsForLogin = _ref.availableAppsForLogin,
    showApplicationMenu = _ref.showApplicationMenu,
    applicationId = _ref.applicationId;
  var setApplicationMenuVisibility = function setApplicationMenuVisibility(isVisible) {
    showApplicationMenu(isVisible);
  };
  var hasMultipleProducts = availableAppsForLogin && availableAppsForLogin.length > 1;
  if (!hasMultipleProducts) return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "header-app-info",
    key: "info"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "header-app-title single"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ApplicationTitle__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A, {
    productId: applicationId
  })));
  var getTitle = function getTitle() {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "header-app-title"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "ion-md-apps"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ApplicationTitle__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A, {
      productId: applicationId
    }));
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "header-app-info",
    key: "info"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ClickableMenu__WEBPACK_IMPORTED_MODULE_3__["default"], {
    id: "appSelector",
    title: getTitle(),
    setIsVisible: setApplicationMenuVisibility
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_AppSelector__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A, {
    apps: availableAppsForLogin
  })));
};
ApplicationMenu.defaultProps = {
  availableAppsForLogin: [],
  showApplicationMenu: function showApplicationMenu() {}
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ApplicationMenu);

/***/ }),

/***/ 4247:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utilities_ProductUtilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2500);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);



var ApplicationTitle = function ApplicationTitle(_ref) {
  var productId = _ref.productId;
  var currentProduct = (0,_utilities_ProductUtilities__WEBPACK_IMPORTED_MODULE_2__/* .getProductConfigurationById */ .OI)(productId);
  if (currentProduct) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "header-app-name"
    }, currentProduct.label);
  }
  return null;
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ApplicationTitle);

/***/ }),

/***/ 8883:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3368);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



var Divider = function Divider(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("header-divider", "phone-display-none", className)
  }, "|");
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Divider);

/***/ }),

/***/ 8436:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5609);
/* harmony import */ var _components_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9692);
/* harmony import */ var _components_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9305);
/* harmony import */ var _ModalDialog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1336);
/* harmony import */ var _ModalDialog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1264);
/* harmony import */ var _ModalDialog__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6021);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7204);
/* harmony import */ var _entities_Icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8607);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







var EnterNabpEPidDialog = /*#__PURE__*/function (_React$Component) {
  function EnterNabpEPidDialog(props, context) {
    var _this;
    _classCallCheck(this, EnterNabpEPidDialog);
    _this = _callSuper(this, EnterNabpEPidDialog, [props, context]);
    _defineProperty(_this, "onCheckboxCheck", function () {
      _this.setState({
        hasNoNabp: !_this.state.hasNoNabp
      });
    });
    _defineProperty(_this, "onNext", function () {
      var _this$doneButton;
      _this.setState({
        showSecondDialog: true
      });
      (_this$doneButton = _this.doneButton) === null || _this$doneButton === void 0 || _this$doneButton.setFocus();
    });
    _defineProperty(_this, "onDone", function () {
      _this.props.onDone(_this.state.hasNoNabp);
    });
    _defineProperty(_this, "onBack", function () {
      _this.setState({
        showSecondDialog: false
      });
    });
    _defineProperty(_this, "onEnterNabpKeyDown", function (event) {
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isTabPressed */ .Wz)(event) && !(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isShiftPressed */ .Hk)(event)) {
        var _this$checkBox;
        event.preventDefault();
        (_this$checkBox = _this.checkBox) === null || _this$checkBox === void 0 || _this$checkBox.setFocus();
      }
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isTabPressed */ .Wz)(event) && (0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isShiftPressed */ .Hk)(event)) {
        var _this$modalDialog;
        event.preventDefault();
        (_this$modalDialog = _this.modalDialog) === null || _this$modalDialog === void 0 || _this$modalDialog.setFocus();
      }
    });
    _defineProperty(_this, "onCheckBoxKeyDown", function (event) {
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isTabPressed */ .Wz)(event) && !(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isShiftPressed */ .Hk)(event)) {
        var _this$nextModalButton;
        event.preventDefault();
        (_this$nextModalButton = _this.nextModalButton) === null || _this$nextModalButton === void 0 || _this$nextModalButton.setFocus();
      }
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isTabPressed */ .Wz)(event) && (0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isShiftPressed */ .Hk)(event)) {
        event.preventDefault();
        if (_this.state.hasNoNabp) {
          var _this$modalDialog2;
          (_this$modalDialog2 = _this.modalDialog) === null || _this$modalDialog2 === void 0 || _this$modalDialog2.setFocus();
        } else {
          var _this$enterNabpButton;
          (_this$enterNabpButton = _this.enterNabpButton) === null || _this$enterNabpButton === void 0 || _this$enterNabpButton.setFocus();
        }
      }
    });
    _defineProperty(_this, "onNextKeyDown", function (event) {
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isTabPressed */ .Wz)(event) && !(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isShiftPressed */ .Hk)(event)) {
        var _this$modalDialog3;
        event.preventDefault();
        (_this$modalDialog3 = _this.modalDialog) === null || _this$modalDialog3 === void 0 || _this$modalDialog3.setFocus();
      }
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isTabPressed */ .Wz)(event) && (0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isShiftPressed */ .Hk)(event)) {
        var _this$checkBox2;
        event.preventDefault();
        (_this$checkBox2 = _this.checkBox) === null || _this$checkBox2 === void 0 || _this$checkBox2.setFocus();
      }
    });
    _defineProperty(_this, "onDoneKeyDown", function (event) {
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isTabPressed */ .Wz)(event) && !(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isShiftPressed */ .Hk)(event)) {
        var _this$backButton;
        event.preventDefault();
        (_this$backButton = _this.backButton) === null || _this$backButton === void 0 || _this$backButton.setFocus();
      }
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isTabPressed */ .Wz)(event) && (0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isShiftPressed */ .Hk)(event)) {
        var _this$warningModalDia;
        event.preventDefault();
        (_this$warningModalDia = _this.warningModalDialog) === null || _this$warningModalDia === void 0 || _this$warningModalDia.setFocus();
      }
    });
    _defineProperty(_this, "onBackKeyDown", function (event) {
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isTabPressed */ .Wz)(event) && !(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isShiftPressed */ .Hk)(event)) {
        var _this$warningModalDia2;
        event.preventDefault();
        (_this$warningModalDia2 = _this.warningModalDialog) === null || _this$warningModalDia2 === void 0 || _this$warningModalDia2.setFocus();
      }
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isTabPressed */ .Wz)(event) && (0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isShiftPressed */ .Hk)(event)) {
        var _this$doneButton2;
        event.preventDefault();
        (_this$doneButton2 = _this.doneButton) === null || _this$doneButton2 === void 0 || _this$doneButton2.setFocus();
      }
    });
    _defineProperty(_this, "moveFocusForwardFromCloseButton", function () {
      if (_this.state.hasNoNabp) {
        var _this$checkBox3;
        (_this$checkBox3 = _this.checkBox) === null || _this$checkBox3 === void 0 || _this$checkBox3.setFocus();
      } else {
        var _this$enterNabpButton2;
        (_this$enterNabpButton2 = _this.enterNabpButton) === null || _this$enterNabpButton2 === void 0 || _this$enterNabpButton2.setFocus();
      }
    });
    _this.state = {
      hasNoNabp: false,
      showSecondDialog: false
    };
    return _this;
  }
  _inherits(EnterNabpEPidDialog, _React$Component);
  return _createClass(EnterNabpEPidDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$enterNabpButton3;
      (_this$enterNabpButton3 = this.enterNabpButton) === null || _this$enterNabpButton3 === void 0 || _this$enterNabpButton3.setFocus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, !this.state.showSecondDialog && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ModalDialog__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A, {
        ref: function ref(_ref4) {
          return _this2.modalDialog = _ref4;
        },
        moveFocusBack: function moveFocusBack() {
          var _this2$nextModalButto;
          return (_this2$nextModalButto = _this2.nextModalButton) === null || _this2$nextModalButto === void 0 ? void 0 : _this2$nextModalButto.setFocus();
        },
        moveFocusForward: function moveFocusForward() {
          return _this2.moveFocusForwardFromCloseButton();
        },
        tabIndex: this.props.tabIndex,
        title: "Enter Your NABP e-Profile ID to get CPE credit",
        onClose: this.props.onCancel
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ModalDialog__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "description"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, "If you do not enter a valid NABP within 30 days of completing a course, you will not receive CPE credit.")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_components_index__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A, {
        name: "hasNoNabp",
        className: "hasNoNabpCheckBox",
        label: "Check this if you don't have an NABP e-Profile ID",
        labelClassName: "hasNoNabp",
        checked: this.state.hasNoNabp,
        value: this.state.hasNoNabp,
        autoFocus: true,
        tabIndex: this.props.tabIndex,
        ref: function ref(_ref) {
          return _this2.checkBox = _ref;
        },
        onChange: this.onCheckboxCheck,
        onKeyDown: this.onCheckBoxKeyDown
      }), this.state.hasNoNabp && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "no-nabp-warning"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, "I understand I won\u2019t get credit for my Continuing Education courses."))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ModalDialog__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_components_index__WEBPACK_IMPORTED_MODULE_7__["default"], {
        name: "enterNabpButton",
        className: "btn btn-success",
        tabIndex: this.props.tabIndex,
        title: "Enter NABP e-Profile ID",
        onClick: this.props.onEnterNabp,
        disabled: this.state.hasNoNabp,
        ref: function ref(_ref2) {
          return _this2.enterNabpButton = _ref2;
        },
        onKeyDown: this.onEnterNabpKeyDown
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_components_index__WEBPACK_IMPORTED_MODULE_7__["default"], {
        name: "nextButton",
        className: "btn btn-danger",
        tabIndex: this.props.tabIndex,
        title: "CONTINUE TO COURSES",
        onClick: this.onNext,
        disabled: false,
        ref: function ref(_ref3) {
          return _this2.nextModalButton = _ref3;
        },
        onKeyDown: this.onNextKeyDown
      }))), this.state.showSecondDialog && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ModalDialog__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A, {
        moveFocusBack: function moveFocusBack() {
          var _this2$backButton;
          return (_this2$backButton = _this2.backButton) === null || _this2$backButton === void 0 ? void 0 : _this2$backButton.setFocus();
        },
        moveFocusForward: function moveFocusForward() {
          var _this2$doneButton;
          return (_this2$doneButton = _this2.doneButton) === null || _this2$doneButton === void 0 ? void 0 : _this2$doneButton.setFocus();
        },
        ref: function ref(_ref7) {
          return _this2.warningModalDialog = _ref7;
        },
        tabIndex: this.props.tabIndex,
        title: "WARNING: You will not get credit for Continuing Education courses without a NABP e-Profile ID",
        onClose: this.props.onCancel,
        titleClass: "warning-dialog-title"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ModalDialog__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "description warning-bullets"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, "To get CPE credit you must enter your NABP e-Profile ID within 30 days of completing a course."), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", null, "It is your responsibility to provide a valid NABP e-Profile ID and the month/day from your date of birth.")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ModalDialog__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_IconButton__WEBPACK_IMPORTED_MODULE_8__["default"], {
        name: "backButton",
        className: "btn back-button",
        tabIndex: this.props.tabIndex + 1,
        title: "BACK",
        onClick: this.onBack,
        disabled: false,
        icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A("keyboard_backspace", 1),
        ref: function ref(_ref5) {
          return _this2.backButton = _ref5;
        },
        onKeyDown: this.onBackKeyDown
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_components_index__WEBPACK_IMPORTED_MODULE_7__["default"], {
        name: "nextButton",
        className: "btn btn-danger",
        tabIndex: this.props.tabIndex + 1,
        title: "DONE",
        onClick: this.onDone,
        autoFocus: true,
        disabled: false,
        onKeyDown: this.onDoneKeyDown,
        ref: function ref(_ref6) {
          return _this2.doneButton = _ref6;
        }
      }))));
    }
  }]);
}((react__WEBPACK_IMPORTED_MODULE_0___default().Component));
EnterNabpEPidDialog.defaultProps = {
  tabIndex: 1
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (EnterNabpEPidDialog);

/***/ }),

/***/ 9997:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export HeaderGlobalSearch */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5609);
/* harmony import */ var _SearchButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4869);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




var HeaderGlobalSearch = /*#__PURE__*/function (_React$Component) {
  function HeaderGlobalSearch(props, context) {
    var _this;
    _classCallCheck(this, HeaderGlobalSearch);
    _this = _callSuper(this, HeaderGlobalSearch, [props, context]);
    _defineProperty(_this, "onKeyUp", function (e) {
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isEnterPressed */ .DV)(e)) _this.props.goToGlobalSearchPage(_this.state.globalSearchText);
    });
    _defineProperty(_this, "onGlobalChange", function (value) {
      _this.setState({
        globalSearchText: value
      });
    });
    _defineProperty(_this, "handleMagnifierClick", function () {
      var isActive = !_this.props.mobileGlobalSearchActive;
      _this.props.setGlobalSearchActiveValue(isActive);
    });
    _defineProperty(_this, "onClear", function () {
      _this.props.setGlobalSearchActiveValue(false);
    });
    _this.state = {
      globalSearchText: null
    };
    return _this;
  }
  _inherits(HeaderGlobalSearch, _React$Component);
  return _createClass(HeaderGlobalSearch, [{
    key: "render",
    value: function render() {
      if (!this.props.showGlobalSearch) return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "header-global-search"
      });
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "header-global-search"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_SearchButton__WEBPACK_IMPORTED_MODULE_3__["default"], {
        defaultText: this.props.globalSearchPlaceholder,
        onChange: this.onGlobalChange,
        searchText: this.state.globalSearchText,
        onClick: this.handleMagnifierClick,
        onKeyUp: this.onKeyUp
      }));
    }
  }]);
}((react__WEBPACK_IMPORTED_MODULE_0___default().Component));
HeaderGlobalSearch.defaultProps = {
  showGlobalSearch: false,
  goToGlobalSearchPage: function goToGlobalSearchPage() {},
  globalSearchPlaceholder: "Search",
  setGlobalSearchActiveValue: function setGlobalSearchActiveValue() {},
  mobileGlobalSearchActive: false
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HeaderGlobalSearch);

/***/ }),

/***/ 2881:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export LocationMenuTitle */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3368);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);




var LocationMenuTitle = function LocationMenuTitle(_ref) {
  var showOrganizationMenu = _ref.showOrganizationMenu,
    currentOrganization = _ref.currentOrganization,
    shouldShowLocationMenu = _ref.shouldShowLocationMenu,
    isLocationMenuAvailable = _ref.isLocationMenuAvailable;
  if (!isLocationMenuAvailable) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("header-location-menu-name", "phone-display-none", shouldShowLocationMenu ? " active" : "")
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "organization-name"
    }, currentOrganization && currentOrganization.name)));
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("header-location-menu-button", "phone-display-none", shouldShowLocationMenu ? " active" : ""),
    onClick: function onClick() {
      return showOrganizationMenu(!shouldShowLocationMenu);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "organization-name"
  }, currentOrganization && currentOrganization.name), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "ion-md-arrow-dropdown"
  })));
};
LocationMenuTitle.defaultProps = {
  isLocationMenuAvailable: false
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LocationMenuTitle);

/***/ }),

/***/ 2518:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4442);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_router_dom__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utilities_UrlUtilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5226);





var UserPanel = function UserPanel(_ref) {
  var user = _ref.user,
    onLogoutClick = _ref.onLogoutClick,
    baseUrl = _ref.baseUrl,
    onProfileClick = _ref.onProfileClick,
    notificationPreferencePanel = _ref.notificationPreferencePanel,
    shouldUseReactRouter = _ref.shouldUseReactRouter,
    documentationUrl = _ref.documentationUrl,
    onDocumentationLinkClick = _ref.onDocumentationLinkClick;
  var abbreviation = user ? getFirstLetterFromName(user.firstName) + getFirstLetterFromName(user.lastName) : "";
  var getProfile = function getProfile() {
    var profileUrl = (0,_utilities_UrlUtilities__WEBPACK_IMPORTED_MODULE_3__/* .getProfileUrl */ .l)(baseUrl, "/profile");
    if (shouldUseReactRouter) return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_2__.Link, {
      to: profileUrl,
      id: "profileLink",
      onClick: onProfileClick
    }, "View Profile");
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
      id: "profileLink",
      onClick: onProfileClick
    }, "View Profile");
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("aside", {
    "aria-labelledby": "helpprofile",
    className: "right-user-menu"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "panel-section userProfile center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "info-badge"
  }, abbreviation)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "profileEmail"
  }, user.email), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, getProfile()), notificationPreferencePanel && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, notificationPreferencePanel)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "panel-section userInfo"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    name: "profileName"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "infoLabel"
  }, "Name"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    name: "infoValue"
  }, user.firstName, " ", user.lastName)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    name: "profileRole"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "infoLabel"
  }, "Role"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    name: "infoValue"
  }, user.virtualProfileName)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    name: "profileLocation"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "infoLabel"
  }, "Locations"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    name: "infoValue"
  }, user.activeOrganizations.length, " Sites"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "panel-section center technical-support bottom-border"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "product-training",
    "data-name": "product-training-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Product Training"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: documentationUrl,
    "data-name": "product-training-link",
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: onDocumentationLinkClick
  }, "SoleSource Academy\u2122 Training", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "material-icons outbound-icon"
  }, "open_in_new"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-name": "contact-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Contact"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: "https://www.wolterskluwer.com/en/solutions/solesource/technical-support",
    "data-name": "technical-support-link",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Technical Support"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: "tel:+18003410450",
    "data-name": "technical-support-phone",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "800-341-0450"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: "mailto:CSCsupport@wolterskluwer.com",
    "data-name": "technical-support-mail",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "CSCsupport@wolterskluwer.com")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("hr", null), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: "#",
    onClick: onLogoutClick,
    id: "logoutLink"
  }, "Sign Out"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "panel-section brand-display"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Powered by SoleSource\xAE")));
};
var getFirstLetterFromName = function getFirstLetterFromName(name) {
  return name && name.length > 0 ? name.charAt(0) : "";
};
UserPanel.defaultProps = {
  onLogoutClick: function onLogoutClick() {},
  shouldUseReactRouter: false
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (UserPanel);

/***/ }),

/***/ 2197:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ components_Header)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./src/components/Header/ApplicationMenu.jsx
var ApplicationMenu = __webpack_require__(3472);
// EXTERNAL MODULE: ./src/components/Header/HeaderGlobalSearch.jsx
var HeaderGlobalSearch = __webpack_require__(9997);
// EXTERNAL MODULE: ./src/components/ClickableMenu.js
var ClickableMenu = __webpack_require__(7276);
// EXTERNAL MODULE: ./src/components/Header/UserPanel.jsx
var UserPanel = __webpack_require__(2518);
// EXTERNAL MODULE: ./src/components/Header/Divider.jsx
var Divider = __webpack_require__(8883);
// EXTERNAL MODULE: ./src/components/Header/LocationMenuTitle.jsx
var LocationMenuTitle = __webpack_require__(2881);
// EXTERNAL MODULE: ./src/components/Header/EnterNabpEPidDialog.jsx
var EnterNabpEPidDialog = __webpack_require__(8436);
// EXTERNAL MODULE: ./src/utilities/UrlUtilities.js
var UrlUtilities = __webpack_require__(5226);
// EXTERNAL MODULE: ./src/components/Profile/ProfileParts.js
var ProfileParts = __webpack_require__(860);
// EXTERNAL MODULE: ./src/entities/ExternalIdentifiers.js
var ExternalIdentifiers = __webpack_require__(3465);
;// CONCATENATED MODULE: ./src/components/Header/Header.jsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
















var Header = /*#__PURE__*/function (_PureComponent) {
  function Header(props, context) {
    var _this;
    _classCallCheck(this, Header);
    _this = _callSuper(this, Header, [props, context]);
    _defineProperty(_this, "onLogout", function () {
      if (_this.props.logoutUser) _this.props.logoutUser();
    });
    _defineProperty(_this, "profileBadge", function () {
      var user = _this.props.currentVirtualUser;
      var abbriviation = user ? getFirstLetterFromName(user.firstName) + getFirstLetterFromName(user.lastName) : "";
      return /*#__PURE__*/external_react_default().createElement("span", {
        className: "logout-badge"
      }, abbriviation);
    });
    _defineProperty(_this, "showApplicationMenu", function (isVisible) {
      if (isVisible) {
        _this.props.showApplicationMenu();
      }
    });
    _defineProperty(_this, "setGlobalSearchActiveValue", function (value) {
      _this.setState({
        mobileGlobalSearchActive: value
      });
    });
    _defineProperty(_this, "onProfileMenuClick", function () {
      _this.props.showApplicationMenu(false);
    });
    _defineProperty(_this, "onDocumentationLinkClick", function (event) {
      if (_this.props.isNabpEPidExist && !_this.props.isNabpEPidExist()) {
        event.preventDefault();
        _this.showEnterNabpDialog();
      }
    });
    _defineProperty(_this, "showEnterNabpDialog", function () {
      _this.setState({
        showDialog: true
      });
    });
    _defineProperty(_this, "onEnterNabpSkip", function () {
      (0,UrlUtilities/* openUrlInNewTab */.e2)(_this.props.documentationUrl);
      _this.setState({
        showDialog: false
      });
    });
    _defineProperty(_this, "onEnterNabpCancel", function () {
      _this.setState({
        showDialog: false
      });
    });
    _defineProperty(_this, "onEnterNabp", function () {
      _this.props.goToProfilePage(ProfileParts/* default */.A.editExternalIds);
      _this.setState({
        showDialog: false
      });
    });
    _defineProperty(_this, "onDone", function (hasNoNabp) {
      if (hasNoNabp) {
        var externalIds = _this.props.currentVirtualUser.externalIds;
        if (!externalIds) {
          externalIds = new ExternalIdentifiers/* default */.A();
        }
        externalIds.nabpRoleId = undefined;
        externalIds.dateOfBirth = "";
        externalIds.nabpEPid = "";
        externalIds.hasNoNabp = true;
        _this.props.updateExternalIds(_this.props.currentVirtualUser, externalIds);
        (0,UrlUtilities/* openUrlInNewTab */.e2)(_this.props.documentationUrl);
      }
      _this.setState({
        showDialog: false
      });
    });
    _this.state = {
      mobileGlobalSearchActive: false,
      showDialog: false
    };
    return _this;
  }
  _inherits(Header, _PureComponent);
  return _createClass(Header, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var profileBadge = this.profileBadge();
      var isSearchActiveClassName = this.state.mobileGlobalSearchActive ? "header header-global-search-active" : "header header-global-search-hide";
      var menuLabel = /*#__PURE__*/external_react_default().createElement("span", {
        id: "helpprofile",
        className: "menu-label"
      }, "Help & Profile");
      var menuIconClassName = this.props.shouldShowMobileMenu ? "ion-md-close" : "ion-md-menu";
      return /*#__PURE__*/external_react_default().createElement("header", {
        name: this.props.appConfig.name
      }, /*#__PURE__*/external_react_default().createElement("div", {
        id: "skipToMainContentContainer"
      }, /*#__PURE__*/external_react_default().createElement("a", {
        id: "skipToMainContent",
        href: "#content"
      }, "Skip to Main Content")), /*#__PURE__*/external_react_default().createElement("div", {
        className: isSearchActiveClassName
      }, /*#__PURE__*/external_react_default().createElement(ApplicationMenu/* default */.A, {
        availableAppsForLogin: this.props.availableAppsForLogin,
        showApplicationMenu: this.showApplicationMenu,
        applicationId: this.props.appConfig.id
      }), /*#__PURE__*/external_react_default().createElement(Divider/* default */.A, {
        className: "ipad-display-none"
      }), /*#__PURE__*/external_react_default().createElement("div", {
        className: "header-title phone-display-none ipad-display-none"
      }, "SoleSource", /*#__PURE__*/external_react_default().createElement("span", {
        className: "reg-mark"
      }, "\xAE")), /*#__PURE__*/external_react_default().createElement(HeaderGlobalSearch/* default */.A, {
        goToGlobalSearchPage: this.props.goToGlobalSearchPage,
        showGlobalSearch: this.props.showGlobalSearch,
        setGlobalSearchActiveValue: this.setGlobalSearchActiveValue,
        mobileGlobalSearchActive: this.state.mobileGlobalSearchActive,
        globalSearchPlaceholder: this.props.globalSearchPlaceholder
      }), /*#__PURE__*/external_react_default().createElement(Divider/* default */.A, null), /*#__PURE__*/external_react_default().createElement(LocationMenuTitle/* default */.A, {
        currentOrganization: this.props.currentOrganization,
        isLocationMenuAvailable: this.props.isLocationMenuAvailable,
        showOrganizationMenu: this.props.showOrganizationMenu,
        shouldShowLocationMenu: this.props.shouldShowLocationMenu
      }), /*#__PURE__*/external_react_default().createElement(Divider/* default */.A, null), /*#__PURE__*/external_react_default().createElement("div", {
        className: "header-user-abbreviation phone-display-none"
      }, /*#__PURE__*/external_react_default().createElement(ClickableMenu["default"], {
        id: "userProfile",
        icon: profileBadge,
        title: "",
        onClick: this.onProfileMenuClick,
        label: menuLabel,
        titleClass: "avatar-label-link"
      }, /*#__PURE__*/external_react_default().createElement(UserPanel/* default */.A, {
        user: this.props.currentVirtualUser,
        onLogoutClick: this.onLogout,
        onProfileClick: this.props.onProfileClick,
        baseUrl: this.props.baseUrl,
        shouldUseReactRouter: this.props.shouldUseReactRouter,
        notificationPreferencePanel: this.props.notificationPreferencePanel,
        documentationUrl: this.props.documentationUrl,
        onDocumentationLinkClick: this.onDocumentationLinkClick
      }))), /*#__PURE__*/external_react_default().createElement("div", {
        className: "show-mobile-only header-mobile-menu"
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: menuIconClassName,
        onClick: function onClick() {
          return _this2.props.showMobileMenu();
        }
      }))), this.state.showDialog && /*#__PURE__*/external_react_default().createElement(EnterNabpEPidDialog/* default */.A, {
        onCancel: this.onEnterNabpCancel,
        onEnterNabp: this.onEnterNabp,
        onDone: this.onDone
      }));
    }
  }]);
}(external_react_.PureComponent);
var getFirstLetterFromName = function getFirstLetterFromName(name) {
  return name && name.length > 0 ? name.charAt(0) : "";
};
Header.defaultProps = {
  availableAppsForLogin: [],
  logoutUser: function logoutUser() {},
  showGlobalSearch: false,
  goToGlobalSearchPage: function goToGlobalSearchPage() {},
  globalSearchPlaceholder: "Search",
  appConfig: {},
  showMobileMenu: function showMobileMenu() {},
  showApplicationMenu: function showApplicationMenu() {},
  shouldUseReactRouter: false,
  shouldShowMobileMenu: true
};
 false ? 0 : void 0;
/* harmony default export */ const Header_Header = (Header);
// EXTERNAL MODULE: ./src/components/Header/_styles.scss
var _styles = __webpack_require__(7386);
;// CONCATENATED MODULE: ./src/components/Header/index.js


/* harmony default export */ const components_Header = (Header_Header);

/***/ }),

/***/ 7204:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ components_IconButton)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: ./src/components/IconButton/_styles.scss
var _styles = __webpack_require__(4222);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3368);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/IconButton/IconButton.jsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





var IconButton = /*#__PURE__*/function (_Component) {
  function IconButton() {
    var _this;
    _classCallCheck(this, IconButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, IconButton, [].concat(args));
    _defineProperty(_this, "setFocus", function () {
      _this.button.focus();
    });
    return _this;
  }
  _inherits(IconButton, _Component);
  return _createClass(IconButton, [{
    key: "getIcon",
    value: function getIcon(icon, otherClass) {
      if (!icon) return null;
      var iconClass = classnames_default()("material-icons fixed-icon", otherClass);
      var iconName = icon.name;
      if (!icon.isMaterial) {
        iconClass = icon.name ? "fixed-icon " + icon.name : icon;
        iconName = "";
      }
      return /*#__PURE__*/external_react_default().createElement("span", {
        className: iconClass,
        name: "icon"
      }, iconName);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var buttonClasses = classnames_default()("btn", "icon-button", this.props.className);
      return /*#__PURE__*/external_react_default().createElement("button", {
        ref: function ref(input) {
          _this2.button = input;
        },
        tabIndex: this.props.tabIndex,
        className: buttonClasses,
        onClick: this.props.onClick,
        disabled: this.props.disabled,
        onKeyDown: this.props.onKeyDown,
        autoFocus: this.props.autoFocus,
        id: this.props.id,
        name: this.props.name
      }, this.props.showIconAtRight ? /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("span", {
        className: "icon-button-text"
      }, this.props.title), " ", this.getIcon(this.props.icon, "right-icon")) : /*#__PURE__*/external_react_default().createElement("div", null, this.getIcon(this.props.icon, "left-icon"), " ", /*#__PURE__*/external_react_default().createElement("span", {
        className: "icon-button-text"
      }, this.props.title)));
    }
  }]);
}(external_react_.Component);
 false ? 0 : void 0;
/* harmony default export */ const IconButton_IconButton = (IconButton);
;// CONCATENATED MODULE: ./src/components/IconButton/index.js

/* harmony default export */ const components_IconButton = (IconButton_IconButton);

/***/ }),

/***/ 7434:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export IconView */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _entities_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8607);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3368);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants_SvgIcons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8754);





var IconView = function IconView(_ref) {
  var icon = _ref.icon,
    className = _ref.className,
    name = _ref.name;
  if (!icon) return null;
  var iconContent, iconClass, ariaHidden, SvgIconComponent;
  switch (icon.iconType) {
    case _entities_Icon__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes */ .B["default"]:
      iconClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, icon.name);
      iconContent = "";
      break;
    case _entities_Icon__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes */ .B.material:
      iconClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()("material-icons", className);
      iconContent = icon.name;
      ariaHidden = true;
      break;
    case _entities_Icon__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes */ .B.jumpstart:
      iconClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, "wk-icon-" + icon.name);
      iconContent = "";
      break;
    case _entities_Icon__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes */ .B.svg:
      iconClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()("svg-icon", className);
      SvgIconComponent = _constants_SvgIcons__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A[icon.name];
      iconContent = SvgIconComponent ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(SvgIconComponent, null) : "";
      break;
    default:
      iconClass = className;
      iconContent = icon.name;
  }
  iconClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()(iconClass, icon.extraClass);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: iconClass,
    name: name,
    "aria-hidden": ariaHidden
  }, iconContent);
};
IconView.defaultProps = {
  name: "icon"
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (IconView);

/***/ }),

/***/ 7293:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ components_LeftMenuPage)
});

// UNUSED EXPORTS: LeftMenuPage

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./src/components/LeftNavigationMenu/LeftNavigationMenu.jsx + 2 modules
var LeftNavigationMenu = __webpack_require__(970);
// EXTERNAL MODULE: ./src/components/Overlay.jsx
var Overlay = __webpack_require__(5669);
// EXTERNAL MODULE: ./src/components/LeftNavigationMenu/NavigationLinksList.jsx
var NavigationLinksList = __webpack_require__(1937);
// EXTERNAL MODULE: ./src/components/LeftNavigationMenu/_mobileMenuStyles.scss
var _mobileMenuStyles = __webpack_require__(1326);
// EXTERNAL MODULE: ./src/utilities/UrlUtilities.js
var UrlUtilities = __webpack_require__(5226);
// EXTERNAL MODULE: external "react-router-dom"
var external_react_router_dom_ = __webpack_require__(4442);
;// CONCATENATED MODULE: ./src/components/LeftNavigationMenu/MobileMenu.jsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








var MobileMenu = /*#__PURE__*/function (_PureComponent) {
  function MobileMenu() {
    var _this;
    _classCallCheck(this, MobileMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MobileMenu, [].concat(args));
    _defineProperty(_this, "hideMenu", function () {
      _this.props.showMobileMenu(false);
    });
    _defineProperty(_this, "onLogoutClick", function () {
      _this.props.logoutUser();
    });
    _defineProperty(_this, "onProfileClick", function () {
      _this.hideMenu();
      _this.props.setCurrentUrl();
    });
    _defineProperty(_this, "onLocationClick", function () {
      _this.props.showMobileMenu(false);
      _this.props.showOrganizationMenu();
    });
    _defineProperty(_this, "getProfile", function (content, id) {
      if (_this.props.shouldUseReactRouter) {
        // We should remove baseUrl in the future.
        // App should decide, what link profile will have, not common library.
        var profileUrl = (0,UrlUtilities/* getProfileUrl */.l)(_this.props.baseUrl, "/profile");
        var profileLink = _this.props.profileLink;
        return /*#__PURE__*/external_react_default().createElement(external_react_router_dom_.Link, {
          to: profileUrl || profileLink,
          id: id,
          onClick: _this.onProfileClick
        }, content);
      }
      return /*#__PURE__*/external_react_default().createElement("a", {
        id: "profileLink",
        onClick: _this.onProfileClick
      }, content);
    });
    _defineProperty(_this, "onLinkClick", function () {
      _this.props.onLinkClick();
      _this.hideMenu();
    });
    return _this;
  }
  _inherits(MobileMenu, _PureComponent);
  return _createClass(MobileMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        currentOrganization = _this$props.currentOrganization,
        shouldShowMobileMenu = _this$props.shouldShowMobileMenu,
        currentVirtualUser = _this$props.currentVirtualUser,
        notificationPreferencePanel = _this$props.notificationPreferencePanel,
        documentationUrl = _this$props.documentationUrl,
        isLocationMenuAvailable = _this$props.isLocationMenuAvailable;
      var className = shouldShowMobileMenu ? "mobile-menu-showed" : "mobile-menu-hidden";
      return /*#__PURE__*/external_react_default().createElement("div", {
        id: "mobile-menu",
        className: className
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "mobile-menu-current-location",
        onClick: isLocationMenuAvailable ? this.onLocationClick : function () {}
      }, /*#__PURE__*/external_react_default().createElement("span", null, currentOrganization && currentOrganization.name), isLocationMenuAvailable && /*#__PURE__*/external_react_default().createElement("span", {
        className: "ion-ios-arrow-down"
      })), /*#__PURE__*/external_react_default().createElement(Divider, null), this.props.groupsOfLinks.map(function (group, index) {
        var links = group.links;
        return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, {
          key: index
        }, index !== 0 && /*#__PURE__*/external_react_default().createElement(Divider, null), /*#__PURE__*/external_react_default().createElement(NavigationLinksList/* default */.A, {
          links: links,
          getLinkRowContent: _this2.props.getLinkRow,
          onLinkClick: _this2.onLinkClick,
          checkActive: _this2.props.checkActive
        }));
      }), /*#__PURE__*/external_react_default().createElement(Divider, null), /*#__PURE__*/external_react_default().createElement("div", {
        className: "mobile-menu-current-user-row"
      }, this.getProfile(/*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement("div", null, currentVirtualUser.fullName), /*#__PURE__*/external_react_default().createElement("small", null, currentVirtualUser.email)), "currentUserLink")), /*#__PURE__*/external_react_default().createElement("div", {
        className: "mobile-menu-profile"
      }, this.getProfile("View Profile", "profileLink")), notificationPreferencePanel && /*#__PURE__*/external_react_default().createElement("div", null, notificationPreferencePanel), /*#__PURE__*/external_react_default().createElement(Divider, null), /*#__PURE__*/external_react_default().createElement("div", {
        className: "mobile-technical-support"
      }, /*#__PURE__*/external_react_default().createElement("span", {
        "data-name": "product-training-label"
      }, "Product Training"), /*#__PURE__*/external_react_default().createElement("div", {
        className: "mobile-menu-help-link",
        "data-name": "product-training-wrapper"
      }, /*#__PURE__*/external_react_default().createElement("a", {
        href: documentationUrl,
        "data-name": "product-training-link",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "SoleSource Academy\u2122 Training", /*#__PURE__*/external_react_default().createElement("span", {
        className: "material-icons outbound-icon"
      }, "open_in_new"))), /*#__PURE__*/external_react_default().createElement("div", {
        "data-name": "contact-wrapper"
      }, /*#__PURE__*/external_react_default().createElement("span", null, "Contact"), /*#__PURE__*/external_react_default().createElement("a", {
        href: "https://www.wolterskluwer.com/en/solutions/solesource/technical-support",
        "data-name": "technical-support-link",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Technical Support"), /*#__PURE__*/external_react_default().createElement("a", {
        href: "tel:+18003410450",
        "data-name": "technical-support-phone",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "800-341-0450"), /*#__PURE__*/external_react_default().createElement("a", {
        href: "mailto:CSCsupport@wolterskluwer.com",
        "data-name": "technical-support-mail",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "CSCsupport@wolterskluwer.com"))), /*#__PURE__*/external_react_default().createElement(Divider, null), /*#__PURE__*/external_react_default().createElement("div", {
        className: "mobile-menu-logout-link"
      }, /*#__PURE__*/external_react_default().createElement("a", {
        href: "#",
        onClick: this.onLogoutClick,
        id: "logoutLink"
      }, "Sign Out")));
    }
  }]);
}(external_react_.PureComponent);
var Divider = function Divider() {
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "mobile-menu-divider"
  });
};
MobileMenu.defaultProps = {
  shouldShowMobileMenu: false,
  isLocationMenuAvailable: true,
  onLinkClick: function onLinkClick() {}
};
 false ? 0 : void 0;
/* harmony default export */ const LeftNavigationMenu_MobileMenu = (MobileMenu);
// EXTERNAL MODULE: ./src/components/Menu/OrganizationMenu.jsx + 4 modules
var OrganizationMenu = __webpack_require__(2234);
;// CONCATENATED MODULE: ./src/components/LeftMenuPage.jsx










var LeftMenuPage = function LeftMenuPage(_ref) {
  var isLeftMenuCollapsed = _ref.isLeftMenuCollapsed,
    groupsOfLinks = _ref.groupsOfLinks,
    getLinkRow = _ref.getLinkRow,
    children = _ref.children,
    currentOrganization = _ref.currentOrganization,
    onLinkClick = _ref.onLinkClick,
    onCollapseLeftMenu = _ref.onCollapseLeftMenu,
    isContentBlocked = _ref.isContentBlocked,
    blockContent = _ref.blockContent,
    currentVirtualUser = _ref.currentVirtualUser,
    baseUrl = _ref.baseUrl,
    shouldShowMobileMenu = _ref.shouldShowMobileMenu,
    showMobileMenu = _ref.showMobileMenu,
    logoutUser = _ref.logoutUser,
    setCurrentUrl = _ref.setCurrentUrl,
    showOrganizationMenu = _ref.showOrganizationMenu,
    setCurrentOrganization = _ref.setCurrentOrganization,
    goToSecondLevelSection = _ref.goToSecondLevelSection,
    shouldShowLocationMenu = _ref.shouldShowLocationMenu,
    organizations = _ref.organizations,
    documentationUrl = _ref.documentationUrl,
    shouldUseReactRouter = _ref.shouldUseReactRouter,
    checkActive = _ref.checkActive,
    profileLink = _ref.profileLink,
    notificationPreferencePanel = _ref.notificationPreferencePanel;
  var containerClass = isLeftMenuCollapsed ? "full-menu-container" : "left-menu-container";
  return /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement(LeftNavigationMenu/* default */.A, {
    onCollapseLeftMenu: onCollapseLeftMenu,
    groupsOfLinks: groupsOfLinks,
    getLinkRow: getLinkRow,
    isLeftMenuCollapsed: isLeftMenuCollapsed,
    onLinkClick: onLinkClick,
    checkActive: checkActive
  }), /*#__PURE__*/external_react_default().createElement("main", {
    id: "content",
    className: containerClass
  }, /*#__PURE__*/external_react_default().createElement(Overlay["default"], {
    isContentBlocked: isContentBlocked,
    onClick: blockContent
  }), children), /*#__PURE__*/external_react_default().createElement(LeftNavigationMenu_MobileMenu, {
    groupsOfLinks: groupsOfLinks,
    getLinkRow: getLinkRow,
    onLinkClick: onLinkClick,
    currentOrganization: currentOrganization,
    currentVirtualUser: currentVirtualUser,
    baseUrl: baseUrl,
    profileLink: profileLink,
    shouldShowMobileMenu: shouldShowMobileMenu,
    showOrganizationMenu: showOrganizationMenu,
    setCurrentUrl: setCurrentUrl,
    logoutUser: logoutUser,
    showMobileMenu: showMobileMenu,
    documentationUrl: documentationUrl,
    shouldUseReactRouter: shouldUseReactRouter,
    checkActive: checkActive,
    notificationPreferencePanel: notificationPreferencePanel,
    isLocationMenuAvailable: (organizations === null || organizations === void 0 ? void 0 : organizations.length) > 1
  }), /*#__PURE__*/external_react_default().createElement(OrganizationMenu/* default */.A, {
    currentOrganization: currentOrganization,
    setCurrentOrganization: setCurrentOrganization,
    goToSecondLevelSection: goToSecondLevelSection,
    showOrganizationMenu: showOrganizationMenu,
    shouldShowLocationMenu: shouldShowLocationMenu,
    organizations: organizations,
    currentUser: currentVirtualUser
  }));
};
LeftMenuPage.defaultProps = {
  isLeftMenuCollapsed: false,
  onLinkClick: function onLinkClick() {},
  goToSecondLevelSection: function goToSecondLevelSection() {},
  shouldUseReactRouter: false
};
 false ? 0 : void 0;
/* harmony default export */ const components_LeftMenuPage = ((0,external_react_router_dom_.withRouter)(LeftMenuPage));

/***/ }),

/***/ 970:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ LeftNavigationMenu_LeftNavigationMenu)
});

// UNUSED EXPORTS: LeftNavigationMenu

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./src/components/LeftNavigationMenu/NavigationLinksList.jsx
var NavigationLinksList = __webpack_require__(1937);
// EXTERNAL MODULE: ./src/components/LeftNavigationMenu/_styles.scss
var _styles = __webpack_require__(1679);
;// CONCATENATED MODULE: ./src/components/LeftNavigationMenu/MenuIcon.jsx


var MenuIcon = function MenuIcon(_ref) {
  var isLeftMenuCollapsed = _ref.isLeftMenuCollapsed;
  if (isLeftMenuCollapsed) return /*#__PURE__*/external_react_default().createElement("div", {
    className: "extend-icon"
  });
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "collapse-icon"
  });
};
 false ? 0 : void 0;
/* harmony default export */ const LeftNavigationMenu_MenuIcon = (MenuIcon);
;// CONCATENATED MODULE: ./src/components/LeftNavigationMenu/CollapseMenuIcon.jsx



var CollapseMenuIcon = function CollapseMenuIcon(_ref) {
  var onClick = _ref.onClick,
    shouldShow = _ref.shouldShow,
    isLeftMenuCollapsed = _ref.isLeftMenuCollapsed;
  if (!shouldShow) return null;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "left-menu-toggle-icon",
    onClick: onClick
  }, /*#__PURE__*/external_react_default().createElement(LeftNavigationMenu_MenuIcon, {
    isLeftMenuCollapsed: isLeftMenuCollapsed
  }));
};
CollapseMenuIcon.defaultProps = {
  onClick: function onClick() {},
  shouldShow: true,
  isLeftMenuCollapsed: true
};
 false ? 0 : void 0;
/* harmony default export */ const LeftNavigationMenu_CollapseMenuIcon = (CollapseMenuIcon);
;// CONCATENATED MODULE: ./src/components/LeftNavigationMenu/LeftNavigationMenu.jsx






var LeftNavigationMenu = function LeftNavigationMenu(_ref) {
  var isLeftMenuCollapsed = _ref.isLeftMenuCollapsed,
    getLinkRow = _ref.getLinkRow,
    groupsOfLinks = _ref.groupsOfLinks,
    onCollapseLeftMenu = _ref.onCollapseLeftMenu,
    onLinkClick = _ref.onLinkClick,
    checkActive = _ref.checkActive;
  var className = isLeftMenuCollapsed ? "left-menu-collapsed" : "left-menu-extended";
  return /*#__PURE__*/external_react_default().createElement("nav", {
    "aria-labelledby": "mainmenu",
    id: "left-menu",
    className: className
  }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "left-menu-links-container"
  }, groupsOfLinks.map(function (group, index) {
    var links = group.links;
    return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, {
      key: index
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "left-menu-row"
    }, /*#__PURE__*/external_react_default().createElement("span", {
      id: index === 0 ? "mainmenu" : null,
      className: "left-menu-title"
    }, group.title), /*#__PURE__*/external_react_default().createElement(LeftNavigationMenu_CollapseMenuIcon, {
      onClick: onCollapseLeftMenu,
      shouldShow: index === 0,
      isLeftMenuCollapsed: isLeftMenuCollapsed
    })), /*#__PURE__*/external_react_default().createElement(NavigationLinksList/* default */.A, {
      onLinkClick: onLinkClick,
      links: links,
      getLinkRowContent: getLinkRow,
      checkActive: checkActive
    }));
  }), /*#__PURE__*/external_react_default().createElement("div", null)), /*#__PURE__*/external_react_default().createElement("div", {
    className: "left-menu-footer"
  }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "bigLogo"
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: "smallLogo"
  })))));
};
LeftNavigationMenu.defaultProps = {
  isLeftMenuCollapsed: false,
  onCollapseLeftMenu: function onCollapseLeftMenu() {},
  groupsOfLinks: [],
  onLinkClick: function onLinkClick() {}
};
 false ? 0 : void 0;
/* harmony default export */ const LeftNavigationMenu_LeftNavigationMenu = (LeftNavigationMenu);

/***/ }),

/***/ 1937:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _IconView_IconView__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7434);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4442);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_router_dom__WEBPACK_IMPORTED_MODULE_2__);




var NavigationLinksList = function NavigationLinksList(_ref) {
  var links = _ref.links,
    onLinkClick = _ref.onLinkClick,
    getLinkRowContent = _ref.getLinkRowContent,
    checkActive = _ref.checkActive;
  if (links && links.length < 1) return null;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    className: "menu left-menu-links"
  }, links.map(function (link, index) {
    return getViewLinkItem(link, index, onLinkClick, getLinkRowContent, checkActive);
  }));
};
var getViewLinkItem = function getViewLinkItem(link, index, onLinkClick, getLinkRowContent, checkActive) {
  var linkClassName = link.title.replace(" ", "-").toLowerCase() + "-menu-link";
  var isActiveFunc = checkActive ? function (match, location) {
    return checkActive(match, location, link);
  } : null;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
    className: "left-menu-row linkItem",
    key: index
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_2__.NavLink, {
    to: link.url,
    className: linkClassName,
    onClick: onLinkClick,
    isActive: isActiveFunc
  }, getLinkContent(link, getLinkRowContent, index)));
};
var getLinkContent = function getLinkContent(link, getLinkRowContent, index) {
  if (getLinkRowContent) return getLinkRowContent(link, index);
  return [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    key: "link" + index
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_IconView_IconView__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A, {
    className: "link-icon",
    icon: link.icon,
    key: "icon" + index
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "link-name",
    key: "name" + index
  }, link.title))];
};
NavigationLinksList.defaultProps = {
  links: []
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (NavigationLinksList);

/***/ }),

/***/ 4256:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _LeftNavigationMenu__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(970);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_LeftNavigationMenu__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A);

/***/ }),

/***/ 3320:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ LoadingContainer)
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }


var LoadingContainer = /*#__PURE__*/function (_PureComponent) {
  function LoadingContainer() {
    _classCallCheck(this, LoadingContainer);
    return _callSuper(this, LoadingContainer, arguments);
  }
  _inherits(LoadingContainer, _PureComponent);
  return _createClass(LoadingContainer, [{
    key: "render",
    value: function render() {
      var LinearProgress = this.props.LinearProgress;
      if (this.props.isLoading) return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(LinearProgress, {
        name: "loadingIndicator",
        className: "loading-progress-bar"
      });
      return this.props.children;
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

LoadingContainer.defaultProps = {
  isLoading: false
};
 false ? 0 : void 0;

/***/ }),

/***/ 6282:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export LoadingIndicator */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }


var LoadingIndicator = /*#__PURE__*/function (_PureComponent) {
  function LoadingIndicator() {
    _classCallCheck(this, LoadingIndicator);
    return _callSuper(this, LoadingIndicator, arguments);
  }
  _inherits(LoadingIndicator, _PureComponent);
  return _createClass(LoadingIndicator, [{
    key: "render",
    value: function render() {
      var LinearProgress = this.props.LinearProgress;
      return this.props.isLoading ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(LinearProgress, {
        name: "loadingIndicator",
        className: "loading-progress-bar"
      }) : null;
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LoadingIndicator);

/***/ }),

/***/ 2234:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ OrganizationMenu)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3368);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Menu/_locationMenu.scss
var _locationMenu = __webpack_require__(8106);
// EXTERNAL MODULE: ./src/components/Tooltip/Tooltip.jsx
var Tooltip = __webpack_require__(9004);
;// CONCATENATED MODULE: ./src/components/Menu/OrganizationMenuRow.jsx




var OrganizationMenuRow = function OrganizationMenuRow(_ref) {
  var organization = _ref.organization,
    currentOrganizationId = _ref.currentOrganizationId,
    showAsSuborganization = _ref.showAsSuborganization,
    _onClick = _ref.onClick;
  if (!organization) return null;
  var isCurrentOrganization = organization.id === currentOrganizationId;
  var rowClassName = classnames_default()("organization-row", organization.isSuborganization() && showAsSuborganization ? "suborganization" : "", isCurrentOrganization ? "active" : "");
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: rowClassName,
    onClick: function onClick() {
      return _onClick(organization);
    }
  }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "location-info"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "location-contacts"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "locationName",
    name: "locationName"
  }, organization.name), /*#__PURE__*/external_react_default().createElement("small", null, organization.addressString, " | Site ", organization.site)), /*#__PURE__*/external_react_default().createElement("div", {
    className: "location-tags"
  }, organization.tags.map(function (tag, idx) {
    return /*#__PURE__*/external_react_default().createElement("div", {
      key: idx
    }, tag);
  }))), isCurrentOrganization && /*#__PURE__*/external_react_default().createElement("div", {
    className: "location-is-current"
  }, /*#__PURE__*/external_react_default().createElement("small", null, "Current Site"))));
};
OrganizationMenuRow.defaultProps = {
  showAsSuborganization: false,
  onClick: function onClick() {}
};
 false ? 0 : void 0;
/* harmony default export */ const Menu_OrganizationMenuRow = (OrganizationMenuRow);
// EXTERNAL MODULE: ./src/utilities/StringUtilities.js
var StringUtilities = __webpack_require__(1146);
;// CONCATENATED MODULE: ./src/components/Menu/OrganizationMenuIdn.jsx





var OrganizationMenuIdn = function OrganizationMenuIdn(_ref) {
  var organization = _ref.organization,
    currentOrganizationId = _ref.currentOrganizationId,
    onClick = _ref.onClick,
    showAsGroup = _ref.showAsGroup,
    value = _ref.value,
    selectedTags = _ref.selectedTags;
  if (!organization) return null;
  var filteredSubOrganizations = organization.suborganizations ? organization.suborganizations.filter(function (o) {
    return isMatchFilterFunction(o, value, selectedTags);
  }) : [];
  var filterIsMatched = function filterIsMatched(org) {
    return isMatchFilterFunction(org, value, selectedTags);
  };
  if (!filterIsMatched(organization) && filteredSubOrganizations.length === 0) return null;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/external_react_default().createElement(Menu_OrganizationMenuRow, {
    organization: organization,
    key: currentOrganizationId,
    currentOrganizationId: currentOrganizationId,
    onClick: onClick,
    showAsSuborganization: false
  }), showAsGroup && filteredSubOrganizations.map(function (children) {
    return /*#__PURE__*/external_react_default().createElement(Menu_OrganizationMenuRow, {
      organization: children,
      currentOrganizationId: currentOrganizationId,
      onClick: onClick,
      showAsSuborganization: true,
      key: children.id
    });
  }));
};
OrganizationMenuIdn.defaultProps = {
  selectedTags: [],
  onClick: function onClick() {},
  showAsGroup: true
};
 false ? 0 : void 0;
/* harmony default export */ const Menu_OrganizationMenuIdn = (OrganizationMenuIdn);
var isMatchFilterFunction = function isMatchFilterFunction(location, value, tags) {
  return location && isLocationMatched(location, value) && isTagsMatched(location, tags);
};
var isLocationMatched = function isLocationMatched(location, value) {
  return !value || (0,StringUtilities/* contains */.gR)(location.name, value) || (0,StringUtilities/* contains */.gR)(location.site.toString(), value);
};
var isTagsMatched = function isTagsMatched(location, tags) {
  return tags.length === 0 || location.tags.some(function (tag) {
    return tags.some(function (t) {
      return t === tag;
    });
  });
};
// EXTERNAL MODULE: ./src/components/SearchWidget.jsx
var SearchWidget = __webpack_require__(3949);
// EXTERNAL MODULE: ./src/utilities/EventUtilities.js
var EventUtilities = __webpack_require__(5609);
// EXTERNAL MODULE: ./src/utilities/OrganizationUtilities.js
var OrganizationUtilities = __webpack_require__(2000);
// EXTERNAL MODULE: ./src/utilities/SortingUtilities.js
var SortingUtilities = __webpack_require__(7609);
// EXTERNAL MODULE: ./src/utilities/ValidationUtilities.js
var ValidationUtilities = __webpack_require__(4708);
;// CONCATENATED MODULE: ./src/components/Menu/Tag.jsx




var Tag = function Tag(_ref) {
  var tag = _ref.tag,
    selectedTags = _ref.selectedTags,
    index = _ref.index,
    _onClick = _ref.onClick;
  if ((0,ValidationUtilities/* isNullOrEmpty */.uJ)(tag)) return null;
  var tagClassName = classnames_default()(selectedTags.some(function (t) {
    return t === tag;
  }) ? "selected" : "");
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: tagClassName,
    key: index,
    onClick: function onClick() {
      return _onClick(tag);
    }
  }, tag);
};
Tag.defaultProps = {
  selectedTags: [],
  onClick: function onClick() {}
};
 false ? 0 : void 0;
/* harmony default export */ const Menu_Tag = (Tag);
// EXTERNAL MODULE: ./src/components/IconView/IconView.jsx
var IconView = __webpack_require__(7434);
// EXTERNAL MODULE: ./src/entities/Icon.js
var Icon = __webpack_require__(8607);
;// CONCATENATED MODULE: ./src/components/Menu/Tags.jsx
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }






var moreIcon = new Icon/* default */.A("ion-ios-arrow-down");
var lessIcon = new Icon/* default */.A("ion-ios-arrow-up");
var maxTagsCountByDefault = 40;
var Tags = function Tags(_ref) {
  var tags = _ref.tags,
    selectedTags = _ref.selectedTags,
    onSelectTags = _ref.onSelectTags;
  var _useState = (0,external_react_.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    showMore = _useState2[0],
    setShow = _useState2[1];
  var resultedTags = showMore ? tags.slice(0, maxTagsCountByDefault) : tags;
  resultedTags = resultedTags.sort(SortingUtilities/* sortByString */.NM);
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "location-menu-tags-container"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "location-menu-tags"
  }, resultedTags.sort(SortingUtilities/* sortByName */.VV).map(function (tag, index) {
    return /*#__PURE__*/external_react_default().createElement(Menu_Tag, {
      key: index,
      selectedTags: selectedTags,
      tag: tag,
      onClick: onSelectTags
    });
  })), tags.length > maxTagsCountByDefault && /*#__PURE__*/external_react_default().createElement("div", {
    className: "location-menu-tags-expand"
  }, showMore ? /*#__PURE__*/external_react_default().createElement("div", {
    name: "tags-expand",
    onClick: function onClick() {
      return setShow(false);
    }
  }, /*#__PURE__*/external_react_default().createElement("span", null, "Show More"), /*#__PURE__*/external_react_default().createElement(IconView/* default */.A, {
    icon: moreIcon
  })) : /*#__PURE__*/external_react_default().createElement("div", {
    name: "tags-expand",
    onClick: function onClick() {
      return setShow(true);
    }
  }, /*#__PURE__*/external_react_default().createElement("span", null, "Show Less"), /*#__PURE__*/external_react_default().createElement(IconView/* default */.A, {
    icon: lessIcon
  }))));
};
Tags.defaultProps = {
  tags: [],
  selectedTags: [],
  onSelectTags: function onSelectTags() {}
};
 false ? 0 : void 0;
/* harmony default export */ const Menu_Tags = (Tags);
;// CONCATENATED MODULE: ./src/components/Menu/OrganizationMenu.jsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || OrganizationMenu_unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function OrganizationMenu_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return OrganizationMenu_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? OrganizationMenu_arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return OrganizationMenu_arrayLikeToArray(r); }
function OrganizationMenu_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }











var OrganizationMenu = /*#__PURE__*/function (_PureComponent) {
  function OrganizationMenu(props) {
    var _this;
    _classCallCheck(this, OrganizationMenu);
    _this = _callSuper(this, OrganizationMenu, [props]);
    _defineProperty(_this, "onOrganizationClick", function (organization) {
      _this.setState({
        value: "",
        selectedTags: []
      });
      _this.props.setCurrentOrganization(organization);
      _this.props.goToSecondLevelSection();
    });
    _defineProperty(_this, "onKeyUp", function (event) {
      if (EventUtilities/* isEscPressed */.e0(event)) _this.closeLocationMenu();
    });
    _defineProperty(_this, "closeLocationMenu", function () {
      _this.props.showOrganizationMenu(false);
    });
    _defineProperty(_this, "onSearchChange", function (value) {
      _this.setState({
        value: value,
        selectedTags: []
      });
    });
    _defineProperty(_this, "onSelectTags", function (tag) {
      var index = _this.state.selectedTags.indexOf(tag);
      var result = [];
      if (index > -1) {
        result = [].concat(_toConsumableArray(_this.state.selectedTags.slice(0, index)), _toConsumableArray(_this.state.selectedTags.slice(index + 1)));
        _this.setState({
          selectedTags: result
        });
      } else {
        result = [].concat(_toConsumableArray(_this.state.selectedTags), [tag]);
        _this.setState({
          selectedTags: result
        });
      }
    });
    _defineProperty(_this, "expandList", function (expanded) {
      _this.setState({
        showAsGroup: expanded
      });
    });
    _defineProperty(_this, "getOrganizationRow", function (organization) {
      if (!organization) return null;
      return /*#__PURE__*/external_react_default().createElement(Menu_OrganizationMenuIdn, {
        organization: organization,
        currentOrganizationId: _this.props.currentOrganization.id,
        onClick: _this.onOrganizationClick,
        showAsGroup: _this.state.showAsGroup,
        value: _this.state.value,
        selectedTags: _this.state.selectedTags,
        key: organization.id
      });
    });
    var organizations = props.organizations;
    var treeList = (0,OrganizationUtilities/* createTreeList */.RO)(organizations);
    var tags = (0,OrganizationUtilities/* getTags */.Q2)(organizations);
    var currentIdn = (0,OrganizationUtilities/* getCurrentIdn */.LT)(organizations, props.currentOrganization);
    var p1sOrganization = (0,OrganizationUtilities/* getCurrentP1s */.gR)(organizations);
    _this.state = {
      value: undefined,
      selectedTags: [],
      showAsGroup: true,
      tags: tags,
      treeList: treeList,
      currentIdn: currentIdn,
      p1sOrganization: p1sOrganization
    };
    return _this;
  }
  _inherits(OrganizationMenu, _PureComponent);
  return _createClass(OrganizationMenu, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOrganizationsChanged = prevProps.organizations !== this.props.organizations;
      if (isOrganizationsChanged) {
        var treeList = (0,OrganizationUtilities/* createTreeList */.RO)(this.props.organizations);
        var tags = (0,OrganizationUtilities/* getTags */.Q2)(this.props.organizations);
        var p1sOrganization = (0,OrganizationUtilities/* getCurrentP1s */.gR)(this.props.organizations);
        this.setState({
          tags: tags,
          treeList: treeList,
          p1sOrganization: p1sOrganization
        });
      }
      if (prevProps.shouldShowLocationMenu !== this.props.shouldShowLocationMenu && !this.props.shouldShowLocationMenu) {
        this.setState({
          selectedTags: [],
          value: undefined
        });
      }
      if (isOrganizationsChanged || prevProps.currentOrganization !== this.props.currentOrganization) {
        var currentIdn = (0,OrganizationUtilities/* getCurrentIdn */.LT)(this.props.organizations, this.props.currentOrganization);
        this.setState({
          currentIdn: currentIdn
        });
      }
    }
  }, {
    key: "getIcons",
    value: function getIcons() {
      var _this2 = this;
      if (this.props.organizations.length < 2) return null;
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "location-menu-icons"
      }, /*#__PURE__*/external_react_default().createElement(Tooltip/* default */.A, {
        title: /*#__PURE__*/external_react_default().createElement("span", {
          className: classnames_default()("material-icons", this.state.showAsGroup ? "" : "selected"),
          onClick: function onClick() {
            return _this2.expandList(false);
          }
        }, "menu"),
        description: "List"
      }), /*#__PURE__*/external_react_default().createElement(Tooltip/* default */.A, {
        title: /*#__PURE__*/external_react_default().createElement("span", {
          className: classnames_default()("material-icons", this.state.showAsGroup ? "selected" : ""),
          onClick: function onClick() {
            return _this2.expandList(true);
          }
        }, "sort"),
        description: "Group"
      }));
    }
  }, {
    key: "showP1S",
    value: function showP1S() {
      if (!this.state.p1sOrganization || this.props.currentOrganization.id === this.state.p1sOrganization.id) return null;
      return this.getOrganizationRow(this.state.p1sOrganization);
    }
  }, {
    key: "organizationP1SOrCurrent",
    value: function organizationP1SOrCurrent(organization, currentOrganization) {
      if (organization.isP1S()) return true;
      if (organization.id === currentOrganization.id) return true;
      if (this.state.showAsGroup) {
        if (currentOrganization.isSuborganization()) {
          return organization.id === currentOrganization.parentOrganizationId;
        }
        if (currentOrganization.isIDN()) {
          return organization.parentOrganizationId === currentOrganization.id;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      if (!this.props.shouldShowLocationMenu || !this.props.currentOrganization) return null;
      var viewList = this.state.showAsGroup ? this.state.treeList : this.props.organizations;
      var currentSiteOrIdn = this.state.showAsGroup ? this.state.currentIdn : this.props.currentOrganization;
      return /*#__PURE__*/external_react_default().createElement("div", {
        id: "location-menu"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "location-menu-header-search-close"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "location-menu-header-search-container"
      }, /*#__PURE__*/external_react_default().createElement(SearchWidget["default"], {
        placeholder: "Search for a site",
        onChange: this.onSearchChange,
        onKeyUp: this.onKeyUp,
        showCancel: true,
        searchText: this.state.value,
        onClear: function onClear() {
          return _this3.onSearchChange("");
        }
      })), /*#__PURE__*/external_react_default().createElement("div", {
        className: "location-menu-close",
        onClick: this.closeLocationMenu
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: "material-icons"
      }, "close"))), /*#__PURE__*/external_react_default().createElement("div", {
        className: "location-menu-header"
      }, /*#__PURE__*/external_react_default().createElement(Menu_Tags, {
        tags: this.state.tags,
        selectedTags: this.state.selectedTags,
        onSelectTags: this.onSelectTags
      }), this.getIcons()), /*#__PURE__*/external_react_default().createElement("div", {
        className: "location-menu-organizations row-list"
      }, this.showP1S(), this.getOrganizationRow(currentSiteOrIdn), viewList.map(function (organization) {
        if (_this3.organizationP1SOrCurrent(organization, _this3.props.currentOrganization)) return null;
        return _this3.getOrganizationRow(organization);
      })));
    }
  }]);
}(external_react_.PureComponent);

OrganizationMenu.defaultProps = {
  organizations: [],
  shouldShowLocationMenu: false,
  showOrganizationMenu: function showOrganizationMenu() {}
};
 false ? 0 : void 0;

/***/ }),

/***/ 2563:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _OrganizationMenu__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2234);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_OrganizationMenu__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A);

/***/ }),

/***/ 1336:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6123);
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_style_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5609);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3368);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





var ModalDialog = /*#__PURE__*/function (_PureComponent) {
  function ModalDialog() {
    var _this;
    _classCallCheck(this, ModalDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ModalDialog, [].concat(args));
    _defineProperty(_this, "onClose", function (e) {
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_4__/* .isEscPressed */ .e0)(e)) {
        e.preventDefault();
        _this.props.onClose();
      }
    });
    _defineProperty(_this, "onCloseButtonKeyDown", function (e) {
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_4__/* .isShiftPressed */ .Hk)(e) && (0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_4__/* .isTabPressed */ .Wz)(e) && _this.props.moveFocusBack) {
        e.preventDefault();
        _this.props.moveFocusBack();
      }
      if (!(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_4__/* .isShiftPressed */ .Hk)(e) && (0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_4__/* .isTabPressed */ .Wz)(e) && _this.props.moveFocusForward) {
        e.preventDefault();
        _this.props.moveFocusForward();
      }
    });
    _defineProperty(_this, "setFocus", function () {
      _this.closeButton.focus();
    });
    return _this;
  }
  _inherits(ModalDialog, _PureComponent);
  return _createClass(ModalDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("keydown", this.onClose);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("keydown", this.onClose);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var titleClass = classnames__WEBPACK_IMPORTED_MODULE_3___default()("modal-title", this.props.titleClass);
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "modal-dialog-backdrop"
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "modal-dialog-inner-content modal-dialog-width",
        name: this.props.name
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "modal-dialog-header"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
        className: titleClass
      }, this.props.title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
        disabled: this.props.disableClose,
        className: "close-button close",
        onKeyDown: this.onCloseButtonKeyDown,
        onClick: this.props.onClose,
        tabIndex: this.props.tabIndex,
        ref: function ref(_ref) {
          return _this2.closeButton = _ref;
        }
      }, "\xD7")), this.props.children));
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);
ModalDialog.defaultProps = {
  name: "modalDialog",
  tabIndex: 1,
  disableClose: false
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ModalDialog);

/***/ }),

/***/ 1264:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var ModalDialogBody = function ModalDialogBody(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "modal-dialog-body"
  }, children);
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ModalDialogBody);

/***/ }),

/***/ 6021:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var ModalDialogButtons = function ModalDialogButtons(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "btn-control"
  }, children);
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ModalDialogButtons);

/***/ }),

/***/ 9548:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export MultipleAutoSuggest */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }


var MultipleAutoSuggest = /*#__PURE__*/function (_Component) {
  function MultipleAutoSuggest(props, context) {
    var _this;
    _classCallCheck(this, MultipleAutoSuggest);
    _this = _callSuper(this, MultipleAutoSuggest, [props, context]);
    _this.getSelectedItem = _this.getSelectedItem.bind(_this);
    _this.onAutoSuggestKeyDown = _this.onAutoSuggestKeyDown.bind(_this);
    _this.onAutoSuggestFocus = _this.onAutoSuggestFocus.bind(_this);
    _this.onAutoSuggestBlur = _this.onAutoSuggestBlur.bind(_this);
    _this.onFocus = _this.onFocus.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.onTextChange = _this.onTextChange.bind(_this);
    _this.setFocus = _this.setFocus.bind(_this);
    _this.state = {
      isFocused: false,
      searchKey: "",
      dropdownIsActive: false
    };
    return _this;
  }
  _inherits(MultipleAutoSuggest, _Component);
  return _createClass(MultipleAutoSuggest, [{
    key: "onAutoSuggestKeyDown",
    value: function onAutoSuggestKeyDown(e) {
      var code = e.which ? e.which : e.keyCode;
      switch (code) {
        case 8:
          if (!this.props.selectedItems.length) return;
          var itemToRemove = this.props.selectedItems[this.props.selectedItems.length - 1];
          this.props.removeSelectedItem(itemToRemove);
          break;
      }
    }
  }, {
    key: "onAutoSuggestFocus",
    value: function onAutoSuggestFocus() {
      this.setState({
        isFocused: true
      });
    }
  }, {
    key: "onAutoSuggestBlur",
    value: function onAutoSuggestBlur() {
      this.setState({
        isFocused: false
      });
    }
  }, {
    key: "onTextChange",
    value: function onTextChange(event) {
      var value = event.target.value;
      this.setState({
        searchKey: value
      });
    }
  }, {
    key: "getItemsContent",
    value: function getItemsContent(items, displayValue) {
      var _this2 = this;
      var getItemRow = function getItemRow(item, index) {
        var title = displayValue ? item[displayValue] : item;
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
          key: index,
          ref: _this2.addDropDownItem
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
          href: "#",
          onMouseDown: function onMouseDown() {
            return _this2.onItemSelected(item);
          }
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
          className: "truncate",
          title: title
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, title))));
      };
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
        className: "dropdown-menu"
      }, items.map(function (item, index) {
        return getItemRow(item, index);
      }));
    }
  }, {
    key: "onItemSelected",
    value: function onItemSelected(item) {
      this.props.addSelectedItem(item);
      this.clearSearchKey();
    }
  }, {
    key: "clearSearchKey",
    value: function clearSearchKey() {
      this.setState({
        searchKey: ""
      });
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      this.setState({
        dropdownIsActive: true
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.setState({
        dropdownIsActive: false
      });
    }
  }, {
    key: "setFocus",
    value: function setFocus() {
      this.textInput && this.textInput.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state = this.state,
        isFocused = _this$state.isFocused,
        searchKey = _this$state.searchKey,
        dropdownIsActive = _this$state.dropdownIsActive;
      var _this$props = this.props,
        items = _this$props.items,
        isReadonly = _this$props.isReadonly,
        selectedItems = _this$props.selectedItems,
        canDelete = _this$props.canDelete,
        displayValue = _this$props.displayValue,
        placeholder = _this$props.placeholder,
        autoFocus = _this$props.autoFocus;
      var dropdownIsVisible = dropdownIsActive && searchKey.length > 0;
      var wrapPanelClass = "items-wrap-panel";
      if (isReadonly) wrapPanelClass += " readonly";
      if (isFocused) wrapPanelClass += " focused";
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: this.props.className
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
        className: wrapPanelClass,
        onClick: this.setFocus
      }, selectedItems.map(function (item, index) {
        return _this3.getSelectedItem(item, index, isReadonly, displayValue, canDelete);
      }), !isReadonly && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
        className: "autoSuggestContainer"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "autoSuggest"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
        autoComplete: "off",
        name: "autosuggest",
        ref: function ref(input) {
          _this3.textInput = input;
        },
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        className: "form-control",
        onChange: this.onTextChange,
        value: searchKey,
        placeholder: placeholder,
        autoFocus: autoFocus
      })), dropdownIsVisible && this.getItemsContent(items, displayValue)))));
    }
  }, {
    key: "getSelectedItem",
    value: function getSelectedItem(item, index, isReadonly, displayValue) {
      var _this4 = this;
      var canDelete = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var title = displayValue ? item[displayValue] : item;
      var separator = this.props.separator;
      var hasMultipleItems = this.props.selectedItems.length > 1;
      var notLast = index < this.props.selectedItems.length - 1;
      var hasSeparator = separator.length > 0;
      var showSeparator = hasSeparator && hasMultipleItems && notLast;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
        key: index
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: this.props.selectedItemClassName,
        title: title
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "content truncate",
        onClick: function onClick() {
          return _this4.props.onItemClick(item);
        }
      }, title), (!isReadonly || canDelete) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "icon-cancel icon",
        onClick: function onClick() {
          return _this4.props.removeSelectedItem(item);
        }
      })), showSeparator && isReadonly && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
        className: "separator"
      }, separator));
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
MultipleAutoSuggest.defaultProps = {
  items: [],
  selectedItems: [],
  addSelectedItem: function addSelectedItem() {},
  removeSelectedItem: function removeSelectedItem() {},
  isReadonly: false,
  autoFocus: true,
  displayValue: "name",
  placeholder: "",
  separator: "",
  onItemClick: function onItemClick() {}
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MultipleAutoSuggest);

/***/ }),

/***/ 144:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export NavigationBar */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4442);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_router_dom__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3368);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }




var NavigationBar = /*#__PURE__*/function (_React$PureComponent) {
  function NavigationBar(props) {
    var _this;
    _classCallCheck(this, NavigationBar);
    _this = _callSuper(this, NavigationBar, [props]);
    _this.setFocus = _this.setFocus.bind(_this);
    return _this;
  }
  _inherits(NavigationBar, _React$PureComponent);
  return _createClass(NavigationBar, [{
    key: "setFocus",
    value: function setFocus() {
      if (this.backLinkRef) {
        this.backLinkRef.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var extraComponentClassName = classnames__WEBPACK_IMPORTED_MODULE_3___default()(this.props.extraComponent ? "col-sm-2 col-xs-2" : "hidden-sm-down", "col-md-2");
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "base-content row",
        id: "pageTitle"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        ref: function ref(div) {
          return _this2.backLinkRef = div;
        },
        className: "col-xs-2 col-md-2 back-link",
        tabIndex: this.props.backLinkTabIndex,
        onKeyDown: this.props.onKeyDown,
        name: this.props.backLinkName
      }, this.props.backLink && this.props.hasRouter ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(BackNavLink, {
        backLink: this.props.backLink,
        onClick: this.props.onClick
      }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(BackHref, {
        disabled: this.props.disabled,
        onClick: this.props.onClick,
        backLink: this.props.backLink
      })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "col-xs-10 col-md-8"
      }, this.props.children, !this.props.children && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
        name: "navBarTitle"
      }, this.props.titleText)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: extraComponentClassName
      }, this.props.extraComponent ? this.props.extraComponent : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, "\xA0")));
    }
  }]);
}((react__WEBPACK_IMPORTED_MODULE_0___default().PureComponent));
var BackNavLink = function BackNavLink(_ref) {
  var backLink = _ref.backLink,
    onClick = _ref.onClick;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_2__.NavLink, {
    to: backLink,
    activeClassName: "active",
    onClick: onClick,
    name: "navBarBackLink"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "ion-ios-arrow-back",
    "aria-hidden": "true"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "backText"
  }, "\xA0\xA0Back"));
};
 false ? 0 : void 0;
var BackHref = function BackHref(_ref2) {
  var onClick = _ref2.onClick,
    disabled = _ref2.disabled,
    backLink = _ref2.backLink;
  if (backLink) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
      onClick: onClick,
      name: "navBarBackLink",
      className: disabled ? "back-link disabled" : "back-link",
      href: backLink
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "ion-ios-arrow-back",
      "aria-hidden": "true"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "backText"
    }, "\xA0\xA0Back"));
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    onClick: onClick,
    name: "navBarBackLink",
    className: disabled ? "back-link disabled" : "back-link"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "ion-ios-arrow-back",
    "aria-hidden": "true"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "backText"
  }, "\xA0\xA0Back"));
};
 false ? 0 : void 0;
NavigationBar.defaultProps = {
  titleText: "",
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {},
  disabled: false,
  hasRouter: true,
  backLinkTabIndex: 0,
  backLinkName: ""
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (NavigationBar);

/***/ }),

/***/ 6126:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ components_NotificationsPopup)
});

// UNUSED EXPORTS: NotificationsPopup

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
;// CONCATENATED MODULE: ./src/constants/MessageType.js
var MessageType = {
  success: "success",
  error: "error",
  warning: "warning"
};
/* harmony default export */ const constants_MessageType = (MessageType);
;// CONCATENATED MODULE: ./src/constants/NotificationsPopupPosition.js
var NotificationsPopupPosition = {
  topLeft: "toast-top-left",
  topRight: "toast-top-right",
  bottomLeft: "toast-bottom-left",
  bottomRight: "toast-bottom-right"
};
/* harmony default export */ const constants_NotificationsPopupPosition = ((/* unused pure expression or super */ null && (NotificationsPopupPosition)));
// EXTERNAL MODULE: ./src/components/ReactToastr/index.js + 3 modules
var ReactToastr = __webpack_require__(1867);
;// CONCATENATED MODULE: ./src/components/NotificationsPopup.jsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }





var NotificationsPopup = /*#__PURE__*/function (_Component) {
  function NotificationsPopup() {
    _classCallCheck(this, NotificationsPopup);
    return _callSuper(this, NotificationsPopup, arguments);
  }
  _inherits(NotificationsPopup, _Component);
  return _createClass(NotificationsPopup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var operationResult = this.props.operationResult;
      if (operationResult !== null) {
        var type = operationResult.type;
        if (!type) {
          type = operationResult.error ? constants_MessageType.error : constants_MessageType.success;
        }
        switch (type) {
          case constants_MessageType.error:
            this.container.error(operationResult.message, "");
            break;
          case constants_MessageType.warning:
            this.container.warning(operationResult.message, "");
            break;
          default:
            this.container.success(operationResult.message, "");
            break;
        }
        this.props.clearToaster();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      return /*#__PURE__*/external_react_default().createElement(ReactToastr["default"], {
        ref: function ref(_ref) {
          return _this.container = _ref;
        },
        className: this.props.position
      });
    }
  }]);
}(external_react_.Component);
NotificationsPopup.defaultProps = {
  position: NotificationsPopupPosition.topRight
};
 false ? 0 : void 0;
/* harmony default export */ const components_NotificationsPopup = (NotificationsPopup);

/***/ }),

/***/ 3678:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export NumericInput */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }


var NumericInput = /*#__PURE__*/function (_PureComponent) {
  function NumericInput(props, context) {
    var _this;
    _classCallCheck(this, NumericInput);
    _this = _callSuper(this, NumericInput, [props, context]);
    _this.setFocus = _this.setFocus.bind(_this);
    return _this;
  }
  _inherits(NumericInput, _PureComponent);
  return _createClass(NumericInput, [{
    key: "setFocus",
    value: function setFocus() {
      this.textInput.focus();
    }
  }, {
    key: "select",
    value: function select() {
      this.textInput.select();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var wrapperClass = "form-group";
      if (this.props.error && this.props.error.length > 0) {
        wrapperClass += " " + "has-error";
      }
      if (this.props.className) wrapperClass += " " + this.props.className;
      var inputProps = {};
      inputProps["disabled"] = this.props.disabled;
      inputProps["autoFocus"] = this.props.autoFocus;
      if (this.props.readonly) {
        inputProps["readOnly"] = this.props.readonly;
      }
      if (this.props.autoComplete !== undefined) inputProps["autoComplete"] = this.props.autoComplete ? "on" : "off";
      var componentName = this.props.name + "Field";
      var labelId = this.props.name + "Label";
      var inputId = this.props.name + "Input";
      var inputFinalClassName = this.props.inputClassName ? "form-control " + this.props.inputClassName : "form-control";
      if (this.props.min) {
        inputProps["min"] = this.props.min;
      }
      if (this.props.max) {
        inputProps["max"] = this.props.max;
      }
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: wrapperClass,
        name: componentName
      }, this.props.label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", {
        id: labelId,
        htmlFor: this.props.name
      }, this.props.label), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", _extends({
        id: inputId,
        type: "number",
        ref: function ref(input) {
          _this2.textInput = input;
        },
        name: this.props.name,
        tabIndex: this.props.tabIndex,
        className: inputFinalClassName,
        placeholder: this.props.placeholder,
        maxLength: this.props.maxlength,
        value: this.props.value
      }, inputProps, {
        onChange: this.props.onChange,
        onKeyPress: this.props.onKeyPress,
        onKeyDown: this.props.onKeyDown,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        size: ""
      })), this.props.error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "validate-error-message"
      }, this.props.error));
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (NumericInput);

/***/ }),

/***/ 5669:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export Overlay */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }


var Overlay = /*#__PURE__*/function (_PureComponent) {
  function Overlay() {
    _classCallCheck(this, Overlay);
    return _callSuper(this, Overlay, arguments);
  }
  _inherits(Overlay, _PureComponent);
  return _createClass(Overlay, [{
    key: "render",
    value: function render() {
      var _this = this;
      if (this.props.isContentBlocked) return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "shadow",
        onClick: function onClick() {
          _this.props.onClick(false);
        }
      });
      return null;
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);
Overlay.defaultProps = {
  isContentBlocked: false,
  onClick: function onClick() {}
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Overlay);

/***/ }),

/***/ 7113:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ components_PendingButton)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./src/components/Button.jsx
var Button = __webpack_require__(9305);
// EXTERNAL MODULE: ./src/components/IconView/IconView.jsx
var IconView = __webpack_require__(7434);
// EXTERNAL MODULE: ./src/entities/Icon.js
var Icon = __webpack_require__(8607);
// EXTERNAL MODULE: ./src/components/PendingButton/_styles.scss
var _styles = __webpack_require__(7874);
;// CONCATENATED MODULE: ./src/components/PendingButton/PendingButton.jsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }






var PendingButton = /*#__PURE__*/function (_PureComponent) {
  function PendingButton(props) {
    var _this;
    _classCallCheck(this, PendingButton);
    _this = _callSuper(this, PendingButton, [props]);
    _this.setFocus = _this.setFocus.bind(_this);
    return _this;
  }
  _inherits(PendingButton, _PureComponent);
  return _createClass(PendingButton, [{
    key: "setFocus",
    value: function setFocus() {
      this.button.setFocus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var buttonProps = {};
      buttonProps["disabled"] = this.props.disabled;
      buttonProps["autoFocus"] = this.props.autoFocus;
      buttonProps["id"] = this.props.id;
      buttonProps["name"] = this.props.name;
      var defaultClassName = this.props.className;
      var pendingClassName = "btn btn-loader throbberContainer";
      if (this.props.isPending) {
        defaultClassName = defaultClassName + " hiddenBtn";
        pendingClassName = pendingClassName + " btn-updating";
      } else {
        pendingClassName = pendingClassName + " hiddenBtn";
      }
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "btn-pending"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: pendingClassName
      }, /*#__PURE__*/external_react_default().createElement("div", null), /*#__PURE__*/external_react_default().createElement("label", null, this.props.pendingTitle)), /*#__PURE__*/external_react_default().createElement(Button["default"], _extends({
        className: defaultClassName,
        onClick: this.props.onClick,
        onKeyDown: this.props.onKeyDown,
        tabIndex: this.props.tabIndex,
        ref: function ref(button) {
          _this2.button = button;
        }
      }, buttonProps), this.props.iconName && /*#__PURE__*/external_react_default().createElement(IconView/* default */.A, {
        icon: new Icon/* default */.A(this.props.iconName, Icon/* IconTypes */.B.material),
        className: this.props.iconClassName,
        name: this.props.iconName
      }), this.props.title));
    }
  }]);
}(external_react_.PureComponent);
PendingButton.defaultProps = {
  isPending: false,
  pendingTitle: "Saving",
  className: "btn btn-success update",
  onKeyDown: function onKeyDown() {}
};
 false ? 0 : void 0;
/* harmony default export */ const PendingButton_PendingButton = (PendingButton);
;// CONCATENATED MODULE: ./src/components/PendingButton/index.js

/* harmony default export */ const components_PendingButton = (PendingButton_PendingButton);

/***/ }),

/***/ 296:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export OptionsPopup */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3368);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Popup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6812);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




var getBaseIcon = function getBaseIcon(moreIconName) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("more-link", moreIconName)
  });
};
var OptionsPopup = /*#__PURE__*/function (_React$PureComponent) {
  function OptionsPopup() {
    var _this;
    _classCallCheck(this, OptionsPopup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, OptionsPopup, [].concat(args));
    _defineProperty(_this, "state", {
      isPopupVisible: false
    });
    _defineProperty(_this, "togglePopup", function (isVisible) {
      _this.setState({
        isPopupVisible: isVisible
      });
    });
    _defineProperty(_this, "getResultedIcon", function (iconName) {
      if (_this.props.getIcon) return _this.props.getIcon();
      return getBaseIcon(iconName);
    });
    _defineProperty(_this, "setFocusToContext", function () {
      var _this$popupRef;
      (_this$popupRef = _this.popupRef) === null || _this$popupRef === void 0 || _this$popupRef.setFocusToContext();
    });
    _defineProperty(_this, "handleItemClick", function (itemOnClick) {
      return function () {
        itemOnClick();
        _this.togglePopup(false);
      };
    });
    return _this;
  }
  _inherits(OptionsPopup, _React$PureComponent);
  return _createClass(OptionsPopup, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        hidden = _this$props.hidden,
        items = _this$props.items,
        moreIconName = _this$props.moreIconName,
        popupClass = _this$props.popupClass,
        showAlways = _this$props.showAlways,
        popupContextTabIndex = _this$props.popupContextTabIndex,
        onContextKeyDown = _this$props.onContextKeyDown,
        popupTabIndex = _this$props.popupTabIndex;
      var isPopupVisible = this.state.isPopupVisible;
      var containerClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()("popupContainer", {
        "invisible": hidden
      });
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: containerClasses
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Popup__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A, {
        target: this.getResultedIcon(moreIconName),
        showAlways: showAlways,
        className: popupClass,
        popupTabIndex: popupTabIndex,
        contextTabIndex: popupContextTabIndex,
        onContextKeyDown: onContextKeyDown,
        ref: function ref(_ref) {
          return _this2.popupRef = _ref;
        },
        isPopupVisible: isPopupVisible,
        onTogglePopup: this.togglePopup
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", null, items.map(function (item, index) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
          key: index,
          onClick: _this2.handleItemClick(item.onClick)
        }, item.title);
      }))));
    }
  }]);
}((react__WEBPACK_IMPORTED_MODULE_0___default().PureComponent));
OptionsPopup.defaultProps = {
  hidden: false,
  items: [{
    onClick: function onClick() {},
    title: ""
  }],
  showAlways: false,
  popupClass: "right-side-popup",
  moreIconName: "ion-md-more",
  popupContextTabIndex: null
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OptionsPopup);

/***/ }),

/***/ 6812:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export Popup */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3368);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3719);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_3__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




var Popup = /*#__PURE__*/function (_PureComponent) {
  function Popup() {
    var _this;
    _classCallCheck(this, Popup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Popup, [].concat(args));
    _defineProperty(_this, "state", {
      showPopup: false
    });
    _defineProperty(_this, "contextRef", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createRef());
    _defineProperty(_this, "popupRef", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createRef());
    _defineProperty(_this, "togglePopup", function (isVisible) {
      if (_this.props.onTogglePopup) {
        _this.props.onTogglePopup(isVisible);
      } else {
        _this.setState({
          showPopup: isVisible
        });
      }
    });
    _defineProperty(_this, "hidePopup", function (event) {
      var _this$popupRef;
      if (!((_this$popupRef = _this.popupRef) !== null && _this$popupRef !== void 0 && (_this$popupRef = _this$popupRef.current) !== null && _this$popupRef !== void 0 && _this$popupRef.contains(event.target))) {
        _this.togglePopup(false);
      }
    });
    _defineProperty(_this, "onClick", function (e, showPopup) {
      if (!showPopup) {
        _this.togglePopup(!_this.isShown);
        _this.setFocusToContext();
        e.preventDefault();
      }
    });
    _defineProperty(_this, "onFocus", function () {
      _this.togglePopup(true);
      _this.setFocusToContext();
    });
    _defineProperty(_this, "onBlur", function () {
      _this.togglePopup(false);
    });
    _defineProperty(_this, "setFocusToContext", function () {
      var _this$contextRef;
      (_this$contextRef = _this.contextRef) === null || _this$contextRef === void 0 || (_this$contextRef = _this$contextRef.current) === null || _this$contextRef === void 0 || _this$contextRef.focus();
      // contextRef is always present
      // but when we change styles dynamically in popupContextClassName
      // focus might be set incorrectly
      // so, we set it twice in SOME cases
      if (_this.props.setFocusTwice) setTimeout(function () {
        var _this$contextRef2;
        (_this$contextRef2 = _this.contextRef) === null || _this$contextRef2 === void 0 || (_this$contextRef2 = _this$contextRef2.current) === null || _this$contextRef2 === void 0 || _this$contextRef2.focus();
      }, 1);
    });
    return _this;
  }
  _inherits(Popup, _PureComponent);
  return _createClass(Popup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("click", this.hidePopup, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("click", this.hidePopup, false);
    }
  }, {
    key: "isShown",
    get: function get() {
      return typeof this.props.isPopupVisible !== "undefined" ? this.props.isPopupVisible : this.state.showPopup;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var showPopup = this.props.showAlways || this.isShown;
      var popupContextClassName = classnames__WEBPACK_IMPORTED_MODULE_2___default()("popup-context", {
        "show": showPopup
      }, this.props.className);
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "popup",
        onClick: function onClick(e) {
          return _this2.onClick(e, _this2.isShown);
        },
        tabIndex: showPopup ? null : this.props.popupTabIndex,
        ref: this.popupRef,
        onFocus: this.onFocus
      }, this.props.target, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        onBlur: this.onBlur,
        className: popupContextClassName,
        ref: this.contextRef,
        onKeyDown: this.props.onContextKeyDown,
        tabIndex: showPopup ? this.props.contextTabIndex : null
      }, !!showPopup && this.props.children));
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);
Popup.defaultProps = {
  showAlways: false,
  contextTabIndex: null,
  onContextKeyDown: function onContextKeyDown() {},
  isPopupVisible: undefined,
  onTogglePopup: undefined,
  setFocusTwice: true
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Popup);

/***/ }),

/***/ 9124:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ EditEmail)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./src/utilities/UserUtilities.js
var UserUtilities = __webpack_require__(9840);
// EXTERNAL MODULE: ./src/components/Profile/PendingEmail.jsx
var PendingEmail = __webpack_require__(1664);
// EXTERNAL MODULE: ./src/components/ActionButtonsPanel.js
var ActionButtonsPanel = __webpack_require__(1504);
// EXTERNAL MODULE: ./src/components/NavigationBar.jsx
var NavigationBar = __webpack_require__(144);
// EXTERNAL MODULE: ./src/utilities/OrganizationUtilities.js
var OrganizationUtilities = __webpack_require__(2000);
// EXTERNAL MODULE: ./src/constants/OrganizationTypeEnum.js
var OrganizationTypeEnum = __webpack_require__(9220);
;// CONCATENATED MODULE: ./src/entities/Product.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var Product = /*#__PURE__*/_createClass(function Product(json) {
  _classCallCheck(this, Product);
  if (json) {
    this.id = json.Id;
    this.name = json.Name;
    this.order = json.Order;
    this.status = json.Status;
  }
});

// EXTERNAL MODULE: ./src/constants/OrganizationStatusEnum.js
var OrganizationStatusEnum = __webpack_require__(1486);
// EXTERNAL MODULE: ./src/utilities/SortingUtilities.js
var SortingUtilities = __webpack_require__(7609);
// EXTERNAL MODULE: ./src/entities/BaseClass.js
var BaseClass = __webpack_require__(39);
// EXTERNAL MODULE: ./src/constants/ProductEnum.js
var ProductEnum = __webpack_require__(4006);
;// CONCATENATED MODULE: ./src/entities/Organization.js
function Organization_typeof(o) { "@babel/helpers - typeof"; return Organization_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Organization_typeof(o); }
function Organization_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Organization_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Organization_toPropertyKey(o.key), o); } }
function Organization_createClass(e, r, t) { return r && Organization_defineProperties(e.prototype, r), t && Organization_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Organization_toPropertyKey(t) { var i = Organization_toPrimitive(t, "string"); return "symbol" == Organization_typeof(i) ? i : i + ""; }
function Organization_toPrimitive(t, r) { if ("object" != Organization_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Organization_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == Organization_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }







var Organization = /*#__PURE__*/function (_BaseClass) {
  function Organization(json) {
    var _this;
    Organization_classCallCheck(this, Organization);
    _this = _callSuper(this, Organization);
    _this.address = {};
    _this.contact = {};
    _this.virtualProductIdsOfOrganizationAndSubordinates = [];
    _this.virtualProducts = [];
    _this.virtualProductIds = [];
    _this.virtualContentIds = [];
    _this.isDarwinInfrastructure = false;
    _this.tags = [];
    _this.decommissionedDate = null;
    _this.isDecommissioned = false;
    _this.isReportProblemInSepsisMonitorEnabled = false;
    _this.sonicUCompanyId = null;
    if (json) mapJsonToOrganization(json, _this);
    return _this;
  }
  _inherits(Organization, _BaseClass);
  return Organization_createClass(Organization, [{
    key: "isP1S",
    value: function isP1S() {
      return this.type == OrganizationTypeEnum/* default */.A.P1S || !this.site;
    }
  }, {
    key: "isIDN",
    value: function isIDN() {
      return this.type == OrganizationTypeEnum/* default */.A.Parent;
    }
  }, {
    key: "isSuborganization",
    value: function isSuborganization() {
      return this.type == OrganizationTypeEnum/* default */.A.Subordinate;
    }
  }, {
    key: "isSeparateOrganization",
    value: function isSeparateOrganization() {
      return this.type == OrganizationTypeEnum/* default */.A.Separate;
    }
  }, {
    key: "addressString",
    get: function get() {
      if (this.address) {
        var city = this.address.city ? this.address.city.trim() : "";
        var state = this.address.state ? this.address.state.trim() : "";
        var delimiter = city && state ? ", " : "";
        return city + delimiter + state;
      }
      return "";
    }
  }, {
    key: "getAddressToJson",
    value: function getAddressToJson() {
      if (this.address) return {
        City: this.address.city,
        Street: this.address.street,
        State: this.address.state,
        ZipCode: this.address.zipCode
      };
      return {};
    }
  }, {
    key: "getAuthenticationType",
    value: function getAuthenticationType() {
      if (this.authenticationType) return (0,OrganizationUtilities/* getAuthenticationType */.Ds)(this.authenticationType);
      return null;
    }
  }, {
    key: "hasAccessToRuleManagement",
    get: function get() {
      return this.virtualProductIds.some(function (id) {
        return id == ProductEnum/* default */.A.RuleManagement.id;
      });
    }
  }, {
    key: "hasAccessToSimplifi",
    get: function get() {
      return this.virtualProductIds.some(function (id) {
        return id == Product.Simplifi.id;
      });
    }
  }, {
    key: "hasAccessToAnalytics",
    get: function get() {
      return this.virtualProductIds.some(function (id) {
        return id == Product.Analytics.id;
      });
    }
  }, {
    key: "isAvailableForRules",
    get: function get() {
      return this.hasAccessToRuleManagement && !this.isDisabled && this.status.value != OrganizationStatusEnum/* default */.A.Locked.value;
    }
  }, {
    key: "toJson",
    value: function toJson(user, provisioningProfile, selectedProductsIds, hydraGridNumber) {
      var json = {};
      json.Name = this.name;
      json.SiloNumber = this.silo;
      json.IsDarwinInfrastructure = this.isDarwinInfrastructure;
      if (user) {
        json.DefaultUserFirstName = user.firstName;
        json.DefaultUserLastName = user.lastName;
        json.DefaultUserEmail = user.email;
        json.DefaultUserPassword = user.password;
      }
      if (this.parentOrganizationId) json.ParentOrganizationId = this.parentOrganizationId;
      if (this.address) {
        json.Address = {
          City: this.address.city,
          Street: this.address.street,
          State: this.address.state,
          ZipCode: this.address.zipCode
        };
      }
      if (this.id) json.Id = this.id;
      if (provisioningProfile) {
        json.ProvisioningProfile = provisioningProfile.id;
      }
      if (hydraGridNumber) {
        json.HydraGridNumber = hydraGridNumber;
      }
      json.VirtualProductIds = selectedProductsIds || [];
      return json;
    }
  }]);
}(BaseClass/* default */.A);

var mapJsonToOrganization = function mapJsonToOrganization(json, organization) {
  organization.id = json.Id;
  organization.name = json.Name;
  organization.site = json.Site;
  organization.parentOrganizationId = json.ParentOrganizationId;
  organization.parentOrganizationName = json.ParentOrganizationName;
  organization.activeLocationsCount = json.ActiveSubordinateOrganizationsCount || 0;
  organization.virtualUsersCount = json.VirtualUsersCount || 0;
  organization.address = {};
  organization.contact = {};
  organization.authenticationType = json.AuthenticationType;
  organization.virtualProductIds = json.VirtualProductIds;
  organization.virtualContentIds = json.VirtualContentIds;
  organization.isReportProblemInSepsisMonitorEnabled = json.IsReportProblemInSepsisMonitorEnabled;
  organization.sonicUCompanyId = json.SonicUCompanyId;
  organization.isDisabled = json.IsDisabled;
  organization.isDecommissioned = json.IsDecommissioned;
  organization.decommissionedDate = json.DecommissionedDate;
  if (json.VirtualProductIdsOfOrganizationAndSubordinates) {
    organization.virtualProductIdsOfOrganizationAndSubordinates = [];
    json.VirtualProductIdsOfOrganizationAndSubordinates.forEach(function (item) {
      organization.virtualProductIdsOfOrganizationAndSubordinates.push(item);
    });
  }
  if (json.VirtualProducts) {
    organization.virtualProducts = [];
    json.VirtualProducts.forEach(function (item) {
      organization.virtualProducts.push(new Product(item));
    });
  }
  if (json.Type) {
    organization.type = (0,OrganizationUtilities/* getOrganizationType */.Iv)(json.Type);
  }
  if (json.Status) {
    organization.status = (0,OrganizationUtilities/* getOrganizationStatus */.AU)(json.Status);
  }
  if (json.Address) {
    organization.address = {
      city: json.Address.City,
      state: json.Address.State,
      street: json.Address.Street,
      zipCode: json.Address.ZipCode
    };
  }
  if (json.PrimaryContact) {
    organization.contact = {
      firstName: json.PrimaryContact.FirstName,
      lastName: json.PrimaryContact.LastName
    };
  }
  if (json.SiloView) {
    organization.silo = json.SiloView.Number;
    organization.isDarwinInfrastructure = !json.SiloView.Number;
  }
  if (json.Tags) organization.tags = json.Tags.sort(SortingUtilities/* sortByString */.NM).slice();
};
;// CONCATENATED MODULE: ./src/entities/Permission.js
function Permission_typeof(o) { "@babel/helpers - typeof"; return Permission_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Permission_typeof(o); }
function Permission_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Permission_toPropertyKey(o.key), o); } }
function Permission_createClass(e, r, t) { return r && Permission_defineProperties(e.prototype, r), t && Permission_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Permission_toPropertyKey(t) { var i = Permission_toPrimitive(t, "string"); return "symbol" == Permission_typeof(i) ? i : i + ""; }
function Permission_toPrimitive(t, r) { if ("object" != Permission_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Permission_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function Permission_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var Permission = /*#__PURE__*/Permission_createClass(function Permission(json) {
  Permission_classCallCheck(this, Permission);
  if (json) {
    this.id = json.Id;
    this.name = json.Name;
  }
});

;// CONCATENATED MODULE: ./src/entities/UnverifiedEmail.js
function UnverifiedEmail_typeof(o) { "@babel/helpers - typeof"; return UnverifiedEmail_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, UnverifiedEmail_typeof(o); }
function UnverifiedEmail_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function UnverifiedEmail_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, UnverifiedEmail_toPropertyKey(o.key), o); } }
function UnverifiedEmail_createClass(e, r, t) { return r && UnverifiedEmail_defineProperties(e.prototype, r), t && UnverifiedEmail_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function UnverifiedEmail_toPropertyKey(t) { var i = UnverifiedEmail_toPrimitive(t, "string"); return "symbol" == UnverifiedEmail_typeof(i) ? i : i + ""; }
function UnverifiedEmail_toPrimitive(t, r) { if ("object" != UnverifiedEmail_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != UnverifiedEmail_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var UnverifiedEmail = /*#__PURE__*/function () {
  function UnverifiedEmail(json) {
    UnverifiedEmail_classCallCheck(this, UnverifiedEmail);
    this.email = "";
    this.activatedDateTime = undefined;
    this.canBeDiscarded = false;
    if (json) mapJsonToObj(json, this);
  }
  return UnverifiedEmail_createClass(UnverifiedEmail, [{
    key: "toJson",
    value: function toJson() {
      var json = {};
      mapObjToJson(this, json);
      return json;
    }
  }]);
}();

var mapJsonToObj = function mapJsonToObj(json, unverifiedEmail) {
  unverifiedEmail.email = json.Email;
  unverifiedEmail.activatedDateTime = json.ActivatedDateTime;
  unverifiedEmail.canBeDiscarded = json.CanBeDiscarded;
};
var mapObjToJson = function mapObjToJson(unverifiedEmail, json) {
  json.Email = unverifiedEmail.email;
  json.ActivatedDateTime = unverifiedEmail.activatedDateTime;
  json.CanBeDiscarded = unverifiedEmail.canBeDiscarded;
};
// EXTERNAL MODULE: ./src/utilities/ProductUtilities.js
var ProductUtilities = __webpack_require__(2500);
;// CONCATENATED MODULE: ./src/entities/Tag.js
function Tag_typeof(o) { "@babel/helpers - typeof"; return Tag_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Tag_typeof(o); }
function Tag_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Tag_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Tag_toPropertyKey(o.key), o); } }
function Tag_createClass(e, r, t) { return r && Tag_defineProperties(e.prototype, r), t && Tag_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Tag_toPropertyKey(t) { var i = Tag_toPrimitive(t, "string"); return "symbol" == Tag_typeof(i) ? i : i + ""; }
function Tag_toPrimitive(t, r) { if ("object" != Tag_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Tag_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Tag = /*#__PURE__*/function () {
  function Tag(json) {
    Tag_classCallCheck(this, Tag);
    this.id = -1;
    this.name = "";
    if (json) this.fromJson(json, this);
  }
  return Tag_createClass(Tag, [{
    key: "fromJson",
    value: function fromJson(json, tag) {
      tag.id = json.Id;
      tag.name = json.Name;
    }
  }, {
    key: "createCopy",
    value: function createCopy() {
      var tag = new Tag();
      tag.id = this.id;
      tag.name = this.name;
    }
  }]);
}();

// EXTERNAL MODULE: ./src/entities/ExternalIdentifiers.js
var ExternalIdentifiers = __webpack_require__(3465);
;// CONCATENATED MODULE: ./src/entities/User.js
function User_typeof(o) { "@babel/helpers - typeof"; return User_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, User_typeof(o); }
function User_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function User_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, User_toPropertyKey(o.key), o); } }
function User_createClass(e, r, t) { return r && User_defineProperties(e.prototype, r), t && User_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function User_toPropertyKey(t) { var i = User_toPrimitive(t, "string"); return "symbol" == User_typeof(i) ? i : i + ""; }
function User_toPrimitive(t, r) { if ("object" != User_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != User_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function User_callSuper(t, o, e) { return o = User_getPrototypeOf(o), User_possibleConstructorReturn(t, User_isNativeReflectConstruct() ? Reflect.construct(o, e || [], User_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function User_possibleConstructorReturn(t, e) { if (e && ("object" == User_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return User_assertThisInitialized(t); }
function User_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function User_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (User_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function User_getPrototypeOf(t) { return User_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, User_getPrototypeOf(t); }
function User_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && User_setPrototypeOf(t, e); }
function User_setPrototypeOf(t, e) { return User_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, User_setPrototypeOf(t, e); }










var User = /*#__PURE__*/function (_BaseClass) {
  function User(json) {
    var _this;
    User_classCallCheck(this, User);
    _this = User_callSuper(this, User);
    _this.firstName = "";
    _this.lastName = "";
    _this.email = "";
    _this.externalUserId = "";
    _this.isVirtualSuperUser = false;
    _this.hasAccessToEntireIdn = false;
    _this.activeOrganizations = [];
    _this.assignedVirtualProducts = [];
    _this.permissions = [];
    _this.organizationId = 0;
    _this.organizationName = "";
    _this.virtualProfileId = 0;
    _this.authType = "";
    _this.isActive = true;
    _this.pin = "";
    _this.pendingEmail = undefined;
    _this.isEmailLoginEnabled = false;
    _this.tags = [];
    _this.externalIdentifiers = null;
    if (json) mapJsonToUser(json, _this);
    return _this;
  }
  User_inherits(User, _BaseClass);
  return User_createClass(User, [{
    key: "getInitials",
    value: function getInitials() {
      if (this.isSystem) return "P1";else return this.firstName.substring(0, 1) + this.lastName.substring(0, 1);
    }
  }, {
    key: "fullName",
    get: function get() {
      return this.firstName + " " + this.lastName;
    }
  }, {
    key: "hasUnverifiedEmail",
    get: function get() {
      return this.pendingEmail ? true : false;
    }
  }, {
    key: "toJson",
    value: function toJson() {
      var json = {};
      mapUserToJson(this, json);
      return json;
    }
  }, {
    key: "canChangeLocation",
    get: function get() {
      return this.isVirtualSuperUser === true || this.activeOrganizations.length > 1;
    }
  }, {
    key: "hasSurveillanceProducts",
    get: function get() {
      return this.assignedVirtualProducts.filter(function (product) {
        return (0,ProductUtilities/* isSurveillanceProduct */.ZV)(product.id);
      });
    }
  }, {
    key: "hasSafetyProducts",
    get: function get() {
      return this.assignedVirtualProducts.filter(function (product) {
        return (0,ProductUtilities/* isSafetyProduct */.ih)(product.id);
      });
    }
  }, {
    key: "hasTools",
    get: function get() {
      return this.assignedVirtualProducts.filter(function (product) {
        return (0,ProductUtilities/* isTools */.gL)(product.id);
      });
    }
  }]);
}(BaseClass/* default */.A);

var mapJsonToUser = function mapJsonToUser(json, user) {
  user.id = json.Id;
  user.externalUserId = json.ExternalUserId;
  user.firstName = json.FirstName;
  user.lastName = json.LastName;
  user.email = json.Email;
  user.isActive = json.IsActive;
  user.organizationId = json.OrganizationId;
  user.organizationName = json.OrganizationName;
  user.virtualProfileId = json.VirtualProfileId;
  user.virtualProfileName = json.VirtualProfileName;
  user.isVirtualSuperUser = json.IsVirtualSuperUser;
  user.hasAccessToEntireIdn = json.HasAccessToEntireIdn;
  user.activeOrganizations = [];
  user.authType = json.AuthenticationType;
  user.pin = json.Pin;
  user.isEmailLoginEnabled = json.IsEmailLoginEnabled;
  if (json.AssignedOrganizations) {
    user.activeOrganizations = json.AssignedOrganizations.map(function (item) {
      return new Organization(item);
    }).sort(SortingUtilities/* sortByName */.VV);
  }
  if (json.AssignedVirtualProducts) {
    json.AssignedVirtualProducts.forEach(function (item) {
      user.assignedVirtualProducts.push(new Product(item));
    });

    // TODO temporary
    if (json.HasAccessToUserManagement) {
      var userManagementProduct = new Product({
        Id: ProductEnum/* default */.A.UserManagement.id,
        Name: ProductEnum/* default */.A.UserManagement.name
      });
      user.assignedVirtualProducts.push(userManagementProduct);
    }
  }
  if (json.Permissions) {
    json.Permissions.forEach(function (item) {
      user.permissions.push(new Permission(item));
    });
  }
  if (json.PendingEmail) {
    user.pendingEmail = new UnverifiedEmail(json.PendingEmail);
  }
  if (json.Tags) {
    user.tags = json.Tags.map(function (tagJson) {
      return new Tag(tagJson);
    });
  }
  if (json.ExternalIdentifiers) {
    user.externalIdentifiers = new ExternalIdentifiers/* default */.A(json.ExternalIdentifiers);
  }
};
var mapUserToJson = function mapUserToJson(user, json) {
  json.Id = user.id;
  json.ExternalUserId = user.externalUserId;
  json.FirstName = user.firstName;
  json.LastName = user.lastName;
  json.Email = user.email;
  json.IsActive = user.isActive;
  json.OrganizationId = user.organizationId;
  json.OrganizationName = user.organizationName;
  json.VirtualProfileId = user.virtualProfileId;
  json.VirtualProfileName = user.virtualProfileName;
  json.IsVirtualSuperUser = user.isVirtualSuperUser;
  if (user.pendingEmail) {
    json.PendingEmail = user.pendingEmail.toJson();
  }
  if (user.externalIdentifiers) {
    json.ExternalIdentifiers = user.externalIdentifiers.toJson();
  }
  json.AssignedOrganizations = user.activeOrganizations.map(function (o) {
    return o.id;
  });
  json.AssignedVirtualProducts = user.assignedVirtualProducts.map(function (p) {
    return p.id;
  });
  json.Permissions = user.permissions.map(function (p) {
    return p.id;
  });
  json.Pin = user.pin;
  json.Tags = user.tags.map(function (p) {
    return p.id;
  });
};
// EXTERNAL MODULE: ./src/components/TextInput.jsx
var TextInput = __webpack_require__(7642);
// EXTERNAL MODULE: ./src/utilities/EventUtilities.js
var EventUtilities = __webpack_require__(5609);
;// CONCATENATED MODULE: ./src/components/Profile/EditEmail.jsx
function EditEmail_typeof(o) { "@babel/helpers - typeof"; return EditEmail_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, EditEmail_typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function EditEmail_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function EditEmail_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, EditEmail_toPropertyKey(o.key), o); } }
function EditEmail_createClass(e, r, t) { return r && EditEmail_defineProperties(e.prototype, r), t && EditEmail_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function EditEmail_callSuper(t, o, e) { return o = EditEmail_getPrototypeOf(o), EditEmail_possibleConstructorReturn(t, EditEmail_isNativeReflectConstruct() ? Reflect.construct(o, e || [], EditEmail_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function EditEmail_possibleConstructorReturn(t, e) { if (e && ("object" == EditEmail_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return EditEmail_assertThisInitialized(t); }
function EditEmail_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function EditEmail_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (EditEmail_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function EditEmail_getPrototypeOf(t) { return EditEmail_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, EditEmail_getPrototypeOf(t); }
function EditEmail_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && EditEmail_setPrototypeOf(t, e); }
function EditEmail_setPrototypeOf(t, e) { return EditEmail_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, EditEmail_setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = EditEmail_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function EditEmail_toPropertyKey(t) { var i = EditEmail_toPrimitive(t, "string"); return "symbol" == EditEmail_typeof(i) ? i : i + ""; }
function EditEmail_toPrimitive(t, r) { if ("object" != EditEmail_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != EditEmail_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









var EditEmail = /*#__PURE__*/function (_PureComponent) {
  function EditEmail(props, context) {
    var _this;
    EditEmail_classCallCheck(this, EditEmail);
    _this = EditEmail_callSuper(this, EditEmail, [props, context]);
    _defineProperty(_this, "onChange", function (event) {
      var value = event.target.value;
      return _this.setState({
        newEmail: value
      });
    });
    _defineProperty(_this, "onBackClick", function () {
      _this.props.backToProfilePage();
    });
    _defineProperty(_this, "onSave", function () {
      var user = _this.state.user;
      var newEmail = _this.state.newEmail;
      if (user && newEmail !== undefined && _this.isValid(newEmail)) {
        Promise.resolve(_this.props.onVerifyUserEmail(user, newEmail, _this.context)).then(function () {
          _this.onBackClick();
        });
      } else if (newEmail === undefined) {
        _this.props.backToProfilePage();
      }
    });
    _defineProperty(_this, "onDiscardChanges", function () {
      var user = _this.state.user;
      _this.props.discardChanges(user);
    });
    _defineProperty(_this, "onResendVerificationEmail", function () {
      var user = _this.state.user;
      var unverifiedEmail = user.pendingEmail;
      _this.props.resendVerificationEmail(user, unverifiedEmail.email, _this.context);
    });
    _defineProperty(_this, "setFocusToEmail", function () {
      _this.emailRef.setFocus();
      _this.emailRef.select();
    });
    _defineProperty(_this, "onEmailKeyDown", function (event) {
      if ((0,EventUtilities/* isTabPressed */.Wz)(event) && (0,EventUtilities/* isShiftPressed */.Hk)(event)) {
        event.preventDefault();
        _this.buttonsRef.setFocus();
      }
    });
    var _newEmail = _this.props.newEmail;
    _this.state = {
      user: props.user,
      errors: {},
      newEmail: _newEmail ? _newEmail : undefined
    };
    return _this;
  }
  EditEmail_inherits(EditEmail, _PureComponent);
  return EditEmail_createClass(EditEmail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.emailRef) this.setFocusToEmail();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.user !== this.props.user) {
        var user = _extends(new User(), this.props.user);
        this.setState({
          user: user
        });
      }
    }
  }, {
    key: "isValid",
    value: function isValid(newEmail) {
      var errors = {};
      var validationResult = UserUtilities/* Validation */.OH.isEmailValid(newEmail);
      errors.Email = validationResult.error;
      this.setState({
        errors: errors
      });
      return validationResult.isValid;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var user = this.state.user;
      var hasUnverifiedEmail = user.hasUnverifiedEmail && user.pendingEmail.canBeDiscarded;
      var title = user ? user.firstName + " " + user.lastName : "";
      var email = this.state.newEmail !== undefined ? this.state.newEmail : user.email;
      if (!email) email = "";
      var onBackClick = function onBackClick() {
        return _this2.props.backToProfilePage();
      };
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "form-container"
      }, /*#__PURE__*/external_react_default().createElement(NavigationBar["default"], {
        onClick: onBackClick,
        titleText: title,
        hasRouter: false
      }), /*#__PURE__*/external_react_default().createElement("div", {
        className: "base-content"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "form form-vertical"
      }, !hasUnverifiedEmail ? /*#__PURE__*/external_react_default().createElement("fieldset", null, /*#__PURE__*/external_react_default().createElement(TextInput["default"], {
        ref: function ref(_ref) {
          return _this2.emailRef = _ref;
        },
        name: "email",
        label: "Email",
        value: email,
        autoFocus: true,
        tabIndex: 1,
        onChange: this.onChange,
        disabled: false,
        onKeyDown: this.onEmailKeyDown,
        error: this.state.errors.Email,
        placeholder: "Enter Email",
        maxlength: 60
      }), /*#__PURE__*/external_react_default().createElement("div", {
        name: "note"
      }, "Note - Editing a user's email changes how they log in, so a verification email will be sent before finalizing any changes.")) : /*#__PURE__*/external_react_default().createElement("fieldset", null, /*#__PURE__*/external_react_default().createElement(PendingEmail/* default */.A, {
        currentEmail: user.email,
        unverifiedEmail: user.pendingEmail.email,
        discardChanges: this.onDiscardChanges,
        resendVerificationEmail: this.onResendVerificationEmail
      })), /*#__PURE__*/external_react_default().createElement(ActionButtonsPanel["default"], {
        ref: function ref(_ref2) {
          return _this2.buttonsRef = _ref2;
        },
        hasExternalFocus: true,
        moveFocusBack: this.setFocusToEmail,
        onSave: hasUnverifiedEmail ? this.onBackClick : this.onSave,
        onCancel: this.onBackClick
      }))));
    }
  }]);
}(external_react_.PureComponent);

 false ? 0 : void 0;

/***/ }),

/***/ 6271:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ EditInfo)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _LastName__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3206);
/* harmony import */ var _utilities_UserUtilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9840);
/* harmony import */ var _NavigationBar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(144);
/* harmony import */ var _utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5609);
/* harmony import */ var _ActionButtonsPanel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1504);
/* harmony import */ var _TextInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7642);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









var EditInfo = /*#__PURE__*/function (_PureComponent) {
  function EditInfo(props, context) {
    var _this;
    _classCallCheck(this, EditInfo);
    _this = _callSuper(this, EditInfo, [props, context]);
    _defineProperty(_this, "onChange", function (event) {
      var field = event.target.name;
      var newState = {};
      newState[field] = event.target.value;
      _this.setState(newState);
    });
    _defineProperty(_this, "onSave", function () {
      if (_this.infoIsValid()) {
        var newUser = _this.props.user.createCopy();
        newUser.firstName = _this.state.firstName;
        newUser.lastName = _this.state.lastName;
        Promise.resolve(_this.props.updateCurrentUser(newUser, _this.context)).then(function () {
          _this.props.backToProfilePage();
        });
      }
    });
    _this.state = {
      firstName: props.user.firstName,
      lastName: props.user.lastName,
      errors: {}
    };
    _this.onCancelTab = _this.onCancelTab.bind(_this);
    _this.isAcceptableKey = _this.isAcceptableKey.bind(_this);
    _this.onFirstNamePressed = _this.onFirstNamePressed.bind(_this);
    return _this;
  }
  _inherits(EditInfo, _PureComponent);
  return _createClass(EditInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.firstNameRef) {
        this.firstNameRef.setFocus();
        this.firstNameRef.select();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.user != this.props.user) {
        var firstName = this.state.firstName;
        var lastName = this.state.lastName;
        this.setState({
          firstName: firstName,
          lastName: lastName
        });
      }
    }
  }, {
    key: "infoIsValid",
    value: function infoIsValid() {
      var errors = {};
      var formIsValid = true;
      var validationResult = _utilities_UserUtilities__WEBPACK_IMPORTED_MODULE_2__/* .Validation */ .OH.isNameValid(this.state.firstName);
      errors.FirstName = validationResult.error;
      formIsValid = formIsValid && validationResult.isValid;
      validationResult = _utilities_UserUtilities__WEBPACK_IMPORTED_MODULE_2__/* .Validation */ .OH.isNameValid(this.state.lastName);
      errors.LastName = validationResult.error;
      formIsValid = formIsValid && validationResult.isValid;
      this.setState({
        errors: errors
      });
      return formIsValid;
    }
  }, {
    key: "onFirstNamePressed",
    value: function onFirstNamePressed(event) {
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_3__/* .isTabPressed */ .Wz)(event) && (0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_3__/* .isShiftPressed */ .Hk)(event)) {
        event.preventDefault();
        this.buttonsRef.setFocus();
      }
    }
  }, {
    key: "isAcceptableKey",
    value: function isAcceptableKey(event) {
      if (!(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_3__/* .isLiteralKeyFromEvent */ .fZ)(event)) {
        event.preventDefault();
      }
    }
  }, {
    key: "onCancelTab",
    value: function onCancelTab() {
      this.firstNameRef.setFocus();
      this.firstNameRef.select();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var onBackClick = function onBackClick() {
        return _this2.props.backToProfilePage();
      };
      var title = this.state.firstName + " " + this.state.lastName;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "form-container"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_NavigationBar__WEBPACK_IMPORTED_MODULE_4__["default"], {
        onClick: onBackClick,
        titleText: title,
        hasRouter: false
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "base-content"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "form form-vertical"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("legend", null, "Profile"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "form form-vertical"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("fieldset", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_TextInput__WEBPACK_IMPORTED_MODULE_5__["default"], {
        ref: function ref(_ref) {
          return _this2.firstNameRef = _ref;
        },
        name: "firstName",
        label: "First Name",
        tabIndex: 1,
        value: this.state.firstName,
        autoFocus: true,
        onChange: this.onChange,
        error: this.state.errors.FirstName,
        disabled: false,
        onKeyDown: this.onFirstNamePressed,
        onKeyPress: this.isAcceptableKey,
        placeholder: "Enter First Name",
        maxlength: 30
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_LastName__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A, {
        tabIndex: 1,
        value: this.state.lastName,
        onChange: this.onChange,
        error: this.state.errors.LastName,
        onKeyPress: this.isAcceptableKey
      })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ActionButtonsPanel__WEBPACK_IMPORTED_MODULE_7__["default"], {
        hasExternalFocus: true,
        ref: function ref(_ref2) {
          return _this2.buttonsRef = _ref2;
        },
        onSave: this.onSave,
        onCancel: onBackClick,
        moveFocusBack: this.onCancelTab
      })))));
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);

 false ? 0 : void 0;

/***/ }),

/***/ 3206:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _TextInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7642);



var LastName = function LastName(_ref) {
  var value = _ref.value,
    error = _ref.error,
    onChange = _ref.onChange,
    onKeyPress = _ref.onKeyPress,
    disabled = _ref.disabled,
    tabIndex = _ref.tabIndex,
    autoFocus = _ref.autoFocus;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_TextInput__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "lastName",
    label: "Last Name",
    value: value,
    autoFocus: autoFocus,
    tabIndex: tabIndex,
    onChange: onChange,
    error: error,
    onKeyPress: onKeyPress,
    disabled: disabled,
    placeholder: "Enter Last Name",
    maxlength: 30
  });
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LastName);

/***/ }),

/***/ 1546:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ Profile_LocationList)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
;// CONCATENATED MODULE: ./src/components/Profile/LocationsConfiguration.js
var LocationsConfiguration = {
  entireHealthSystemMessage: "Entire Health System",
  noLocationsMessage: "NONE",
  userLocationsTableOptions: {
    defaultSortName: "name",
    defaultSortOrder: "asc"
  }
};
/* harmony default export */ const Profile_LocationsConfiguration = (LocationsConfiguration);
;// CONCATENATED MODULE: ./src/components/Profile/LocationList.jsx




var LocationList = function LocationList(_ref) {
  var hasAccessToEntireIdn = _ref.hasAccessToEntireIdn,
    userOrganizations = _ref.userOrganizations,
    className = _ref.className;
  function getLocationName(location) {
    return /*#__PURE__*/external_react_default().createElement("span", null, location.name, " - ", location.site);
  }
  function getLocationString() {
    if (!userOrganizations || userOrganizations.length === 0) return Profile_LocationsConfiguration.noLocationsMessage;
    if (hasAccessToEntireIdn) return Profile_LocationsConfiguration.entireHealthSystemMessage;
    if (userOrganizations.length == 1) return getLocationName(userOrganizations[0]);
    return userOrganizations.length + " Locations";
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: className
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "dark"
  }, getLocationString()));
};
 false ? 0 : void 0;
/* harmony default export */ const Profile_LocationList = (LocationList);

/***/ }),

/***/ 1664:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9305);



var PendingEmail = function PendingEmail(_ref) {
  var currentEmail = _ref.currentEmail,
    unverifiedEmail = _ref.unverifiedEmail,
    discardChanges = _ref.discardChanges,
    resendVerificationEmail = _ref.resendVerificationEmail;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", null, "Email"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    id: "modal-gray",
    className: "card"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", null, "Unverified Email Address"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    name: "note"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, "This users's email address has been changed, but is unverified. The user must verify their email address by clicking a secure link sent to them to confirm changes.")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    name: "currentEmail"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, "Previous Email: ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    name: "currentEmail"
  }, currentEmail))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    name: "pendingEmail"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, "New Email: ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    name: "unverifiedEmail"
  }, unverifiedEmail))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Button__WEBPACK_IMPORTED_MODULE_2__["default"], {
    id: "discard-button",
    className: "btn btn-info",
    title: "Discard this Change",
    onClick: discardChanges
  })), "\xA0", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Button__WEBPACK_IMPORTED_MODULE_2__["default"], {
    id: "resend-button",
    className: "btn btn-info",
    title: "Resend Verification Email",
    onClick: resendVerificationEmail
  }))))));
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PendingEmail);

/***/ }),

/***/ 2898:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ Profile_ProductsList)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./src/components/IconView/IconView.jsx
var IconView = __webpack_require__(7434);
// EXTERNAL MODULE: ./src/utilities/ProductUtilities.js
var ProductUtilities = __webpack_require__(2500);
;// CONCATENATED MODULE: ./src/components/Profile/ProductItem.jsx




var ProductItem = function ProductItem(_ref) {
  var productId = _ref.productId;
  var productConfiguration = (0,ProductUtilities/* getProductConfigurationById */.OI)(productId);
  return productConfiguration && /*#__PURE__*/external_react_default().createElement("li", null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "checkbox-icon icon-product " + productConfiguration.iconContainerClass
  }, /*#__PURE__*/external_react_default().createElement(IconView/* default */.A, {
    icon: productConfiguration.icon
  })), /*#__PURE__*/external_react_default().createElement("span", {
    className: "dark"
  }, productConfiguration.label));
};
 false ? 0 : void 0;
/* harmony default export */ const Profile_ProductItem = (ProductItem);
;// CONCATENATED MODULE: ./src/components/Profile/ProductsList.jsx



var ProductsList = function ProductsList(_ref) {
  var className = _ref.className,
    products = _ref.products;
  var noProducts = !products || products.length === 0;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: className
  }, !noProducts && /*#__PURE__*/external_react_default().createElement("ul", {
    className: "productsList"
  }, products.map(function (productId) {
    return /*#__PURE__*/external_react_default().createElement(Profile_ProductItem, {
      key: productId,
      productId: productId
    });
  })), noProducts && /*#__PURE__*/external_react_default().createElement("span", {
    className: "dark"
  }, "None"));
};
ProductsList.defaultProps = {
  products: []
};
 false ? 0 : void 0;
/* harmony default export */ const Profile_ProductsList = (ProductsList);

/***/ }),

/***/ 860:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export showParts */
var showParts = {
  details: 1,
  editName: 2,
  editEmail: 3,
  editExternalIds: 4
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (showParts);

/***/ }),

/***/ 6278:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ components_Profile)
});

// UNUSED EXPORTS: EditEmail, EditInfo, Email, FirstName, LastName, LocationList, PendingEmail, ProductsList, ShowParts

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./src/components/Profile/_styles.scss
var _styles = __webpack_require__(8004);
// EXTERNAL MODULE: ./src/components/Profile/EditEmail.jsx + 6 modules
var EditEmail = __webpack_require__(9124);
// EXTERNAL MODULE: ./src/components/Profile/EditInfo.jsx
var EditInfo = __webpack_require__(6271);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3368);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/constants/AuthenticationTypeEnum.js
var AuthenticationTypeEnum = __webpack_require__(4143);
;// CONCATENATED MODULE: ./src/components/Profile/DetailsPageConfiguration.js
var detailsPageNames = {
  Name: {
    id: "nameDetails",
    title: "User Information",
    iconClassName: "ion-ios-person",
    label: "Name"
  },
  Email: {
    id: "emailDetails",
    title: "User Information",
    iconClassName: "ion-ios-mail",
    label: "Email"
  },
  ExternalUserId: {
    id: "externalUserId",
    title: "User Information",
    iconClassName: "ion-ios-lock",
    label: "SSO Account"
  },
  AuthenticationPassword: {
    id: "authenticationPassword",
    title: "Authentication",
    iconClassName: "ion-ios-lock",
    label: "Authentication"
  },
  AuthenticationSso: {
    id: "authenticationSso",
    title: "Authentication",
    iconClassName: "ion-ios-lock",
    label: "Authentication"
  },
  Roles: {
    id: "roleDetails",
    title: "User Role",
    iconClassName: "ion-ios-flag",
    label: "Role"
  },
  Permission: {
    id: "permissionsDetails",
    title: "Tools",
    iconClassName: "ion-ios-pricetag",
    label: "Tools"
  },
  Products: {
    id: "productsDetails",
    title: "Clinical Products",
    iconClassName: "ion-ios-medkit",
    label: "Products"
  },
  Surveillance: {
    id: "surveillanceDetails",
    title: "Sentri7® Surveillance Products",
    iconClassName: "ion-ios-medkit",
    label: "Sentri7® Surveillance"
  },
  SafetyProduct: {
    id: "safetyDetails",
    title: "Simplifi+® Compliance Products",
    iconClassName: "ion-ios-medkit",
    label: "Simplifi+® Compliance"
  },
  Locations: {
    id: "locationsDetails",
    title: "Location Access",
    iconClassName: "ion-ios-navigate",
    label: "Locations"
  },
  Accounts: {
    id: "accounts",
    title: "Accounts",
    iconClassName: "accounts",
    label: "Accounts"
  },
  ExternalIds: {
    id: "externalIds",
    title: "External Identifiers",
    iconClassName: "externalIds",
    label: "External Ids"
  },
  getPageByName: function getPageByName(formPart) {
    switch (formPart.toLowerCase()) {
      case detailsPageNames.Name.id.toLowerCase():
        return detailsPageNames.Name;
      case detailsPageNames.Email.id.toLowerCase():
        return detailsPageNames.Email;
      case detailsPageNames.ExternalUserId.id.toLowerCase():
        return detailsPageNames.ExternalUserId;
      case detailsPageNames.AuthenticationPassword.id.toLowerCase():
        return detailsPageNames.AuthenticationPassword;
      case detailsPageNames.AuthenticationSso.id.toLowerCase():
        return detailsPageNames.AuthenticationSso;
      case detailsPageNames.Roles.id.toLowerCase():
        return detailsPageNames.Roles;
      case detailsPageNames.Permission.id.toLowerCase():
        return detailsPageNames.Permission;
      case detailsPageNames.Surveillance.id.toLowerCase():
        return detailsPageNames.Surveillance;
      case detailsPageNames.SafetyProduct.id.toLowerCase():
        return detailsPageNames.SafetyProduct;
      case detailsPageNames.Locations.id.toLowerCase():
        return detailsPageNames.Locations;
      case detailsPageNames.Accounts.id.toLowerCase():
        return detailsPageNames.Accounts;
      case detailsPageNames.ExternalIds.id.toLowerCase():
        return detailsPageNames.ExternalIds;
      default:
        return detailsPageNames.Name;
    }
  }
};
// EXTERNAL MODULE: ./src/entities/Icon.js
var Icon = __webpack_require__(8607);
;// CONCATENATED MODULE: ./src/constants/UserRolesEnum.js
var UserRolesEnum = {
  StandardUserProfileId: 1,
  HealthSystemAdminProfileId: 3,
  UserManagerProfileId: 4,
  SafetyAdminProfileId: 5,
  SurveillanceAdminProfileId: 6
};
/* harmony default export */ const constants_UserRolesEnum = (UserRolesEnum);
;// CONCATENATED MODULE: ./src/utilities/UserRolesUtilities.js


var UserRolesUtilities = {
  getUserRoleIconClass: function getUserRoleIconClass(roleId) {
    return UserRolesUtilities.getUserRoleIcon(roleId).name;
  },
  getUserRoleIcon: function getUserRoleIcon(roleId) {
    var icon = new Icon/* default */.A();
    switch (roleId) {
      case constants_UserRolesEnum.StandardUserProfileId:
        icon = new Icon/* default */.A("ion-md-person");
        break;
      case constants_UserRolesEnum.HealthSystemAdminProfileId:
        icon = new Icon/* default */.A("ion-md-globe");
        break;
      case constants_UserRolesEnum.UserManagerProfileId:
        icon = new Icon/* default */.A("ion-ios-people");
        break;
      case constants_UserRolesEnum.SafetyAdminProfileId:
        icon = new Icon/* default */.A("icon-syringe");
        break;
      case constants_UserRolesEnum.SurveillanceAdminProfileId:
        icon = new Icon/* default */.A("remove_red_eye", Icon/* IconTypes */.B.material);
        break;
    }
    return icon;
  },
  getOrder: function getOrder(roleId) {
    var order = 0;
    switch (roleId) {
      case constants_UserRolesEnum.StandardUserProfileId:
        order = 1;
        break;
      case constants_UserRolesEnum.HealthSystemAdminProfileId:
        order = 4;
        break;
      case constants_UserRolesEnum.UserManagerProfileId:
        order = 5;
        break;
      case constants_UserRolesEnum.SafetyAdminProfileId:
        order = 2;
        break;
      case constants_UserRolesEnum.SurveillanceAdminProfileId:
        order = 3;
        break;
    }
    return order;
  },
  filter: function filter(a, b) {
    var orderA = UserRolesUtilities.getOrder(a.id);
    var orderB = UserRolesUtilities.getOrder(b.id);
    return orderA - orderB;
  }
};
/* harmony default export */ const utilities_UserRolesUtilities = (UserRolesUtilities);
// EXTERNAL MODULE: ./src/components/NavigationBar.jsx
var NavigationBar = __webpack_require__(144);
// EXTERNAL MODULE: ./src/components/UnverifiedEmailControl.jsx + 1 modules
var UnverifiedEmailControl = __webpack_require__(9778);
// EXTERNAL MODULE: ./src/components/Row.jsx
var Row = __webpack_require__(8201);
;// CONCATENATED MODULE: ./src/components/Profile/AuthenticationCell.jsx




var AuthenticationCell = function AuthenticationCell(_ref) {
  var user = _ref.user,
    dataClassName = _ref.dataClassName;
  var authenticationType = (0,AuthenticationTypeEnum/* getAuthenticationTypeByValue */.Rl)(user.authType);
  var headerClassName = "authentication-title";
  var detailsClassName = "authentication-details";
  switch (authenticationType) {
    case AuthenticationTypeEnum/* default */.Ay.Sso:
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: dataClassName
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: headerClassName
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: "dark"
      }, authenticationType.text)), /*#__PURE__*/external_react_default().createElement("div", {
        className: detailsClassName
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: "maxTruncate"
      }, user.externalUserId || "ADD")));
    case AuthenticationTypeEnum/* default */.Ay.Password:
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: dataClassName
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: headerClassName
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: "dark"
      }, authenticationType.text)), /*#__PURE__*/external_react_default().createElement("div", {
        className: detailsClassName
      }, /*#__PURE__*/external_react_default().createElement("span", null, "PIN: ", user.pin)));
    case AuthenticationTypeEnum/* default */.Ay.User:
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: dataClassName
      }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("span", {
        className: "light"
      }, authenticationType.text)));
    default:
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: dataClassName
      }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("span", {
        className: "light"
      }, "None")));
  }
};
 false ? 0 : void 0;
/* harmony default export */ const Profile_AuthenticationCell = (AuthenticationCell);
// EXTERNAL MODULE: ./src/components/IconView/IconView.jsx
var IconView = __webpack_require__(7434);
// EXTERNAL MODULE: ./src/components/Profile/ProductsList.jsx + 1 modules
var ProductsList = __webpack_require__(2898);
// EXTERNAL MODULE: ./src/utilities/ProductUtilities.js
var ProductUtilities = __webpack_require__(2500);
// EXTERNAL MODULE: ./src/components/Profile/LocationList.jsx + 1 modules
var LocationList = __webpack_require__(1546);
;// CONCATENATED MODULE: ./src/components/Profile/Details.jsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }















var Details = /*#__PURE__*/function (_PureComponent) {
  function Details() {
    var _this;
    _classCallCheck(this, Details);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Details, [].concat(args));
    _defineProperty(_this, "onResendVerificationEmail", function () {
      if (!_this.props.waitForSend) {
        var user = _this.props.currentUser;
        _this.props.onVerifyUserEmail(user, user.pendingEmail.email);
      }
    });
    return _this;
  }
  _inherits(Details, _PureComponent);
  return _createClass(Details, [{
    key: "render",
    value: function render() {
      var user = this.props.currentUser;
      if (user == null) return null;
      var dataClassName = "col-xs-9 col-md-8 ValueColumn";
      var showHealthSystemRow = user.isVirtualSuperUser;
      var hasUnverifiedEmail = user.hasUnverifiedEmail;
      var emailRowClassName = classnames_default()(dataClassName, hasUnverifiedEmail ? "italic" : "");
      var email = (hasUnverifiedEmail ? user.pendingEmail.email + " (Unverified)" : user.email) || "ADD";
      var authenticationType = (0,AuthenticationTypeEnum/* getAuthenticationTypeByValue */.Rl)(user.authType);
      var authenticationPart = authenticationType === AuthenticationTypeEnum/* default */.Ay.Sso ? detailsPageNames.AuthenticationSso : detailsPageNames.AuthenticationPassword;
      var roleIcon = utilities_UserRolesUtilities.getUserRoleIcon(user.virtualProfileId);
      var productIds = user.assignedVirtualProducts.map(function (product) {
        return product.id;
      });
      return /*#__PURE__*/external_react_default().createElement("div", {
        id: "profileContainer"
      }, /*#__PURE__*/external_react_default().createElement(NavigationBar["default"], {
        backLink: this.props.currentUrl,
        titleText: getTitleText(user),
        hasRouter: this.props.hasRouter
      }), /*#__PURE__*/external_react_default().createElement(UnverifiedEmailControl["default"], {
        user: user,
        resendVerificationEmail: this.onResendVerificationEmail,
        sentRecently: this.props.sentRecently,
        waitForSend: this.props.waitForSend
      }), /*#__PURE__*/external_react_default().createElement("div", {
        className: "user-header"
      }, /*#__PURE__*/external_react_default().createElement("h4", null, "User Details")), /*#__PURE__*/external_react_default().createElement("div", {
        className: "base-content rowList detailsPage",
        id: "profile"
      }, /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: detailsPageNames.Name,
        onClick: this.props.onEditName,
        editable: true
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: dataClassName
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: "dark"
      }, user.firstName, " ", user.lastName))), showHealthSystemRow && getHealthSystemRow(dataClassName), /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: detailsPageNames.Email,
        onClick: this.props.onEditEmail,
        editable: true
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: emailRowClassName
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: hasUnverifiedEmail ? "light" : "dark"
      }, email))), /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: authenticationPart,
        editable: false
      }, /*#__PURE__*/external_react_default().createElement(Profile_AuthenticationCell, {
        user: user,
        dataClassName: dataClassName
      })), /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: detailsPageNames.Roles,
        editable: false
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: dataClassName
      }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement(IconView/* default */.A, {
        icon: roleIcon,
        className: "icon-roles"
      }), /*#__PURE__*/external_react_default().createElement("span", {
        className: "dark"
      }, user.virtualProfileName)))), /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: detailsPageNames.Surveillance,
        onClick: this.onEditRow,
        editable: false
      }, /*#__PURE__*/external_react_default().createElement(ProductsList/* default */.A, {
        products: productIds.filter(function (productId) {
          return (0,ProductUtilities/* isSurveillanceProduct */.ZV)(productId);
        }),
        className: dataClassName
      })), /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: detailsPageNames.SafetyProduct,
        onClick: this.onEditRow,
        editable: false
      }, /*#__PURE__*/external_react_default().createElement(ProductsList/* default */.A, {
        products: productIds.filter(function (productId) {
          return (0,ProductUtilities/* isSafetyProduct */.ih)(productId);
        }),
        className: dataClassName
      })), /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: detailsPageNames.Permission,
        onClick: this.onEditRow,
        editable: false
      }, /*#__PURE__*/external_react_default().createElement(ProductsList/* default */.A, {
        products: productIds.filter(function (productId) {
          return (0,ProductUtilities/* isTools */.gL)(productId);
        }),
        className: dataClassName
      })), /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: detailsPageNames.Locations,
        editable: false
      }, /*#__PURE__*/external_react_default().createElement(LocationList/* default */.A, {
        userOrganizations: user.activeOrganizations,
        hasAccessToEntireIdn: user.hasAccessToEntireIdn,
        className: dataClassName
      })), /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: detailsPageNames.ExternalIds,
        onClick: this.props.onEditExternalIds,
        editable: this.props.enableExternalIdsEditing
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: dataClassName
      }, "NPI, NABP e-Profile ID"))));
    }
  }]);
}(external_react_.PureComponent);
var getTitleText = function getTitleText(user) {
  return user.isActive ? /*#__PURE__*/external_react_default().createElement("span", {
    className: "truncate dark",
    name: "userTitle"
  }, user.firstName, " ", user.lastName) : /*#__PURE__*/external_react_default().createElement("div", {
    className: "truncate light"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "material-icons"
  }, "\uE888"), /*#__PURE__*/external_react_default().createElement("span", {
    name: "userTitle"
  }, "Inactive - ", user.firstName, " ", user.lastName));
};
var getHealthSystemRow = function getHealthSystemRow(dataClassName) {
  var rowDisabledClassName = "row row-link inactive";
  var labelClassName = "col-xs-2 col-md-3 NameColumn";
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: rowDisabledClassName,
    id: "hsDetails"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: labelClassName
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "light"
  }, "Health System")), /*#__PURE__*/external_react_default().createElement("div", {
    className: dataClassName
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "dark"
  }, "P1S")), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-1 col-md-1"
  }));
};
 false ? 0 : void 0;
/* harmony default export */ const Profile_Details = (Details);
// EXTERNAL MODULE: ./src/utilities/UserUtilities.js
var UserUtilities = __webpack_require__(9840);
// EXTERNAL MODULE: ./src/components/TextInput.jsx
var TextInput = __webpack_require__(7642);
// EXTERNAL MODULE: ./src/components/DateInput.jsx
var DateInput = __webpack_require__(1789);
// EXTERNAL MODULE: ./src/components/DropDown/index.js + 2 modules
var DropDown = __webpack_require__(3615);
// EXTERNAL MODULE: ./src/components/ActionButtonsPanel.js
var ActionButtonsPanel = __webpack_require__(1504);
// EXTERNAL MODULE: ./src/utilities/EventUtilities.js
var EventUtilities = __webpack_require__(5609);
// EXTERNAL MODULE: ./src/utilities/ValidationUtilities.js
var ValidationUtilities = __webpack_require__(4708);
// EXTERNAL MODULE: ./src/components/Accordion/index.js + 1 modules
var Accordion = __webpack_require__(2696);
// EXTERNAL MODULE: ./src/components/CheckBox/CheckBox.jsx
var CheckBox = __webpack_require__(9692);
;// CONCATENATED MODULE: ./src/components/Profile/ExternalIdentifiers.jsx
function ExternalIdentifiers_typeof(o) { "@babel/helpers - typeof"; return ExternalIdentifiers_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, ExternalIdentifiers_typeof(o); }
function ExternalIdentifiers_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function ExternalIdentifiers_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, ExternalIdentifiers_toPropertyKey(o.key), o); } }
function ExternalIdentifiers_createClass(e, r, t) { return r && ExternalIdentifiers_defineProperties(e.prototype, r), t && ExternalIdentifiers_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function ExternalIdentifiers_callSuper(t, o, e) { return o = ExternalIdentifiers_getPrototypeOf(o), ExternalIdentifiers_possibleConstructorReturn(t, ExternalIdentifiers_isNativeReflectConstruct() ? Reflect.construct(o, e || [], ExternalIdentifiers_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function ExternalIdentifiers_possibleConstructorReturn(t, e) { if (e && ("object" == ExternalIdentifiers_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return ExternalIdentifiers_assertThisInitialized(t); }
function ExternalIdentifiers_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function ExternalIdentifiers_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ExternalIdentifiers_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ExternalIdentifiers_getPrototypeOf(t) { return ExternalIdentifiers_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, ExternalIdentifiers_getPrototypeOf(t); }
function ExternalIdentifiers_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && ExternalIdentifiers_setPrototypeOf(t, e); }
function ExternalIdentifiers_setPrototypeOf(t, e) { return ExternalIdentifiers_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, ExternalIdentifiers_setPrototypeOf(t, e); }
function ExternalIdentifiers_defineProperty(e, r, t) { return (r = ExternalIdentifiers_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ExternalIdentifiers_toPropertyKey(t) { var i = ExternalIdentifiers_toPrimitive(t, "string"); return "symbol" == ExternalIdentifiers_typeof(i) ? i : i + ""; }
function ExternalIdentifiers_toPrimitive(t, r) { if ("object" != ExternalIdentifiers_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != ExternalIdentifiers_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }













var ExternalIdentifiers = /*#__PURE__*/function (_Component) {
  function ExternalIdentifiers(props, context) {
    var _this$props$externalI, _this$props$externalI2, _this$props$externalI3, _this$props$externalI4;
    var _this;
    ExternalIdentifiers_classCallCheck(this, ExternalIdentifiers);
    _this = ExternalIdentifiers_callSuper(this, ExternalIdentifiers, [props, context]);
    ExternalIdentifiers_defineProperty(_this, "getLabel", function (name, tooltip) {
      return /*#__PURE__*/external_react_default().createElement("div", null, name, /*#__PURE__*/external_react_default().createElement("span", {
        className: "tooltip-container"
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: "material-icons row-icon external-ids-info-icon",
        "data-name": "infoIcon"
      }, "info"), /*#__PURE__*/external_react_default().createElement("span", {
        className: "tooltip"
      }, tooltip)));
    });
    ExternalIdentifiers_defineProperty(_this, "onNumericInputKeyPress", function (event) {
      if (!(0,EventUtilities/* isNumberKeyFromEvent */.Db)(event)) {
        event.preventDefault();
      }
    });
    ExternalIdentifiers_defineProperty(_this, "onNpiChange", function (event) {
      if ((0,ValidationUtilities/* isDigitsOnly */.Db)(event.target.value)) {
        _this.props.onNpiChange(event);
      }
    });
    ExternalIdentifiers_defineProperty(_this, "onNabpEPidChange", function (event) {
      if ((0,ValidationUtilities/* isDigitsOnly */.Db)(event.target.value)) {
        _this.props.onNabpEPidChange(event);
      }
    });
    ExternalIdentifiers_defineProperty(_this, "setFocusOnNabpEPid", function () {
      _this.nabpEPidInput.setFocus();
      _this.nabpEPidInput.select();
    });
    ExternalIdentifiers_defineProperty(_this, "onCheckboxCheck", function () {
      var value = !_this.state.hasNoNabp;
      _this.setState({
        hasNoNabp: value
      });
      _this.setState({
        accordionExpanded: !value
      });
      _this.props.onHasNabpChange(value);
    });
    ExternalIdentifiers_defineProperty(_this, "accordionChange", function () {
      _this.setState({
        accordionExpanded: !_this.state.accordionExpanded
      });
    });
    ExternalIdentifiers_defineProperty(_this, "onBackKeyDown", function (event) {
      if ((0,EventUtilities/* isTabPressed */.Wz)(event) && (0,EventUtilities/* isShiftPressed */.Hk)(event)) {
        event.preventDefault();
        _this.buttonsRef.setFocus();
      }
    });
    _this.state = {
      hasNoNabp: (_this$props$externalI = (_this$props$externalI2 = _this.props.externalIds) === null || _this$props$externalI2 === void 0 ? void 0 : _this$props$externalI2.hasNoNabp) !== null && _this$props$externalI !== void 0 ? _this$props$externalI : false,
      accordionExpanded: (_this$props$externalI3 = (_this$props$externalI4 = _this.props.externalIds) === null || _this$props$externalI4 === void 0 ? void 0 : _this$props$externalI4.nabpEPid) !== null && _this$props$externalI3 !== void 0 ? _this$props$externalI3 : false
    };
    _this.onCancelTab = _this.onCancelTab.bind(_this);
    _this.setFocusOnNabpEPid = _this.setFocusOnNabpEPid.bind(_this);
    return _this;
  }
  ExternalIdentifiers_inherits(ExternalIdentifiers, _Component);
  return ExternalIdentifiers_createClass(ExternalIdentifiers, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.setFocusOnNabpEPid) {
        this.setFocusOnNabpEPid();
      } else if (this.npiRef) {
        this.npiRef.setFocus();
        this.npiRef.select();
      }
    }
  }, {
    key: "onCancelTab",
    value: function onCancelTab() {
      this.navBarRef.setFocus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$nabpRoles,
        _this2 = this,
        _this$props$externalI5,
        _this$props$externalI6,
        _this$props$externalI7;
      var npiLabel = this.getLabel("National Provider Identifier", "Enter a National Provider Identifier to use integrated intervention notes in Sentri7 Pharmacy");
      var nabpEPidLabel = this.getLabel("NABP e-Profile ID", "Enter an NABP e-Profile ID to use CE reporting features for Simplifi 797");
      var options = {
        date: true,
        datePattern: ["m", "d"]
      };
      var items = ((_this$props$nabpRoles = this.props.nabpRoles) === null || _this$props$nabpRoles === void 0 ? void 0 : _this$props$nabpRoles.map(function (x) {
        return {
          name: x.name,
          value: x.nabpRoleId
        };
      })) || [];
      var selected = items === null || items === void 0 ? void 0 : items.find(function (r) {
        var _this2$props$external;
        return r.value === ((_this2$props$external = _this2.props.externalIds) === null || _this2$props$external === void 0 ? void 0 : _this2$props$external.nabpRoleId);
      });
      var isAccordionExpanded = this.state.accordionExpanded;
      var isDateOfBirthDisabled = this.props.isNabpOptionsDisabled || this.props.disabled || this.state.hasNoNabp;
      var isNabpRoleDisabled = this.props.isNabpOptionsDisabled || this.props.disabled || this.state.hasNoNabp;
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "form-container"
      }, /*#__PURE__*/external_react_default().createElement(NavigationBar["default"], {
        onClick: this.props.onBackClick,
        titleText: this.props.title,
        hasRouter: false,
        backLinkTabIndex: 1,
        ref: function ref(_ref) {
          return _this2.navBarRef = _ref;
        },
        onKeyDown: this.onBackKeyDown
      }), /*#__PURE__*/external_react_default().createElement("div", {
        className: "base-content"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        id: "editExternalIds",
        className: "form form-vertical"
      }, /*#__PURE__*/external_react_default().createElement("fieldset", null, /*#__PURE__*/external_react_default().createElement("div", {
        className: "row"
      }, /*#__PURE__*/external_react_default().createElement(TextInput["default"], {
        ref: function ref(_ref2) {
          return _this2.npiRef = _ref2;
        },
        name: "nationalProviderIdentifier",
        label: npiLabel,
        tabIndex: 1,
        value: ((_this$props$externalI5 = this.props.externalIds) === null || _this$props$externalI5 === void 0 ? void 0 : _this$props$externalI5.nationalProviderIdentifier) || "",
        onChange: this.onNpiChange,
        error: this.props.npiError,
        disabled: this.props.disabled,
        placeholder: "(Optional)",
        maxlength: 10,
        className: "col-md-6",
        onKeyPress: this.onNumericInputKeyPress
      })), /*#__PURE__*/external_react_default().createElement(Accordion["default"], {
        id: "nabpEPidAccordion",
        header: "Enter NABP e-Profile ID",
        tabIndex: 1,
        "aria-controls": "nabpEPidAccordion",
        expanded: isAccordionExpanded,
        onChange: this.accordionChange
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "container"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "row"
      }, /*#__PURE__*/external_react_default().createElement(TextInput["default"], {
        name: "nabpEPid",
        label: nabpEPidLabel,
        tabIndex: 1,
        value: ((_this$props$externalI6 = this.props.externalIds) === null || _this$props$externalI6 === void 0 ? void 0 : _this$props$externalI6.nabpEPid) || "",
        onChange: this.onNabpEPidChange,
        error: this.props.nabpEPidError,
        disabled: this.props.disabled || this.state.hasNoNabp,
        placeholder: "(Optional)",
        maxlength: 10,
        className: "col-md-12",
        onKeyPress: this.onNumericInputKeyPress,
        ref: function ref(input) {
          return _this2.nabpEPidInput = input;
        }
      })), /*#__PURE__*/external_react_default().createElement("div", {
        className: "row"
      }, /*#__PURE__*/external_react_default().createElement(DateInput["default"], {
        name: "dateOfBirth",
        value: ((_this$props$externalI7 = this.props.externalIds) === null || _this$props$externalI7 === void 0 ? void 0 : _this$props$externalI7.dateOfBirth) || "",
        label: "Date Of Birth (Month and Day)",
        placeholder: "MM/DD",
        className: "form-group col-md-12 nabp-date-of-birth",
        tabIndex: 1,
        options: options,
        onChange: this.props.onDateOfBirthChange,
        error: this.props.dateOfBirthError,
        disabled: isDateOfBirthDisabled,
        inputClassName: this.props.dateOfBirthClassName
      })), /*#__PURE__*/external_react_default().createElement("div", {
        className: "row"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "form-group col-md-12"
      }, /*#__PURE__*/external_react_default().createElement(DropDown["default"], {
        id: "nabpRole",
        items: items,
        label: "NABP Role",
        selectedItem: selected,
        dataFieldName: "name",
        name: "nabpRole",
        onSelect: this.props.onNabpRoleChanged,
        error: this.props.nabpRoleError,
        tabIndex: isNabpRoleDisabled ? -1 : 1,
        isDisabled: isNabpRoleDisabled
      }))))), /*#__PURE__*/external_react_default().createElement(CheckBox/* default */.A, {
        name: "dontHaveNabp",
        label: "I don't have an NABP e-Profile ID",
        checked: this.state.hasNoNabp,
        value: this.state.hasNoNabp,
        tabIndex: 1,
        onChange: this.onCheckboxCheck,
        className: "has-no-nabp"
      })), /*#__PURE__*/external_react_default().createElement(ActionButtonsPanel["default"], {
        hasExternalFocus: true,
        ref: function ref(_ref3) {
          return _this2.buttonsRef = _ref3;
        },
        onSave: this.props.onSave,
        onCancel: this.props.onCancel,
        isDisabled: this.props.isSaveButtonDisabled,
        moveFocusBack: this.onCancelTab
      }))));
    }
  }]);
}(external_react_.Component);
 false ? 0 : void 0;
/* harmony default export */ const Profile_ExternalIdentifiers = (ExternalIdentifiers);
// EXTERNAL MODULE: ./src/entities/ExternalIdentifiers.js
var entities_ExternalIdentifiers = __webpack_require__(3465);
;// CONCATENATED MODULE: ./src/constants/ExternalIdsErrors.js
var externalIdsErrors = {
  NationalProviderIdentifier: "NPI must be unique within the IDN.",
  NabpEPid: "NABP e-Profile ID must be unique within the IDN."
};
var fieldTypes = {
  nationalProviderIdentifier: "NationalProviderIdentifier",
  nabpEPid: "NabpEPid"
};
;// CONCATENATED MODULE: ./src/components/Profile/EditExternalIds.jsx
function EditExternalIds_typeof(o) { "@babel/helpers - typeof"; return EditExternalIds_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, EditExternalIds_typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == EditExternalIds_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(EditExternalIds_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function EditExternalIds_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function EditExternalIds_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, EditExternalIds_toPropertyKey(o.key), o); } }
function EditExternalIds_createClass(e, r, t) { return r && EditExternalIds_defineProperties(e.prototype, r), t && EditExternalIds_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function EditExternalIds_callSuper(t, o, e) { return o = EditExternalIds_getPrototypeOf(o), EditExternalIds_possibleConstructorReturn(t, EditExternalIds_isNativeReflectConstruct() ? Reflect.construct(o, e || [], EditExternalIds_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function EditExternalIds_possibleConstructorReturn(t, e) { if (e && ("object" == EditExternalIds_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return EditExternalIds_assertThisInitialized(t); }
function EditExternalIds_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function EditExternalIds_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (EditExternalIds_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function EditExternalIds_getPrototypeOf(t) { return EditExternalIds_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, EditExternalIds_getPrototypeOf(t); }
function EditExternalIds_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && EditExternalIds_setPrototypeOf(t, e); }
function EditExternalIds_setPrototypeOf(t, e) { return EditExternalIds_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, EditExternalIds_setPrototypeOf(t, e); }
function EditExternalIds_defineProperty(e, r, t) { return (r = EditExternalIds_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function EditExternalIds_toPropertyKey(t) { var i = EditExternalIds_toPrimitive(t, "string"); return "symbol" == EditExternalIds_typeof(i) ? i : i + ""; }
function EditExternalIds_toPrimitive(t, r) { if ("object" != EditExternalIds_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != EditExternalIds_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






var EditExternalIds = /*#__PURE__*/function (_Component) {
  function EditExternalIds(props, context) {
    var _props$user$externalI, _props$user$externalI2;
    var _this;
    EditExternalIds_classCallCheck(this, EditExternalIds);
    _this = EditExternalIds_callSuper(this, EditExternalIds, [props, context]);
    EditExternalIds_defineProperty(_this, "onNabpRoleChanged", function (item) {
      _this.resetForm();
      var externalIds = _this.state.externalIds;
      if (!externalIds) externalIds = new entities_ExternalIdentifiers/* default */.A();
      externalIds.nabpRoleId = item.value;
      _this.setState({
        externalIds: externalIds
      });
    });
    EditExternalIds_defineProperty(_this, "onSave", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var user, externalIds, duplicatedFields;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            user = _this.state.user;
            externalIds = _this.state.externalIds;
            if (!(externalIds && _this.isValid(externalIds))) {
              _context.next = 16;
              break;
            }
            _context.next = 5;
            return _this.props.checkExternalIdsUniqueness(user, externalIds);
          case 5:
            duplicatedFields = _context.sent;
            if (!(!duplicatedFields || duplicatedFields.length === 0)) {
              _context.next = 13;
              break;
            }
            _this.removeValuesIfNoNabp(externalIds);
            _context.next = 10;
            return _this.props.updateUserExternalIds(user, externalIds);
          case 10:
            _this.props.backToProfilePage();
            _context.next = 14;
            break;
          case 13:
            _this.setState({
              duplicatedFields: duplicatedFields
            });
          case 14:
            _context.next = 21;
            break;
          case 16:
            if (!_this.isValid(externalIds)) {
              _context.next = 21;
              break;
            }
            _this.removeValuesIfNoNabp(externalIds);
            _context.next = 20;
            return _this.props.updateUserExternalIds(user, externalIds);
          case 20:
            _this.props.backToProfilePage();
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    EditExternalIds_defineProperty(_this, "onChange", function (event) {
      _this.resetForm();
      var field = event.target.name;
      var externalIds = _this.state.externalIds;
      if (!externalIds) externalIds = new entities_ExternalIdentifiers/* default */.A();
      externalIds[field] = event.target.value;
      _this.setState({
        externalIds: externalIds
      });
    });
    EditExternalIds_defineProperty(_this, "onNabpEPidChange", function (event) {
      _this.resetForm();
      var value = event.target.value;
      var externalIds = _this.state.externalIds;
      if (!externalIds) externalIds = new entities_ExternalIdentifiers/* default */.A();
      if (!value) {
        externalIds.nabpRoleId = undefined;
        externalIds.dateOfBirth = "";
      }
      externalIds.nabpEPid = value;
      _this.setState({
        isNabpOptionsDisabled: !value
      });
      _this.setState({
        externalIds: externalIds
      });
    });
    EditExternalIds_defineProperty(_this, "onHasNoNabpChange", function (hasNoNabp) {
      _this.resetForm();
      var externalIds = _this.state.externalIds;
      if (!externalIds) {
        externalIds = new entities_ExternalIdentifiers/* default */.A();
      }
      externalIds.hasNoNabp = hasNoNabp;
      _this.setState({
        externalIds: externalIds
      });
    });
    EditExternalIds_defineProperty(_this, "removeValuesIfNoNabp", function (externalIds) {
      if (externalIds.hasNoNabp) {
        externalIds.nabpRoleId = undefined;
        externalIds.dateOfBirth = "";
        externalIds.nabpEPid = "";
      }
      return externalIds;
    });
    EditExternalIds_defineProperty(_this, "isValid", function (externalIds) {
      var errors = {};
      var formIsValid = true;
      if (!externalIds) return formIsValid;
      var validations = [{
        target: "NationalProviderIdentifier",
        validator: UserUtilities/* Validation */.OH.validateNationalProviderIdentifier(externalIds.nationalProviderIdentifier)
      }, {
        target: "NabpEPid",
        validator: UserUtilities/* Validation */.OH.validateNabp(externalIds.nabpEPid)
      }, {
        target: "DateOfBirth",
        validator: UserUtilities/* Validation */.OH.validateNabpBirthDate(externalIds.dateOfBirth, externalIds.nabpEPid)
      }, {
        target: "NabpRoleId",
        validator: UserUtilities/* Validation */.OH.validateNabpRole(externalIds.nabpRoleId, externalIds.nabpEPid)
      }];
      validations.filter(function (el) {
        return !el.validator.isValid;
      }).forEach(function (_ref2) {
        var target = _ref2.target,
          validator = _ref2.validator;
        errors[target] = validator.error;
      });
      formIsValid = !validations.some(function (el) {
        return !el.validator.isValid;
      });
      _this.setState({
        formIsValid: formIsValid
      });
      _this.setState({
        errors: errors
      });
      return formIsValid;
    });
    EditExternalIds_defineProperty(_this, "getExternalIdsError", function (field) {
      if (_this.hasError()) {
        var foundField = _this.state.duplicatedFields.find(function (x) {
          return x === field;
        });
        if (!foundField) return "";
        return externalIdsErrors[foundField];
      }
    });
    EditExternalIds_defineProperty(_this, "hasError", function () {
      return _this.state.duplicatedFields && _this.state.duplicatedFields.length > 0;
    });
    EditExternalIds_defineProperty(_this, "resetForm", function () {
      if (_this.hasError()) _this.resetExternalIdsValidation();
      _this.setState({
        formIsValid: true
      });
    });
    EditExternalIds_defineProperty(_this, "resetExternalIdsValidation", function () {
      _this.setState({
        duplicatedFields: null
      });
    });
    _this.state = {
      errors: {},
      user: props.user.createCopy(),
      isLoading: false,
      isNabpOptionsDisabled: !((_props$user$externalI = props.user.externalIdentifiers) !== null && _props$user$externalI !== void 0 && _props$user$externalI.nabpEPid),
      formIsValid: true,
      externalIds: (_props$user$externalI2 = props.user.externalIdentifiers) === null || _props$user$externalI2 === void 0 ? void 0 : _props$user$externalI2.createCopy(),
      duplicatedFields: null
    };
    _this.onSave = _this.onSave.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.onNabpRoleChanged = _this.onNabpRoleChanged.bind(_this);
    _this.onNabpEPidChange = _this.onNabpEPidChange.bind(_this);
    return _this;
  }
  EditExternalIds_inherits(EditExternalIds, _Component);
  return EditExternalIds_createClass(EditExternalIds, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getNabpRoles();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state$errors$Na,
        _this$state$errors$Na2,
        _this2 = this;
      var user = this.state.user;
      if (!user) return null;
      var dateOfBirthClassName = "form-control";
      dateOfBirthClassName += this.state.isNabpOptionsDisabled ? " disabled" : "";
      var npiError = (_this$state$errors$Na = this.state.errors.NationalProviderIdentifier) !== null && _this$state$errors$Na !== void 0 ? _this$state$errors$Na : this.getExternalIdsError(fieldTypes.nationalProviderIdentifier);
      var nabpEPidError = (_this$state$errors$Na2 = this.state.errors.NabpEPid) !== null && _this$state$errors$Na2 !== void 0 ? _this$state$errors$Na2 : this.getExternalIdsError(fieldTypes.nabpEPid);
      var isValid = this.state.formIsValid && !this.hasError();
      var onBackClick = function onBackClick() {
        return _this2.props.backToProfilePage();
      };
      var title = user.firstName + " " + user.lastName;
      return /*#__PURE__*/external_react_default().createElement(Profile_ExternalIdentifiers, {
        onSave: this.onSave,
        onCancel: onBackClick,
        isSaveButtonDisabled: !isValid,
        onNpiChange: this.onChange,
        npiError: npiError,
        nabpEPidError: nabpEPidError,
        dateOfBirthError: this.state.errors.DateOfBirth,
        nabpRoleError: this.state.errors.NabpRoleId,
        onNabpEPidChange: this.onNabpEPidChange,
        onDateOfBirthChange: this.onChange,
        onNabpRoleChanged: this.onNabpRoleChanged,
        isNabpOptionsDisabled: this.state.isNabpOptionsDisabled,
        disabled: this.state.isLoading,
        dateOfBirthClassName: dateOfBirthClassName,
        nabpRoles: this.props.nabpRoles,
        externalIds: this.state.externalIds,
        title: title,
        onBackClick: onBackClick,
        setFocusOnNabpEPid: this.props.setFocusOnNabpEPid,
        onHasNabpChange: this.onHasNoNabpChange
      });
    }
  }]);
}(external_react_.Component);

 false ? 0 : void 0;
// EXTERNAL MODULE: ./src/components/Profile/ProfileParts.js
var ProfileParts = __webpack_require__(860);
;// CONCATENATED MODULE: ./src/components/Profile/Profile.jsx
function Profile_typeof(o) { "@babel/helpers - typeof"; return Profile_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Profile_typeof(o); }
function Profile_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Profile_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Profile_toPropertyKey(o.key), o); } }
function Profile_createClass(e, r, t) { return r && Profile_defineProperties(e.prototype, r), t && Profile_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Profile_callSuper(t, o, e) { return o = Profile_getPrototypeOf(o), Profile_possibleConstructorReturn(t, Profile_isNativeReflectConstruct() ? Reflect.construct(o, e || [], Profile_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function Profile_possibleConstructorReturn(t, e) { if (e && ("object" == Profile_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return Profile_assertThisInitialized(t); }
function Profile_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function Profile_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Profile_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function Profile_getPrototypeOf(t) { return Profile_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, Profile_getPrototypeOf(t); }
function Profile_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && Profile_setPrototypeOf(t, e); }
function Profile_setPrototypeOf(t, e) { return Profile_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, Profile_setPrototypeOf(t, e); }
function Profile_defineProperty(e, r, t) { return (r = Profile_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Profile_toPropertyKey(t) { var i = Profile_toPrimitive(t, "string"); return "symbol" == Profile_typeof(i) ? i : i + ""; }
function Profile_toPrimitive(t, r) { if ("object" != Profile_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Profile_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }










var Profile = /*#__PURE__*/function (_Component) {
  function Profile(props, context) {
    var _this;
    Profile_classCallCheck(this, Profile);
    _this = Profile_callSuper(this, Profile, [props, context]);
    Profile_defineProperty(_this, "onEditName", function () {
      _this.setState({
        view: ProfileParts/* default */.A.editName
      });
    });
    Profile_defineProperty(_this, "onEditEmail", function () {
      _this.setState({
        view: ProfileParts/* default */.A.editEmail
      });
    });
    Profile_defineProperty(_this, "onEditExternalIds", function () {
      _this.setState({
        view: ProfileParts/* default */.A.editExternalIds
      });
    });
    Profile_defineProperty(_this, "backToDetails", function () {
      _this.setState({
        view: ProfileParts/* default */.A.details
      });
    });
    _this.state = {
      view: _this.props.showPart || ProfileParts/* default */.A.details
    };
    return _this;
  }
  Profile_inherits(Profile, _Component);
  return Profile_createClass(Profile, [{
    key: "render",
    value: function render() {
      var user = this.props.currentUser;
      var setFocusOnNabpEPid = this.props.showPart === ProfileParts/* default */.A.editExternalIds;
      if (user == null) return null;
      if (this.state.view === ProfileParts/* default */.A.editName) return /*#__PURE__*/external_react_default().createElement(EditInfo/* default */.A, {
        user: user,
        updateCurrentUser: this.props.onUserSave,
        backToProfilePage: this.backToDetails
      });
      if (this.state.view === ProfileParts/* default */.A.editEmail) return /*#__PURE__*/external_react_default().createElement(EditEmail/* default */.A, {
        user: user,
        backToProfilePage: this.backToDetails,
        discardChanges: this.props.discardEmailChanges,
        onVerifyUserEmail: this.props.verifyUserEmailAction,
        resendVerificationEmail: this.props.resendVerificationEmail
      });
      if (this.state.view === ProfileParts/* default */.A.editExternalIds) return /*#__PURE__*/external_react_default().createElement(EditExternalIds, {
        user: user,
        backToProfilePage: this.backToDetails,
        checkExternalIdsUniqueness: this.props.checkExternalIdsUniqueness,
        updateUserExternalIds: this.props.updateExternalIds,
        getNabpRoles: this.props.getNabpRoles,
        nabpRoles: this.props.nabpRoles,
        setFocusOnNabpEPid: setFocusOnNabpEPid
      });
      return /*#__PURE__*/external_react_default().createElement(Profile_Details, {
        currentUser: user,
        hasRouter: this.props.hasRouter,
        onEditEmail: this.onEditEmail,
        waitForSend: this.props.waitForSend,
        sentRecently: this.props.sentRecently,
        onEditName: this.onEditName,
        onEditExternalIds: this.onEditExternalIds,
        onVerifyUserEmail: this.props.verifyUserEmailAction,
        currentUrl: this.props.currentUrl,
        enableExternalIdsEditing: this.props.enableExternalIdsEditing
      });
    }
  }]);
}(external_react_.Component);

Profile.defaultProps = {
  enableExternalIdsEditing: false
};
 false ? 0 : void 0;
;// CONCATENATED MODULE: ./src/components/Profile/index.js










/* harmony default export */ const components_Profile = (Profile);

/***/ }),

/***/ 7321:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ components_RadioButton)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./src/components/IconView/IconView.jsx
var IconView = __webpack_require__(7434);
// EXTERNAL MODULE: ./src/components/RadioButton/_styles.scss
var _styles = __webpack_require__(1210);
;// CONCATENATED MODULE: ./src/components/RadioButton/RadioButton.jsx




var RadioButton = function RadioButton(_ref) {
  var name = _ref.name,
    label = _ref.label,
    description = _ref.description,
    groupName = _ref.groupName,
    onChange = _ref.onChange,
    checked = _ref.checked,
    disabled = _ref.disabled,
    className = _ref.className,
    iconClassName = _ref.iconClassName,
    materialIcon = _ref.materialIcon,
    labelClassName = _ref.labelClassName,
    additionalContent = _ref.additionalContent,
    icon = _ref.icon;
  var onClick = disabled ? function () {} : onChange;
  var getIcon = function getIcon() {
    if (icon) return /*#__PURE__*/external_react_default().createElement(IconView/* default */.A, {
      icon: icon,
      className: iconClassName
    });
    return /*#__PURE__*/external_react_default().createElement("span", {
      className: iconClassName
    }, materialIcon);
  };
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: className,
    name: name
  }, /*#__PURE__*/external_react_default().createElement("div", {
    onClick: onClick,
    className: "radioButton",
    "data-checked": checked
  }, /*#__PURE__*/external_react_default().createElement("input", {
    type: "radio",
    name: groupName,
    checked: checked,
    onChange: onClick,
    disabled: disabled
  }), /*#__PURE__*/external_react_default().createElement("i", null)), /*#__PURE__*/external_react_default().createElement("div", {
    onClick: onClick,
    className: "icon-class"
  }, getIcon()), /*#__PURE__*/external_react_default().createElement("div", {
    name: name + "Description"
  }, /*#__PURE__*/external_react_default().createElement("label", {
    className: labelClassName,
    onClick: onClick
  }, label), /*#__PURE__*/external_react_default().createElement("div", {
    className: "radioButtonDescription"
  }, description), additionalContent));
};
RadioButton.defaultProps = {
  label: "",
  checked: false,
  disabled: false,
  onChange: function onChange() {}
};
 false ? 0 : void 0;
/* harmony default export */ const RadioButton_RadioButton = (RadioButton);
;// CONCATENATED MODULE: ./src/components/RadioButton/index.js

/* harmony default export */ const components_RadioButton = (RadioButton_RadioButton);

/***/ }),

/***/ 1867:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ ReactToastr)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3368);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/dom-helpers/events/on.js
var on = __webpack_require__(8774);
var on_default = /*#__PURE__*/__webpack_require__.n(on);
// EXTERNAL MODULE: ./node_modules/dom-helpers/transition/properties.js
var properties = __webpack_require__(3152);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
;// CONCATENATED MODULE: ./src/components/ReactToastr/ToastMessage.jsx
var _excluded = ["className", "type", "iconClassNames", "iconClassName", "closeButton", "onCloseClick", "title", "titleClassName", "message", "messageClassName"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
// @flow




/**
 * Base component for displaying a toast message.
 */

var defaultIconClassNames = {
  error: "toast-error",
  info: "toast-info",
  success: "toast-success",
  warning: "toast-warning"
};
var ToastMessage = function ToastMessage(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "toast" : _ref$className,
    type = _ref.type,
    _ref$iconClassNames = _ref.iconClassNames,
    iconClassNames = _ref$iconClassNames === void 0 ? defaultIconClassNames : _ref$iconClassNames,
    _ref$iconClassName = _ref.iconClassName,
    iconClassName = _ref$iconClassName === void 0 ? iconClassNames[type] : _ref$iconClassName,
    _ref$closeButton = _ref.closeButton,
    closeButton = _ref$closeButton === void 0 ? true : _ref$closeButton,
    _ref$onCloseClick = _ref.onCloseClick,
    onCloseClick = _ref$onCloseClick === void 0 ? function () {} : _ref$onCloseClick,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? false : _ref$title,
    _ref$titleClassName = _ref.titleClassName,
    titleClassName = _ref$titleClassName === void 0 ? "toast-title" : _ref$titleClassName,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? false : _ref$message,
    _ref$messageClassName = _ref.messageClassName,
    messageClassName = _ref$messageClassName === void 0 ? "toast-message" : _ref$messageClassName,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/external_react_default().createElement("div", _extends({}, restProps, {
    className: classnames_default()(className, iconClassName)
  }), !!closeButton && /*#__PURE__*/external_react_default().createElement("button", {
    className: "toast-close-button",
    onClick: onCloseClick,
    dangerouslySetInnerHTML: {
      __html: "&times;"
    }
  }), !!title && /*#__PURE__*/external_react_default().createElement("div", {
    className: titleClassName
  }, title), !!message && /*#__PURE__*/external_react_default().createElement("div", {
    className: messageClassName
  }, message));
};
 false ? 0 : void 0;
/* harmony default export */ const ReactToastr_ToastMessage = ((/* unused pure expression or super */ null && (ToastMessage)));
;// CONCATENATED MODULE: ./src/components/ReactToastr/ToastMessageAnimated.jsx
var ToastMessageAnimated_excluded = ["onRemove", "showAnimation", "hideAnimation", "timeOut", "extendedTimeOut", "tapToDismiss"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ToastMessageAnimated_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = ToastMessageAnimated_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function ToastMessageAnimated_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @flow







/**
 * A decorated component that leverages animate.css for toast showing/hiding.
 *
 * @see https://daneden.github.io/animate.css/
 */
var ToastMessageAnimated = /*#__PURE__*/function (_React$PureComponent) {
  function ToastMessageAnimated() {
    var _this;
    _classCallCheck(this, ToastMessageAnimated);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ToastMessageAnimated, [].concat(args));
    _defineProperty(_this, "state", {
      hidingTimoutId: undefined,
      className: undefined
    });
    _defineProperty(_this, "handleMount", function (ref) {
      _this.message = ref;
    });
    _defineProperty(_this, "handleMouseEnter", function () {
      _this.setState(function (state) {
        if (state.hidingTimoutId) {
          clearTimeout(state.hidingTimoutId);
        }
        return {
          hidingTimoutId: undefined,
          className: undefined
        };
      });
    });
    _defineProperty(_this, "handleMouseLeave", function () {
      _this.setState(function (state) {
        var timeOut = _this.props.extendedTimeOut !== 0 ? _this.props.extendedTimeOut : _this.props.timeOut;
        if (state.hidingTimoutId == null && timeOut !== 0) {
          return {
            hidingTimoutId: setTimeout(_this.handleHide, timeOut)
          };
        }
        return {};
      });
    });
    _defineProperty(_this, "handleTransitionEnd", function () {
      _this.setState(function () {
        return {
          className: undefined
        };
      });
    });
    _defineProperty(_this, "handleHideHookOnEnd", function () {
      on_default()(_this.message, properties/* animationEnd */.My, _this.handleRemove, _this.handleTransitionEnd);
    });
    _defineProperty(_this, "handleHide", function () {
      var override = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      _this.setState(function (state) {
        if (override || state.hidingTimoutId) {
          if (!_this.props.hideAnimation) {
            return {
              hidingTimoutId: setTimeout(_this.handleHideHookOnEnd, 50),
              className: _this.props.hideAnimation
            };
          } else {
            _this.handleRemove();
            return {
              hidingTimoutId: undefined,
              className: undefined
            };
          }
        }
      });
    });
    _defineProperty(_this, "handleRemove", function () {
      _this.props.onRemove();
    });
    _defineProperty(_this, "handleOnClick", function (event) {
      _this.props.onClick(event);
      if (_this.props.tapToDismiss) {
        _this.handleHide(true);
      }
    });
    _defineProperty(_this, "handleOnCloseClick", function (event) {
      event.stopPropagation();
      _this.props.onCloseClick(event);
      _this.handleHide(true);
    });
    return _this;
  }
  _inherits(ToastMessageAnimated, _React$PureComponent);
  return _createClass(ToastMessageAnimated, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.props.showAnimation) {
        this.setState(function () {
          on_default()(_this2.message, properties/* animationEnd */.My, _this2.handleTransitionEnd);
          return {
            className: _this2.props.showAnimation
          };
        });
      }
      if (this.props.timeOut > 0) {
        this.setState(function () {
          return {
            hidingTimoutId: setTimeout(_this2.handleHide, _this2.props.timeOut)
          };
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.hidingTimoutId) {
        clearTimeout(this.state.hidingTimoutId);
      }
      this.setState = function () {};
    }
  }, {
    key: "render",
    value: function render() {
      // <div> in ToastMessage will complain a lot in console if we will pass unused non-standard props.
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props,
        onRemove = _this$props.onRemove,
        showAnimation = _this$props.showAnimation,
        hideAnimation = _this$props.hideAnimation,
        timeOut = _this$props.timeOut,
        extendedTimeOut = _this$props.extendedTimeOut,
        tapToDismiss = _this$props.tapToDismiss,
        toastMessageProps = ToastMessageAnimated_objectWithoutProperties(_this$props, ToastMessageAnimated_excluded);
      return ToastMessage(_objectSpread(_objectSpread({}, toastMessageProps), {}, {
        ref: this.handleMount,
        className: classnames_default()(this.props.className, this.state.className),
        onClick: this.handleOnClick,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onCloseClick: this.handleOnCloseClick
      }));
    }
  }]);
}((external_react_default()).PureComponent);
ToastMessageAnimated.defaultProps = {
  className: "toast",
  showAnimation: "animated fadeIn",
  hideAnimation: "animated fadeOut",
  //
  timeOut: 5000,
  extendedTimeOut: 1000,
  //
  tapToDismiss: true,
  //
  onRemove: undefined,
  onClick: function onClick() {},
  onCloseClick: function onCloseClick() {}
};
 false ? 0 : void 0;
/* harmony default export */ const ReactToastr_ToastMessageAnimated = (ToastMessageAnimated);
;// CONCATENATED MODULE: ./src/components/ReactToastr/ToastContainer.jsx
var ToastContainer_excluded = ["toastType", "id", "toastMessageFactory", "preventDuplicates", "newestOnTop", "onClick"];
function ToastContainer_typeof(o) { "@babel/helpers - typeof"; return ToastContainer_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, ToastContainer_typeof(o); }
function ToastContainer_extends() { return ToastContainer_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, ToastContainer_extends.apply(null, arguments); }
function ToastContainer_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = ToastContainer_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function ToastContainer_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ToastContainer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ToastContainer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ToastContainer_ownKeys(Object(t), !0).forEach(function (r) { ToastContainer_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ToastContainer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ToastContainer_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function ToastContainer_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, ToastContainer_toPropertyKey(o.key), o); } }
function ToastContainer_createClass(e, r, t) { return r && ToastContainer_defineProperties(e.prototype, r), t && ToastContainer_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function ToastContainer_callSuper(t, o, e) { return o = ToastContainer_getPrototypeOf(o), ToastContainer_possibleConstructorReturn(t, ToastContainer_isNativeReflectConstruct() ? Reflect.construct(o, e || [], ToastContainer_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function ToastContainer_possibleConstructorReturn(t, e) { if (e && ("object" == ToastContainer_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return ToastContainer_assertThisInitialized(t); }
function ToastContainer_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function ToastContainer_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ToastContainer_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ToastContainer_getPrototypeOf(t) { return ToastContainer_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, ToastContainer_getPrototypeOf(t); }
function ToastContainer_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && ToastContainer_setPrototypeOf(t, e); }
function ToastContainer_setPrototypeOf(t, e) { return ToastContainer_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, ToastContainer_setPrototypeOf(t, e); }
function ToastContainer_defineProperty(e, r, t) { return (r = ToastContainer_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ToastContainer_toPropertyKey(t) { var i = ToastContainer_toPrimitive(t, "string"); return "symbol" == ToastContainer_typeof(i) ? i : i + ""; }
function ToastContainer_toPrimitive(t, r) { if ("object" != ToastContainer_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != ToastContainer_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
The MIT License (MIT)

Copyright (c) 2016 Tom Chen <developer@tomchentw.com>

Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
the Software, and to permit persons to whom the Software is furnished to do so,
subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */





/**
 * A React container for displaying a list of toast messages.
 * It mimics the APIs with the vanilla [toastr.js](https://github.com/CodeSeven/toastr)
 * by retaining a [ref][react-ref] to publish a new **toast**.
 *
 * To display HTML, simply pass JSX instead of strings for title and message.
 *
 * ```javascript
 * this.container.success(
 *   <strong>I am a strong title</strong>,
 *   <em>I am an emphasized message</em>
 * });
 * ```
 *
 * If you're using Redux for managing states, you might consider using the
 * underlying component directly. See [ToastMessageAnimated](#toastmessage) below
 */
var ToastContainer = /*#__PURE__*/function (_React$PureComponent) {
  function ToastContainer() {
    var _this;
    ToastContainer_classCallCheck(this, ToastContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = ToastContainer_callSuper(this, ToastContainer, [].concat(args));
    ToastContainer_defineProperty(_this, "state", {
      toastList: []
    });
    ToastContainer_defineProperty(_this, "toastMessageRefs", {});
    ToastContainer_defineProperty(_this, "handleOnToastClick", function (event) {
      _this.props.onClick(event);
      if (event.defaultPrevented) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
    });
    ToastContainer_defineProperty(_this, "handleOnToastRemove", function (key) {
      _this.setState(function (state) {
        return {
          toastList: state.toastList.filter(function (x) {
            return x.key !== key;
          })
        };
      });
    });
    return _this;
  }
  ToastContainer_inherits(ToastContainer, _React$PureComponent);
  return ToastContainer_createClass(ToastContainer, [{
    key: "error",
    value:
    /**
    *
    * @param {any} message
    * @param {any} title
    * @param {any} optionsOverride
    * @public
    */
    function error(message, title, optionsOverride) {
      this.handleNotify(this.props.toastType.error, message, title, optionsOverride);
    }

    /**
    *
    * @param {any} message
    * @param {any} title
    * @param {any} optionsOverride
    * @public
    */
  }, {
    key: "info",
    value: function info(message, title, optionsOverride) {
      this.handleNotify(this.props.toastType.info, message, title, optionsOverride);
    }

    /**
    *
    * @param {any} message
    * @param {any} title
    * @param {any} optionsOverride
    * @public
    */
  }, {
    key: "success",
    value: function success(message, title, optionsOverride) {
      this.handleNotify(this.props.toastType.success, message, title, optionsOverride);
    }

    /**
    *
    * @param {any} message
    * @param {any} title
    * @param {any} optionsOverride
    * @public
    */
  }, {
    key: "warning",
    value: function warning(message, title, optionsOverride) {
      this.handleNotify(this.props.toastType.warning, message, title, optionsOverride);
    }

    /**
    *
    * @public
    */
  }, {
    key: "clear",
    value: function clear() {
      this.toastMessageRefs.forEach(function (ref) {
        if (ref) {
          ref.handleHide();
        }
      });
    }
  }, {
    key: "handleNotify",
    value: function handleNotify(type, message, title) {
      var _this2 = this;
      var optionsOverride = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.props.preventDuplicates && this.state.toastList.includes(message)) {
        return;
      }
      // This is poor implementation, but collision chance for few toasters extremly low
      var key = "toast_" + Math.random();
      var nextToast = ToastContainer_objectSpread(ToastContainer_objectSpread({}, optionsOverride), {}, {
        key: key,
        type: type,
        title: title,
        message: message,
        ref: function ref(_ref) {
          _this2.toastMessageRefs[key] = _ref;
        },
        onClick: function onClick(event) {
          if (optionsOverride.handleOnClick) {
            optionsOverride.handleOnClick();
          }
          _this2.handleOnToastClick(event);
        },
        onRemove: function onRemove() {
          _this2.handleOnToastRemove(key);
        }
      });
      this.setState(function (state) {
        return {
          toastList: _this2.props.newestOnTop ? [nextToast].concat(_toConsumableArray(state.toastList)) : [].concat(_toConsumableArray(state.toastList), [nextToast])
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        toastType = _this$props.toastType,
        id = _this$props.id,
        toastMessageFactory = _this$props.toastMessageFactory,
        preventDuplicates = _this$props.preventDuplicates,
        newestOnTop = _this$props.newestOnTop,
        onClick = _this$props.onClick,
        restProps = ToastContainer_objectWithoutProperties(_this$props, ToastContainer_excluded); // eslint-disable-line
      return /*#__PURE__*/external_react_default().createElement("div", ToastContainer_extends({}, restProps, {
        id: id,
        "aria-live": "polite",
        role: "alert"
      }), this.state.toastList.map(function (it) {
        return toastMessageFactory(it);
      }));
    }
  }]);
}((external_react_default()).PureComponent);
ToastContainer.defaultProps = {
  toastType: {
    error: "error",
    info: "info",
    success: "success",
    warning: "warning"
  },
  id: "toast-container",
  toastMessageFactory: function toastMessageFactory(item) {
    return /*#__PURE__*/external_react_default().createElement(ReactToastr_ToastMessageAnimated, item);
  },
  preventDuplicates: true,
  newestOnTop: true,
  onClick: function onClick() {}
};
 false ? 0 : void 0;
/* harmony default export */ const ReactToastr_ToastContainer = (ToastContainer);
;// CONCATENATED MODULE: ./src/components/ReactToastr/index.js

/* harmony default export */ const ReactToastr = (ReactToastr_ToastContainer);

/***/ }),

/***/ 8201:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3368);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Glyph__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4937);




var Row = function Row(_ref) {
  var children = _ref.children,
    rowPart = _ref.rowPart,
    onClick = _ref.onClick,
    editable = _ref.editable;
  var rowEnabledClassName = "row row-link enabled";
  var rowDisabledClassName = "row row-link inactive";
  var rowClassName = editable ? rowEnabledClassName : rowDisabledClassName;
  var labelClassName = "col-xs-2 col-md-3 NameColumn";
  var iconClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()("iconLabel", rowPart.iconClassName || "");
  var getIcon = function getIcon() {
    return rowPart.material ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "iconLabel material-icons"
    }, rowPart.material) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: iconClass
    });
  };
  var onEdit = function onEdit() {
    if (editable) {
      onClick(rowPart);
    }
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: rowClassName,
    onClick: onEdit,
    id: rowPart.id
  }, rowPart.label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: labelClassName
  }, getIcon(), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "light"
  }, rowPart.label)), children, editable ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Glyph__WEBPACK_IMPORTED_MODULE_3__["default"], {
    iconClass: rowPart.rightLinkIconClass,
    iconName: rowPart.rightLinkIconName
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "col-xs-1 col-md-1"
  }));
};
Row.defaultProps = {
  editable: true,
  rowPart: {}
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Row);

/***/ }),

/***/ 4869:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export SearchButton */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _SearchWidget__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3949);
/* harmony import */ var _utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5609);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }




var SearchButton = /*#__PURE__*/function (_PureComponent) {
  function SearchButton(props, context) {
    var _this;
    _classCallCheck(this, SearchButton);
    _this = _callSuper(this, SearchButton, [props, context]);
    var searchText = props.searchText;
    var isSearchMode = !!(searchText && searchText.length > 0);
    _this.state = {
      isSearchMode: isSearchMode
    };
    _this.onClick = _this.onClick.bind(_this);
    _this.onKeyUp = _this.onKeyUp.bind(_this);
    return _this;
  }
  _inherits(SearchButton, _PureComponent);
  return _createClass(SearchButton, [{
    key: "onClick",
    value: function onClick() {
      var isSearchMode = !this.state.isSearchMode;
      if (!isSearchMode) this.resetSearchText();
      this.setState({
        isSearchMode: isSearchMode
      });
      this.props.onClick(isSearchMode);
    }
  }, {
    key: "resetSearchText",
    value: function resetSearchText() {
      this.props.onSearch("");
    }
  }, {
    key: "onKeyUp",
    value: function onKeyUp(event) {
      if (this.props.onKeyUp) {
        this.props.onKeyUp(event);
      }
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isEscPressed */ .e0)(event)) this.onClick();
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.isSearchMode) return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "searchButton"
      }, getSearchButton(this.onClick));
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "searchButton"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_SearchWidget__WEBPACK_IMPORTED_MODULE_3__["default"], {
        placeholder: this.props.defaultText,
        className: this.props.className,
        searchText: this.props.searchText,
        showCancel: true,
        onKeyUp: this.onKeyUp,
        onSearch: this.props.onSearch,
        onChange: this.props.onChange,
        maxlength: this.props.maxlength,
        onClear: this.onClick
      }));
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);
var getSearchButton = function getSearchButton(onClick) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    className: "ion-md-search searchButton",
    onClick: onClick
  }, "\xA0");
};
SearchButton.defaultProps = {
  onSearch: function onSearch() {},
  onChange: function onChange() {},
  onClick: function onClick() {}
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SearchButton);

/***/ }),

/***/ 3949:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SearchWidget)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3368);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5609);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




var SearchWidget = /*#__PURE__*/function (_Component) {
  function SearchWidget(props) {
    var _this;
    _classCallCheck(this, SearchWidget);
    _this = _callSuper(this, SearchWidget, [props]);
    _defineProperty(_this, "onFocus", function () {
      _this.setState({
        active: true
      });
    });
    if (props.focus && _this.searchTextInput) _this.setFocus();
    _this.state = {
      currentSearch: props.searchText ? props.searchText : "",
      active: false
    };
    return _this;
  }
  _inherits(SearchWidget, _Component);
  return _createClass(SearchWidget, [{
    key: "setFocus",
    value: function setFocus() {
      this.searchTextInput.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var className = classnames__WEBPACK_IMPORTED_MODULE_2___default()("search-widget", "editor", this.props.className, "search-widget:hover", "search-widget:active", this.state.active ? "search-active" : "");
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: className
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "icon-magnifier icon",
        onClick: function onClick() {
          return _this2.handleMagnifierClick();
        }
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
        type: "text",
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("search-text", "edit-text"),
        ref: function ref(input) {
          _this2.searchTextInput = input;
        },
        placeholder: this.props.placeholder,
        value: this.state.currentSearch,
        autoFocus: this.props.autoFocus,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        tabIndex: 1,
        onChange: function onChange(message) {
          return _this2.handleChangeText(message);
        },
        onKeyPress: function onKeyPress(message) {
          return _this2.handleBtnDown(message);
        },
        onKeyUp: function onKeyUp(event) {
          return _this2.props.onKeyUp(event);
        },
        onClick: function onClick(event) {
          return _this2.props.onClick(event);
        },
        maxLength: this.props.maxlength
      })), this.state.active || this.props.showCancel ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "icon-cancel icon",
        onClick: function onClick(e) {
          _this2.handleCancelClick(e);
        }
      }) : "");
    }
  }, {
    key: "handleMagnifierClick",
    value: function handleMagnifierClick() {
      this.props.onSearch(this.state.currentSearch);
    }
  }, {
    key: "handleChangeText",
    value: function handleChangeText(changeEvent) {
      this.setState({
        currentSearch: changeEvent.target.value,
        active: changeEvent.target.value.length > 0
      });
      this.props.onChange(changeEvent.target.value);
    }
  }, {
    key: "handleBtnDown",
    value: function handleBtnDown(e) {
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_3__/* .isEnterPressed */ .DV)(e)) {
        e.stopPropagation();
        this.props.onSearch(this.state.currentSearch);
      }
    }
  }, {
    key: "handleCancelClick",
    value: function handleCancelClick(e) {
      this.setState({
        currentSearch: "",
        active: false
      });
      this.props.onClear();
      e.stopPropagation();
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

SearchWidget.defaultProps = {
  autoFocus: true,
  onSearch: function onSearch() {},
  onKeyUp: function onKeyUp() {},
  onClick: function onClick() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onClear: function onClear() {},
  onBlur: function onBlur() {}
};
 false ? 0 : void 0;

/***/ }),

/***/ 4189:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ components_TabbedAutoSuggestControl)
});

// EXTERNAL MODULE: ./src/components/TabbedAutoSuggestControl/_styles.scss
var _styles = __webpack_require__(8589);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./src/utilities/EventUtilities.js
var EventUtilities = __webpack_require__(5609);
;// CONCATENATED MODULE: ./src/components/TabbedAutoSuggestControl/TabbedAutoSuggestRow.jsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var TabbedAutoSuggestRow = /*#__PURE__*/function (_React$Component) {
  function TabbedAutoSuggestRow() {
    var _this;
    _classCallCheck(this, TabbedAutoSuggestRow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TabbedAutoSuggestRow, [].concat(args));
    _defineProperty(_this, "onMouseDown", function () {
      _this.props.onItemSelected(_this.props.item);
    });
    return _this;
  }
  _inherits(TabbedAutoSuggestRow, _React$Component);
  return _createClass(TabbedAutoSuggestRow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.li && this.props.isSelected) {
        this.li.scrollIntoView();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.isSelected && prevProps.isSelected !== this.props.isSelected) {
        this.li.scrollIntoView({
          block: "nearest"
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/external_react_default().createElement("li", {
        className: this.props.className,
        ref: function ref(_ref) {
          return _this2.li = _ref;
        }
      }, /*#__PURE__*/external_react_default().createElement("a", {
        href: "#",
        onMouseDown: this.onMouseDown
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "truncate",
        title: this.props.title
      }, /*#__PURE__*/external_react_default().createElement("span", null, this.props.title))));
    }
  }]);
}((external_react_default()).Component);
 false ? 0 : void 0;
/* harmony default export */ const TabbedAutoSuggestControl_TabbedAutoSuggestRow = (TabbedAutoSuggestRow);
// EXTERNAL MODULE: ./src/components/TextInput.jsx
var TextInput = __webpack_require__(7642);
// EXTERNAL MODULE: ./src/utilities/StringUtilities.js
var StringUtilities = __webpack_require__(1146);
;// CONCATENATED MODULE: ./src/components/TabbedAutoSuggestControl/TabbedAutoSuggestControl.jsx
function TabbedAutoSuggestControl_typeof(o) { "@babel/helpers - typeof"; return TabbedAutoSuggestControl_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, TabbedAutoSuggestControl_typeof(o); }
function TabbedAutoSuggestControl_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function TabbedAutoSuggestControl_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, TabbedAutoSuggestControl_toPropertyKey(o.key), o); } }
function TabbedAutoSuggestControl_createClass(e, r, t) { return r && TabbedAutoSuggestControl_defineProperties(e.prototype, r), t && TabbedAutoSuggestControl_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function TabbedAutoSuggestControl_callSuper(t, o, e) { return o = TabbedAutoSuggestControl_getPrototypeOf(o), TabbedAutoSuggestControl_possibleConstructorReturn(t, TabbedAutoSuggestControl_isNativeReflectConstruct() ? Reflect.construct(o, e || [], TabbedAutoSuggestControl_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function TabbedAutoSuggestControl_possibleConstructorReturn(t, e) { if (e && ("object" == TabbedAutoSuggestControl_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return TabbedAutoSuggestControl_assertThisInitialized(t); }
function TabbedAutoSuggestControl_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function TabbedAutoSuggestControl_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (TabbedAutoSuggestControl_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function TabbedAutoSuggestControl_getPrototypeOf(t) { return TabbedAutoSuggestControl_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, TabbedAutoSuggestControl_getPrototypeOf(t); }
function TabbedAutoSuggestControl_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && TabbedAutoSuggestControl_setPrototypeOf(t, e); }
function TabbedAutoSuggestControl_setPrototypeOf(t, e) { return TabbedAutoSuggestControl_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, TabbedAutoSuggestControl_setPrototypeOf(t, e); }
function TabbedAutoSuggestControl_defineProperty(e, r, t) { return (r = TabbedAutoSuggestControl_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function TabbedAutoSuggestControl_toPropertyKey(t) { var i = TabbedAutoSuggestControl_toPrimitive(t, "string"); return "symbol" == TabbedAutoSuggestControl_typeof(i) ? i : i + ""; }
function TabbedAutoSuggestControl_toPrimitive(t, r) { if ("object" != TabbedAutoSuggestControl_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != TabbedAutoSuggestControl_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







var TabbedAutoSuggestControl = /*#__PURE__*/function (_React$Component) {
  function TabbedAutoSuggestControl(props, context) {
    var _this;
    TabbedAutoSuggestControl_classCallCheck(this, TabbedAutoSuggestControl);
    _this = TabbedAutoSuggestControl_callSuper(this, TabbedAutoSuggestControl, [props, context]);
    TabbedAutoSuggestControl_defineProperty(_this, "setFocus", function () {
      _this.textInput.setFocus();
    });
    TabbedAutoSuggestControl_defineProperty(_this, "onFocus", function () {
      if (!_this.state.dropdownIsActive) {
        _this.setState({
          dropdownIsActive: true
        });
        if (_this.textInput) {
          _this.textInput.select();
        }
      }
    });
    TabbedAutoSuggestControl_defineProperty(_this, "onBlur", function () {
      if (_this.state.dropdownIsActive) {
        _this.setState({
          dropdownIsActive: false
        });
      }
    });
    TabbedAutoSuggestControl_defineProperty(_this, "onTextChange", function (event) {
      var value = event.target.value;
      _this.props.onChange(value);
      _this.resetSelectedItemIndex();
      _this.onFocus();
    });
    TabbedAutoSuggestControl_defineProperty(_this, "filterItems", function (value) {
      var filteredItems = _this.props.items.filter(function (item) {
        return _this.props.filterItemPredicate(item, value);
      }).slice();
      _this.setState({
        filteredItems: filteredItems
      });
    });
    TabbedAutoSuggestControl_defineProperty(_this, "onItemSelected", function (item) {
      _this.props.onChange(item[_this.props.displayValue]);
    });
    TabbedAutoSuggestControl_defineProperty(_this, "onItemKeyDown", function (e) {
      if ((0,EventUtilities/* downArrowPressed */.Ur)(e)) {
        _this.onDownArrowHandler();
        return;
      }
      if ((0,EventUtilities/* upArrowPressed */.P7)(e)) {
        _this.onUpArrowHandler();
        return;
      }
      if ((0,EventUtilities/* isEnterPressed */.DV)(e)) {
        _this.onEnterHandler();
      }
      if ((0,EventUtilities/* isTabPressed */.Wz)(e) && !(0,EventUtilities/* isShiftPressed */.Hk)(e)) {
        _this.onTabHandler(e);
      }
      if ((0,EventUtilities/* isTabPressed */.Wz)(e) && (0,EventUtilities/* isShiftPressed */.Hk)(e)) {
        _this.onShiftTabHandler(e);
      }
    });
    TabbedAutoSuggestControl_defineProperty(_this, "getItemRow", function (item, index) {
      var title = _this.props.displayValue ? item[_this.props.displayValue] : item;
      var isItemSelected = index === _this.state.selectedItemIndex;
      var className = isItemSelected ? "selected" : "";
      return /*#__PURE__*/external_react_default().createElement(TabbedAutoSuggestControl_TabbedAutoSuggestRow, {
        className: className,
        isSelected: isItemSelected,
        key: index,
        title: title,
        onItemSelected: _this.onItemSelected,
        item: item
      });
    });
    TabbedAutoSuggestControl_defineProperty(_this, "getItemsContent", function (items) {
      return /*#__PURE__*/external_react_default().createElement("ul", {
        className: "dropdown-menu"
      }, items.map(function (item, index) {
        return _this.getItemRow(item, index);
      }));
    });
    _this.state = {
      selectedItemIndex: -1,
      dropdownIsActive: false,
      filteredItems: []
    };
    _this.defaultSelectedItemIndex = -1;
    _this.selectedItemClassName = "selected";
    return _this;
  }
  TabbedAutoSuggestControl_inherits(TabbedAutoSuggestControl, _React$Component);
  return TabbedAutoSuggestControl_createClass(TabbedAutoSuggestControl, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.text.length === 0 && prevProps.items.length === 0 && this.props.items && this.props.items.length > 0) {
        this.setState({
          filteredItems: this.props.items.slice()
        });
      } else if (prevProps.text !== this.props.text) {
        this.filterItems(this.props.text);
      }
    }
  }, {
    key: "onDownArrowHandler",
    value: function onDownArrowHandler() {
      var currentIndex = this.state.selectedItemIndex;
      var newIndex = currentIndex < this.state.filteredItems.length - 1 ? currentIndex + 1 : 0;
      this.setState({
        selectedItemIndex: newIndex
      });
    }
  }, {
    key: "resetSelectedItemIndex",
    value: function resetSelectedItemIndex() {
      this.setState({
        selectedItemIndex: this.defaultSelectedItemIndex
      });
    }
  }, {
    key: "onUpArrowHandler",
    value: function onUpArrowHandler() {
      var currentIndex = this.state.selectedItemIndex;
      var newIndex = currentIndex == -1 ? this.state.filteredItems.length - 1 : currentIndex - 1;
      this.setState({
        selectedItemIndex: newIndex
      });
    }
  }, {
    key: "onShiftTabHandler",
    value: function onShiftTabHandler(e) {
      this.props.moveFocusBack();
      e.preventDefault();
    }
  }, {
    key: "onEnterHandler",
    value: function onEnterHandler() {
      var isSelected = this.state.selectedItemIndex !== -1;
      if (isSelected) {
        var item = this.state.filteredItems[this.state.selectedItemIndex];
        var isSelectedAndTextIsNotApplied = isSelected && item && item[this.props.displayValue].trim() !== this.props.text.trim();
        if (isSelectedAndTextIsNotApplied) {
          this.onItemSelected(item);
          return;
        }
      }
      this.props.onEnter();
      this.textInput.select();
    }
  }, {
    key: "onTabHandler",
    value: function onTabHandler(e) {
      var isSelected = this.state.selectedItemIndex !== -1;
      if (!isSelected) {
        return;
      }
      var item = this.state.filteredItems[this.state.selectedItemIndex];
      var isSelectedAndTextIsNotApplied = isSelected && item && item[this.props.displayValue].trim() !== this.props.text.trim();
      if (isSelectedAndTextIsNotApplied) {
        this.onItemSelected(item);
        e.preventDefault();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var dropdownIsVisible = this.state.dropdownIsActive && this.props.text.length > 0;
      var placeholder = this.props.placeholder;
      var autoFocus = this.props.autoFocus;
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "tabbed-auto-suggest",
        name: this.props.name
      }, /*#__PURE__*/external_react_default().createElement(TextInput["default"], {
        ref: function ref(_ref) {
          return _this2.textInput = _ref;
        },
        autoFocus: autoFocus,
        placeholder: placeholder,
        tabIndex: this.props.tabIndex,
        name: "tabbedAutosuggestInput",
        value: this.props.text,
        onChange: this.onTextChange,
        onBlur: this.onBlur,
        autoComplete: false,
        onFocus: this.onFocus,
        maxlength: this.props.maxLength,
        onKeyDown: this.onItemKeyDown
      }), dropdownIsVisible && this.getItemsContent(this.state.filteredItems));
    }
  }]);
}((external_react_default()).Component);
var defaultFilterPredicate = function defaultFilterPredicate(item, key) {
  return !key || (0,StringUtilities/* contains */.gR)(item.name, key);
};
TabbedAutoSuggestControl.defaultProps = {
  items: [],
  filterItemPredicate: defaultFilterPredicate,
  autoFocus: false,
  text: "",
  name: ""
};
 false ? 0 : void 0;
/* harmony default export */ const TabbedAutoSuggestControl_TabbedAutoSuggestControl = (TabbedAutoSuggestControl);
;// CONCATENATED MODULE: ./src/components/TabbedAutoSuggestControl/index.js


/* harmony default export */ const components_TabbedAutoSuggestControl = (TabbedAutoSuggestControl_TabbedAutoSuggestControl);

/***/ }),

/***/ 4668:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ components_Table)
});

// EXTERNAL MODULE: ./src/components/Table/_styles.scss
var _styles = __webpack_require__(4493);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3368);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/utilities/SortingUtilities.js
var SortingUtilities = __webpack_require__(7609);
;// CONCATENATED MODULE: ./src/components/Table/utils.js

var getDefaultSortColumn = function getDefaultSortColumn(columns) {
  if (columns.length == 0) return {};
  var result = columns.find(function (c) {
    return c.isDefaultSort;
  });
  return result ? result : columns[0];
};
var getColumnByField = function getColumnByField(columns, field) {
  var result = columns.find(function (c) {
    return c.field === field;
  });
  return result ? result : columns[0];
};
var sorter = function sorter(a, b, ascValue, field) {
  return (0,SortingUtilities/* sortByField */.q_)(a, b, ascValue, field);
};
var sortDataByColumn = function sortDataByColumn(column, data, isAsc) {
  var ascValue = isAsc ? "asc" : "desc";
  var sortableData = data;
  if (column.onSort) {
    sortableData = data.sort(function (a, b) {
      return column.onSort(a, b, ascValue);
    });
  } else {
    sortableData = data.sort(function (a, b) {
      return sorter(a, b, ascValue, column.field);
    });
  }
  return sortableData;
};
var getResultedClassName = function getResultedClassName(className, value) {
  var item = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var result = value;
  if (className) {
    if (typeof className === "function") {
      result = value + " " + className(item);
    } else {
      result = value + " " + className;
    }
  }
  return result;
};
;// CONCATENATED MODULE: ./src/components/Table/Row.jsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable */




var Row = function Row(_ref) {
  var item = _ref.item,
    columns = _ref.columns,
    trClassName = _ref.trClassName,
    onRowClick = _ref.onRowClick;
  var classNameResult = getResultedClassName(trClassName, "table-row", item);
  var props = {
    className: classNameResult
  };
  if (onRowClick) {
    props.onClick = function () {
      return onRowClick(item);
    };
  }
  return /*#__PURE__*/external_react_default().createElement("tr", props, columns.map(function (column) {
    return getCell(item.id + column.field, item, column);
  }));
};
var getCell = function getCell(key, item, column) {
  var props = {};
  if (column.width) {
    props.style = {
      "width": column.width
    };
  }
  if (column.align) {
    props.style = _objectSpread(_objectSpread({}, props.style), {
      "textAlign": column.align
    });
  }
  if (column.className) {
    props.className = column.className;
  }
  var children = column.dataFormat ? column.dataFormat(item) : item[column.field];
  return /*#__PURE__*/external_react_default().createElement("td", _extends({}, props, {
    key: key
  }), children);
};
 false ? 0 : void 0;
/* harmony default export */ const Table_Row = (Row);
// EXTERNAL MODULE: ./src/components/Caret.jsx
var Caret = __webpack_require__(8124);
;// CONCATENATED MODULE: ./src/components/Table/Header.jsx
function Header_typeof(o) { "@babel/helpers - typeof"; return Header_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Header_typeof(o); }
function Header_extends() { return Header_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, Header_extends.apply(null, arguments); }
function Header_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Header_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Header_ownKeys(Object(t), !0).forEach(function (r) { Header_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Header_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Header_defineProperty(e, r, t) { return (r = Header_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Header_toPropertyKey(t) { var i = Header_toPrimitive(t, "string"); return "symbol" == Header_typeof(i) ? i : i + ""; }
function Header_toPrimitive(t, r) { if ("object" != Header_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Header_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable */



var Header = function Header(_ref) {
  var columns = _ref.columns,
    onSort = _ref.onSort,
    currentSortedField = _ref.currentSortedField,
    isAsc = _ref.isAsc,
    useCaret = _ref.useCaret;
  return /*#__PURE__*/external_react_default().createElement("thead", null, /*#__PURE__*/external_react_default().createElement("tr", null, columns.map(function (column) {
    return /*#__PURE__*/external_react_default().createElement(HeaderCell, {
      column: column,
      onSort: onSort,
      useCaret: useCaret,
      currentSortedField: currentSortedField,
      isAsc: isAsc,
      key: column.field
    });
  })));
};
var HeaderCell = function HeaderCell(_ref2) {
  var column = _ref2.column,
    onSort = _ref2.onSort,
    currentSortedField = _ref2.currentSortedField,
    isAsc = _ref2.isAsc,
    useCaret = _ref2.useCaret;
  var props = {
    name: "th-" + column.field
  };
  if (column.width) {
    props.style = {
      "width": column.width
    };
  }
  if (column.align) {
    props.style = Header_objectSpread(Header_objectSpread({}, props.style), {
      "textAlign": column.align
    });
  }
  if (column.headerAlign) {
    props.style = Header_objectSpread(Header_objectSpread({}, props.style), {
      "textAlign": column.headerAlign
    });
  }
  var children = column.headerFormat ? column.headerFormat() : column.text;
  props.className = column.thClassName ? column.thClassName + " sort-column" : "sort-column";
  if (column.isSortable === false) return /*#__PURE__*/external_react_default().createElement("th", props, children);
  return /*#__PURE__*/external_react_default().createElement("th", Header_extends({}, props, {
    onClick: function onClick() {
      return onSort(column);
    }
  }), children, /*#__PURE__*/external_react_default().createElement(CaretRender, {
    currentSortedField: currentSortedField,
    field: column.field,
    isAsc: isAsc,
    useCaret: useCaret
  }));
};
var CaretRender = function CaretRender(_ref3) {
  var field = _ref3.field,
    currentSortedField = _ref3.currentSortedField,
    isAsc = _ref3.isAsc,
    useCaret = _ref3.useCaret;
  var sort = isAsc ? "asc" : "desc";
  if (useCaret) {
    if (currentSortedField === field) return /*#__PURE__*/external_react_default().createElement(Caret.Caret, {
      sort: sort
    });
    return null;
  }
  if (currentSortedField === field) {
    return isAsc ? Up : Down;
  }
  return Inactive;
};
var Up = /*#__PURE__*/external_react_default().createElement("span", {
  className: "order dropup"
}, /*#__PURE__*/external_react_default().createElement("span", {
  className: "caret"
}));
var Down = /*#__PURE__*/external_react_default().createElement("span", {
  className: "order"
}, /*#__PURE__*/external_react_default().createElement("span", {
  className: "caret"
}));
var Inactive = /*#__PURE__*/external_react_default().createElement("span", {
  className: "order inactive"
}, /*#__PURE__*/external_react_default().createElement("span", {
  className: "dropdown"
}, /*#__PURE__*/external_react_default().createElement("span", {
  className: "caret"
})), /*#__PURE__*/external_react_default().createElement("span", {
  className: "dropup"
}, /*#__PURE__*/external_react_default().createElement("span", {
  className: "caret"
})));
 false ? 0 : void 0;
 false ? 0 : void 0;
Header.defaultProps = {
  isAsc: true,
  onSort: function onSort() {},
  useCaret: false
};
 false ? 0 : void 0;
/* harmony default export */ const Table_Header = (Header);
;// CONCATENATED MODULE: ./src/components/Table/Pagination.jsx


var Pagination = function Pagination(_ref) {
  var currentPage = _ref.currentPage,
    onPageChange = _ref.onPageChange,
    totalCount = _ref.totalCount;
  var showedPages = Array.from({
    length: totalCount
  }, function (v, k) {
    return k + 1;
  });
  if (totalCount > 5) {
    var from = 1;
    if (currentPage > 3) {
      from = currentPage - 2;
    }
    if (currentPage > totalCount - 3) {
      from = totalCount - 4;
    }
    showedPages = Array.from({
      length: 5
    }, function (v, k) {
      return k + from;
    });
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "react-bs-table-pagination"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "row"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-md-6 col-xs-hidden col-sm-hidden col-lg-6"
  }), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-md-6 col-xs-12 col-sm-12 col-lg-6"
  }, /*#__PURE__*/external_react_default().createElement("ul", {
    className: "react-bootstrap-table-page-btns-ul pagination"
  }, getFirst(currentPage, onPageChange, totalCount), getPrevious(currentPage, onPageChange), showedPages.map(function (x) {
    var className = x === currentPage ? "active page-item" : "page-item";
    return /*#__PURE__*/external_react_default().createElement("li", {
      className: className,
      key: x,
      title: x,
      onClick: function onClick() {
        return onPageChange(x);
      }
    }, /*#__PURE__*/external_react_default().createElement("a", {
      href: "#",
      className: "page-link"
    }, x));
  }), getNext(currentPage, onPageChange, totalCount), getLast(currentPage, onPageChange, totalCount)))));
};
var getPrevious = function getPrevious(currentPage, onPageChange) {
  if (currentPage === 1) return /*#__PURE__*/external_react_default().createElement("li", {
    className: "disabled page-item",
    title: "<"
  }, /*#__PURE__*/external_react_default().createElement("a", {
    href: "#",
    className: "page-link"
  }, "<"));else return /*#__PURE__*/external_react_default().createElement("li", {
    className: "page-item",
    title: "<",
    onClick: function onClick() {
      return onPageChange(currentPage - 1);
    }
  }, /*#__PURE__*/external_react_default().createElement("a", {
    href: "#",
    className: "page-link"
  }, "<"));
};
var getNext = function getNext(currentPage, onPageChange, totalCount) {
  if (currentPage === totalCount) return /*#__PURE__*/external_react_default().createElement("li", {
    className: "disabled page-item",
    title: ">"
  }, /*#__PURE__*/external_react_default().createElement("a", {
    href: "#",
    className: "page-link"
  }, ">"));else return /*#__PURE__*/external_react_default().createElement("li", {
    className: "page-item",
    title: ">",
    onClick: function onClick() {
      return onPageChange(currentPage + 1);
    }
  }, /*#__PURE__*/external_react_default().createElement("a", {
    href: "#",
    className: "page-link"
  }, ">"));
};
var getFirst = function getFirst(currentPage, onPageChange, totalCount) {
  if (currentPage < 4 || totalCount < 6) return null;
  return /*#__PURE__*/external_react_default().createElement("li", {
    className: "page-item",
    title: "1",
    onClick: function onClick() {
      return onPageChange(1);
    }
  }, /*#__PURE__*/external_react_default().createElement("a", {
    href: "#",
    className: "page-link"
  }, "1..."));
};
var getLast = function getLast(currentPage, onPageChange, totalCount) {
  if (totalCount < 6 || currentPage > totalCount - 3) return null;
  return /*#__PURE__*/external_react_default().createElement("li", {
    className: "page-item",
    title: "totalCount",
    onClick: function onClick() {
      return onPageChange(totalCount);
    }
  }, /*#__PURE__*/external_react_default().createElement("a", {
    href: "#",
    className: "page-link"
  }, "...", totalCount));
};
 false ? 0 : void 0;
/* harmony default export */ const Table_Pagination = (Pagination);
;// CONCATENATED MODULE: ./src/components/Table/Table.jsx
function Table_typeof(o) { "@babel/helpers - typeof"; return Table_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Table_typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Table_toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == Table_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function Table_defineProperty(e, r, t) { return (r = Table_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Table_toPropertyKey(t) { var i = Table_toPrimitive(t, "string"); return "symbol" == Table_typeof(i) ? i : i + ""; }
function Table_toPrimitive(t, r) { if ("object" != Table_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Table_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







var Table = /*#__PURE__*/function (_Component) {
  function Table(props, context) {
    var _this;
    _classCallCheck(this, Table);
    _this = _callSuper(this, Table, [props, context]);
    Table_defineProperty(_this, "onSort", function (column) {
      var isAsc = _this.state.currentSortedField === column.field ? !_this.state.isAsc : true;
      var sortableData = sortDataByColumn(column, _this.state.data, isAsc);
      _this.setState({
        data: sortableData,
        currentSortedField: column.field,
        isAsc: isAsc
      });
      _this.props.onAfterSort({
        data: sortableData,
        currentSortedField: column.field,
        isAsc: isAsc
      });
    });
    Table_defineProperty(_this, "onPageClick", function (currentPage) {
      _this.setState({
        currentPage: currentPage
      });
    });
    var defaultSortColumn = getDefaultSortColumn(props.columns);
    var defaultField = defaultSortColumn.field;
    var _isAsc = props.defaultSortOrder === "asc";
    var data = sortDataByColumn(defaultSortColumn, props.data, _isAsc);
    var showPagination = props.maxVisibleCount != undefined && props.maxVisibleCount <= data.length;
    var pagesCount = showPagination ? Math.ceil(data.length / props.maxVisibleCount) : 0;
    _this.state = {
      currentSortedField: defaultField,
      data: data,
      isAsc: _isAsc,
      showPagination: showPagination,
      pagesCount: pagesCount,
      currentPage: 1
    };
    return _this;
  }
  _inherits(Table, _Component);
  return _createClass(Table, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps && prevProps.data.length !== this.props.data.length) {
        var showPagination = this.state.showPagination;
        var pagesCount = this.state.pagesCount;
        if (this.props.maxVisibleCount) {
          showPagination = this.props.maxVisibleCount <= this.props.data.length;
          pagesCount = showPagination ? Math.ceil(this.props.data.length / this.props.maxVisibleCount) : 0;
        }
        var currentColumn = getColumnByField(this.props.columns, this.state.currentSortedField);
        var sortedData = sortDataByColumn(currentColumn, this.props.data, this.state.isAsc);
        this.setState({
          data: sortedData,
          pagesCount: pagesCount,
          showPagination: showPagination
        });
      } else if (prevProps && prevProps.data !== this.props.data) {
        var _currentColumn = getColumnByField(this.props.columns, this.state.currentSortedField);
        var _sortedData = sortDataByColumn(_currentColumn, this.props.data, this.state.isAsc);
        this.setState({
          data: _sortedData
        });
      }
    }
  }, {
    key: "getContent",
    value: function getContent() {
      var _this2 = this;
      var _this$props = this.props,
        noDataText = _this$props.noDataText,
        columns = _this$props.columns,
        keyField = _this$props.keyField;
      var result = this.state.data;
      if (this.state.showPagination && this.state.currentPage) {
        var begin = (this.state.currentPage - 1) * this.props.maxVisibleCount;
        var end = begin + this.props.maxVisibleCount;
        result = this.state.data.slice(begin, end);
      }
      if (this.state.data.length > 0) {
        {
          return result.map(function (item) {
            return /*#__PURE__*/external_react_default().createElement(Table_Row, {
              item: item,
              columns: _this2.props.columns,
              trClassName: _this2.props.trClassName,
              onRowClick: _this2.props.onRowClick,
              key: item[keyField]
            });
          });
        }
      }
      return /*#__PURE__*/external_react_default().createElement("tr", null, /*#__PURE__*/external_react_default().createElement("td", {
        colSpan: columns.length,
        className: "noData"
      }, noDataText));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        columns = _this$props2.columns,
        className = _this$props2.className;
      var tableClassName = classnames_default()("table", "table-bordered", className);
      if (columns.length === 0) return null;
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "react-bs-table-container"
      }, /*#__PURE__*/external_react_default().createElement("table", {
        className: tableClassName
      }, /*#__PURE__*/external_react_default().createElement(Table_Header, {
        columns: columns,
        onSort: this.onSort,
        isAsc: this.state.isAsc,
        useCaret: this.props.useCaretRender,
        currentSortedField: this.state.currentSortedField
      }), /*#__PURE__*/external_react_default().createElement("tbody", null, this.getContent())), this.state.showPagination && /*#__PURE__*/external_react_default().createElement(Table_Pagination, {
        currentPage: this.state.currentPage,
        onPageChange: this.onPageClick,
        totalCount: this.state.pagesCount
      }));
    }
  }]);
}(external_react_.Component);
Table.defaultProps = {
  data: [],
  noDataText: "",
  defaultSortOrder: "asc",
  trClassName: "",
  useCaretRender: false,
  onAfterSort: function onAfterSort() {}
};
 false ? 0 : void 0;
/* harmony default export */ const Table_Table = (Table);
;// CONCATENATED MODULE: ./src/components/Table/index.js


/* harmony default export */ const components_Table = (Table_Table);

/***/ }),

/***/ 7642:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export TextInput */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }


var TextInput = /*#__PURE__*/function (_Component) {
  function TextInput(props, context) {
    var _this;
    _classCallCheck(this, TextInput);
    _this = _callSuper(this, TextInput, [props, context]);
    _this.setFocus = _this.setFocus.bind(_this);
    return _this;
  }
  _inherits(TextInput, _Component);
  return _createClass(TextInput, [{
    key: "setFocus",
    value: function setFocus() {
      this.textInput.focus();
    }
  }, {
    key: "select",
    value: function select() {
      this.textInput.select();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var wrapperClass = "form-group";
      if (this.props.error && this.props.error.length > 0 || this.props.isInvalid) {
        wrapperClass += " " + "has-error";
      }
      if (this.props.className) wrapperClass += " " + this.props.className;
      var inputProps = {};
      inputProps["disabled"] = this.props.disabled;
      inputProps["autoFocus"] = this.props.autoFocus;
      if (this.props.readonly) {
        inputProps["readOnly"] = this.props.readonly;
      }
      if (this.props.autoComplete !== undefined) inputProps["autoComplete"] = this.props.autoComplete ? "on" : "off";
      var componentName = this.props.name + "Field";
      var labelId = this.props.name + "Label";
      var inputId = this.props.name + "Input";
      var inputType = this.props.isPassword ? "password" : "text";
      var inputFinalClassName = this.props.inputClassName ? "form-control " + this.props.inputClassName : "form-control";
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: wrapperClass,
        name: componentName
      }, this.props.label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", {
        id: labelId,
        htmlFor: this.props.name
      }, this.props.label), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", _extends({
        id: inputId,
        type: inputType,
        ref: function ref(input) {
          _this2.textInput = input;
        },
        name: this.props.name,
        tabIndex: this.props.tabIndex,
        className: inputFinalClassName,
        placeholder: this.props.placeholder,
        maxLength: this.props.maxlength,
        value: this.props.value
      }, inputProps, {
        onChange: this.props.onChange,
        onKeyPress: this.props.onKeyPress,
        onKeyDown: this.props.onKeyDown,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        size: "",
        "aria-describedby": this.props.ariaDescribedBy,
        "aria-labelledby": this.props.ariaLabelledBy
      })), this.props.error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "validate-error-message"
      }, this.props.error));
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
TextInput.defaultProps = {
  isInvalid: false
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TextInput);

/***/ }),

/***/ 275:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ components_Toggle)
});

// EXTERNAL MODULE: ./src/components/Toggle/_styles.scss
var _styles = __webpack_require__(7023);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3368);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
;// CONCATENATED MODULE: ./src/components/Toggle/check.js

/* harmony default export */ const check = (function () {
  return /*#__PURE__*/external_react_default().createElement("svg", {
    width: "14",
    height: "11",
    viewBox: "0 0 14 11"
  }, /*#__PURE__*/external_react_default().createElement("title", null), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
    fill: "#fff",
    fillRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ./src/components/Toggle/x.js

/* harmony default export */ const x = (function () {
  return /*#__PURE__*/external_react_default().createElement("svg", {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10"
  }, /*#__PURE__*/external_react_default().createElement("title", null), /*#__PURE__*/external_react_default().createElement("path", {
    d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",
    fill: "#fff",
    fillRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ./src/components/Toggle/Toggle.jsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }






var Toggle = /*#__PURE__*/function (_Component) {
  function Toggle(props) {
    var _this;
    _classCallCheck(this, Toggle);
    _this = _callSuper(this, Toggle, [props]);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
    _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.previouslyChecked = !!(props.checked || props.defaultChecked);
    _this.state = {
      checked: !!(props.checked || props.defaultChecked),
      hasFocus: false
    };
    return _this;
  }
  _inherits(Toggle, _Component);
  return _createClass(Toggle, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.checked !== undefined && this.props.checked !== prevProps.checked) {
        this.setState({
          checked: !!this.props.checked
        });
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var checkbox = this.input;
      if (this.props.stopClickPropagation) event.stopPropagation();
      if (event.target !== checkbox && !this.moved) {
        this.previouslyChecked = checkbox.checked;
        event.preventDefault();
        checkbox.focus();
        checkbox.click();
        return;
      }
      var checked = this.props.checked !== undefined ? this.props.checked : checkbox.checked;
      this.setState({
        checked: checked
      });
    }
  }, {
    key: "handleTouchStart",
    value: function handleTouchStart(event) {
      this.startX = pointerCoord(event).x;
      this.activated = true;
    }
  }, {
    key: "handleTouchMove",
    value: function handleTouchMove(event) {
      if (!this.activated) return;
      this.moved = true;
      if (this.startX) {
        var currentX = pointerCoord(event).x;
        if (this.state.checked && currentX + 15 < this.startX) {
          this.setState({
            checked: false
          });
          this.startX = currentX;
          this.activated = true;
        } else if (currentX - 15 > this.startX) {
          this.setState({
            checked: true
          });
          this.startX = currentX;
          this.activated = currentX < this.startX + 5;
        }
      }
    }
  }, {
    key: "handleTouchEnd",
    value: function handleTouchEnd(event) {
      if (!this.moved) return;
      var checkbox = this.input;
      event.preventDefault();
      if (this.startX) {
        var endX = pointerCoord(event).x;
        if (this.previouslyChecked === true && this.startX + 4 > endX) {
          if (this.previouslyChecked !== this.state.checked) {
            this.setState({
              checked: false
            });
            this.previouslyChecked = this.state.checked;
            checkbox.click();
          }
        } else if (this.startX - 4 < endX) {
          if (this.previouslyChecked !== this.state.checked) {
            this.setState({
              checked: true
            });
            this.previouslyChecked = this.state.checked;
            checkbox.click();
          }
        }
        this.activated = false;
        this.startX = null;
        this.moved = false;
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.setState({
        hasFocus: true
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        hasFocus: false
      });
    }
  }, {
    key: "getIcon",
    value: function getIcon(type) {
      var icons = {
        checked: /*#__PURE__*/external_react_default().createElement(check, null),
        unchecked: /*#__PURE__*/external_react_default().createElement(x, null)
      };
      return icons[type];
    }
  }, {
    key: "onChange",
    value: function onChange(value) {
      if (!this.props.disabled) {
        this.props.onChange(value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var className = this.props.className;
      var inputProps = {
        className: className,
        value: this.props.value,
        checked: this.props.checked,
        onChange: this.onChange,
        name: this.props.name,
        id: this.props.id,
        tabIndex: this.props.tabIndex
      };
      var classes = classnames_default()("react-toggle", {
        "react-toggle--checked": this.state.checked,
        "react-toggle--focus": this.state.hasFocus,
        "react-toggle--disabled": this.props.disabled
      }, className);
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: classes,
        name: this.props.toggleContainerName,
        onClick: this.handleClick,
        onTouchStart: this.handleTouchStart,
        onTouchMove: this.handleTouchMove,
        onTouchEnd: this.handleTouchEnd
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "react-toggle-track"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "react-toggle-track-check"
      }, this.getIcon("checked")), /*#__PURE__*/external_react_default().createElement("div", {
        className: "react-toggle-track-x"
      }, this.getIcon("unchecked"))), /*#__PURE__*/external_react_default().createElement("div", {
        className: "react-toggle-thumb"
      }), /*#__PURE__*/external_react_default().createElement("input", _extends({}, inputProps, {
        ref: function ref(_ref) {
          _this2.input = _ref;
        },
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        className: "react-toggle-screenreader-only",
        type: "checkbox"
      })));
    }
  }]);
}(external_react_.Component);

Toggle.defaultProps = {
  checked: false,
  disabled: false,
  stopClickPropagation: false,
  toggleContainerName: "toggleContainer"
};
 false ? 0 : void 0;
function pointerCoord(event) {
  // get coordinates for either a mouse click
  // or a touch depending on the given event
  if (event) {
    var changedTouches = event.changedTouches;
    if (changedTouches && changedTouches.length > 0) {
      var touch = changedTouches[0];
      return {
        x: touch.clientX,
        y: touch.clientY
      };
    }
    var pageX = event.pageX;
    if (pageX !== undefined) {
      return {
        x: pageX,
        y: event.pageY
      };
    }
  }
  return {
    x: 0,
    y: 0
  };
}
;// CONCATENATED MODULE: ./src/components/Toggle/index.js


/* harmony default export */ const components_Toggle = (Toggle);

/***/ }),

/***/ 9004:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export Tooltip */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var Tooltip = function Tooltip(_ref) {
  var title = _ref.title,
    description = _ref.description;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tooltipContainer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tooltip-title"
  }, title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "tooltip"
  }, description));
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Tooltip);

/***/ }),

/***/ 9778:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ components_UnverifiedEmailControl)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3368);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
;// CONCATENATED MODULE: ./src/utilities/DateUtilities.js
var formatDate = function formatDate(date, options) {
  var isUtc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return formatDateTime("toLocaleDateString", date, options, isUtc);
};
var formatTime = function formatTime(time, options) {
  var isUtc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return formatDateTime("toLocaleTimeString", time, options, isUtc);
};
var addDays = function addDays(date, daysCount) {
  date.setDate(date.getDate() + daysCount);
  return date;
};
var formatDateTime = function formatDateTime(methodName, date, options, isUtc) {
  if (isUtc) {
    date = date + "Z";
  }
  var d = new Date(date);
  if (isNaN(d)) return "";
  return d[methodName]("en-US", options).replace(",", "").replace(new RegExp(String.fromCharCode(8206), "g"), ""); // https://www.csgpro.com/blog/2016/08/a-bad-date-with-internet-explorer-11-trouble-with-new-unicode-characters-in-javascript-date-strings
};
var isYearly = function isYearly(frequencyInMonth) {
  return frequencyInMonth % 12 === 0;
};
var isMonthly = function isMonthly(frequencyInMonth) {
  return frequencyInMonth % 12 !== 0;
};
var getYearsFromMonths = function getYearsFromMonths(frequencyInMonth) {
  return frequencyInMonth / 12;
};
var getTimeMinutes = function getTimeMinutes(dueTime) {
  var timeArr = dueTime.split(":");
  var hours = timeArr[0];
  var minutes = timeArr[1];
  var minutesCount = 60 * hours + 1 * minutes;
  return minutesCount;
};
var getTimeFromMinutes = function getTimeFromMinutes(time) {
  var hours = Math.floor(time / 60);
  hours = hours < 10 ? "0" + hours : hours;
  var minutes = time % 60;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var formattedTime = hours + ":" + minutes;
  return formattedTime;
};
var showDate = function showDate(date) {
  if (!date || isNaN(date)) return "";
  var dd = date.getDate();
  if (isNaN(dd)) return "";
  if (dd < 10) dd = "0" + dd;
  var mm = date.getMonth() + 1;
  if (mm < 10) mm = "0" + mm;
  var yy = date.getFullYear();
  return mm + "/" + dd + "/" + yy;
};
var parseDate = function parseDate(date) {
  var result = Date.parse(date);
  if (result) return new Date(result);
  return undefined;
};
;// CONCATENATED MODULE: ./src/components/UnverifiedEmailControl.jsx





var UnverifiedEmailControl = function UnverifiedEmailControl(_ref) {
  var user = _ref.user,
    resendVerificationEmail = _ref.resendVerificationEmail,
    sentRecently = _ref.sentRecently,
    waitForSend = _ref.waitForSend;
  if (!user) return null;
  var hasUnverifiedEmail = user.hasUnverifiedEmail;
  if (!hasUnverifiedEmail) return null;
  var options = {
    month: "2-digit",
    day: "2-digit",
    year: "numeric"
  };
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "notification-container"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "notification-block"
  }, /*#__PURE__*/external_react_default().createElement("h5", {
    className: "user-header"
  }, "Unverified Email Address"), sentRecently ? /*#__PURE__*/external_react_default().createElement("span", {
    name: "sent-just",
    className: "card-text"
  }, "Verification email was just sent") : user.pendingEmail.activatedDateTime && /*#__PURE__*/external_react_default().createElement("span", {
    name: "sent-note",
    className: "card-text"
  }, "Verification email was sent on", /*#__PURE__*/external_react_default().createElement("span", {
    name: "sent-date"
  }, " " + formatDate(user.pendingEmail.activatedDateTime, options, true)))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "notification-block button-block"
  }, sentRecently ? /*#__PURE__*/external_react_default().createElement("span", {
    className: "notification-sent"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "ion-md-checkmark"
  }, "\xA0"), /*#__PURE__*/external_react_default().createElement("span", {
    name: "verification-note"
  }, "Verification Sent")) : /*#__PURE__*/external_react_default().createElement("a", {
    name: "verification-button",
    href: "#",
    className: classnames_default()("btn btn-primary", {
      "disabled": waitForSend
    }),
    onClick: resendVerificationEmail
  }, "Resend Verification")));
};
 false ? 0 : void 0;
/* harmony default export */ const components_UnverifiedEmailControl = (UnverifiedEmailControl);

/***/ }),

/***/ 5552:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export WarningMessage */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _WarningMessage_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6228);
/* harmony import */ var _WarningMessage_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_WarningMessage_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



var WarningMessage = function WarningMessage(props) {
  return props.isVisible ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "warning-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    id: props.messageId,
    className: "warning-block"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h5", null, props.title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "warning-message"
  }, props.children))) : null;
};
WarningMessage.defaultProps = {
  isVisible: false,
  messageId: "yellowOptionalMessage",
  title: ""
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (WarningMessage);

/***/ }),

/***/ 4143:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ay: () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   Rl: () => (/* binding */ getAuthenticationTypeByValue)
/* harmony export */ });
/* unused harmony export AuthenticationTypeEnum */
var AuthenticationTypeEnum = {
  User: {
    value: "User",
    label: "Site/User/Password",
    text: "Site/User/Password",
    description: "Users log in with site number, user number, and password.",
    iconClass: "material-icons",
    materialIcon: "settings_input_component"
  },
  Sso: {
    value: "Sso",
    label: "Single Sign-On",
    text: "SSO",
    description: "Users log in using credentials managed by their organization.",
    iconClass: "material-icons",
    materialIcon: "vpn_key"
  },
  Password: {
    value: "Password",
    label: "Password",
    text: "Password",
    description: "Users log in using passwords they create and manage themselves.",
    iconClass: "material-icons",
    materialIcon: "lock"
  }
};
var getAuthenticationTypeByValue = function getAuthenticationTypeByValue(value) {
  var authenticationType = null;
  switch (value) {
    case AuthenticationTypeEnum.User.value:
      authenticationType = AuthenticationTypeEnum.User;
      break;
    case AuthenticationTypeEnum.Sso.value:
      authenticationType = AuthenticationTypeEnum.Sso;
      break;
    case AuthenticationTypeEnum.Password.value:
      authenticationType = AuthenticationTypeEnum.Password;
      break;
  }
  return authenticationType;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AuthenticationTypeEnum);

/***/ }),

/***/ 1486:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export OrganizationStatusEnum */
var OrganizationStatusEnum = {
  Active: {
    value: "Active",
    label: "Active"
  },
  Locked: {
    value: "Locked",
    label: "Locked"
  },
  SuperUsersOnly: {
    value: "SuperUsersOnly",
    label: "Superuser Only"
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrganizationStatusEnum);

/***/ }),

/***/ 9220:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export OrganizationTypeEnum */
var OrganizationTypeEnum = {
  Separate: "separate",
  Subordinate: "subordinate",
  Parent: "parent",
  P1S: "p1s"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrganizationTypeEnum);

/***/ }),

/***/ 4006:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export ProductEnum */
/* harmony import */ var _entities_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8607);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2382);



var productIds = {
  pharmacyProductId: 1,
  quantifyProductId: 2,
  infectionPreventionProductId: 3,
  veriFormProductId: 4,
  ruleProductId: 5,
  analyticsProductId: 6,
  simplifiProductId: 7,
  pocAdvisorProductId: 8,
  medStorageProductId: 9,
  sepsisMonitorProductId: 10,
  medTraysProductId: 11,
  patientDecompensationId: 12,
  documentationProductId: 13,
  aurReportingProductId: 14,
  flowlyticsProductId: 15,
  ivWorkflowProductId: 16,
  userManagementProductId: 99,
  superUserProductId: 101
};

// structure of enum:
//         id -  product id in Identifi, should be the same in all applications
//         name -  name of product,
//         abbreviation -
//         type - type of product (for grouping),
//         icon - object of type Icon like new Icon("icon-pill"),
//         iconContainerClass - class of patent element,
//         label - visible product name in left menu (if there is no override in "leftMenuLabel") and in Product Selector in Identifi,
//         iconClass - string of icon class name in Identifi (Product Selector),
//         iconName - string of icon name in Identifi (Product Selector),
//         tileClassName - class name for tile in Identifi Product Selector,
//         leftMenuLabel - visible product name in left menu
//         ariaLabel - aria-label attribute
var ProductEnum = {
  Pharmacy: {
    id: productIds.pharmacyProductId,
    name: "Sentri7 Pharmacy",
    abbreviation: "s7",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.surveillance,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("icon-pill"),
    iconContainerClass: "icon-product",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Pharmacy"),
    iconClass: "custom-icon icon-pill",
    tileClassName: "pharmacy"
  },
  Quantifi: {
    id: productIds.quantifyProductId,
    name: "Quantifi",
    abbreviation: "q",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.surveillance,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("ion-md-stats"),
    iconContainerClass: "icon-product",
    iconClass: "icon ion-stats-bars",
    tileClassName: "quantifi",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Quantifi", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("sup", null, "\xAE"))
  },
  InfectionPrevention: {
    id: productIds.infectionPreventionProductId,
    name: "Sentri7 Infection Prevention",
    abbreviation: "s7",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.surveillance,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("ion-md-bug"),
    iconContainerClass: "icon-product",
    iconClass: "icon bug_report",
    tileClassName: "ip",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Infection Prevention")
  },
  Veriform: {
    id: productIds.veriFormProductId,
    name: "Veriform",
    abbreviation: "v",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.safety,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("ion-md-clipboard"),
    iconContainerClass: "icon-product",
    iconClass: "custom-icon list-alt--outline",
    tileClassName: "veriform",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "VeriForm", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("sup", null, "\xAE"))
  },
  Simplifi: {
    id: productIds.simplifiProductId,
    name: "Simplifi 797",
    abbreviation: "s",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.safety,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("icon-syringe"),
    iconContainerClass: "icon-product",
    iconClass: "icon-syringe",
    tileClassName: "simplifi",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Simplifi 797", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("sup", null, "\xAE"))
  },
  Analytics: {
    id: productIds.analyticsProductId,
    name: "Analytics",
    abbreviation: "a",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.tools,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("ion-md-pulse"),
    iconContainerClass: "permission-analytics",
    iconClass: "icon ion-ios-pulse-strong",
    tileClassName: "analytics",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Analytics")
  },
  UserManagement: {
    id: productIds.userManagementProductId,
    name: "Settings & User Management",
    abbreviation: "cm",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.tools,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("icon-cogs"),
    iconContainerClass: "permission-userManagement",
    iconClass: "icon settings",
    tileClassName: "admin",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Settings & User Management")
  },
  RuleManagement: {
    id: productIds.ruleProductId,
    name: "Rules Management",
    abbreviation: "rm",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.tools,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("widgets"),
    iconContainerClass: "permission-ruleManagement",
    iconClass: "icon widgets",
    tileClassName: "rules",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Rules Management")
  },
  PocAdvisor: {
    id: productIds.pocAdvisorProductId,
    name: "POC Advisor",
    abbreviation: "pa",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.surveillance,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("flag"),
    iconContainerClass: "icon-product",
    iconClass: "icon flag",
    tileClassName: "pocadvisor",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "POC Advisor", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("sup", null, "\xAE"))
  },
  SuperUser: {
    id: productIds.superUserProductId,
    name: "Super User",
    abbreviation: "",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.tools,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("ion-ios-color-wand"),
    iconContainerClass: "icon-product",
    iconClass: "icon ion-ios-color-wand",
    tileClassName: "superuser",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Super User")
  },
  MedStorage: {
    id: productIds.medStorageProductId,
    name: "Simplifi+ MedStorage",
    abbreviation: "m",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.safety,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("checklist"),
    iconContainerClass: "icon-product",
    iconClass: "checklist",
    tileClassName: "med-storage",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Simplifi+", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("sup", null, "\xAE"), " MedStorage"),
    leftMenuLabel: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "MedStorage"),
    ariaLabel: "Simplify Plus MedStorage"
  },
  MedTrays: {
    id: productIds.medTraysProductId,
    name: "Simplifi+ MedTrays",
    abbreviation: "mt",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.safety,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("view_quilt"),
    iconContainerClass: "icon-product med-trays",
    iconClass: "icon view_quilt",
    tileClassName: "med-trays",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Simplifi+", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("sup", null, "\xAE"), " MedTrays"),
    leftMenuLabel: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "MedTrays"),
    ariaLabel: "Simplify Plus MedTrays"
  },
  SepsisMonitor: {
    id: productIds.sepsisMonitorProductId,
    name: "Sepsis Monitor",
    abbreviation: "fl",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.surveillance,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("custom-icon icon-policy"),
    iconContainerClass: "icon-product",
    iconClass: "custom-icon icon-policy",
    tileClassName: "sepsis-monitor",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Sepsis Monitor")
  },
  PatientDecompensation: {
    id: productIds.patientDecompensationId,
    name: "Pharmacy (New)",
    abbreviation: "pd",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.surveillance,
    // Icon name should be in pascal case for svg icons both here and in assets/svg as they will be converted to react components
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("SvgPharmacyNew", _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes */ .B.svg, "pharmacy-new"),
    iconContainerClass: "icon-product",
    iconClass: "pharmacy-new",
    tileClassName: "pharmacy-new-tile",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Pharmacy (New)"),
    ariaLabel: "Pharmacy New"
  },
  AurReporting: {
    id: productIds.aurReportingProductId,
    name: "AUR Reporting",
    abbreviation: "aur",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.surveillance,
    iconClass: "material-symbols-outlined",
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("icon-data-exploration"),
    iconContainerClass: "icon-product",
    tileClassName: "S7AurOnly",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "AUR Reporting")
  },
  Flowlytics: {
    id: productIds.flowlyticsProductId,
    name: "Drug Diversion",
    abbreviation: "fl",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.surveillance,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("icon-alt-route"),
    iconContainerClass: "icon-product",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Drug Diversion"),
    iconClass: "material-symbols-outlined",
    tileClassName: "flowlytics"
  },
  IVWorkflow: {
    id: productIds.ivWorkflowProductId,
    name: "Simplifi+ IV Workflow",
    abbreviation: "ivw",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.safety,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("iv-workflow"),
    iconContainerClass: "icon-product",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Simplifi+", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("sup", null, "\xAE"), " IV Workflow"),
    iconClass: "iv-workflow",
    tileClassName: "ivWorkflow",
    ariaLabel: "Simplify Plus IV Workflow"
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductEnum);

/***/ }),

/***/ 2382:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export ProductType */
var ProductType = {
  surveillance: 0,
  safety: 1,
  tools: 2
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductType);

/***/ }),

/***/ 8754:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgPharmacyNew = function SvgPharmacyNew(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 240 240",
    preserveAspectRatio: "none"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    fill: "#007AC3",
    fillRule: "evenodd",
    d: "M201 40h-16v24h-24v16h24v24h16V80h24V64h-24zM56 168H40v16H24v16h16v16h16v-16h16v-16H56zM144 16h-16v8h-8v16h8v8h16v-8h8V24h-8zM31.147 40.147c28.285-28.284 59.397-8.485 67.882 0l101.824 101.824c8.485 8.485 28.284 39.598 0 67.882s-59.397 8.485-67.882 0L31.147 108.029c-8.485-8.485-28.284-39.597 0-67.882m56.569 101.824L42.46 96.716c-5.657-5.657-18.385-26.87 0-45.255s39.598-5.657 45.255 0l45.255 45.255zm11.313 11.313 45.255 45.255c5.657 5.657 26.87 18.385 45.255 0s5.657-39.598 0-45.255l-45.255-45.255z",
    clipRule: "evenodd"
  }));
};
var SvgIcons = {
  SvgPharmacyNew: SvgPharmacyNew
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgIcons);

/***/ }),

/***/ 39:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ BaseClass)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BaseClass = /*#__PURE__*/function () {
  function BaseClass() {
    _classCallCheck(this, BaseClass);
  }
  return _createClass(BaseClass, [{
    key: "createCopy",
    value: function createCopy() {
      var copy = new this.__proto__.constructor();
      for (var attr in this) {
        // eslint-disable-next-line no-use-before-define,no-prototype-builtins
        if (this.hasOwnProperty(attr)) {
          if (this[attr] instanceof Array) {
            copy[attr] = this[attr].map(function (item) {
              return getCopy(item);
            });
          } else {
            copy[attr] = getCopy(this[attr]);
          }
        }
      }
      return copy;
    }
  }]);
}();

var getCopy = function getCopy(item) {
  if (item instanceof BaseClass) {
    return item.createCopy();
  } else return item;
};

/***/ }),

/***/ 3465:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ ExternalIdentifiers)
/* harmony export */ });
/* harmony import */ var _BaseClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

var ExternalIdentifiers = /*#__PURE__*/function (_BaseClass) {
  function ExternalIdentifiers(json) {
    var _this;
    _classCallCheck(this, ExternalIdentifiers);
    _this = _callSuper(this, ExternalIdentifiers);
    if (json) {
      _this.externalIdentifiersId = json.ExternalIdentifiersId;
      _this.nationalProviderIdentifier = json.NationalProviderIdentifier;
      _this.nabpEPid = json.NabpEPid;
      _this.dateOfBirth = json.DateOfBirth;
      _this.nabpRoleId = json.NabpRoleId;
      _this.hasNoNabp = json.HasNoNabp;
    }
    return _this;
  }
  _inherits(ExternalIdentifiers, _BaseClass);
  return _createClass(ExternalIdentifiers, [{
    key: "toJson",
    value: function toJson() {
      return {
        ExternalIdentifiersId: this.externalIdentifiersId,
        NationalProviderIdentifier: this.nationalProviderIdentifier,
        NabpEPid: this.nabpEPid,
        DateOfBirth: this.dateOfBirth,
        NabpRoleId: this.nabpRoleId,
        HasNoNabp: this.hasNoNabp
      };
    }
  }]);
}(_BaseClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A);


/***/ }),

/***/ 8607:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ Icon),
/* harmony export */   B: () => (/* binding */ IconTypes)
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3368);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var IconTypes = {
  "default": 0,
  material: 1,
  jumpstart: 2,
  svg: 3
};
var Icon = /*#__PURE__*/function () {
  function Icon(name) {
    var _this = this;
    var iconType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : IconTypes["default"];
    var extraClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    _classCallCheck(this, Icon);
    _defineProperty(this, "addClasses", function (extraClasses) {
      return _this.extraClass = classnames__WEBPACK_IMPORTED_MODULE_0___default()(_this.extraClass, extraClasses);
    });
    this.name = name;
    this.iconType = iconType;
    this.extraClass = extraClass;
  }

  /**
   * @deprecated use IconView
   */
  return _createClass(Icon, [{
    key: "isMaterial",
    get: function get() {
      return this.iconType === IconTypes.material;
    }
  }]);
}();


/***/ }),

/***/ 5609:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DV: () => (/* binding */ isEnterPressed),
/* harmony export */   Db: () => (/* binding */ isNumberKeyFromEvent),
/* harmony export */   Hk: () => (/* binding */ isShiftPressed),
/* harmony export */   IE: () => (/* binding */ isDecimalPointFromEvent),
/* harmony export */   P7: () => (/* binding */ upArrowPressed),
/* harmony export */   Ur: () => (/* binding */ downArrowPressed),
/* harmony export */   Wz: () => (/* binding */ isTabPressed),
/* harmony export */   e0: () => (/* binding */ isEscPressed),
/* harmony export */   fZ: () => (/* binding */ isLiteralKeyFromEvent),
/* harmony export */   l_: () => (/* binding */ isSpacePressed)
/* harmony export */ });
/* unused harmony exports isNumberKey, isDecimalPoint, isZeroFromEvent, isZeroPoint, isBackSlashPressed, isDeletePressed, descriptionAcceptableSymbol, conceptAcceptableSymbol, ruleLogicValueAcceptableSymbol, backSpacePressed */
//
// Helpers for handling browser events
//

//event hasn't property which IE  < 9
function isNumberKeyFromEvent(e) {
  return isNumberKey(e.which ? e.which : e.keyCode);
}
function isNumberKey(code) {
  return code >= 48 && code <= 57;
}
function isDecimalPointFromEvent(e) {
  return isDecimalPoint(e.which ? e.which : e.keyCode);
}
function isDecimalPoint(code) {
  return code == 46;
}
function isZeroFromEvent(e) {
  return isZeroPoint(e.which ? e.which : e.keyCode);
}
function isZeroPoint(code) {
  return code == 48;
}
function isLiteralKeyFromEvent(e) {
  return isAcceptableKey(e.which ? e.which : e.keyCode);
}
function isEnterPressed(e) {
  var code = e.which ? e.which : e.keyCode;
  return code == 13;
}
function isTabPressed(e) {
  var code = e.which ? e.which : e.keyCode;
  return code == 9;
}
function isShiftPressed(e) {
  return e.shiftKey;
}
function isBackSlashPressed(e) {
  var code = e.which ? e.which : e.keyCode;
  return code == 92;
}
function isDeletePressed(e) {
  var code = e.which ? e.which : e.keyCode;
  return code == 46;
}
function isEscPressed(e) {
  return e.keyCode == 27;
}
function isSpacePressed(e) {
  var code = e.which ? e.which : e.keyCode;
  return code == 32;
}
function upArrowPressed(e) {
  var code = e.which ? e.which : e.keyCode;
  return code == 38;
}
function downArrowPressed(e) {
  var code = e.which ? e.which : e.keyCode;
  return code == 40;
}
function descriptionAcceptableSymbol(e) {
  var code = e.which ? e.which : e.keyCode;
  return code > 0 && code < 256;
}
function conceptAcceptableSymbol(e) {
  return !isBackSlashPressed(e);
}
function ruleLogicValueAcceptableSymbol(e) {
  var code = e.which ? e.which : e.keyCode;
  return isLiteralKey(code) || code == 32 || code == 40 || code == 41;
}
function isAcceptableKey(code) {
  return isLiteralKey(code) || isAcceptableSymbol(code);
}
// 0-9A-Za-z
function isLiteralKey(code) {
  return code >= 48 && code <= 57 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}
// space'-.
function isAcceptableSymbol(code) {
  return code == 32 || code == 39 || code == 45 || code == 46;
}
function backSpacePressed(e) {
  var code = e.which ? e.which : e.keyCode;
  return code == 8;
}

/***/ }),

/***/ 2000:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AU: () => (/* binding */ getOrganizationStatus),
/* harmony export */   Ds: () => (/* binding */ getAuthenticationType),
/* harmony export */   Iv: () => (/* binding */ getOrganizationType),
/* harmony export */   LT: () => (/* binding */ getCurrentIdn),
/* harmony export */   Q2: () => (/* binding */ getTags),
/* harmony export */   RO: () => (/* binding */ createTreeList),
/* harmony export */   gR: () => (/* binding */ getCurrentP1s)
/* harmony export */ });
/* harmony import */ var _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9220);
/* harmony import */ var _constants_OrganizationStatusEnum__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1486);
/* harmony import */ var _constants_AuthenticationTypeEnum__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4143);
/* harmony import */ var _utilities_SortingUtilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7609);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }




var getOrganizationType = function getOrganizationType(typeValue) {
  if (typeValue && typeValue.length > 0) {
    switch (typeValue.toLowerCase()) {
      case _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.P1S:
        return _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.P1S;
      case _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Parent:
        return _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Parent;
      case _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Separate:
        return _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Separate;
      case _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Subordinate:
        return _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Subordinate;
    }
  }
  return null;
};
var getOrganizationStatus = function getOrganizationStatus(value) {
  var organizationStatus;
  switch (value) {
    case _constants_OrganizationStatusEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.Active.value:
      organizationStatus = _constants_OrganizationStatusEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.Active;
      break;
    case _constants_OrganizationStatusEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.Locked.value:
      organizationStatus = _constants_OrganizationStatusEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.Locked;
      break;
    case _constants_OrganizationStatusEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.SuperUsersOnly.value:
      organizationStatus = _constants_OrganizationStatusEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.SuperUsersOnly;
      break;
  }
  return organizationStatus;
};
var getAuthenticationType = function getAuthenticationType(value) {
  var authenticationType = null;
  switch (value) {
    case _constants_AuthenticationTypeEnum__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Ay.User.value:
      authenticationType = _constants_AuthenticationTypeEnum__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Ay.User;
      break;
    case _constants_AuthenticationTypeEnum__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Ay.Sso.value:
      authenticationType = _constants_AuthenticationTypeEnum__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Ay.Sso;
      break;
    case _constants_AuthenticationTypeEnum__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Ay.Password.value:
      authenticationType = _constants_AuthenticationTypeEnum__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Ay.Password;
      break;
  }
  return authenticationType;
};
var createTreeList = function createTreeList(organizations) {
  var result = [];
  organizations.filter(function (o) {
    return !o.isSuborganization();
  }).forEach(function (organization) {
    result = [].concat(_toConsumableArray(result), [organization]);
    if (organization.isIDN()) {
      organization.suborganizations = organizations.filter(function (o) {
        return o.parentOrganizationId === organization.id;
      }).sort(_utilities_SortingUtilities__WEBPACK_IMPORTED_MODULE_3__/* .sortByName */ .VV);
    }
  });
  var notSubordinateIds = result.map(function (o) {
    return o.id;
  });
  var organizationsWithoutParent = organizations.filter(function (o) {
    return o.isSuborganization() && !notSubordinateIds.includes(o.parentOrganizationId);
  });
  result = [].concat(_toConsumableArray(result), _toConsumableArray(organizationsWithoutParent)).sort(_utilities_SortingUtilities__WEBPACK_IMPORTED_MODULE_3__/* .sortByName */ .VV);
  if (result.length === 0 && organizations.length > 0) return organizations;
  return result;
};
var getTags = function getTags(organizations) {
  var tags = [];
  organizations.forEach(function (organization) {
    tags = tags.concat(organization.tags);
    if (organizations.suborganizations) {
      organizations.suborganizations.forEach(function (subOrganization) {
        tags = tags.concat(subOrganization.tags);
      });
    }
  });
  return _toConsumableArray(new Set(tags));
};
var getCurrentP1s = function getCurrentP1s(organizations) {
  return organizations.find(function (o) {
    return o.site === 1;
  });
};
var getCurrentIdn = function getCurrentIdn(organizations, currentOrganization) {
  if (!currentOrganization) return undefined;
  if (currentOrganization.isSuborganization()) {
    var parent = organizations.find(function (org) {
      return org.id === currentOrganization.parentOrganizationId;
    });
    return parent ? parent : currentOrganization;
  }
  return currentOrganization;
};

/***/ }),

/***/ 2500:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   OI: () => (/* binding */ getProductConfigurationById),
/* harmony export */   ZV: () => (/* binding */ isSurveillanceProduct),
/* harmony export */   gL: () => (/* binding */ isTools),
/* harmony export */   ih: () => (/* binding */ isSafetyProduct)
/* harmony export */ });
/* unused harmony exports isProductNeedsAnalytics, isSuperUserProduct, isLegacyProduct */
/* harmony import */ var _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4006);
var _ProductsMemo;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var ProductsMemo = (_ProductsMemo = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ProductsMemo, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Pharmacy.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Pharmacy), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.InfectionPrevention.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.InfectionPrevention), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.RuleManagement.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.RuleManagement), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.SuperUser.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.SuperUser), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Quantifi.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Quantifi), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Veriform.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Veriform), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.PocAdvisor.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.PocAdvisor), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.MedStorage.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.MedStorage), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Simplifi.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Simplifi), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.MedTrays.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.MedTrays), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ProductsMemo, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.SepsisMonitor.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.SepsisMonitor), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.PatientDecompensation.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.PatientDecompensation), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Analytics.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Analytics), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.UserManagement.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.UserManagement), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.AurReporting.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.AurReporting), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Flowlytics.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Flowlytics), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.IVWorkflow.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.IVWorkflow));
var getProductConfigurationById = function getProductConfigurationById(productId) {
  return ProductsMemo[productId];
};
var isProductNeedsAnalytics = function isProductNeedsAnalytics(product) {
  return product.id === Products.Pharmacy.id || product.id === Products.InfectionPrevention.id || product.id === Products.RuleManagement.id;
};
var isSuperUserProduct = function isSuperUserProduct(product) {
  return product.id === Products.SuperUser.id;
};

// legacyProduct
var legacyProductIds = [_constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Pharmacy.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Quantifi.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.InfectionPrevention.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Veriform.id];
var isLegacyProduct = function isLegacyProduct(productId) {
  return legacyProductIds.indexOf(productId) > -1;
};

// toolsProduct
var tools = [_constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.RuleManagement.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Analytics.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.UserManagement.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.SuperUser.id];
var isTools = function isTools(productId) {
  return tools.indexOf(productId) > -1;
};

// surveillanceProduct
var surveillanceProductIds = [_constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Pharmacy.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Quantifi.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.InfectionPrevention.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.PocAdvisor.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.SepsisMonitor.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.PatientDecompensation.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.AurReporting.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Flowlytics.id];
var isSurveillanceProduct = function isSurveillanceProduct(productId) {
  return surveillanceProductIds.indexOf(productId) > -1;
};

// safetyProduct
var safetyProductIds = [_constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Veriform.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.MedStorage.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Simplifi.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.MedTrays.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.IVWorkflow.id];
var isSafetyProduct = function isSafetyProduct(productId) {
  return safetyProductIds.indexOf(productId) > -1;
};

/***/ }),

/***/ 7609:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NM: () => (/* binding */ sortByString),
/* harmony export */   VV: () => (/* binding */ sortByName),
/* harmony export */   q_: () => (/* binding */ sortByField)
/* harmony export */ });
/* unused harmony exports sortByOrder, sortByFields, sortByDueDate, sortByBoolean, sortByNumber, sortByDate, sortByNameAsc, sortStringByFieldAsc */
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var sortByName = function sortByName(item1, item2, order) {
  return sortByField(item1, item2, order, "name");
};
var sortByOrder = function sortByOrder(item1, item2, order) {
  return sortByField(item1, item2, order, "order");
};
var sortByFields = function sortByFields(item1, item2, fields) {
  if (fields && fields.length > 0) {
    var result = 0;
    fields.forEach(function (field) {
      if (result == 0) {
        var fieldName = field.name ? field.name : field;
        var fieldOrder = field.order;
        result = sortByField(item1, item2, fieldOrder, fieldName);
      }
    });
    return result;
  }
  return -1;
};
var sortByDueDate = function sortByDueDate(item1, item2, order) {
  return sortByField(item1, item2, order, "dueAtTime");
};
var sortByField = function sortByField(item1, item2, order, field) {
  var value1 = field ? item1[field] : item1;
  var value2 = field ? item2[field] : item2;
  if (value1 == value2) return 0;
  var orderByDesc = order && order.toLowerCase() === "desc";
  // believe that undefined is the lowest
  if (value1 == undefined) return orderByDesc ? 1 : -1;
  if (value2 == undefined) return orderByDesc ? -1 : 1;
  if (_typeof(value1) != _typeof(value2)) return sortByString(_typeof(value1), _typeof(value2), order);
  if (typeof value1 == "boolean") return sortByBoolean(value1, value2, order);
  if (typeof value1 == "string") return sortByString(value1, value2, order);
  if (typeof value1 == "number") return sortByNumber(value1, value2, order);
  if (value1 instanceof Date) return sortByDate(value1, value2, order);
};
var sortByBoolean = function sortByBoolean(value1, value2, order) {
  if (value1 == value2) return 0;
  var result = 1;
  if (order && order.toLowerCase() === "desc") result = -1;
  if (value1 && !value2) {
    return result;
  }
  if (!value1 && value2) {
    return -result;
  }
  return 0;
};
var sortByString = function sortByString(value1, value2, order) {
  if (value1 == undefined && value2 == undefined) return 0;
  var orderByDesc = order && order.toLowerCase() === "desc";

  // believe that undefined is the lowest
  if (value1 == undefined) return orderByDesc ? 1 : -1;
  if (value2 == undefined) return orderByDesc ? -1 : 1;
  if (value1.toLowerCase() == value2.toLowerCase()) return 0;
  var result = orderByDesc ? -1 : 1;
  return value1.toLowerCase() > value2.toLowerCase() ? result : -result;
};
var sortByNumber = function sortByNumber(value1, value2, order) {
  if (value1 == value2) return 0;
  var orderByDesc = order && order.toLowerCase() === "desc";

  // believe that undefined is the lowest
  if (value1 == undefined) return orderByDesc ? 1 : -1;
  if (value2 == undefined) return orderByDesc ? -1 : 1;
  var result = orderByDesc ? -1 : 1;
  return value1 > value2 ? result : -result;
};
var sortByDate = function sortByDate(value1, value2, order) {
  if (value1 == value2) return 0;
  if (value1 instanceof Date && value2 instanceof Date) {
    if (value1.getTime() === value2.getTime()) return 0;
  }
  var orderByDesc = order && order.toLowerCase() === "desc";
  var result = orderByDesc ? -1 : 1;

  // believe that undefined is the lowest
  if (value1 == undefined) return -result;
  if (value2 == undefined) return result;
  return value1 > value2 ? result : -result;
};
var sortByNameAsc = function sortByNameAsc(a, b) {
  return sortByName(a, b, "asc");
};
var sortStringByFieldAsc = function sortStringByFieldAsc(a, b, field) {
  return a[field] == "" || a[field].toLowerCase() > b[field].toLowerCase() ? 1 : -1;
};

/***/ }),

/***/ 1146:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   gR: () => (/* binding */ contains)
/* harmony export */ });
/* unused harmony exports deleteWhiteSpaces, encodeString, equals, guid, getUniqueFromStringArray, getUniqueFromArray, plural */
/* eslint-disable */
var deleteWhiteSpaces = function deleteWhiteSpaces(value) {
  if (value && value.length > 0) return value.trim().replace(/\s+/g, " ");
  return value;
};
var encodeString = function encodeString(value) {
  if (value && value.length > 0) return value.replace(/[<>\/&\\]/gim, function (i) {
    return "&#" + i.charCodeAt(0) + ";";
  });
  return value;
};
var contains = function contains(item, key) {
  var ignoreMissedItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (key) {
    key = deleteWhiteSpaces(key).toLowerCase();
  }
  return ignoreMissedItem && !item || !key || item.toLowerCase().indexOf(key) > -1;
};
var equals = function equals(string1, string2) {
  var caseSensitive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!string1 || !string2 || caseSensitive) return string1 == string2;
  return string1.toLowerCase() == string2.toLowerCase();
};
var guid = function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
};
var getUniqueFromStringArray = function getUniqueFromStringArray() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return values.reduce(function (acc, el, i, arr) {
    if (acc.indexOf(el) < 0) acc.push(el);
    return acc;
  }, []);
};
var getUniqueFromArray = function getUniqueFromArray() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "name";
  return values.reduce(function (acc, el, i, arr) {
    if (acc.indexOf(el[field]) < 0) acc.push(el[field]);
    return acc;
  }, []);
};

// Makes plural form of sentence by pattern
// Call examples:
// plural("{{count}} {{word}} created.", 3, "item", "items") -> "3 items created"
// plural("{{count}} {{word}} created.", 1, "item", "items") -> "1 item created"
var plural = function plural(pattern, count, singleForm, pluralForm) {
  var countPlaceholder = "{{count}}";
  var wordPlaceholder = "{{word}}";
  var word = count === 1 ? singleForm : pluralForm;
  return pattern.replace(countPlaceholder, count).replace(wordPlaceholder, word);
};

/***/ }),

/***/ 5226:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e2: () => (/* binding */ openUrlInNewTab),
/* harmony export */   l: () => (/* binding */ getProfileUrl)
/* harmony export */ });
/* unused harmony exports getHref, getImagePath, parseUrl, getRoot, getUrl, getIdentifiApiUrl, getIdentifiLogoutPageUrl, navigateToUrl, parse, setWindowLocation, getQueryStringFromObject */
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1837);
/* harmony import */ var _utilities_ValidationUtilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4708);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }


var getHref = function getHref() {
  return window.location.href;
};
var getImagePath = function getImagePath(baseApiPath) {
  return baseApiPath + "/Assets/img/";
};
var getProfileUrl = function getProfileUrl(url, secondPart) {
  if (!(0,_utilities_ValidationUtilities__WEBPACK_IMPORTED_MODULE_1__/* .isNullOrEmpty */ .uJ)(url)) return "/" + url + secondPart;
  return secondPart;
};
var parseUrl = function parseUrl() {
  return Url.parse(getHref(), true);
};
var getRoot = function getRoot() {
  var url = parseUrl();
  return url.protocol + "//" + url.hostname;
};
var getUrl = function getUrl() {
  var url = parseUrl();
  var path = url.protocol + "//" + url.hostname + url.pathname;
  if (path.substr(path.length - 1, 1) == "/") {
    return path.substr(0, path.length - 1);
  }
  return path;
};
var getIdentifiApiUrl = function getIdentifiApiUrl() {
  return GlobalSettings.IdentifiServiceUrl;
};
var getIdentifiLogoutPageUrl = function getIdentifiLogoutPageUrl() {
  return GlobalSettings.IdentifiLogoutPageUrl;
};
var navigateToUrl = function navigateToUrl(url, params) {
  var navUrl = url;
  if (params && params.length > 0) {
    var queryParams = params.map(function (param) {
      return param.key + "=" + param.value;
    });
    navUrl += "?" + queryParams.join("&");
  }
  setWindowLocation(navUrl);
};
var parse = function parse(search) {
  var params = {};
  if (isNullOrEmpty(search)) return params;
  var hashes = search.slice(search.indexOf("?") + 1).split("&");
  hashes.map(function (hash) {
    var _hash$split = hash.split("="),
      _hash$split2 = _slicedToArray(_hash$split, 2),
      key = _hash$split2[0],
      val = _hash$split2[1];
    var keyProp = key.toLowerCase();
    params[keyProp] = decodeURIComponent(val);
  });
  return params;
};
var openUrlInNewTab = function openUrlInNewTab(url) {
  window.open(url, "_blank");
};
var setWindowLocation = function setWindowLocation(url) {
  window.location = url;
};
var getQueryStringFromObject = function getQueryStringFromObject(obj) {
  if (!obj) return "";
  var query = Object.getOwnPropertyNames(obj).map(function (option) {
    return option + "=" + obj[option];
  }).join("&");
  return query.length > 0 ? "?" + query : "";
};

/***/ }),

/***/ 9840:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   OH: () => (/* binding */ Validation)
/* harmony export */ });
/* unused harmony exports getAssignedOrganizationById, getAuthenticationTypeByValue */
/* harmony import */ var _ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4708);


var getAssignedOrganizationById = function getAssignedOrganizationById(user, orgId, assignedOrganizations) {
  if (user == null || assignedOrganizations.length === 0) return null;
  var assignedOrganization = assignedOrganizations.find(function (o) {
    return o.id === orgId;
  });
  if (assignedOrganization != null) return assignedOrganization;
  if (user.organizationId == orgId) return user.getParentOrganization(true);
  return null;
};
var getAuthenticationTypeByValue = function getAuthenticationTypeByValue(value) {
  var authenticationType = null;
  switch (value) {
    case AuthenticationTypeEnum.User.value:
      authenticationType = AuthenticationTypeEnum.User;
      break;
    case AuthenticationTypeEnum.Sso.value:
      authenticationType = AuthenticationTypeEnum.Sso;
      break;
    case AuthenticationTypeEnum.Password.value:
      authenticationType = AuthenticationTypeEnum.Password;
      break;
  }
  return authenticationType;
};
var Validation = {
  isNameValid: function isNameValid(name) {
    var error = null;
    if ((0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isNullOrEmpty */ .uJ)(name)) error = "Required field.";else if (!(0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isValidUserName */ .b5)(name)) error = "Invalid characters in Name.";
    return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(error === null, error);
  },
  isEmailValid: function isEmailValid(email) {
    var error = null;
    if ((0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isNullOrEmpty */ .uJ)(email)) error = "Required field.";else if (!(0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isValidEmailFormat */ .cJ)(email)) error = "Please enter a valid email address.";
    return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(error === null, error);
  },
  isExternalUserIdValid: function isExternalUserIdValid(externalUserId) {
    var error = null;
    if ((0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isNullOrEmpty */ .uJ)(externalUserId)) error = "Required field.";
    return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(error === null, error);
  },
  isPINValid: function isPINValid(pin) {
    var error = null;
    if (!(0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isDigitsOnly */ .Db)(pin)) error = "PIN should consist of digits.";
    if ((0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isNullOrEmpty */ .uJ)(pin)) error = "Required field.";
    if (pin.length < 4) error = "PIN should be more than 4 digits.";
    if (pin.length > 10) error = "PIN should be less than 10 digits.";
    return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(error === null, error);
  },
  validateNationalProviderIdentifier: function validateNationalProviderIdentifier(npi) {
    if (npi && !(0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isDigitsOnly */ .Db)(npi)) return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(false, "NPI should consist of digits.");
    if (npi && npi.length !== 10) return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(false, "NPI must be ten digits.");
    if (npi && !(0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isValidNpi */ .G9)(npi)) return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(false, "Invalid NPI value.");
    return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(true, null);
  },
  validateNabp: function validateNabp(nabp) {
    var error = null;
    if (nabp && !(0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isDigitsOnly */ .Db)(nabp)) error = "NABP e-Profile ID should consist of digits.";
    return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(error === null, error);
  },
  validateNabpBirthDate: function validateNabpBirthDate(birthdate, nabp) {
    if (nabp && !birthdate) return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(false, "Required if NABP e-Profile ID is populated.");
    if (birthdate && !(0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isMonthAndDayDateFormat */ .F$)(birthdate)) return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(false, "Enter a date.");
    return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(true, null);
  },
  validateNabpRole: function validateNabpRole(nabpRole, nabp) {
    var error = null;
    if (nabp && !nabpRole) error = "Required if NABP e-Profile ID is populated.";
    return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(error === null, error);
  }
};

/***/ }),

/***/ 4708:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Db: () => (/* binding */ isDigitsOnly),
/* harmony export */   F$: () => (/* binding */ isMonthAndDayDateFormat),
/* harmony export */   G9: () => (/* binding */ isValidNpi),
/* harmony export */   b5: () => (/* binding */ isValidUserName),
/* harmony export */   cJ: () => (/* binding */ isValidEmailFormat),
/* harmony export */   uJ: () => (/* binding */ isNullOrEmpty),
/* harmony export */   vQ: () => (/* binding */ createValidationResult)
/* harmony export */ });
/* unused harmony exports isValidIdentifier, isValidSiloNumber, exceedsMaxLength, isValidDecimalFormat, isValidName, isHex, isStandardKeyboardCharset, isStandardKeyboardCharsetWithRows, isHtmlDisplaySafeCharset, isDateFormat, isTimeFormat, isDecimalFormat, isNotEmptyDecimalFormat, isIntegerPositiveFormat, isIntegerPositiveFormatFixed, isDecimalCharset, isLimitedDecimalCharset, isPositiveDecimalCharset, isPositiveCharset, doNotAllowBackspace */

var isNullOrEmpty = function isNullOrEmpty(value) {
  return !value || value.trim().length === 0;
};
var isValidIdentifier = function isValidIdentifier(value) {
  return value && value.toString().length > 0 && value > 0;
};
var isValidSiloNumber = function isValidSiloNumber(value) {
  return !value || value && value.toString().length > 0 && value > 0;
};
var exceedsMaxLength = function exceedsMaxLength(value, maxLength) {
  return !value || value.trim().length > maxLength;
};
var isValidEmailFormat = function isValidEmailFormat(value) {
  /* eslint-disable */
  var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(value);
};
var isValidDecimalFormat = function isValidDecimalFormat(value) {
  var decimalCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var regex = new RegExp("(^-?\\d+(.\\d{1," + decimalCount + "})?$)");
  return regex.test(value);
};
var isDigitsOnly = function isDigitsOnly(value) {
  var regex = /^[0-9]*$/;
  return regex.test(value);
};
var isValidName = function isValidName(value) {
  // Starts end ends with literal. Can contain ".", "-", "'" and space. Can be one character.
  /* eslint-disable */
  var regex = /(^[a-zA-Z]+[a-zA-Z\s.'\-]*[a-zA-Z]+$)|(^[a-zA-Z]$)/;
  return regex.test(value);
};
var isValidUserName = function isValidUserName(value) {
  // Starts end ends with literal. Can contain ".", "-", "'" and space. Can be one character.
  var regex = /(^[a-zA-Z]+[a-zA-Z\s.'-]*[a-zA-Z.'-]+$)|(^[a-zA-Z]$)/;
  return regex.test(value);
};
var isHex = function isHex(value) {
  var hex = parseInt(value, 16);
  return hex.toString(16) === value.toLowerCase();
};
var createValidationResult = function createValidationResult(isValid, error) {
  return {
    isValid: isValid,
    error: error
  };
};
var isStandardKeyboardCharset = function isStandardKeyboardCharset(value, additionalPattern) {
  var regexString = "^$|[\\w\\s\\!\\@\\#\\$\\%\\&\\'\\(\\)\\*\\+\\,\\-\\.\\:\\;\\<\\=\\>\\?\\^\\/\\`\\{\\}\\[\\]\\|\\~\"\\\\" + additionalPattern + "]+$";
  var regex = new RegExp(regexString);
  return regex.test(value);
};
var isStandardKeyboardCharsetWithRows = function isStandardKeyboardCharsetWithRows(value) {
  return isStandardKeyboardCharset(value, "\\r\\n");
};
var isHtmlDisplaySafeCharset = function isHtmlDisplaySafeCharset(value) {
  return isStandardKeyboardCharset(value, "¡¢£¤¥¦§¨©ª«¬1®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿŒœŠšŸŽž");
};
var isDateFormat = function isDateFormat(value) {
  var date = /(^$|(^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20|21)\d{2})+$)/;
  return date.test(value);
};
var isTimeFormat = function isTimeFormat(value) {
  var regex = /^[0-2]\d:[0-5]\d$/;
  return regex.test(value);
};
var isDecimalFormat = function isDecimalFormat(value) {
  var regex = /(^$|^-?\d+(\.\d{1,3})?$|^-?\.\d{1,3}$)/;
  return regex.test(value);
};
var isNotEmptyDecimalFormat = function isNotEmptyDecimalFormat(value) {
  var regex = /^-?\d+(\.\d{1,3})?$|^-?\.\d{1,3}$/;
  return regex.test(value);
};
var isIntegerPositiveFormat = function isIntegerPositiveFormat(value) {
  var regex = /^[1-9]\d*$/;
  return regex.test(value);
};
var isIntegerPositiveFormatFixed = function isIntegerPositiveFormatFixed(value, numbersCount) {
  var regex = new RegExp("^[1-9]\\d{0," + (numbersCount - 1) + "}$");
  return regex.test(value);
};
var isDecimalCharset = function isDecimalCharset(value) {
  var decimalCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var regex = new RegExp("(^$|^-?\\d*\\.?(\\d{1," + decimalCount + "})?$)"); // /(^$|^-?\d*\.?(\d{1,2})?$)/;
  return regex.test(value);
};
var isLimitedDecimalCharset = function isLimitedDecimalCharset(value, integerCount, decimalCount) {
  var regex = new RegExp("(^(^$|^-)?\\d{0," + integerCount + "}?(\\.\\d{0," + decimalCount + "})?)$"); //   /(^\d{0,2}?(\.[0-9]{0,2})?)$/
  return regex.test(value);
};
var isPositiveDecimalCharset = function isPositiveDecimalCharset(value, integerCount, decimalCount) {
  var regex = new RegExp("(^\\d{0," + integerCount + "}?(\\.\\d{0," + decimalCount + "})?)$"); //   /(^\d{0,2}?(\.[0-9]{0,2})?)$/
  return regex.test(value);
};
var isPositiveCharset = function isPositiveCharset(value) {
  var integerCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 18;
  var regex = new RegExp("(^\\d{0," + integerCount + "})$");
  return regex.test(value);
};
var doNotAllowBackspace = function doNotAllowBackspace(event, textInput) {
  var value = event.target.value;
  if (value.length === 1 && backSpacePressed(event)) {
    event.preventDefault();
    textInput.select();
  }
};

// https://www.eclaims.com/articles/how-to-calculate-the-npi-check-digit/
var isValidNpi = function isValidNpi(npi) {
  if (!npi) return false;
  if (npi.length !== 10) return false;
  var sum;
  sum = sumDigits(npi[8] * 2) + sumDigits(npi[6] * 2) + sumDigits(npi[4] * 2) + sumDigits(npi[2] * 2) + sumDigits(npi[0] * 2) + 24;
  sum += +npi[1] + +npi[3] + +npi[5] + +npi[7];

  //Subtract the next highest number divisible by 10 from the sum (gives us check digit)
  if (sum % 10 !== 0) {
    sum = sum + (10 - sum % 10) - sum;
  } else {
    sum = 0; //Check digit must be zero
  }
  //Check if our calculated check-digit matches the one originally provided by the user
  return sum === +npi[9];
};
var sumDigits = function sumDigits(number) {
  var sum = 0;
  while (number > 0) {
    sum += number % 10;
    number = Math.trunc(number / 10);
  }
  return sum;
};
var isMonthAndDayDateFormat = function isMonthAndDayDateFormat(value) {
  var date = /(^$|(^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01]))+$)/;
  return date.test(value);
};

/***/ }),

/***/ 5355:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accordion{box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0px rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}.accordion .accordion-header-container{padding:0 16px;display:inline-flex;justify-content:space-between;align-items:center;cursor:pointer;width:100%;height:48px}.accordion .accordion-header-container .accordion-header-icon-container{transform:rotate(0);transition:transform 200ms ease-in-out}.accordion .accordion-header-container:focus-visible{outline:none;background-color:#ececec}.accordion .accordion-content-container{display:none}.accordion.expanded .accordion-header-container{height:64px}.accordion.expanded .accordion-header-container .accordion-header-icon-container{transform:rotate(-180deg)}.accordion.expanded .accordion-content-container{display:flex;padding:10px 16px 0 16px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 9530:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sl-checkbox{display:table;padding-bottom:10px;text-align:right}.sl-checkbox>div{padding:4px 2px 3px 2px;display:table-cell;vertical-align:middle}.sl-checkbox>div .icon{font-size:40px;line-height:40px}.sl-checkbox>div.blueCheckBox{padding:2px 5px 1px 5px;outline:none;vertical-align:middle}.sl-checkbox>div.blueCheckBox input[type=checkbox]:checked+i{color:#007ac3}.sl-checkbox>div.blueCheckBox:focus{outline:#a6c7ff solid 2px}.sl-checkbox .inactive{color:#999}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 7316:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-loader{width:98%;height:98%;border:4px dashed #999;border-radius:5px;margin:auto auto 8px;min-height:150px}.file-loader .overlay-help-text{margin-top:20px;text-align:center}.file-loader .additional-helper-text{font-style:italic;color:#474747;text-align:center}.file-loader.overlay{border:4px dashed #80bde1;background-color:#ddd}.file-loader .file-loader-header{width:300px;padding:20px;margin:auto}.file-loader .file-description-loading,.file-loader .file-description{max-width:70%;margin:0 auto 12px}.file-loader .file-description-loading .long-row-truncate,.file-loader .file-description .long-row-truncate{max-width:70%;width:auto}.file-loader .file-description-loading .file-uploaded-icon,.file-loader .file-description .file-uploaded-icon{color:#85bc20;vertical-align:middle;height:100%;margin-right:4px}.file-loader .file-description-loading .file-uploaded-icon.failure,.file-loader .file-description .file-uploaded-icon.failure{color:#999}.file-loader .file-description-loading .file-uploaded-size,.file-loader .file-description .file-uploaded-size{color:#999;margin-left:10px}.file-loader .file-description-loading .file-loading-progress-bar,.file-loader .file-description-loading .loading-progress-bar,.file-loader .file-description .file-loading-progress-bar,.file-loader .file-description .loading-progress-bar{background-color:#a6d1ea !important}.file-loader .file-description-loading .file-loading-progress-bar>div,.file-loader .file-description-loading .loading-progress-bar>div,.file-loader .file-description .file-loading-progress-bar>div,.file-loader .file-description .loading-progress-bar>div{background-color:#007ac3}.file-loader .file-description-loading .file-delete-icon,.file-loader .file-description .file-delete-icon{margin-left:0;margin-right:5px;position:relative;top:5px;color:#999;font-size:16pt}.file-loader .file-description-loading .file-delete-icon:hover,.file-loader .file-description .file-delete-icon:hover{cursor:pointer}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 2818:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#pageTitle{padding:10px 20px;margin:20px 0;line-height:28px;word-wrap:break-word}#pageTitle .back-link:focus{outline:2px solid #a6c7ff}#pageTitle>div{text-align:center}#pageTitle>div a{float:left;color:#212121;cursor:pointer;text-decoration:none}#pageTitle>div a:hover{color:#007ac3}header{height:60px;max-height:60px;width:100%;position:fixed;top:0;z-index:20;font-family:\"Fira Sans\"}header .header{height:60px;display:table;width:100%;border-spacing:0;border-collapse:collapse}header .header .logout-badge{border-radius:20px;text-transform:uppercase;height:40px;width:40px;line-height:40px;cursor:pointer;padding:10px;vertical-align:middle;white-space:nowrap;background-color:#fff;font-family:\"Inter\";display:inline-table}header .header button:focus{outline:none}header .header>div{display:table-cell;vertical-align:middle}header .header .header-title{padding-right:20px;width:90px;font-weight:300}header .header .header-title .reg-mark{top:-0.5em;font-size:75%;line-height:0;position:relative;vertical-align:baseline}header .header .header-divider{padding:0 20px;font-size:30px;font-weight:lighter;width:56px;color:#75dada}header .header .header-app-info{padding-left:20px}header .header .header-app-info .ion-md-apps{font-size:24px;width:15px;vertical-align:middle;padding-right:20px}header .header .header-app-info .header-app-title{white-space:nowrap;cursor:pointer}header .header .header-app-info .header-app-title>div{display:inline-block;vertical-align:middle;font-weight:400;white-space:nowrap}header .header .header-app-info .header-app-title.single{cursor:default}header .header .header-global-search{width:100%;text-align:right}header .header .header-global-search .searchButton{color:#fff;min-width:max-content;padding-left:5px}header .header .header-global-search .icon-magnifier{text-align:right;font-size:24px;cursor:pointer}header .header .header-global-search .search-widget{background-color:#fff}header .header .header-global-search .search-widget input,header .header .header-global-search .search-widget .icon{background-color:#fff;color:#212121}header .header .header-global-search .mobile-icon-hide,header .header .header-global-search .global-search-hide{display:none}header .header .header-user-abbreviation{padding-right:30px}header .header .header-location-menu-name{white-space:nowrap}header .header .header-location-menu-name>div{padding:6px 10px;vertical-align:middle;white-space:nowrap}header .header .header-location-menu-name>div .organization-name{padding-right:5px}header .header .header-location-menu-button{white-space:nowrap;cursor:pointer}header .header .header-location-menu-button>div{cursor:pointer;padding:6px 10px;vertical-align:middle;white-space:nowrap}header .header .header-location-menu-button>div .organization-name{padding-right:5px}header .header .header-location-menu-button.active>div,header .header .header-location-menu-button:hover>div{border-radius:20px;color:#212121;background-color:#fff}header .header .header-location-menu-button.active>div span,header .header .header-location-menu-button:hover>div span{color:#212121}header .header .header-location-menu-button.active>div .ion-md-arrow-dropdown,header .header .header-location-menu-button:hover>div .ion-md-arrow-dropdown{visibility:visible}header #skipToMainContent{padding:6px;position:absolute;top:-60px;left:0;border-right:1px solid;border-bottom:1px solid;border-bottom-right-radius:8px;-webkit-transition:top .5s ease-out;transition:top .5s ease-out;z-index:100}header #skipToMainContent:focus{top:0;transition:top .05s ease-in;width:auto;height:auto}.menu-label{margin:8px 20px 0 0;font-weight:bold;float:left}.avatar-label-link{width:164px}.right-user-menu{background:#fff;border-left:1px solid #eee;max-width:360px;position:fixed;top:60px;bottom:0;z-index:1000;right:0;color:#212121;display:grid;grid-auto-rows:min-content;grid-template-rows:min-content min-content min-content auto}.right-user-menu a{color:#007ac3}.right-user-menu .panel-section{padding:20px}.right-user-menu .panel-section>hr{width:212px;margin-left:auto;margin-right:auto}.right-user-menu .panel-section.userProfile>div{margin-top:16px}.right-user-menu .panel-section .info-badge{display:inline-block;text-align:center;vertical-align:middle;font-weight:normal;font-size:26px;padding:1px;text-transform:uppercase;height:62px;width:62px;line-height:62px;background-color:#007ac3;color:#fff;border-radius:36px}.right-user-menu .panel-section .profileEmail{font-weight:400}.right-user-menu .panel-section.userInfo{border-top:1px solid #eee;border-bottom:1px solid #eee}.right-user-menu .panel-section.userInfo>div{display:table-row;width:100%}.right-user-menu .panel-section.userInfo>div .infoLabel{width:100px;min-width:100px;white-space:nowrap;color:#999}.right-user-menu .panel-section.userInfo>div>*{width:100%;display:table-cell}.right-user-menu .panel-section.center{text-align:center;line-height:25.6px}.right-user-menu .panel-section.center>div{vertical-align:middle;width:100%}.right-user-menu .panel-section.bottom-border{border-bottom:1px solid #eee}.right-user-menu .panel-section.technical-support{padding:24px}.right-user-menu .panel-section.technical-support>div>a,.right-user-menu .panel-section.technical-support>div span{vertical-align:middle;width:100%;display:inline-block}.right-user-menu .panel-section.technical-support>div>a>span{display:inline}.right-user-menu .panel-section.technical-support>div>span{font-weight:bold}.right-user-menu .panel-section.technical-support .product-training{padding-bottom:20px}.right-user-menu .panel-section.technical-support .outbound-icon{margin-left:3px}.right-user-menu .brand-display{display:inline;margin:auto 0 0 auto}#left-menu{font-family:\"Inter\"}#left-menu .left-menu-title{color:#474747}.menu-visible .left-menu-select-product{left:0;width:250px}.menu-visible .right-user-menu,.menu-visible .right-smooth-menu{right:0}.menu-invisible .left-menu-select-product{left:-100%}.menu-invisible .right-user-menu,.menu-invisible .right-smooth-menu{right:-100%}.left-menu-select-product{position:fixed;top:0;bottom:0;left:0;z-index:1000;max-width:250px;color:#fff;overflow-y:auto;overflow-x:hidden;background:#003d61}.left-menu-select-product .product-icon,.left-menu-select-product .product-portfolio{color:#9cb0be}.left-menu-select-product .svg-icon{width:24px;height:24px}.left-menu-select-product .svg-icon path{fill:#9cb0be}.left-menu-select-product .app-button,.left-menu-select-product .ion-md-apps{cursor:pointer;width:35px;color:#fff !important}.left-menu-select-product .app-list{padding-top:20px;margin:0;list-style:none;position:relative;width:100vw}.left-menu-select-product .app-list .sidebar-item>a,.left-menu-select-product .app-list .sidebar-item>span{padding:0 10px 0 20px;display:flex;align-items:center}.left-menu-select-product div.sidebar-item{padding:0 10px 0 20px}.left-menu-select-product .sidebar-item{opacity:1;transition:none;display:block;min-height:40px}.left-menu-select-product .sidebar-item.solesource-title{margin:10px 0 0 0;font-size:20px;font-weight:500}.left-menu-select-product .sidebar-item.app-button{margin-top:20px}.left-menu-select-product .sidebar-item a{color:#fff;display:block;vertical-align:middle;width:100%;text-decoration:none}.left-menu-select-product .sidebar-item a .product-icon{padding-right:5px;font-size:22px;vertical-align:middle;width:30px;display:inline-block;height:40px;line-height:40px}.left-menu-select-product .sidebar-item a .product-title{font-weight:400;white-space:normal;display:inline-table;font-size:14px}.left-menu-select-product .sidebar-item a.locked{color:#999;cursor:not-allowed;text-decoration:none}.left-menu-select-product .sidebar-item a:hover{background-color:#076b9a}.hasNoNabpCheckBox{padding-left:0}.no-nabp-warning{color:#ac1822;font-weight:bold}.modal-dialog-header,.modal-dialog-body{color:#000}.warning-bullets{margin-left:17px}.btn.back-button{color:#007ac3;background-color:unset;border:1px solid #007ac3}.warning-dialog-title{color:#ac1822}@media(max-width: 544px){#pageTitle .backText{display:none}#pageTitle .ion-ios-arrow-back{font-size:24px}#pageTitle div:first-child{line-height:48px}#pageTitle .col-xs-10{line-height:50px;vertical-align:middle;min-height:48px}.header-mobile-menu{padding:0 15px 0 10px;font-size:24px;width:30px}header .header-global-search-hide .header-global-search{width:30px}header .header-global-search-hide .header-app-info{padding-left:15px}header .header-global-search-hide .header-app-info .ion-md-apps{padding-right:15px}.header-global-search-active .header-app-info,.header-global-search-active .header-mobile-menu{display:none}.header-global-search-active .search-widget{height:60px}.header-global-search-active .search-widget .search-text,.header-global-search-active .search-widget .icon-cancel,.header-global-search-active .search-widget .icon-magnifier{line-height:58px;height:58px}}@media(min-width: 544px)and (max-width: 992px){.header-user-abbreviation{padding-right:20px !important}}@media print{#skipToMainContentContainer{display:none}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 1926:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left-icon,.right-icon{margin-top:3px}.left-icon{float:left}.right-icon{float:right}.fixed-icon{width:25px;display:inline-block;text-align:center}.icon-button-p1s-common{width:90px;height:33px;padding:0}.icon-button-p1s-common .fixed-icon{vertical-align:middle;margin-bottom:2px}.icon-button-p1s-common:focus{outline:1px solid #007ac3;outline-offset:0}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 4310:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#mobile-menu{overflow-y:auto;font-family:\"Inter\";position:fixed;top:60px;bottom:0;right:0;z-index:1000;width:100%;background:#003d61;color:#fff}#mobile-menu.mobile-menu-hidden{right:-100%}#mobile-menu.mobile-menu-showed{right:0}#mobile-menu .mobile-menu-title{text-decoration:none;line-height:25px}#mobile-menu .mobile-menu-title span{font-size:16px;padding-right:10px;vertical-align:middle;font-weight:lighter}#mobile-menu .mobile-menu-current-location{position:relative;cursor:pointer}#mobile-menu .mobile-menu-current-location>span:first-child{font-weight:400;padding-left:20px}#mobile-menu .mobile-menu-current-location .ion-ios-arrow-down{position:absolute;right:5px}#mobile-menu .mobile-menu-profile{cursor:pointer}#mobile-menu .mobile-menu-divider{height:2px;background:#a3a3a3}#mobile-menu>div{margin:20px 20px;vertical-align:middle}#mobile-menu .left-menu-links{padding-left:0;display:block;width:100%}#mobile-menu .left-menu-links .linkItem{line-height:50px;vertical-align:middle}#mobile-menu .left-menu-links .linkItem>a{cursor:pointer;padding:0 20px;font-weight:300;display:block;color:#fff}#mobile-menu .left-menu-links .linkItem>a .link-icon{padding-right:10px;font-size:20px;vertical-align:middle}#mobile-menu .left-menu-links .linkItem>a.active{background:#007ac3}#mobile-menu .left-menu-links .linkItem>a.active span{color:#fff}#mobile-menu a{color:#fff}#mobile-menu .left-menu-row,#mobile-menu .mobile-menu-current-location{text-decoration:none;line-height:30px}#mobile-menu .mobile-menu-current-user-row div:first-child{padding-bottom:4px}#mobile-menu .mobile-menu-current-user-row small{font-weight:lighter}#mobile-menu .mobile-technical-support div>span,#mobile-menu .mobile-technical-support a{display:block}#mobile-menu .mobile-technical-support div{margin-bottom:24px}#mobile-menu .mobile-technical-support span{font-weight:bold}#mobile-menu .mobile-technical-support a{text-decoration-line:underline}#mobile-menu .mobile-technical-support .outbound-icon{text-decoration-line:underline;font-weight:normal;margin-left:3px}@media(min-width: 545px){#mobile-menu{display:none}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 8247:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#left-menu{background:#fff;border-right:1px solid #dadada;width:250px;min-width:250px;top:60px;position:fixed;height:100%;overflow-y:auto}#left-menu>div{height:calc(100% - 60px)}#left-menu .left-menu-title{padding-right:10px;padding-left:16px;color:gray;text-transform:uppercase;font-size:12px}#left-menu .left-menu-toggle-icon{float:right;padding-right:10px;cursor:pointer}#left-menu .left-menu-toggle-icon .collapse-icon{background:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAyNyAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMC41IDFMMjYuNSAxIiBzdHJva2U9IiM0NzQ3NDciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPg0KPHBhdGggZD0iTTEwLjUgNkwyNi41IDYiIHN0cm9rZT0iIzQ3NDc0NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+DQo8cGF0aCBkPSJNMTAuNSAxMUwyNi41IDExIiBzdHJva2U9IiM0NzQ3NDciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPg0KPHBhdGggZD0iTTYgMUwxIDZMNiAxMSIgc3Ryb2tlPSIjNDc0NzQ3IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4NCjwvc3ZnPg0K) no-repeat left center;width:27px;height:12px}#left-menu .left-menu-toggle-icon .extend-icon{background:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAyNyAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0wLjUgMS4yMjk0OUwxNi41IDEuMjI5NDkiIHN0cm9rZT0iIzc1NzU3NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+DQo8cGF0aCBkPSJNMC41IDUuNTc5MUwxNi41IDUuNTc5MSIgc3Ryb2tlPSIjNzU3NTc1IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4NCjxwYXRoIGQ9Ik0wLjUgOS45MjgyMkwxNi41IDkuOTI4MjIiIHN0cm9rZT0iIzc1NzU3NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+DQo8cGF0aCBkPSJNMjEgOS45MjgyMkwyNiA1LjU3ODg1TDIxIDEuMjI5NDgiIHN0cm9rZT0iIzc1NzU3NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+DQo8L3N2Zz4NCg==) no-repeat left center;width:27px;height:12px}#left-menu .left-menu-toggle-icon .collapse-icon,#left-menu .left-menu-toggle-icon .extend-icon{margin-top:17px}#left-menu .left-menu-toggle-icon .ion-md-menu{font-size:25px;vertical-align:middle}#left-menu .left-menu-links-container{width:100%;height:calc(100% - 60px);overflow-y:auto}#left-menu .left-menu-links-container>div,#left-menu .left-menu-links-container ul{width:100%}#left-menu .left-menu-links{padding-left:0;width:100%}#left-menu .left-menu-links .linkItem>a>div{border-left:2px solid #fff;display:block;color:#212121;cursor:pointer;line-height:45px}#left-menu .left-menu-links .linkItem>a span.link-icon{font-size:25px;padding-right:10px;padding-left:10px;vertical-align:middle;color:gray}#left-menu .left-menu-links .linkItem>a .link-name{font-weight:500;font-size:14px}#left-menu .left-menu-links .linkItem>a.active>div,#left-menu .left-menu-links .linkItem>a:hover>div{border-left:2px solid #007ac3;color:#007ac3;background:#e6f2f9}#left-menu .left-menu-links .linkItem>a.active>div span,#left-menu .left-menu-links .linkItem>a:hover>div span{color:#007ac3}#left-menu .left-menu-row{text-decoration:none;line-height:45px}#left-menu .left-menu-footer>div{border-top:1px solid #dadada;margin:0;text-align:center;height:70px;padding:15px 0;display:block}#left-menu .smallLogo{margin:0 auto;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAADr0lEQVR4AbWWaUwTQRSAX7GllEoV5YeYWJTDYlUkikcoGqKICMohGNRioIpc0cYLr2BBI4qCF0akVYxulWA0WOsBKAhtUCqaiiSiVKMl4g+IMeoPRY6OM1Swy5JoIt3ka3c3M+/rm337pgDDHWwOy2mCp2B8QPjcGQeuZ+ZUt7ern3SioWzRmj9AKrUVJvsHAN/NBViOrOHCMe6NcuJzx0XK/P1OVl+QUG87JWqT5UDNR4aACOV32hDkGS2QreuATZoi8EvzAy7fkRHU9gbbWTBaGLs1Y77a9AgHRwP8RUJEVo4Y6yE0YyPwXJxt4w6eY4FzUNo6hfxuXsf2hyeQLVTTLVTVqmOQ31CCltyQ0wi+ktHuvi56M/AEvMHg5AQvEUcYuy1p/fWrH4807EDHnshpaF6rkN6sYVDclIOSHiylIa1cYfE4ozTjjNbgpWNbRSwWjJkXJp59qUWXqC1H/y9ZiYTFagSHG2tgZogIcHxgu7jypu+lDpH1H1EJKYhkpQL4rk7gMnW277zip+/sIEGgqDOBh783uIfJIrGg2y6SPGMXSBLCIeu26TIpUcJZw2NU/qoEkQdtS9OpTGTenMzgbrEM7X9EZ48+FS0uu4V8VS39iE4/ywfK0PF14E3WNDcj3Xsto4qI4HPAIgb1ilW0KiRVebhhJ4q7WTn4jgVSrZ8ACyz2lEio1p9EMtgy7JGJhDL1gdrQ2TMgso8EZ4KfyWd7SgLVpnZIv/ayME1rRoSs2hp0/sVxdLH5KI3qgg2oMSOKQVnRarSvPpFGpi4FBZdqkI+yxUpWmQL665jUM+6kwgvnkLQqgtaLSG8iZTq0n5HrPXopY6y08ndb6e/Mz7/j1hIKMHmWF2TXtdhFkqM3guccD8C9hQvJqt1Y0jPCmXQ5pCrl44ReeBMjXXJmoDfk3q/AEssILZcFUkzaKRL5lGUREWOs7Z7r7ACh6VGTik6+ia+I6k2oWt5ny7765L48wzYGu3SJtHFkTnxFdO+kQtUrCEkPF89dwAmLjBVbJeSTJ+AK1sbJvFS5Rp9LBV9siblZ8iXlXimDqHLVN9tx5NxbmdvouiY+Bm/BnLFubqPEkiD+H4lV5IgzioEUVTV+RhZSDATS7EiXHgq5PzAGf/fCJlUVzmAl/sEceuChV2TpJopEWHQQ/wtpw5O7/yLpxtX5HhePAtxFPuCI5//TQYqB78rDG44YFias9j3zrDaQMv2wzQRffxcVPq2FIGkcHjetfwck84Y5fgFCf1tlM6DoNQAAAABJRU5ErkJggg==) no-repeat left center;width:25px;height:25px}#left-menu .bigLogo{margin:0 auto;width:190px;height:31px;background:url(data:image/svg+xml;base64,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) no-repeat center center}@media(min-width: 545px){#left-menu.left-menu-collapsed{width:50px;min-width:50px}#left-menu.left-menu-collapsed .left-menu-title,#left-menu.left-menu-collapsed .linkItem>a>div>.link-name{display:none}#left-menu.left-menu-collapsed .left-menu-footer{width:50px}#left-menu.left-menu-collapsed .bigLogo{display:none}#left-menu.left-menu-extended{display:block}#left-menu.left-menu-extended .left-menu-footer{width:250px}#left-menu.left-menu-extended .smallLogo{display:none}}@media(max-width: 545px){#left-menu{width:100%;z-index:10}#left-menu.left-menu-extended,#left-menu.left-menu-collapsed{display:none}#left-menu li.menu-item{padding-right:10px}}@media(min-width: 545px)and (max-width: 993px){#left-menu{z-index:10}#left-menu.left-menu-extended{display:block;height:100%}.left-menu-collapsed{width:50px;min-width:50px}.left-menu-collapsed .left-menu-title,.left-menu-collapsed .linkItem>a>div>.link-name{display:none}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 9682:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#location-menu{position:fixed;-webkit-backface-visibility:hidden;top:60px;width:100%;height:100%;background:#fff;z-index:20;overflow-y:auto}#location-menu .location-menu-header-search-close{display:table;width:100%}#location-menu .location-menu-header-search-close>div{display:table-cell}#location-menu .location-menu-header-search-close .location-menu-header-search-container{width:100%}#location-menu .location-menu-header-search-close .search-widget{margin:10px;height:40px;border-radius:20px;line-height:38px}#location-menu .location-menu-header-search-close .search-widget .icon{line-height:38px;font-size:22px}#location-menu .location-menu-header-search-close .search-widget .icon-cancel{display:none}#location-menu .location-menu-header-search-close .search-widget .search-text{line-height:36px;height:36px;width:92%}#location-menu .location-menu-header-search-close .location-menu-close{display:inline-block;padding:0 20px;width:60px;cursor:pointer}#location-menu .location-menu-organizations{margin-bottom:60px}#location-menu .row-list{font-family:\"Inter\"}#location-menu .row-list .location-info,#location-menu .row-list .location-tags,#location-menu .row-list .location-is-current{display:table-cell;vertical-align:middle}#location-menu .row-list .location-is-current{text-align:right}#location-menu .row-list .locationName{font-weight:700;font-size:14px}#location-menu .row-list .suborganization{padding-left:40px !important}#location-menu .row-list .suborganization .locationName{font-weight:500 !important}#location-menu .row-list .organization-row{padding:10px;cursor:pointer;width:100%;display:table;white-space:nowrap;border-left:2px solid rgba(0,0,0,0)}#location-menu .row-list .organization-row:hover,#location-menu .row-list .organization-row.active{border-left:2px solid #337ab7;background:#f0f8ff}#location-menu .row-list .organization-row:not(:last-child){border-bottom:1px solid #eee}#location-menu .row-list .organization-row>div{display:table-row}#location-menu .row-list .organization-row small{font-size:75%;color:gray;font-weight:300}#location-menu .row-list .organization-row .location-tags{padding-left:30px;width:100%}#location-menu .row-list .organization-row .location-tags>div{background:gray;color:#fff;padding:1px 5px;margin-right:5px;font-size:13px;vertical-align:middle;float:left}#location-menu .row-list .organization-row .location-info>div{display:inline-block;height:100%;vertical-align:middle}#location-menu .location-menu-header{display:table;margin-bottom:10px}#location-menu .location-menu-header>div{display:table-cell}#location-menu .location-menu-header .location-menu-tags-container{width:100%}#location-menu .location-menu-header .location-menu-icons{width:100px;text-align:center;min-width:100px;vertical-align:middle;margin-bottom:10px}#location-menu .location-menu-header .location-menu-icons .material-icons{border:1px solid #dadada;font-size:20px;margin-right:10px;padding:7px 7px;border-radius:28px;text-align:center;font-weight:bolder;cursor:pointer}#location-menu .location-menu-header .location-menu-icons .material-icons:hover{border:1px solid #212121;background:#212121;color:#fff}#location-menu .location-menu-header .location-menu-icons .material-icons.selected{border:1px solid #212121;background:#212121;color:#fff}#location-menu .location-menu-tags{clear:both;margin:0 5px;width:100%}#location-menu .location-menu-tags>div{border:1px solid #dadada;margin:5px;padding:5px 10px;color:#007ac3;clear:both;cursor:pointer;display:inline-block;border-radius:3px;-moz-border-radius:3px;-webkit-border-radius:3px;font-size:12px}#location-menu .location-menu-tags>div.selected{background:#007ac3;color:#fff;border:1px solid #007ac3}#location-menu .location-menu-tags-expand{padding:5px 12px;color:#007ac3;clear:both;cursor:pointer;font-size:12px}#location-menu .location-menu-tags-expand span{padding-right:5px}@media(max-width: 544px){#location-menu .organization-row .location-info .location-contacts,#location-menu .organization-row .location-info .location-tags{display:block !important;width:100%;padding-left:0 !important}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 8851:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-dialog-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:30;background-color:#000;opacity:.5}@media(min-width: 992px){.modal-dialog-width{width:600px}}.modal-dialog-inner-content{display:block;position:fixed;background-color:#fff;border:1px solid rgba(0,0,0,.2);top:200px;left:0;right:0;margin-left:auto;margin-right:auto;z-index:40;box-shadow:0 27px 24px 0 rgba(0,0,0,.2),0 40px 77px 0 rgba(0,0,0,.22);background-clip:padding-box}.modal-dialog-inner-content .modal-dialog-header{padding:24px 24px 0}.modal-dialog-inner-content .modal-dialog-header .close-button{padding:2px 5px;background:rgba(0,0,0,0);margin-top:-2px}.modal-dialog-inner-content .modal-dialog-header .close-button:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5}.modal-dialog-inner-content .modal-dialog-header h2.modal-title{font-size:24px;width:95%;margin:0;padding:0;font-family:unset;font-weight:unset;line-height:28px;display:inline-block}.modal-dialog-inner-content .modal-dialog-body{padding:24px 24px 16px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 9802:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-pending{display:inline-block;line-height:49px}.btn-pending .hiddenBtn{left:-9999px;position:absolute}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 6335:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup{position:relative;display:inline-block;user-select:none}.popup .popup-context{visibility:hidden;user-select:none;background-color:#fff;color:#212121;text-align:center;padding:20px 0;position:absolute;z-index:1;top:0;border:1px solid rgba(0,0,0,.15);box-shadow:0 6px 12px rgba(0,0,0,.175);border-radius:2px}.popup .popup-context.left-side-popup{left:0}.popup .popup-context.right-side-popup{right:0;left:unset}.popup .popup-context.show{z-index:1000;visibility:visible}.popup .popup-context ul{padding:0;list-style:none}.popup .popup-context ul li{padding:0 20px;list-style-type:none;text-align:left;white-space:nowrap;vertical-align:middle}.popup .popup-context ul li:hover:not([disabled]){background-color:#f5f5f5;cursor:pointer}.popup .popup-context ul li[disabled]{cursor:default;opacity:.3}@-webkit-keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}.popupContainer{position:relative;top:0;right:0}.popupContainer span.more-link{font-size:21px;padding:0 11px}.popupContainer span.more-link:hover{cursor:pointer;background-color:#cecece;border-radius:50%}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 3276:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#profile .italic{font-style:italic}#profile .inactive{color:#999}#profile .inactive .dark{color:#999}#profile .inactive .rightLink{display:none}#profile .icon-roles{color:#007ac3}#profile .permission-userManagement{background-color:#474747;border:2px solid #474747 !important;color:#fff !important}#profile .permission-ruleManagement{background-color:#007ac3;color:#fff !important}#profile .permission-analytics{background-color:#ea8f00;border:2px solid #ea8f00 !important;color:#fff !important}#profile div.icon-product{border-radius:100%;border:2px solid #007ac3;width:29px;height:29px;text-align:center;line-height:29px -4px !important;display:inline-block;margin-right:10px;position:relative;color:#007ac3;font-size:18px !important}#profile div.icon-product>a:hover{text-decoration:none}#profile .userDetailsProductsList{list-style:none;line-height:normal;padding:7px 0}#profile .userDetailsProductsList li{padding:3px 0;line-height:28px}#profile .userDetailsProductsList li>.icon-product{display:inline-block}#profile div.icon-product{border-radius:100%;border:2px solid #007ac3;width:29px;height:29px;text-align:center;line-height:29px -4px !important;display:inline-block;margin-right:10px;position:relative;font-size:18px !important}#profile div.icon-product>a:hover{text-decoration:none}#editExternalIds .disabled{color:gray}#editExternalIds .tooltip-container{display:inline-block;position:relative;cursor:pointer}#editExternalIds .tooltip-container .tooltip{width:auto;min-width:250px;max-width:350px;white-space:normal;word-break:normal;text-align:left}#editExternalIds .tooltip-container:hover span.tooltip{opacity:1;visibility:visible}#editExternalIds .tooltip-container .external-ids-info-icon{font-size:24px;margin-left:1px;vertical-align:bottom}#editExternalIds .nabp-date-of-birth{white-space:nowrap}#editExternalIds .has-no-nabp{margin-top:5px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 850:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radioButton{display:flex;flex-flow:row nowrap}.radioButton *{vertical-align:middle}.radioButton input[type=radio]+i{background:rgba(0,0,0,0);font-size:20px;line-height:20px;cursor:pointer}.radioButton input[type=radio]:checked+i{color:#007ac3}.radioButton .checkbox-icon{margin-right:.3vw}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 1381:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabbed-auto-suggest{position:absolute;width:200px}.tabbed-auto-suggest .dropdown-menu{display:block;left:0;z-index:1000;float:left;min-width:200px;width:100%;padding:5px 0;margin:0 0 0;list-style:none;font-size:16px;text-align:left;background-color:#fff;border:1px solid rgba(0,0,0,.15);border-radius:4px;-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175);box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box;max-height:400px;overflow-y:auto}.tabbed-auto-suggest .dropdown-menu>li.selected a,.tabbed-auto-suggest .dropdown-menu>li.selected:hover{background:#007ac3;color:#fff !important}.tabbed-auto-suggest .form-group{margin-bottom:0}.tabbed-auto-suggest input{padding:0 10px;-webkit-box-shadow:none;box-shadow:none;outline:1px solid #eee;background:#fff;border:none;width:100%}.tabbed-auto-suggest input:focus{outline:1px solid #007ac3}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 4437:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-bordered{border:1px solid #ddd}table{width:100%;border-collapse:collapse;border-spacing:0}table td{vertical-align:middle}.react-bs-table-pagination>div{margin-top:0}.react-bs-table-pagination .col-md-6{width:100%;text-align:right}.react-bs-table-pagination .col-md-6 .pagination{margin:20px 0}.react-bs-table-pagination .col-md-6 .pagination .page-item a{border-radius:0;background-color:#a6d1ea;color:#007ac3;border:none}.react-bs-table-pagination .col-md-6 .pagination .page-item.active a{background-color:#fff}.react-bs-table-pagination .col-md-6 .pagination .page-item.disabled a{background:#dadada;color:#fff;pointer-events:none}.react-bs-table-pagination .col-md-6 .pagination .hidden{display:inline-block}.react-bs-table-pagination .col-md-6 .pagination>li:last-child a{background-color:#007ac3;color:#fff}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 2983:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toggle-switch{padding-bottom:10px}.toggle-switch .toggle-icon.react-toggle--checked .react-toggle-track{background-color:#007ac3}.toggle-switch .toggle-icon.react-toggle--checked .react-toggle-thumb{border-color:#007ac3}.toggle-switch .toggle-icon.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track{background-color:#409bd2}.toggle-switch .label-clickable{color:#007ac3;cursor:pointer}.react-toggle{touch-action:pan-x;display:inline-block;position:relative;cursor:pointer;background-color:rgba(0,0,0,0);border:0;padding:0;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color:rgba(0,0,0,0)}.react-toggle-screenreader-only{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.react-toggle--disabled{cursor:not-allowed;opacity:.5;-webkit-transition:opacity .25s;transition:opacity .25s}.react-toggle-track{width:50px;height:24px;padding:0;border-radius:30px;background-color:#4d4d4d;-webkit-transition:all .2s ease;-moz-transition:all .2s ease;transition:all .2s ease}.react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track{background-color:#000}.react-toggle--checked .react-toggle-track{background-color:#007ac3}.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track{background-color:#409bd2}.react-toggle-track-check{position:absolute;width:14px;height:10px;top:0;bottom:0;margin-top:auto;margin-bottom:auto;line-height:0;left:8px;opacity:0;-webkit-transition:opacity .25s ease;-moz-transition:opacity .25s ease;transition:opacity .25s ease}.react-toggle--checked .react-toggle-track-check{opacity:1;-webkit-transition:opacity .25s ease;-moz-transition:opacity .25s ease;transition:opacity .25s ease}.react-toggle-track-x{position:absolute;width:10px;height:10px;top:0;bottom:0;margin-top:auto;margin-bottom:auto;line-height:0;right:10px;opacity:1;-webkit-transition:opacity .25s ease;-moz-transition:opacity .25s ease;transition:opacity .25s ease}.react-toggle--checked .react-toggle-track-x{opacity:0}.react-toggle-thumb{transition:all .5s cubic-bezier(0.23, 1, 0.32, 1) 0ms;position:absolute;top:1px;left:1px;width:22px;height:22px;border:1px solid #4d4d4d;border-radius:50%;background-color:#fafafa;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;-webkit-transition:all .25s ease;-moz-transition:all .25s ease;transition:all .25s ease}.react-toggle--checked .react-toggle-thumb{left:27px;border-color:#007ac3}.react-toggle--focus .react-toggle-thumb{-webkit-box-shadow:0 0 3px 2px #0099e0;-moz-box-shadow:0 0 3px 2px #0099e0;box-shadow:0 0 2px 3px #0099e0}.react-toggle:active:not(.react-toggle--disabled) .react-toggle-thumb{-webkit-box-shadow:0 0 5px 5px #0099e0;-moz-box-shadow:0 0 5px 5px #0099e0;box-shadow:0 0 5px 5px #0099e0}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 5820:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warning-container{width:100%;padding:8px;display:table}.warning-container .warning-block{border:1px solid #ffeeba;display:table-cell;padding:0 16px 0 16px;background-color:#fff3cd}.warning-container .warning-block h5{margin-top:15px;margin-bottom:15px}.warning-container .warning-block .warning-message{margin-bottom:15px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 9267:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(5355);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 3554:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(9530);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 8892:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(7316);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 7386:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(2818);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 4222:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(1926);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 1326:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(4310);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 1679:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(8247);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 8106:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(9682);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 6123:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(8851);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 7874:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(9802);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 3719:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(6335);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 8004:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(3276);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 1210:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(850);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 8589:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(1381);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 4493:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(4437);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 7023:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(2983);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 6228:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(5820);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 3027:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target, parent) {
  if (parent){
    return parent.querySelector(target);
  }
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target, parent) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target, parent);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(5592);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertAt.before, target);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	if(options.attrs.nonce === undefined) {
		var nonce = getNonce();
		if (nonce) {
			options.attrs.nonce = nonce;
		}
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function getNonce() {
	if (false) {}

	return __webpack_require__.nc;
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = typeof options.transform === 'function'
		 ? options.transform(obj.css) 
		 : options.transform.default(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ 1949:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__1949__;

/***/ }),

/***/ 9155:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__9155__;

/***/ }),

/***/ 4442:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__4442__;

/***/ }),

/***/ 2634:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 8772:
/***/ ((module) => {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 3368:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
  'use strict';

  var hasOwn = {}.hasOwnProperty;
  function classNames() {
    var classes = '';
    for (var i = 0; i < arguments.length; i++) {
      var arg = arguments[i];
      if (arg) {
        classes = appendClass(classes, parseValue(arg));
      }
    }
    return classes;
  }
  function parseValue(arg) {
    if (typeof arg === 'string' || typeof arg === 'number') {
      return arg;
    }
    if (typeof arg !== 'object') {
      return '';
    }
    if (Array.isArray(arg)) {
      return classNames.apply(null, arg);
    }
    if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
      return arg.toString();
    }
    var classes = '';
    for (var key in arg) {
      if (hasOwn.call(arg, key) && arg[key]) {
        classes = appendClass(classes, key);
      }
    }
    return classes;
  }
  function appendClass(value, newClass) {
    if (!newClass) {
      return value;
    }
    if (value) {
      return value + ' ' + newClass;
    }
    return value + newClass;
  }
  if ( true && module.exports) {
    classNames.default = classNames;
    module.exports = classNames;
  } else if (true) {
    // register as 'classnames', consistent with npm package name
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return classNames;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})();

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	(() => {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ActionButtonsPanel: () => (/* reexport */ ActionButtonsPanel["default"]),
  AppSelector: () => (/* reexport */ AppSelector/* default */.A),
  ApplicationMenu: () => (/* reexport */ ApplicationMenu/* default */.A),
  ApplicationTitle: () => (/* reexport */ ApplicationTitle/* default */.A),
  BadgeLabel: () => (/* reexport */ BadgeLabel["default"]),
  Button: () => (/* reexport */ Button["default"]),
  Caret: () => (/* reexport */ Caret["default"]),
  CheckBox: () => (/* reexport */ CheckBox/* default */.A),
  ClickableMenu: () => (/* reexport */ ClickableMenu["default"]),
  DecimalInput: () => (/* reexport */ DecimalInput["default"]),
  Divider: () => (/* reexport */ Divider/* default */.A),
  DocumentTitle: () => (/* reexport */ DocumentTitle["default"]),
  DropDown: () => (/* reexport */ DropDown["default"]),
  EmptyItemsList: () => (/* reexport */ Lists_EmptyItemsList),
  EnterNabpEPidDialog: () => (/* reexport */ EnterNabpEPidDialog/* default */.A),
  FileUpload: () => (/* reexport */ FileUpload_FileUpload),
  FormContainer: () => (/* reexport */ FormContainer["default"]),
  Glyph: () => (/* reexport */ Glyph["default"]),
  Header: () => (/* reexport */ Header["default"]),
  HeaderGlobalSearch: () => (/* reexport */ HeaderGlobalSearch/* default */.A),
  IconButton: () => (/* reexport */ IconButton["default"]),
  ItemsListHeader: () => (/* reexport */ Lists_ItemsListHeader),
  LeftMenuPage: () => (/* reexport */ LeftMenuPage["default"]),
  LeftNavigationMenu: () => (/* reexport */ LeftNavigationMenu["default"]),
  LoadingContainer: () => (/* reexport */ LoadingContainer["default"]),
  LoadingIndicator: () => (/* reexport */ LoadingIndicator["default"]),
  LocationMenuTitle: () => (/* reexport */ LocationMenuTitle/* default */.A),
  Menu: () => (/* reexport */ Menu["default"]),
  ModalDialog: () => (/* reexport */ ModalDialog/* default */.A),
  ModalDialogBody: () => (/* reexport */ ModalDialogBody/* default */.A),
  ModalDialogButtons: () => (/* reexport */ ModalDialogButtons/* default */.A),
  MultipleAutoSuggest: () => (/* reexport */ MultipleAutoSuggest["default"]),
  NavigationBar: () => (/* reexport */ NavigationBar["default"]),
  NavigationLinksList: () => (/* reexport */ NavigationLinksList/* default */.A),
  NotificationsPopup: () => (/* reexport */ NotificationsPopup["default"]),
  NumericInput: () => (/* reexport */ NumericInput["default"]),
  OptionsPopup: () => (/* reexport */ OptionsPopup/* default */.A),
  OrganizationMenu: () => (/* reexport */ OrganizationMenu/* default */.A),
  Overlay: () => (/* reexport */ Overlay["default"]),
  PendingButton: () => (/* reexport */ PendingButton["default"]),
  Popup: () => (/* reexport */ Popup/* default */.A),
  Profile: () => (/* reexport */ Profile["default"]),
  RadioButton: () => (/* reexport */ RadioButton["default"]),
  Row: () => (/* reexport */ Row["default"]),
  SearchButton: () => (/* reexport */ SearchButton["default"]),
  SearchWidget: () => (/* reexport */ SearchWidget["default"]),
  TabbedAutoSuggestControl: () => (/* reexport */ TabbedAutoSuggestControl["default"]),
  Table: () => (/* reexport */ Table["default"]),
  TextInput: () => (/* reexport */ TextInput["default"]),
  Toggle: () => (/* reexport */ Toggle["default"]),
  Tooltip: () => (/* reexport */ Tooltip/* default */.A),
  UserPanel: () => (/* reexport */ UserPanel/* default */.A),
  WarningMessage: () => (/* reexport */ WarningMessage["default"])
});

// EXTERNAL MODULE: ./src/components/Glyph.js
var Glyph = __webpack_require__(4937);
// EXTERNAL MODULE: ./src/components/Caret.jsx
var Caret = __webpack_require__(8124);
// EXTERNAL MODULE: ./src/components/WarningMessage.jsx
var WarningMessage = __webpack_require__(5552);
// EXTERNAL MODULE: ./src/components/BadgeLabel.jsx
var BadgeLabel = __webpack_require__(8312);
// EXTERNAL MODULE: ./src/components/ModalDialog/ModalDialog.jsx
var ModalDialog = __webpack_require__(1336);
// EXTERNAL MODULE: ./src/components/ModalDialog/ModalDialogBody.jsx
var ModalDialogBody = __webpack_require__(1264);
// EXTERNAL MODULE: ./src/components/ModalDialog/ModalDialogButtons.jsx
var ModalDialogButtons = __webpack_require__(6021);
// EXTERNAL MODULE: ./src/components/MultipleAutoSuggest.jsx
var MultipleAutoSuggest = __webpack_require__(9548);
// EXTERNAL MODULE: ./src/components/SearchWidget.jsx
var SearchWidget = __webpack_require__(3949);
// EXTERNAL MODULE: ./src/components/SearchButton.jsx
var SearchButton = __webpack_require__(4869);
// EXTERNAL MODULE: ./src/components/NotificationsPopup.jsx + 2 modules
var NotificationsPopup = __webpack_require__(6126);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);
// EXTERNAL MODULE: ./node_modules/attr-accept/dist/index.js
var dist = __webpack_require__(5320);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./node_modules/react-dropzone/dist/es/utils/index.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;
function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt = event.dataTransfer;

    // NOTE: Only the 'drop' event has access to DataTransfer.files,
    // otherwise it will always be empty
    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      // During the drag even the dataTransfer.files is null
      // but Chrome implements some drag store, which is accesible via dataTransfer.items
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }

  // Convert from DataTransferItemsList to the native Array
  return Array.prototype.slice.call(dataTransferItemsList);
}

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || dist_default()(file, accept);
}
function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}
function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}
function isDragDataWithFiles(evt) {
  if (!evt.dataTransfer) {
    return true;
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
  return Array.prototype.every.call(evt.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}
function isKindFile(item) {
  return (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null && item.kind === 'file';
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}
function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}
function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}
function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
;// CONCATENATED MODULE: ./node_modules/react-dropzone/dist/es/utils/styles.js
/* harmony default export */ const styles = ({
  active: {
    borderStyle: 'solid',
    backgroundColor: '#eee'
  },
  accepted: {
    borderStyle: 'solid',
    borderColor: '#6c6',
    backgroundColor: '#eee'
  },
  rejected: {
    borderStyle: 'solid',
    borderColor: '#c66',
    backgroundColor: '#eee'
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
  },
  disabled: {
    opacity: 0.5
  }
});
;// CONCATENATED MODULE: ./node_modules/react-dropzone/dist/es/index.js
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/* eslint prefer-template: 0 */





var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);
  function Dropzone(props, context) {
    _classCallCheck(this, Dropzone);
    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));
    _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === 'function') {
        return children(_extends({}, _this.state, {
          isDragActive: isDragActive,
          isDragAccept: isDragAccept,
          isDragReject: isDragReject,
          open: _this.open
        }));
      }
      return children;
    };
    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);
    _this.open = _this.open.bind(_this);
    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);
    _this.isFileDialogActive = false;
    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }
  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;
      this.dragTargets = [];
      if (preventDropOnDocument) {
        document.addEventListener('dragover', onDocumentDragOver, false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
      }
      window.addEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', this.onDocumentDrop);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
      }
      window.removeEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'composeHandlers',
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }
      return handler;
    }
  }, {
    key: 'onDocumentDrop',
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(evt) {
      evt.persist();
      if (this.props.onDragStart && isDragDataWithFiles(evt)) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(evt) {
      var _this2 = this;
      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }
      evt.persist();
      if (isDragDataWithFiles(evt)) {
        Promise.resolve(this.props.getDataTransferItems(evt)).then(function (draggedFiles) {
          if (evt.isPropagationStopped()) {
            return;
          }
          _this2.setState({
            draggedFiles: draggedFiles,
            // Do not rely on files for the drag state. It doesn't work in Safari.
            isDragActive: true
          });
        });
        if (this.props.onDragEnter) {
          this.props.onDragEnter.call(this, evt);
        }
      }
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.persist();
      try {
        // The file dialog on Chrome allows users to drag files from the dialog onto
        // the dropzone, causing the browser the crash when the file dialog is closed.
        // A drop effect of 'none' prevents the file from being dropped
        evt.dataTransfer.dropEffect = this.isFileDialogActive ? 'none' : 'copy'; // eslint-disable-line no-param-reassign
      } catch (err) {
        // continue regardless of error
      }
      if (this.props.onDragOver && isDragDataWithFiles(evt)) {
        this.props.onDragOver.call(this, evt);
      }
      return false;
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(evt) {
      var _this3 = this;
      evt.preventDefault();
      evt.persist();

      // Only deactivate once the dropzone and all children have been left.
      this.dragTargets = this.dragTargets.filter(function (el) {
        return el !== evt.target && _this3.node.contains(el);
      });
      if (this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });
      if (this.props.onDragLeave && isDragDataWithFiles(evt)) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(evt) {
      var _this4 = this;
      var _props = this.props,
        onDrop = _props.onDrop,
        onDropAccepted = _props.onDropAccepted,
        onDropRejected = _props.onDropRejected,
        multiple = _props.multiple,
        disablePreview = _props.disablePreview,
        accept = _props.accept,
        getDataTransferItems = _props.getDataTransferItems;

      // Stop default browser behavior

      evt.preventDefault();

      // Persist event for later usage
      evt.persist();

      // Reset the counter along with the drag on a drop.
      this.dragTargets = [];
      this.isFileDialogActive = false;

      // Clear files value
      this.draggedFiles = null;

      // Reset drag state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });
      if (isDragDataWithFiles(evt)) {
        Promise.resolve(getDataTransferItems(evt)).then(function (fileList) {
          var acceptedFiles = [];
          var rejectedFiles = [];
          if (evt.isPropagationStopped()) {
            return;
          }
          fileList.forEach(function (file) {
            if (!disablePreview) {
              file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
            }
            if (fileAccepted(file, accept) && fileMatchSize(file, _this4.props.maxSize, _this4.props.minSize)) {
              acceptedFiles.push(file);
            } else {
              rejectedFiles.push(file);
            }
          });
          if (!multiple && acceptedFiles.length > 1) {
            // if not in multi mode add any extra accepted files to rejected.
            // This will allow end users to easily ignore a multi file drop in "single" mode.
            rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(0)));
          }

          // Update `acceptedFiles` and `rejectedFiles` state
          // This will make children render functions receive the appropriate
          // values
          _this4.setState({
            acceptedFiles: acceptedFiles,
            rejectedFiles: rejectedFiles
          }, function () {
            if (onDrop) {
              onDrop.call(_this4, acceptedFiles, rejectedFiles, evt);
            }
            if (rejectedFiles.length > 0 && onDropRejected) {
              onDropRejected.call(_this4, rejectedFiles, evt);
            }
            if (acceptedFiles.length > 0 && onDropAccepted) {
              onDropAccepted.call(_this4, acceptedFiles, evt);
            }
          });
        });
      }
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      var _props2 = this.props,
        onClick = _props2.onClick,
        disableClick = _props2.disableClick;

      // if onClick prop is given, run it first

      if (onClick) {
        onClick.call(this, evt);
      }

      // if disableClick is not set and the event hasn't been default prefented within
      // the onClick listener, open the file dialog
      if (!disableClick && !evt.isDefaultPrevented()) {
        evt.stopPropagation();

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        if (isIeOrEdge()) {
          setTimeout(this.open, 0);
        } else {
          this.open();
        }
      }
    }
  }, {
    key: 'onInputElementClick',
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick(evt);
      }
    }
  }, {
    key: 'onFileDialogCancel',
    value: function onFileDialogCancel() {
      var _this5 = this;

      // timeout will not recognize context of this method
      var onFileDialogCancel = this.props.onFileDialogCancel;
      // execute the timeout only if the FileDialog is opened in the browser

      if (this.isFileDialogActive) {
        setTimeout(function () {
          if (_this5.fileInputEl != null) {
            // Returns an object as FileList
            var files = _this5.fileInputEl.files;
            if (!files.length) {
              _this5.isFileDialogActive = false;
            }
          }
          if (typeof onFileDialogCancel === 'function') {
            onFileDialogCancel();
          }
        }, 300);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.node = ref;
    }
  }, {
    key: 'setRefs',
    value: function setRefs(ref) {
      this.fileInputEl = ref;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */
  }, {
    key: 'open',
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
        accept = _props3.accept,
        acceptClassName = _props3.acceptClassName,
        activeClassName = _props3.activeClassName,
        children = _props3.children,
        disabled = _props3.disabled,
        disabledClassName = _props3.disabledClassName,
        inputProps = _props3.inputProps,
        multiple = _props3.multiple,
        name = _props3.name,
        rejectClassName = _props3.rejectClassName,
        rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);
      var acceptStyle = rest.acceptStyle,
        activeStyle = rest.activeStyle,
        _rest$className = rest.className,
        className = _rest$className === undefined ? '' : _rest$className,
        disabledStyle = rest.disabledStyle,
        rejectStyle = rest.rejectStyle,
        style = rest.style,
        props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);
      var _state = this.state,
        isDragActive = _state.isDragActive,
        draggedFiles = _state.draggedFiles;
      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && allFilesAccepted(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;
      if (isDragActive && activeClassName) {
        className += ' ' + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += ' ' + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += ' ' + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += ' ' + disabledClassName;
      }
      if (noStyles) {
        style = styles["default"];
        activeStyle = styles.active;
        acceptStyle = styles.accepted;
        rejectStyle = styles.rejected;
        disabledStyle = styles.disabled;
      }
      var appliedStyle = _extends({
        position: 'relative'
      }, style);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, appliedStyle, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, appliedStyle, disabledStyle);
      }
      var inputAttributes = {
        accept: accept,
        disabled: disabled,
        type: 'file',
        style: _extends({
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          opacity: 0.00001,
          pointerEvents: 'none'
        }, inputProps.style),
        multiple: supportMultiple && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: 'off'
      };
      if (name && name.length) {
        inputAttributes.name = name;
      }

      // Destructure custom props away from props used for the div element
      /* eslint-disable no-unused-vars */

      var acceptedFiles = props.acceptedFiles,
        preventDropOnDocument = props.preventDropOnDocument,
        disablePreview = props.disablePreview,
        disableClick = props.disableClick,
        onDropAccepted = props.onDropAccepted,
        onDropRejected = props.onDropRejected,
        onFileDialogCancel = props.onFileDialogCancel,
        maxSize = props.maxSize,
        minSize = props.minSize,
        getDataTransferItems = props.getDataTransferItems,
        divProps = _objectWithoutProperties(props, ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize', 'getDataTransferItems']);
      /* eslint-enable no-unused-vars */

      /* eslint-disable jsx-a11y/no-static-element-interactions */
      /* eslint-disable jsx-a11y/click-events-have-key-events */

      return external_react_default().createElement('div', _extends({
        className: className,
        style: appliedStyle
      }, divProps /* expand user provided props first so event handlers are never overridden */, {
        onClick: this.composeHandlers(this.onClick),
        onDragStart: this.composeHandlers(this.onDragStart),
        onDragEnter: this.composeHandlers(this.onDragEnter),
        onDragOver: this.composeHandlers(this.onDragOver),
        onDragLeave: this.composeHandlers(this.onDragLeave),
        onDrop: this.composeHandlers(this.onDrop),
        ref: this.setRef,
        'aria-disabled': disabled
      }), this.renderChildren(children, isDragActive, isDragAccept, isDragReject), external_react_default().createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes)));
    }
  }]);
  return Dropzone;
}((external_react_default()).Component);
/* harmony default export */ const es = (Dropzone);
Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: external_prop_types_default().oneOfType([(external_prop_types_default()).string, external_prop_types_default().arrayOf((external_prop_types_default()).string)]),
  /**
   * Contents of the dropzone
   */
  children: external_prop_types_default().oneOfType([(external_prop_types_default()).node, (external_prop_types_default()).func]),
  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: (external_prop_types_default()).bool,
  /**
   * Enable/disable the dropzone entirely
   */
  disabled: (external_prop_types_default()).bool,
  /**
   * Enable/disable preview generation
   */
  disablePreview: (external_prop_types_default()).bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: (external_prop_types_default()).bool,
  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: (external_prop_types_default()).object,
  /**
   * Allow dropping multiple files
   */
  multiple: (external_prop_types_default()).bool,
  /**
   * `name` attribute for the input tag
   */
  name: (external_prop_types_default()).string,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: (external_prop_types_default()).number,
  /**
   * Minimum file size (in bytes)
   */
  minSize: (external_prop_types_default()).number,
  /**
   * className
   */
  className: (external_prop_types_default()).string,
  /**
   * className to apply when drag is active
   */
  activeClassName: (external_prop_types_default()).string,
  /**
   * className to apply when drop will be accepted
   */
  acceptClassName: (external_prop_types_default()).string,
  /**
   * className to apply when drop will be rejected
   */
  rejectClassName: (external_prop_types_default()).string,
  /**
   * className to apply when dropzone is disabled
   */
  disabledClassName: (external_prop_types_default()).string,
  /**
   * CSS styles to apply
   */
  style: (external_prop_types_default()).object,
  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: (external_prop_types_default()).object,
  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: (external_prop_types_default()).object,
  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: (external_prop_types_default()).object,
  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: (external_prop_types_default()).object,
  /**
   * getDataTransferItems handler
   * @param {Event} event
   * @returns {Array} array of File objects
   */
  getDataTransferItems: (external_prop_types_default()).func,
  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: (external_prop_types_default()).func,
  /**
   * onDrop callback
   */
  onDrop: (external_prop_types_default()).func,
  /**
   * onDropAccepted callback
   */
  onDropAccepted: (external_prop_types_default()).func,
  /**
   * onDropRejected callback
   */
  onDropRejected: (external_prop_types_default()).func,
  /**
   * onDragStart callback
   */
  onDragStart: (external_prop_types_default()).func,
  /**
   * onDragEnter callback
   */
  onDragEnter: (external_prop_types_default()).func,
  /**
   * onDragOver callback
   */
  onDragOver: (external_prop_types_default()).func,
  /**
   * onDragLeave callback
   */
  onDragLeave: (external_prop_types_default()).func,
  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: (external_prop_types_default()).func
};
Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disablePreview: false,
  disableClick: false,
  inputProps: {},
  multiple: true,
  maxSize: Infinity,
  minSize: 0,
  getDataTransferItems: getDataTransferItems
};
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3368);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/utilities/FileUtilities.js
var BytesInMegabyte = 1048576;
var BytesInKilobyte = 1024;
var convertFileSize = function convertFileSize(fileSize) {
  return fileSize < BytesInMegabyte ? "".concat((fileSize / BytesInKilobyte).toFixed(1), "kB") : "".concat((fileSize / BytesInMegabyte).toFixed(1), "MB");
};
;// CONCATENATED MODULE: ./src/components/FileUpload/FileUploadRow.jsx



var FileUploadRow = function FileUploadRow(_ref) {
  var fileId = _ref.fileId,
    name = _ref.name,
    size = _ref.size,
    onDeleteClick = _ref.onDeleteClick,
    isLoading = _ref.isLoading,
    errorMessage = _ref.errorMessage,
    readonly = _ref.readonly,
    LinearProgress = _ref.LinearProgress;
  var icon = errorMessage ? /*#__PURE__*/external_react_default().createElement("span", {
    className: "material-icons file-uploaded-icon failure",
    name: "fileUploadedIcon"
  }, "highlight_off") : /*#__PURE__*/external_react_default().createElement("span", {
    className: "material-icons file-uploaded-icon",
    name: "fileUploadedIcon"
  }, "check_circle");
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "file-description",
    name: "fileDescriptionRow"
  }, !isLoading && name && (size || size === 0) && icon, name && /*#__PURE__*/external_react_default().createElement("span", {
    className: "long-row-truncate",
    name: "fileName"
  }, name), isLoading && /*#__PURE__*/external_react_default().createElement(LinearProgress, {
    className: "file-loading-progress-bar",
    name: "fileLoadingProgressBar"
  }), !isLoading && (size || size === 0) && /*#__PURE__*/external_react_default().createElement("span", {
    className: "file-uploaded-size",
    name: "fileUploadedSize"
  }, convertFileSize(size)), !isLoading && !errorMessage && !readonly && /*#__PURE__*/external_react_default().createElement("span", {
    className: "material-icons file-delete-icon",
    name: "fileDeleteIcon",
    onClick: function onClick() {
      onDeleteClick(fileId);
    }
  }, "delete"), errorMessage && /*#__PURE__*/external_react_default().createElement("div", {
    className: "validate-error-message",
    name: "fileUploadedErrorMessage"
  }, errorMessage));
};
FileUploadRow.defaultProps = {
  readonly: false,
  isLoading: false
};
 false ? 0 : void 0;
/* harmony default export */ const FileUpload_FileUploadRow = (FileUploadRow);
// EXTERNAL MODULE: ./src/components/FileUpload/_styles.scss
var _styles = __webpack_require__(8892);
;// CONCATENATED MODULE: ./src/components/FileUpload/FileUpload.jsx
function FileUpload_typeof(o) { "@babel/helpers - typeof"; return FileUpload_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, FileUpload_typeof(o); }
function FileUpload_toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function FileUpload_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function FileUpload_createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), FileUpload_possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function FileUpload_possibleConstructorReturn(t, e) { if (e && ("object" == FileUpload_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function FileUpload_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == FileUpload_typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != FileUpload_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != FileUpload_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






var FileUpload = /*#__PURE__*/function (_PureComponent) {
  function FileUpload(props, context) {
    var _this;
    FileUpload_classCallCheck(this, FileUpload);
    _this = _callSuper(this, FileUpload, [props, context]);
    _defineProperty(_this, "onDrop", function (accepted) {
      if (_this.props.readonly) return;
      _this.setState({
        showOverlay: false
      });
      _this.props.onDrop(accepted);
    });
    _defineProperty(_this, "onDragEnter", function () {
      if (_this.props.readonly) return;
      _this.setState({
        showOverlay: true
      });
    });
    _defineProperty(_this, "onDragLeave", function () {
      if (_this.props.readonly) return;
      _this.setState({
        showOverlay: false
      });
    });
    _this.state = {
      showOverlay: false
    };
    return _this;
  }
  FileUpload_inherits(FileUpload, _PureComponent);
  return FileUpload_createClass(FileUpload, [{
    key: "setFocusOnUploadLink",
    value: function setFocusOnUploadLink() {
      this.child && this.child.focus();
    }
  }, {
    key: "openUpload",
    value: function openUpload() {
      this.dropZoneRef.open();
    }
  }, {
    key: "getUploadLink",
    value: function getUploadLink(open) {
      var _this2 = this;
      return /*#__PURE__*/external_react_default().createElement("a", {
        ref: function ref(_ref) {
          return _this2.child = _ref;
        },
        tabIndex: this.props.tabIndex,
        className: "file-input-link",
        onKeyDown: function onKeyDown(e) {
          return _this2.props.onBrowseKeyDown(e);
        },
        onClick: function onClick() {
          return open();
        }
      }, "browse");
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var filesWithError = this.props.files.filter(function (file) {
        return file.errorMessage;
      });
      var filesWithoutError = this.props.files.filter(function (file) {
        return !file.errorMessage;
      });
      if (this.props.sortFunction) {
        filesWithError = filesWithError.sort(this.props.sortFunction);
        filesWithoutError = filesWithoutError.sort(this.props.sortFunction);
      }
      var filesToPrint = [].concat(FileUpload_toConsumableArray(filesWithError), FileUpload_toConsumableArray(filesWithoutError));
      var dropZoneClasses = classnames_default()("file-loader", this.state.showOverlay ? "overlay" : "", this.props.wrapperClassName);
      return /*#__PURE__*/external_react_default().createElement(es, {
        ref: function ref(_ref3) {
          return _this3.dropZoneRef = _ref3;
        },
        className: dropZoneClasses,
        disableClick: true,
        onDragEnter: this.onDragEnter,
        onDragLeave: this.onDragLeave,
        onDrop: this.onDrop
      }, function (_ref2) {
        var open = _ref2.open;
        return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, !_this3.props.readonly && /*#__PURE__*/external_react_default().createElement("div", {
          className: "file-loader-header",
          name: "fileLoaderHeader"
        }, /*#__PURE__*/external_react_default().createElement("span", {
          className: "material-icons",
          name: "cloudUploadIcon"
        }, "cloud_upload"), /*#__PURE__*/external_react_default().createElement("span", {
          name: "uploadHelperText"
        }, "\xA0Drop files to upload or ", _this3.getUploadLink(open))), !!_this3.props.additionalHelperText && /*#__PURE__*/external_react_default().createElement("div", {
          name: "additionalHelperText",
          className: "additional-helper-text"
        }, _this3.props.additionalHelperText), _this3.state.showOverlay && /*#__PURE__*/external_react_default().createElement("div", {
          className: "overlay-help-text",
          name: "overlayHelpText"
        }, "Drop files to upload them"), /*#__PURE__*/external_react_default().createElement("div", {
          className: "file-uploaded-list",
          name: "listFiles"
        }, filesToPrint.map(function (file, index) {
          if (_this3.props.getFileRow) return /*#__PURE__*/external_react_default().createElement("div", {
            key: index
          }, _this3.props.getFileRow(file, index));
          return /*#__PURE__*/external_react_default().createElement(FileUpload_FileUploadRow, {
            key: index,
            fileId: file.id,
            name: file.name,
            size: file.size,
            LinearProgress: _this3.props.LinearProgress,
            isLoading: file.isLoading,
            errorMessage: file.errorMessage,
            readonly: _this3.props.readonly,
            onDeleteClick: _this3.props.onDeleteFile
          });
        }), _this3.props.children));
      });
    }
  }]);
}(external_react_.PureComponent);
FileUpload.defaultProps = {
  readonly: false,
  getFileRow: null,
  wrapperClassName: "",
  tabIndex: 1
};
 false ? 0 : void 0;
/* harmony default export */ const FileUpload_FileUpload = (FileUpload);
// EXTERNAL MODULE: ./src/components/TabbedAutoSuggestControl/index.js + 2 modules
var TabbedAutoSuggestControl = __webpack_require__(4189);
// EXTERNAL MODULE: ./src/components/RadioButton/index.js + 1 modules
var RadioButton = __webpack_require__(7321);
// EXTERNAL MODULE: ./src/components/TextInput.jsx
var TextInput = __webpack_require__(7642);
// EXTERNAL MODULE: ./src/components/DecimalInput.jsx
var DecimalInput = __webpack_require__(6938);
// EXTERNAL MODULE: ./src/components/Toggle/index.js + 3 modules
var Toggle = __webpack_require__(275);
// EXTERNAL MODULE: ./src/components/CheckBox/CheckBox.jsx
var CheckBox = __webpack_require__(9692);
// EXTERNAL MODULE: ./src/components/DropDown/index.js + 2 modules
var DropDown = __webpack_require__(3615);
// EXTERNAL MODULE: ./src/components/NumericInput.jsx
var NumericInput = __webpack_require__(3678);
// EXTERNAL MODULE: ./src/components/Button.jsx
var Button = __webpack_require__(9305);
// EXTERNAL MODULE: ./src/components/PendingButton/index.js + 1 modules
var PendingButton = __webpack_require__(7113);
// EXTERNAL MODULE: ./src/components/ActionButtonsPanel.js
var ActionButtonsPanel = __webpack_require__(1504);
// EXTERNAL MODULE: ./src/components/Popup/Popup.jsx
var Popup = __webpack_require__(6812);
// EXTERNAL MODULE: ./src/components/Popup/OptionsPopup.jsx
var OptionsPopup = __webpack_require__(296);
// EXTERNAL MODULE: ./src/components/Row.jsx
var Row = __webpack_require__(8201);
// EXTERNAL MODULE: ./src/components/Overlay.jsx
var Overlay = __webpack_require__(5669);
// EXTERNAL MODULE: ./src/components/Tooltip/Tooltip.jsx
var Tooltip = __webpack_require__(9004);
// EXTERNAL MODULE: ./src/components/IconButton/index.js + 1 modules
var IconButton = __webpack_require__(7204);
// EXTERNAL MODULE: ./src/components/DocumentTitle.jsx
var DocumentTitle = __webpack_require__(4834);
// EXTERNAL MODULE: ./src/components/FormContainer.jsx
var FormContainer = __webpack_require__(6426);
// EXTERNAL MODULE: ./src/components/LoadingContainer.jsx
var LoadingContainer = __webpack_require__(3320);
// EXTERNAL MODULE: ./src/components/LoadingIndicator.jsx
var LoadingIndicator = __webpack_require__(6282);
// EXTERNAL MODULE: ./src/components/NavigationBar.jsx
var NavigationBar = __webpack_require__(144);
// EXTERNAL MODULE: ./src/components/ClickableMenu.js
var ClickableMenu = __webpack_require__(7276);
// EXTERNAL MODULE: ./src/components/Header/index.js + 1 modules
var Header = __webpack_require__(2197);
// EXTERNAL MODULE: ./src/components/Menu/index.js
var Menu = __webpack_require__(2563);
// EXTERNAL MODULE: ./src/components/Menu/OrganizationMenu.jsx + 4 modules
var OrganizationMenu = __webpack_require__(2234);
// EXTERNAL MODULE: ./src/components/LeftNavigationMenu/index.js
var LeftNavigationMenu = __webpack_require__(4256);
// EXTERNAL MODULE: ./src/components/LeftNavigationMenu/NavigationLinksList.jsx
var NavigationLinksList = __webpack_require__(1937);
// EXTERNAL MODULE: ./src/components/Profile/index.js + 9 modules
var Profile = __webpack_require__(6278);
// EXTERNAL MODULE: ./src/components/Table/index.js + 5 modules
var Table = __webpack_require__(4668);
// EXTERNAL MODULE: ./src/components/LeftMenuPage.jsx + 1 modules
var LeftMenuPage = __webpack_require__(7293);
// EXTERNAL MODULE: external "react-router-dom"
var external_react_router_dom_ = __webpack_require__(4442);
;// CONCATENATED MODULE: ./src/components/Lists/ItemsListHeader.jsx



var ItemsListHeader = function ItemsListHeader(_ref) {
  var title = _ref.title,
    link = _ref.link,
    icon = _ref.icon,
    onClick = _ref.onClick,
    titleWrapperClassName = _ref.titleWrapperClassName,
    childrenWrapperClassName = _ref.childrenWrapperClassName,
    iconLinkWrapperClassName = _ref.iconLinkWrapperClassName,
    hideControls = _ref.hideControls,
    useCustomTitleLayout = _ref.useCustomTitleLayout,
    children = _ref.children,
    customIcon = _ref.customIcon;
  var getIcon = function getIcon() {
    if (hideControls) return null;
    if (customIcon) return customIcon;
    if (!link) return /*#__PURE__*/external_react_default().createElement("div", {
      className: iconLinkWrapperClassName
    }, /*#__PURE__*/external_react_default().createElement("div", {
      onClick: onClick
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: icon
    })));
    return /*#__PURE__*/external_react_default().createElement("div", {
      className: iconLinkWrapperClassName
    }, /*#__PURE__*/external_react_default().createElement(external_react_router_dom_.Link, {
      to: link,
      onClick: onClick
    }, /*#__PURE__*/external_react_default().createElement("span", {
      className: icon
    })));
  };
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "row",
    name: "itemsListsInfo"
  }, title && /*#__PURE__*/external_react_default().createElement("div", {
    className: titleWrapperClassName
  }, useCustomTitleLayout ? title : /*#__PURE__*/external_react_default().createElement("h4", null, title)), /*#__PURE__*/external_react_default().createElement("div", {
    className: childrenWrapperClassName
  }, children), getIcon());
};
ItemsListHeader.defaultProps = {
  title: "",
  icon: "",
  onClick: function onClick() {},
  titleWrapperClassName: "col-xs-10 col-md-11",
  childrenWrapperClassName: "",
  iconLinkWrapperClassName: "col-xs-2 col-md-1 itemsList-iconLink",
  hideControls: false,
  useCustomTitleLayout: false
};
 false ? 0 : void 0;
/* harmony default export */ const Lists_ItemsListHeader = (ItemsListHeader);
;// CONCATENATED MODULE: ./src/components/Lists/EmptyItemsList.jsx


var EmptyItemsList = function EmptyItemsList(_ref) {
  var title = _ref.title,
    icon = _ref.icon;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "emptyItemList"
  }, "You don't have any ", title, ". Click ", /*#__PURE__*/external_react_default().createElement("span", {
    className: icon
  }), " to create a new one.");
};
EmptyItemsList.defaultProps = {
  icon: "ion-md-add-circle"
};
 false ? 0 : void 0;
/* harmony default export */ const Lists_EmptyItemsList = (EmptyItemsList);
// EXTERNAL MODULE: ./src/components/Header/HeaderGlobalSearch.jsx
var HeaderGlobalSearch = __webpack_require__(9997);
// EXTERNAL MODULE: ./src/components/Header/ApplicationMenu.jsx
var ApplicationMenu = __webpack_require__(3472);
// EXTERNAL MODULE: ./src/components/Header/ApplicationTitle.jsx
var ApplicationTitle = __webpack_require__(4247);
// EXTERNAL MODULE: ./src/components/Header/AppSelector.jsx
var AppSelector = __webpack_require__(1233);
// EXTERNAL MODULE: ./src/components/Header/Divider.jsx
var Divider = __webpack_require__(8883);
// EXTERNAL MODULE: ./src/components/Header/LocationMenuTitle.jsx
var LocationMenuTitle = __webpack_require__(2881);
// EXTERNAL MODULE: ./src/components/Header/UserPanel.jsx
var UserPanel = __webpack_require__(2518);
// EXTERNAL MODULE: ./src/components/Header/EnterNabpEPidDialog.jsx
var EnterNabpEPidDialog = __webpack_require__(8436);
;// CONCATENATED MODULE: ./src/components/index.js














// forms









//buttons










//containers






// navigation









//Profile







// Header









})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});